/**
 * CUSTOMIFY AI PHOTO CUSTOMIZATION
 * Clean JavaScript implementation for Shopify theme integration
 */

// Wycisz debug logi na produkcji (error/warn zostają). Debug: ?customify_debug=1 lub localStorage.customify_debug='1'
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    var debugEnabled = params.get('customify_debug') === '1' || localStorage.getItem('customify_debug') === '1';
    if (!debugEnabled) {
      var noop = function () {};
      console.log = noop;
      console.info = noop;
      console.debug = noop;
    }
  } catch (e) {}
})();

// Galeria: po kliknięciu miniaturki pokaż cały główny obraz (góra pod headerem).
// Bez smooth — przeglądarka pomija kolejny smooth do tego samego Y i kotwiczy scroll na miniaturce.
window.customifyScrollToEl = function (el) {
  if (!el) return;
  try {
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    document.documentElement.style.overflowAnchor = 'none';
    document.body.style.overflowAnchor = 'none';
    el.style.overflowAnchor = 'none';
    const thumbsRow = document.querySelector('.etsy-thumbnails-row');
    if (thumbsRow) {
      thumbsRow.style.overflowAnchor = 'none';
      thumbsRow.querySelectorAll('li').forEach(function (li) { li.style.overflowAnchor = 'none'; });
    }

    let pad = 12;
    const header = document.querySelector('sticky-header, header-component');
    if (header) {
      const hs = getComputedStyle(header);
      if (hs.position === 'sticky' || hs.position === 'fixed') {
        pad = Math.round(header.getBoundingClientRect().bottom) + 12;
      }
    }

    const move = function () {
      const r = el.getBoundingClientRect();
      if (!r.height) return;
      const y = Math.max(0, Math.round((window.pageYOffset || document.documentElement.scrollTop) + r.top - pad));
      document.documentElement.scrollTop = y;
      document.body.scrollTop = y;
    };
    move();
    setTimeout(move, 50);
  } catch (e) {}
};

if (!window.__customifyGalleryScrollBound) {
  window.__customifyGalleryScrollBound = true;
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('.etsy-thumbnails-row li')) return;
    const main = document.querySelector('.etsy-main-image');
    if (main) window.customifyScrollToEl(main);
  }, true);
}

// ============================================================
// ASYNC-TRANSFORM-FEATURE: FLAGA
// true  = generacja przez /api/transform-start + polling /api/transform-status
//         (krótkie żądania, odporne na tło karty i zrywanie mobilnego łącza)
// false = stara ścieżka: jeden długi POST /api/transform (1-4 min)
// ROLLBACK: ustaw false + npm run deploy. Backend działa dla obu ścieżek.
// Uwaga: przy błędzie /api/transform-start frontend i tak automatycznie
// używa starej ścieżki (bezpieczny fallback, np. zanim backend się wdroży).
// ============================================================
const CUSTOMIFY_ASYNC_TRANSFORM = true;

// ============================================================
// A/B FRAMEWORK LUMLY — test konwersji per produkt (handle).
// Nowy produkt: dodaj wpis tutaj + w utils/abTests.js (modelB na backendzie).
// ============================================================
const LUMLY_AB_EXPERIMENTS = {
  mysliwy_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'personalizowany-obraz-karykatura-ze-zdjecia-dla-mysliwego-wyjatkowy-prezent',
    split: 0.5
  },
  gta_gpt_image_25_flare: {
    enabled: true,
    productHandle: 'portret-w-stylu-gta-obraz-na-plotnie-z-twojego-zdjecia-super-prezent',
    split: 0.5
  },
  dla_niej_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania',
    split: 0.5
  },
  slubna_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary',
    split: 0.5
  },
  szef_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'obraz-ze-zdjecia-karykatura-szefa',
    split: 0.5
  },
  akwarela_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'obraz-ze-zdjecia-akwarela',
    split: 0.5
  },
  rocznica50_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'karykatura-na-50-rocznice-slubu-prezent-na-50-lecie',
    split: 0.5
  },
  czerwony_dywan_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan',
    split: 0.5
  },
  mechanik_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata',
    split: 0.5
  },
  rocznica_para_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie',
    split: 0.5
  },
  rocznica40_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'karykatura-na-40-rocznice-slubu-obraz-ze-zdjecia-na-40-lecie',
    split: 0.5
  },
  para_moto_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'pary-na-motocyklu-personalizowany-obraz-wyjatkowy-prezent-dla-motocyklistow',
    split: 0.5
  },
  kulturysta_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny',
    split: 0.5
  },
  nauczycielka_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'portret-dla-nauczycielki-ze-zdjecia-na-zkaonczenie-podziekowanie-prezent',
    split: 0.5
  },
  nauczyciel_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'portret-nauczyciela-ze-zdjecia-na-zakonczenie-roku-podziekowanie',
    split: 0.5
  },
  elle_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'portret-w-stylu-elle-ze-zdjecia-personalizowany-prezent-dla-dziewczyny',
    split: 0.5
  },
  vogue_ceo_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'obraz-w-stylu-vogue-ceo-ze-zdjecia-personalizowany-prezent-dla-kobiety',
    split: 0.5
  },
  vogue_gold_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'obraz-w-stylu-vogue-ze-zdjecia-classic-gold-personalizowany-prezent-dla-dziewczyny',
    split: 0.5
  },
  vogue_party_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'obraz-w-stylu-vogue-ze-zdjecia-party-personalizowany-prezent-dla-dziewczyny',
    split: 0.5
  },
  time_faceta_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'obraz-w-stylu-time-ze-zdjecia-personalizowany-prezent-dla-faceta',
    split: 0.5
  },
  time_kobiety_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'plakat-w-stylu-time-ze-zdjecia-personalizowany-prezent-dla-kobiety',
    split: 0.5
  },
  mens_health_gpt_image_25_flare: {
    enabled: false,
    productHandle: 'plakat-w-stylu-mens-health-ze-zdjecia-personalizowany-prezent-dla-niego',
    split: 0.5
  }
};

// A/B edycji obrazu — jedno losowanie na kohortę; wyniki per produkt (sync z utils/pilotEditCohort.js)
const LUMLY_PILOT_COHORT_EXPERIMENT_ID = 'pilot_image_edit_caricature_v1';
const LUMLY_PILOT_EDIT_CORE_HANDLES = [
  'portret-dla-nauczycielki-ze-zdjecia-na-zkaonczenie-podziekowanie-prezent',
  'karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary',
  'karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie',
  'karykatura-na-50-rocznice-slubu-prezent-na-50-lecie',
  'karykatura-na-40-rocznice-slubu-obraz-ze-zdjecia-na-40-lecie'
];
const LUMLY_PILOT_AB_EXPERIMENTS = {
  pilot_image_edit_caricature_v1: {
    enabled: false,
    split: 0.5
  }
};
/** Max poprawek AI łącznie (KV jak generacje: device/customer; sync z backend). */
const LUMLY_PILOT_EDIT_MAX_EDITS = 5;

// Aktywne produkty tematyczne Lumly — jeden ukryty styl, GPT Image 2.5 Flare + FACE FINISH.
const ACTIVE_THEMED_PORTRAIT_STYLE_BY_HANDLE = {
  'portret-piratow-personalizowany-obraz-ze-zdjecia': 'pirates',
  'portret-w-stylu-bonnie-i-clyde-z-lat-20-personalizowany-obraz': 'bonnie-clyde',
  'kowboje-z-dzikiego-zachodu-personalizowany-obraz-ze-zdjecia-dla-pary': 'cowboys',
  'personalizowany-portret-w-stylu-minecraft-fotoobraz-na-prezent': 'minecraft',
  'portret-z-klockow-personalizowany-obraz-ze-zdjecia': 'brick-figures',
  'personalizowany-portret-kubistyczny-ze-zdjecia': 'cubist',
  'personalizowany-portret-ze-zdjecia-w-stylu-japonskim-fotoobraz-na-prezent': 'japanese',
  'wiktorianska-dama-w-kapeluszu-personalizowany-portret-ze-zdjecia': 'victorian-lady',
  'portret-indianina-w-pioropuszu-personalizowany-obraz-ze-zdjecia-na-prezent': 'headdress-portrait'
};

(function setupLumlyAb() {
  var COOKIE_EXP = 'lumly_exp';
  var COOKIE_VID = 'lumly_vid';
  var DAYS = 90;
  var API_URL = 'https://customify-s56o.vercel.app/api/ab-event';

  function readCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function writeCookie(name, value) {
    try {
      var maxAge = DAYS * 24 * 60 * 60;
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    } catch (e) {}
  }

  function hashBucket(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0) % 100;
  }

  function getVisitorId() {
    var id = '';
    try { id = localStorage.getItem(COOKIE_VID) || ''; } catch (e) {}
    if (!id) id = readCookie(COOKIE_VID);
    if (!id) {
      id = 'v' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    }
    try { localStorage.setItem(COOKIE_VID, id); } catch (e) {}
    writeCookie(COOKIE_VID, id);
    return id;
  }

  function loadAssignments() {
    var raw = '';
    try { raw = localStorage.getItem(COOKIE_EXP) || ''; } catch (e) {}
    if (!raw) raw = readCookie(COOKIE_EXP);
    if (!raw) return {};
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function saveAssignments(map) {
    var raw = JSON.stringify(map);
    try { localStorage.setItem(COOKIE_EXP, raw); } catch (e) {}
    writeCookie(COOKIE_EXP, raw);
  }

  function urlOverride(experimentId) {
    try {
      var param = new URLSearchParams(window.location.search).get('lumly_ab');
      if (!param) return null;
      var parts = param.split(':');
      if (parts.length === 2) {
        if (parts[0] === experimentId && (parts[1] === 'A' || parts[1] === 'B')) return parts[1];
        return null;
      }
      if (param === 'A' || param === 'B') return param;
    } catch (e) {}
    return null;
  }

  function activeExperimentId() {
    var ids = Object.keys(LUMLY_AB_EXPERIMENTS);
    var pathname = String(window.location.pathname || '').toLowerCase();
    for (var i = 0; i < ids.length; i++) {
      var config = LUMLY_AB_EXPERIMENTS[ids[i]];
      if (
        config &&
        (config.enabled || config.trackAfter) &&
        config.productHandle &&
        pathname.indexOf('/products/' + String(config.productHandle).toLowerCase()) !== -1
      ) {
        return ids[i];
      }
    }
    return null;
  }

  function assignVariant(experimentId) {
    var config = LUMLY_AB_EXPERIMENTS[experimentId];
    if (!config) return 'A';
    if (!config.enabled && config.trackAfter) return 'P';
    if (!config.enabled) return 'A';
    var override = urlOverride(experimentId);
    if (override) return override;
    var map = loadAssignments();
    if (map[experimentId] === 'A' || map[experimentId] === 'B') return map[experimentId];
    var split = typeof config.split === 'number' ? config.split : 0.5;
    var variant = hashBucket(getVisitorId() + ':' + experimentId) < Math.round(split * 100) ? 'B' : 'A';
    map[experimentId] = variant;
    saveAssignments(map);
    return variant;
  }

  function lumlyAb(experimentId) {
    return assignVariant(experimentId);
  }

  function lumlyAbActive() {
    var id = activeExperimentId();
    if (!id) return null;
    return { experiment: id, variant: assignVariant(id), visitorId: getVisitorId() };
  }

  function lumlyAbTrack(metric) {
    var active = lumlyAbActive();
    if (!active) return Promise.resolve();
    var payload = {
      experiment: active.experiment,
      variant: active.variant,
      metric: metric,
      visitorId: active.visitorId
    };
    var qs = API_URL
      + '?experiment=' + encodeURIComponent(active.experiment)
      + '&variant=' + encodeURIComponent(active.variant)
      + '&metric=' + encodeURIComponent(metric)
      + '&visitorId=' + encodeURIComponent(active.visitorId);
    // Jedna ścieżka = 1 event (wcześniej beacon+fetch dublowały „Generacje”)
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(API_URL, new Blob([JSON.stringify(payload)], { type: 'text/plain' }))) {
        return Promise.resolve();
      }
    } catch (e) {}
    return fetch(qs, { method: 'GET', keepalive: true, credentials: 'omit' }).catch(function () {
      return fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      });
    }).catch(function () {});
  }

  window.lumlyAb = lumlyAb;
  window.lumlyAbActive = lumlyAbActive;
  window.lumlyAbTrack = lumlyAbTrack;
})();

(function setupLumlyPilotAb() {
  var COOKIE_EXP = 'lumly_pilot_exp';
  var COOKIE_VID = 'lumly_vid';
  var DAYS = 90;
  var API_URL = 'https://customify-s56o.vercel.app/api/ab-pilot-event';

  function readCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function writeCookie(name, value) {
    try {
      var maxAge = DAYS * 24 * 60 * 60;
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    } catch (e) {}
  }

  function hashBucket(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0) % 100;
  }

  function getVisitorId() {
    var id = '';
    try { id = localStorage.getItem(COOKIE_VID) || ''; } catch (e) {}
    if (!id) id = readCookie(COOKIE_VID);
    if (!id) {
      id = 'v' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    }
    try { localStorage.setItem(COOKIE_VID, id); } catch (e) {}
    writeCookie(COOKIE_VID, id);
    return id;
  }

  function loadAssignments() {
    var raw = '';
    try { raw = localStorage.getItem(COOKIE_EXP) || ''; } catch (e) {}
    if (!raw) raw = readCookie(COOKIE_EXP);
    if (!raw) return {};
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function saveAssignments(map) {
    var raw = JSON.stringify(map);
    try { localStorage.setItem(COOKIE_EXP, raw); } catch (e) {}
    writeCookie(COOKIE_EXP, raw);
  }

  function urlOverride(experimentId) {
    try {
      var param = new URLSearchParams(window.location.search).get('lumly_pilot_ab');
      if (!param) return null;
      var parts = param.split(':');
      if (parts.length === 2) {
        if (parts[1] === 'A' || parts[1] === 'B') return parts[1];
        return null;
      }
      if (param === 'A' || param === 'B') return param;
    } catch (e) {}
    return null;
  }

  function isOnPilotCohortProduct(pathname) {
    var path = String(pathname || '').toLowerCase();
    for (var i = 0; i < LUMLY_PILOT_EDIT_CORE_HANDLES.length; i++) {
      var h = String(LUMLY_PILOT_EDIT_CORE_HANDLES[i]).toLowerCase();
      if (path.indexOf('/products/' + h) !== -1) return h;
    }
    return '';
  }

  function activeExperimentId() {
    if (!isOnPilotCohortProduct(window.location.pathname)) return null;
    if (LUMLY_PILOT_AB_EXPERIMENTS[LUMLY_PILOT_COHORT_EXPERIMENT_ID]?.enabled) {
      return LUMLY_PILOT_COHORT_EXPERIMENT_ID;
    }
    return null;
  }

  function assignVariant(experimentId) {
    var config = LUMLY_PILOT_AB_EXPERIMENTS[experimentId];
    if (!config || !config.enabled) return 'A';
    var override = urlOverride(experimentId);
    if (override) return override;
    var map = loadAssignments();
    if (map[experimentId] === 'A' || map[experimentId] === 'B') return map[experimentId];
    var split = typeof config.split === 'number' ? config.split : 0.5;
    var variant = hashBucket(getVisitorId() + ':pilot:' + experimentId) < Math.round(split * 100) ? 'B' : 'A';
    map[experimentId] = variant;
    saveAssignments(map);
    return variant;
  }

  function lumlyPilotAbActive() {
    var id = activeExperimentId();
    if (!id) return null;
    return { experiment: id, variant: assignVariant(id), visitorId: getVisitorId() };
  }

  function lumlyPilotAbTrack(metric) {
    var active = lumlyPilotAbActive();
    if (!active) return Promise.resolve();
    var productHandle = isOnPilotCohortProduct(window.location.pathname) || '';
    var payload = {
      experiment: active.experiment,
      variant: active.variant,
      metric: metric,
      visitorId: active.visitorId,
      productHandle: productHandle
    };
    var qs = API_URL
      + '?experiment=' + encodeURIComponent(active.experiment)
      + '&variant=' + encodeURIComponent(active.variant)
      + '&metric=' + encodeURIComponent(metric)
      + '&visitorId=' + encodeURIComponent(active.visitorId)
      + '&productHandle=' + encodeURIComponent(productHandle);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(API_URL, new Blob([JSON.stringify(payload)], { type: 'text/plain' }))) {
        return Promise.resolve();
      }
    } catch (e) {}
    return fetch(qs, { method: 'GET', keepalive: true, credentials: 'omit' }).catch(function () {
      return fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      });
    }).catch(function () {});
  }

  window.lumlyPilotAbActive = lumlyPilotAbActive;
  window.lumlyPilotAbTrack = lumlyPilotAbTrack;
  window.LUMLY_PILOT_COHORT_EXPERIMENT_ID = LUMLY_PILOT_COHORT_EXPERIMENT_ID;
  window.LUMLY_PILOT_EDIT_CORE_HANDLES = LUMLY_PILOT_EDIT_CORE_HANDLES;

  window.getLumlyProductAbActive = function () {
    var pilot = lumlyPilotAbActive();
    if (pilot) return pilot;
    if (typeof window.lumlyAbActive === 'function') return window.lumlyAbActive();
    return null;
  };

  window.trackProductAbMetric = function (metric) {
    if (lumlyPilotAbActive()) return lumlyPilotAbTrack(metric);
    if (typeof window.lumlyAbTrack === 'function') return window.lumlyAbTrack(metric);
    return Promise.resolve();
  };
})();

// ============================================================
// PRODUCT CUSTOM FIELDS CONFIG
// Klucz = product handle z URL.
// ============================================================
const PRODUCT_FIELD_CONFIGS = {
  'prezent-z-okazji-dnia-matki-personalizowany-fotoobraz-ze-zdjecia': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz dedykację - tekst pojawi się na postumencie', type: 'text', placeholder: 'np. Kochanej Mamie', required: false }
    ]
  },
  'prezent-z-okazji-dnia-matki-personalizowany-obraz-supermama': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz dedykację - tekst pojawi się na postumencie', type: 'text', placeholder: 'np. Kochanej Mamie', required: false },
      { id: 'opis_charakteru', label: 'Opisz mamę, jej pasje lub klimat sceny - tekst nie pojawi się na obrazku', type: 'text', placeholder: 'np. gotowanie, zakupy, kocia mama', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. pielęgniarka, podróże | nauczycielka, sport', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-kelnerki': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. kelnerka, restauracja, taca', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-kelnera': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. kelner, barman, restauracja', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-rowerzysty-kolarza': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. rowerzysta, kolarz, rower', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-policjantka': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. pielęgniarka, podróże | nauczycielka, sport', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-rolniczka': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. pielęgniarka, podróże | nauczycielka, sport', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-lekarka': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. pielęgniarka, podróże | nauczycielka, sport', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. pielęgniarka, podróże | nauczycielka, sport', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-psycholog': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. pielęgniarka, podróże | nauczycielka, sport', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-kucharka': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. pielęgniarka, podróże | nauczycielka, sport', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-fitness': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. pielęgniarka, podróże | nauczycielka, sport', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-szefowa': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. szefowa sklepu, produkty spożywcze', required: false }
    ]
  },
  'karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. rolnik, wędkarz, sport', required: false }
    ]
  },
  'karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. rolnik, traktor, pole, wieś', required: false }
    ]
  },
  'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. mechanik, warsztat, narzędzia, samochód', required: false }
    ]
  },
  'motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. motocykl, motor, trasa, pasja do jazdy', required: false }
    ]
  },
  'obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Kacper', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. piłkarz, zwycięzca, sport', required: false }
    ]
  },
  'fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Karol', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 35', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. strażak, ratownik, bohater', required: false }
    ]
  },
  'portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Piotr', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. lekarz, chirurg, pediatra', required: false }
    ]
  },
  'prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Marek', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. budowlaniec, murarz, majster', required: false }
    ]
  },
  'prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Tomek', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. kierowca tira, trasa, podróże', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Marek', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. policjant, detektyw, straż', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-szefa': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Marek', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'firma transportowa, prezes, dział marketingu, firma budowlana', required: false }
    ]
  },
  'karykatura-pary-na-diamentowe-gody-ze-zdjecia-60-rocznica-slubu': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Para na rocznicę', required: false },
      { id: 'rocznica', label: 'Wpisz liczbę lat rocznicy (np. 50, 55, 60) - liczba pojawi się na obrazie', type: 'text', placeholder: 'np. 50, 55, 60', required: false },
      { id: 'opis_charakteru', label: 'Opisz lokalizacje, styl, kolory - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. elegancko, srebro, kwiaty, uroczystość', required: false }
    ]
  },
  'karykatura-dziadkow-ze-zdjecia-wesola-para-personalizowany-prezent': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Babcia i Dziadek', required: false },
      { id: 'rocznica', label: 'Liczba lat / rocznica (jubileusz) — wpisz dokładnie tę cyfrę, która ma być duża na obrazku (np. 50, 55, 60)', type: 'text', placeholder: 'np. 50, 55, 60', required: false },
      { id: 'opis_charakteru', label: 'Opisz osoby, nastrój, szczegóły - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. ogród, złoto, rodzina', required: false }
    ]
  },
  'karykatura-pary-podroznikow-ze-zdjecia-personalizowany-prezent-dla-pary': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Ania i Piotr', required: false },
      { id: 'rocznica', label: 'Liczba lat / rocznica (jubileusz) — opcjonalne, puste = brak liczby na obrazku', type: 'text', placeholder: 'np. 30, 40, 45', required: false },
      { id: 'opis_charakteru', label: 'Opisz parę, nastrój, szczegóły - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. podróże, walizki, mapa świata, samolot', required: false }
    ]
  },
  'pary-na-motocyklu-personalizowany-obraz-wyjatkowy-prezent-dla-motocyklistow': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Imię / dedykacja - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Ania i Tomek', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku (opcjonalnie)', type: 'text', placeholder: 'np. 1, 5, 10, 25', required: false },
      { id: 'rodzaj_motocykla', label: 'Rodzaj motocykla', type: 'text', placeholder: 'np. sportowy / ścigacz, cruiser, chopper, enduro, naked', required: false },
      { id: 'kto_prowadzi', label: 'Kto prowadzi', type: 'select', required: false, options: [
        'On prowadzi',
        'Ona prowadzi',
        'Oboje / nie ważne'
      ]},
      { id: 'ubrania', label: 'Ubrania', type: 'text', placeholder: 'np. skórzane kurtki, kaski, jeansy', required: false },
      { id: 'otoczenie', label: 'Otoczenie / tło', type: 'text', placeholder: 'np. górska droga, miasto nocą, pustynia, tor wyścigowy', required: false },
      { id: 'opis_charakteru', label: 'Co jeszcze ma być na obrazku? (opcjonalnie)', type: 'text', placeholder: 'np. romantycznie, dynamika, zachód słońca', required: false }
    ]
  },
  'karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Imię / dedykacja - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Ania i Tomek', required: false },
      { id: 'poza', label: 'Poza pary', type: 'select', required: false, options: [
        'Jak na zdjęciu',
        'Stoją obok siebie',
        'Siedzą razem',
        'On trzyma ją na rękach',
        'Tańczą / objęci',
        'Romantyczna poza (on klęczy)'
      ]},
      { id: 'ubranie_pana', label: 'Ubranie pana młodego', type: 'text', placeholder: 'np. zielony garnitur, czarny smoking, marynarka navy', required: false },
      { id: 'ubranie_panny', label: 'Ubranie panny młodej', type: 'text', placeholder: 'np. biała suknia z welonem, sukienka bez ramiączek', required: false },
      {
        id: 'bukiet',
        label: 'Bukiet panny młodej — kolor',
        type: 'select',
        required: false,
        options: [
          'Domyślny (jak w przykładzie)',
          'Biały',
          'Różowy',
          'Czerwone róże',
          'Kremowy / ecru',
          'Lawenda / fioletowy',
          'Zielony / eukaliptus',
          'Brązowy / bordowy',
          'Własne'
        ],
        customInput: {
          id: 'bukiet_wlasny',
          label: 'Własny kolor bukietu',
          placeholder: 'np. biało-różowy, gipsówka, niebieski'
        }
      },
      { id: 'tlo', label: 'Tło / miejsce', type: 'text', placeholder: 'np. kościół, plener, sala weselna, plaża o zachodzie', required: false },
      { id: 'opis_charakteru', label: 'Co jeszcze ma być na obrazku? (opcjonalnie)', type: 'text', placeholder: 'np. tort, obrączki, pies, złote akcenty', required: false }
    ]
  },
  'karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Para na rocznicę', required: false },
      { id: 'rocznica', label: 'Wpisz liczbę lat rocznicy (np. 25, 30, 40, 50) - liczba pojawi się na obrazie', type: 'text', placeholder: 'np. 25, 30, 40, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz lokalizacje, styl, kolory - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. elegancko, złoto, kwiaty, uroczystość', required: false }
    ]
  },
  'karykatura-na-50-rocznice-slubu-prezent-na-50-lecie': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Para na rocznicę', required: false },
      { id: 'rocznica', label: 'Wpisz liczbę lat rocznicy (np. 25, 30, 40, 50) - liczba pojawi się na obrazie', type: 'text', placeholder: 'np. 25, 30, 40, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz lokalizacje, styl, kolory - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. elegancko, złoto, kwiaty, uroczystość', required: false }
    ]
  },
  'karykatura-na-40-rocznice-slubu-obraz-ze-zdjecia-na-40-lecie': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Para na rocznicę', required: false },
      { id: 'rocznica', label: 'Wpisz liczbę lat rocznicy (np. 20, 30, 40) - liczba pojawi się na obrazie', type: 'text', placeholder: 'np. 20, 30, 40', required: false },
      { id: 'opis_charakteru', label: 'Opisz lokalizacje, styl, kolory - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. elegancko, złoto, kwiaty, uroczystość', required: false }
    ]
  },
  'karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. wędkarz, ryby, jezioro', required: false }
    ]
  },
  'personalizowany-obraz-karykatura-elektryka-ze-zdjecia-wyjatkowy-prezent': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. elektryk, instalacje, kable', required: false }
    ]
  },
  'portret-ze-zdjecia-hydraulik': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. hydraulik, rury, narzędzia', required: false }
    ]
  },
  'personalizowany-obraz-karykatura-ze-zdjecia-dla-mysliwego-wyjatkowy-prezent': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. myśliwy, las, łowiectwo', required: false }
    ]
  },
  'portret-spawacza-personalizowany-obraz-karykatura-ze-zdjecia-wyjatkowy-prezent': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. spawacz, spawanie, warsztat', required: false }
    ]
  },
  'personalizowany-obraz-karykatura-ze-zdjecia-dla-zolnierza-i-super-prezent': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Rodzaj służby / formacja (np. czołgista, piechota, pilot) - tekst nie pojawi się na obrazku, ale decyduje o wyglądzie', type: 'text', placeholder: 'np. czołgista, piechota, pilot, marynarz', required: false }
    ]
  },
  'karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. piłkarz, piłka nożna, football', required: false }
    ]
  },
  'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Jan', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. kulturysta, siłownia, sport', required: false }
    ]
  },
  'active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. fitness, sport, siłownia', required: false }
    ]
  },
  'active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. fitness, sport, siłownia', required: false }
    ]
  },
  'portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. salon manicure, tipsy, rzęsy', required: false }
    ]
  },
  'portret-ze-zdjecia-superbohater-prezent-dla-chlopca': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Dedykacja / podpis na dole (styl plakatów o superbohaterach)', type: 'text', placeholder: 'np. SuperKuba, Dla Wojtka', required: false }
    ]
  },
  'portret-superbohater-obraz-na-plotnie-z-twojego-zdjecia-superman': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Dedykacja / podpis na dole (styl plakatów o superbohaterach)', type: 'text', placeholder: 'np. SuperMichał, Dla Taty', required: false }
    ]
  },
  'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Ania', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 40', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. fitness, podróże, moda', required: false }
    ]
  },
  'portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 18, 25, 30', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. glamour, Hollywood, czerwony dywan', required: false }
    ]
  },
  'portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false },
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 30', required: false },
      { id: 'opis_charakteru', label: 'Opisz osobę, jej zawód, hobby - tekst nie pojawi się na obrazku ale decyduje o jego wyglądzie', type: 'text', placeholder: 'np. nauczycielka, szkoła, książki', required: false }
    ]
  },
  'portret-dla-nauczycielki-ze-zdjecia-na-zkaonczenie-podziekowanie-prezent': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Pani Anno, dziękujemy - Klasa 3C', required: false },
      { id: 'opis_charakteru', label: 'Przedmiot nauczycielki - tekst nie pojawi się na obrazku ale decyduje o wyglądzie', type: 'text', placeholder: 'np. nauczycielka matematyki, chemii, geografii', required: false }
    ]
  },
  'portret-nauczyciela-ze-zdjecia-na-zakonczenie-roku-podziekowanie': {
    title: 'Personalizacja',
    fields: [
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Panie Janie, dziękujemy - Klasa 3B', required: false },
      { id: 'opis_charakteru', label: 'Przedmiot nauczyciela - tekst nie pojawi się na obrazku ale decyduje o wyglądzie', type: 'text', placeholder: 'np. nauczyciel matematyki, chemii, geografii', required: false }
    ]
  },
  'obraz-ze-zdjecia-biznes-woman-personalizowany-prezent': {
    title: 'Personalizacja',
    fields: [
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false }
    ]
  },
  'wydruk-na-szkle-biznes-woman-prezent-na-urodziny-dla-kobiety': {
    title: 'Personalizacja',
    fields: [
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false }
    ]
  },
  'obraz-ze-zdjecia-prezent-na-50-urodziny-dla-kobiety-biznes-woman': {
    title: 'Personalizacja',
    fields: [
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false }
    ]
  },
  'obraz-ze-zdjecia-prezent-na-30-urodziny-dla-kobiety-biznes-woman': {
    title: 'Personalizacja',
    fields: [
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna', required: false }
    ]
  },
  'obraz-ze-zdjecia-pary-na-50-ta-rocznice-wydruk-na-szkle': {
    title: 'Personalizacja',
    fields: [
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna i Marek', required: false }
    ]
  },
  'obraz-ze-zdjecia-karykatura-na-50-ta-rocznice': {
    title: 'Personalizacja',
    fields: [
      { id: 'rocznica', label: 'Rocznica / liczba lat - liczba pojawi się na obrazku', type: 'text', placeholder: 'np. 10, 25, 50', required: false },
      { id: 'imiona', label: 'Wpisz Imię, dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Anna i Marek', required: false }
    ]
  },
  'polacz-pare-na-wspolnym-obrazie-prezent-na-rocznice': {
    title: 'Personalizacja',
    multiUpload: true,
    maxImages: 2,
    fields: [
      { id: 'dedykacja', label: 'Napis / dedykacja (opcjonalnie)', type: 'text', placeholder: 'np. Anna i Marek · 14.02.2020', required: false }
    ]
  },
  'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk': {
    title: 'Personalizacja',
    multiUpload: true,
    maxImages: 4,
    fields: [
      { id: 'scena', label: 'Opisz scenę / klimat zdjęcia', type: 'text', placeholder: 'np. rodzinny obiad, spotkanie biznesowe, piknik w parku', required: false },
      { id: 'dedykacja', label: 'Dodaj napis / dedykację', type: 'text', placeholder: 'np. Kochana Mamo, Wesołych Świąt!', required: false }
    ]
  },
  'kolaz-ze-zdjec-prezent-dla-mamy': {
    title: 'Personalizacja',
    multiUpload: true,
    maxImages: 8,
    fields: [
      { id: 'dedykacja_imie', label: 'Wpisz dedykację / imię (opcjonalnie)', type: 'text', placeholder: 'np. Kochanej Mamie, Kasia i Tomek', required: false }
    ]
  },
  'generator-zdjec-profilowych-ai': {
    title: 'Personalizacja headshota',
    multiUpload: true,
    maxImages: 3,
    fields: [
      {
        id: 'stroj',
        label: 'Strój',
        type: 'select',
        required: false,
        defaultValue: 'Marynarka granatowa',
        options: [
          'Marynarka granatowa',
          'Marynarka czarna',
          'Marynarka szara',
          'Koszula biała (bez marynarki)',
          'Smart casual (sweter / polo)',
          'Blazer damski',
          'Własny'
        ],
        customInput: {
          id: 'stroj_wlasny',
          label: 'Własny strój',
          placeholder: 'np. grafitowy garnitur, golf i kamizelka'
        }
      },
      {
        id: 'rodzaj_sesji',
        label: 'Rodzaj sesji',
        type: 'select',
        required: false,
        defaultValue: 'Sesja studyjna',
        options: [
          'Sesja studyjna',
          'Sesja biurowa'
        ],
        tileOptions: [
          {
            value: 'Sesja studyjna',
            image: 'https://customify-s56o.vercel.app/headshot-session-studio.jpg',
            description: 'Neutralne tło i światło fotograficzne',
            backgroundOptions: ['Szare studio', 'Białe studio', 'Ciemne studio (premium)', 'Kolorowe studio', 'Własne']
          },
          {
            value: 'Sesja biurowa',
            image: 'https://customify-s56o.vercel.app/headshot-session-office.jpg',
            description: 'Prawdziwe biuro i biznesowe otoczenie',
            backgroundOptions: ['Nowoczesne biuro', 'Gabinet executive', 'Open space', 'Biuro Manhattan / skyline', 'Własne']
          }
        ]
      },
      {
        id: 'tlo',
        label: 'Tło',
        type: 'select',
        required: false,
        defaultValue: 'Szare studio',
        dependsOn: 'rodzaj_sesji',
        optionsByValue: {
          'Sesja studyjna': [
            'Szare studio',
            'Białe studio',
            'Ciemne studio (premium)',
            'Kolorowe studio',
            'Własne'
          ],
          'Sesja biurowa': [
            'Nowoczesne biuro',
            'Gabinet executive',
            'Open space',
            'Biuro Manhattan / skyline',
            'Własne'
          ]
        },
        customInput: {
          id: 'tlo_wlasne',
          label: 'Własne tło',
          placeholder: 'np. biuro Manhattan z widokiem na wieżowce'
        }
      },
      {
        id: 'kadr',
        label: 'Kadr',
        type: 'select',
        required: false,
        defaultValue: 'Klasyczny (głowa i ramiona)',
        options: [
          'Klasyczny (głowa i ramiona)',
          'Popiersie (do piersi)',
          'Do pasa',
          'Cała postać — stojąc',
          'Cała postać — siedząc'
        ]
      },
      {
        id: 'opis_dodatkowy',
        label: 'Dodatkowe - własne wskazówki',
        type: 'text',
        placeholder: 'np. lekki uśmiech, kolczyki, bardziej formalnie',
        required: false
      }
    ]
  },
  'prezent-na-walentynki-obraz-na-plotnie-z-twojego-zdjecia': {
    title: 'Personalizacja',
    fields: [
      { id: 'napis_banner', label: 'Dodaj napis, pojawi się na wstędze na obrazku', type: 'text', placeholder: 'np. Anna i Marek, zawsze razem', required: false }
    ]
  },
  'portret-ze-zdjecia-4-style-akwareli': {
    title: 'Dodaj dedykację (opcjonalnie)',
    fields: [{ id: 'imiona', label: 'Podpis lub dedykacja na dole obrazu', type: 'text', placeholder: 'np. Zawsze razem', required: false }]
  },
  'obraz-ze-zdjecia-subtelna-akwarela': {
    title: 'Dodaj dedykację (opcjonalnie)',
    fields: [{ id: 'imiona', label: 'Podpis lub dedykacja na dole obrazu', type: 'text', placeholder: 'np. Zawsze razem', required: false }]
  },
  'obraz-ze-zdjecia-akwarela-color-splash': {
    title: 'Dodaj dedykację (opcjonalnie)',
    fields: [{ id: 'imiona', label: 'Podpis lub dedykacja na dole obrazu', type: 'text', placeholder: 'np. Zawsze razem', required: false }]
  },
  'obraz-ze-zdjecia-akwarela-minimalistyczna': {
    title: 'Dodaj dedykację (opcjonalnie)',
    fields: [{ id: 'imiona', label: 'Podpis lub dedykacja na dole obrazu', type: 'text', placeholder: 'np. Zawsze razem', required: false }]
  },
  'obraz-ze-zdjecia-klasyczna-akwarela': {
    title: 'Dodaj dedykację (opcjonalnie)',
    fields: [{ id: 'imiona', label: 'Podpis lub dedykacja na dole obrazu', type: 'text', placeholder: 'np. Zawsze razem', required: false }]
  },
  'obraz-ze-zdjecia-akwarela': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'szkic-ze-zdjecia-obraz-na-plotnie-plakat-ramka': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'portret-piratow-personalizowany-obraz-ze-zdjecia': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na szarfie na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'portret-w-stylu-bonnie-i-clyde-z-lat-20-personalizowany-obraz': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na szarfie na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'kowboje-z-dzikiego-zachodu-personalizowany-obraz-ze-zdjecia-dla-pary': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na szarfie na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'personalizowany-portret-w-stylu-minecraft-fotoobraz-na-prezent': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'portret-z-klockow-personalizowany-obraz-ze-zdjecia': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'personalizowany-portret-kubistyczny-ze-zdjecia': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'personalizowany-portret-ze-zdjecia-w-stylu-japonskim-fotoobraz-na-prezent': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na szarfie na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'wiktorianska-dama-w-kapeluszu-personalizowany-portret-ze-zdjecia': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na szarfie na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'portret-indianina-w-pioropuszu-personalizowany-obraz-ze-zdjecia-na-prezent': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na szarfie na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'obraz-ze-zdjecia-personalizowany-prezent-dla-niej-akwarela': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Moja Królowa', required: false }
    ]
  },
  // karykatura-prezent-na-rocznice — napis TYLKO przez stary overlay po generacji (Segmind „Karykatura” nie bierze promptPhrase)
  'obraz-ze-zdjecia-karykatura-olowkiem-na-zamowienie': {
    title: 'Dodaj Napis',
    fields: [
      { id: 'imiona', label: 'Dodaj podpis / dedykację - tekst pojawi się na dole obrazka', type: 'text', placeholder: 'np. Zawsze Razem', required: false }
    ]
  },
  'portret-zakochana-para-krolewska-prezent-na-walentynki-personalizowany': {
    title: 'Personalizacja',
    fields: [
      { id: 'napis_banner', label: 'Dodaj napis, pojawi się na wstędze na obrazku', type: 'text', placeholder: 'np. Królowie Miłości już 15 lat razem', required: false }
    ]
  },
  'portret-w-stylu-gta-obraz-na-plotnie-z-twojego-zdjecia-super-prezent': {
    title: 'Personalizacja',
    fields: [
      { id: 'napis_gta', label: 'Możesz dodać napis, pojawi się na dole obrazka', type: 'text', placeholder: 'np. Power Couple', required: false },
      { id: 'wyglad_gta', label: 'Wygląd / styl ubioru', type: 'select', required: false, defaultValue: 'Vice City – hawajska koszula, bikini/crop top', options: [
        'Vice City – hawajska koszula, bikini/crop top',
        'Gangster – złote łańcuchy, tank top, bandana',
        'Street – skórzana kurtka, hoodie, sneakersy',
        'Boss – garnitur, sukienka koktajlowa',
        'Jak na zdjęciu'
      ]},
      { id: 'scena_gta', label: 'Scena / miasto', type: 'select', required: false, defaultValue: 'Vice City – plaża, palmy, neony', options: [
        'Vice City – plaża, palmy, neony',
        'Los Santos – downtown, wieżowce',
        'Miasto nocą – deszcz, neony',
        'Wzgórza – willa z basenem, widok na miasto',
        'Garaż / warsztat'
      ]},
      { id: 'pojazd_gta', label: 'Pojazd', type: 'select', required: false, defaultValue: 'Supersamochód', options: [
        'Supersamochód',
        'Motocykl',
        'Kabriolet retro',
        'Helikopter w tle',
        'Bez pojazdu'
      ]},
      { id: 'klimat_gta', label: 'Klimat', type: 'select', required: false, defaultValue: 'Akcja – pieniądze, eksplozje, policja w tle', options: [
        'Akcja – pieniądze, eksplozje, policja w tle',
        'Luz – wakacje, plaża, drinki',
        'Elegancja – garnitury, kasyno, nocne miasto'
      ]},
      { id: 'dodatki_gta', label: 'Co jeszcze ma być na obrazku? (opcjonalnie)', type: 'text', placeholder: 'np. pies husky, gitara, własne auto: czarne BMW E46', required: false }
    ]
  },
  'obraz-w-stylu-forbes-gold-ze-zdjecia-personalizowany-prezent-dla-mezczyzny': {
    title: 'Personalizacja',
    fields: [
      { id: 'imie_nazwisko', label: 'Imię i nazwisko (podpis na dole)', type: 'text', placeholder: 'np. MAREK SKWIERCZEK', required: true },
      { id: 'haslo_1', label: 'Hasło 1 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: ARCHITEKT WŁASNEGO IMPERIUM', required: false },
      { id: 'haslo_2', label: 'Hasło 2 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: SUKCES TO STRATEGIA, NIE PRZYPADEK', required: false }
    ]
  },
  'plakat-w-stylu-forbes-silver-dla-mezczyzny-personalizowany-prezent-ze-zdjecia': {
    title: 'Personalizacja',
    fields: [
      { id: 'imie_nazwisko', label: 'Imię i nazwisko (podpis na dole)', type: 'text', placeholder: 'np. MAREK SKWIERCZEK', required: true },
      { id: 'haslo_1', label: 'Hasło 1 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: ARCHITEKT WŁASNEGO IMPERIUM', required: false },
      { id: 'haslo_2', label: 'Hasło 2 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: SUKCES TO STRATEGIA, NIE PRZYPADEK', required: false }
    ]
  },
  'portret-w-stylu-elle-ze-zdjecia-personalizowany-prezent-dla-dziewczyny': {
    title: 'Personalizacja',
    fields: [
      { id: 'imie_nazwisko', label: 'Imię i nazwisko (podpis na dole)', type: 'text', placeholder: 'np. Anna Kowalska', required: false },
      { id: 'haslo_1', label: 'Hasło 1 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: PEWNA SIEBIE. AUTENTYCZNA. NIEZALEŻNA.', required: false },
      { id: 'haslo_2', label: 'Hasło 2 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: KOBIETA, KTÓRA WIE, CZEGO CHCE', required: false }
    ]
  },
  'obraz-w-stylu-vogue-ceo-ze-zdjecia-personalizowany-prezent-dla-kobiety': {
    title: 'Personalizacja',
    fields: [
      { id: 'imie_nazwisko', label: 'Imię i nazwisko (podpis na dole)', type: 'text', placeholder: 'np. Monika Zielińska', required: false },
      { id: 'haslo_1', label: 'Hasło 1 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: PEWNA SIEBIE. AUTENTYCZNA. NIEZALEŻNA.', required: false },
      { id: 'haslo_2', label: 'Hasło 2 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: KOBIETA, KTÓRA WIE, CZEGO CHCE', required: false }
    ]
  },
  'obraz-w-stylu-vogue-ze-zdjecia-classic-gold-personalizowany-prezent-dla-dziewczyny': {
    title: 'Personalizacja',
    fields: [
      { id: 'imie_nazwisko', label: 'Imię i nazwisko (podpis na dole)', type: 'text', placeholder: 'np. Anna Kowalska', required: false },
      { id: 'haslo_1', label: 'Hasło 1 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: PEWNA SIEBIE. SILNA. NIEZALEŻNA.', required: false },
      { id: 'haslo_2', label: 'Hasło 2 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: KOBIETA, KTÓRA DEFINIUJE SUKCES', required: false }
    ]
  },
  'obraz-w-stylu-vogue-ze-zdjecia-party-personalizowany-prezent-dla-dziewczyny': {
    title: 'Personalizacja',
    fields: [
      { id: 'imie_nazwisko', label: 'Imię i nazwisko (podpis na dole)', type: 'text', placeholder: 'np. Marta Konieczna', required: false },
      { id: 'haslo_1', label: 'Hasło 1 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: PEWNA SIEBIE. AUTENTYCZNA. NIEZALEŻNA.', required: false },
      { id: 'haslo_2', label: 'Hasło 2 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: KOBIETA, KTÓRA WIE, CZEGO CHCE', required: false }
    ]
  },
  'obraz-w-stylu-time-ze-zdjecia-personalizowany-prezent-dla-faceta': {
    title: 'Personalizacja',
    fields: [
      { id: 'imie_nazwisko', label: 'Imię i nazwisko (podpis na dole)', type: 'text', placeholder: 'np. Piotr Nowak', required: false },
      { id: 'haslo_1', label: 'Hasło główne (opcjonalne)', type: 'text', placeholder: 'Domyślnie: MĘŻCZYZNA SUKCESU', required: false },
      { id: 'haslo_2', label: 'Hasło boczne (opcjonalne)', type: 'text', placeholder: 'Domyślnie: Lider, który wyznacza kierunek', required: false }
    ]
  },
  'plakat-w-stylu-time-ze-zdjecia-personalizowany-prezent-dla-kobiety': {
    title: 'Personalizacja',
    fields: [
      { id: 'imie_nazwisko', label: 'Imię i nazwisko (podpis na dole)', type: 'text', placeholder: 'np. Anna Nowak', required: false },
      { id: 'haslo_1', label: 'Hasło główne (opcjonalne)', type: 'text', placeholder: 'Domyślnie: KOBIETA SUKCESU', required: false },
      { id: 'haslo_2', label: 'Hasło boczne (opcjonalne)', type: 'text', placeholder: 'Domyślnie: Liderka nowej ery', required: false }
    ]
  },
  'plakat-w-stylu-mens-health-ze-zdjecia-personalizowany-prezent-dla-niego': {
    title: 'Personalizacja',
    fields: [
      { id: 'imie_nazwisko', label: 'Imię i nazwisko (podpis na dole)', type: 'text', placeholder: 'np. Kamil Wiśniewski', required: false },
      { id: 'haslo_1', label: 'Hasło 1 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: FORMA ŻYCIA', required: false },
      { id: 'haslo_2', label: 'Hasło 2 (opcjonalne)', type: 'text', placeholder: 'Domyślnie: MENTAL ZWYCIĘZCY', required: false }
    ]
  }
};
PRODUCT_FIELD_CONFIGS['prezent-z-okazji-dnia-matki-personalizowany-plakat-pierwsze-nasze-swieto'] =
  PRODUCT_FIELD_CONFIGS['prezent-z-okazji-dnia-matki-personalizowany-fotoobraz-ze-zdjecia'];
PRODUCT_FIELD_CONFIGS['prezent-z-okazji-dnia-matki-kocia-mama-fotoobraz'] =
  PRODUCT_FIELD_CONFIGS['prezent-z-okazji-dnia-matki-personalizowany-fotoobraz-ze-zdjecia'];



const DIAMENTOWE_GODY_PRODUCT_HANDLE = 'karykatura-pary-na-diamentowe-gody-ze-zdjecia-60-rocznica-slubu';
/** Karykatura „Weseli staruszkowie” — jak Diamentowe Gody (prepend opisu). Handle = lumly.pl/products/karykatura-dziadkow-ze-zdjecia-wesola-para-personalizowany-prezent */
const WIESELI_STARUSZKOWIE_PRODUCT_HANDLE = 'karykatura-dziadkow-ze-zdjecia-wesola-para-personalizowany-prezent';
/** Karykatura pary podróżników — domyślna rocznica 40 i styl podróżnicy. */
const PODROZNICY_PARA_PRODUCT_HANDLE = 'karykatura-pary-podroznikow-ze-zdjecia-personalizowany-prezent-dla-pary';
/** Karykatura ślubna młodej pary — bez domyślnej liczby, domyślny klimat ślubny. */
const MLODA_PARA_SLUB_PRODUCT_HANDLE = 'karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary';
/** Para na motocyklu — osobne pola + wymuszenie pary na motorze. */
const PARY_NA_MOTOCYKLU_PRODUCT_HANDLE = 'pary-na-motocyklu-personalizowany-obraz-wyjatkowy-prezent-dla-motocyklistow';
/** Karykatura rocznicowa ślubu — ma pole liczby, ale bez domyślnej liczby gdy puste. */
const ROCZNICA_SLUBU_PARA_PRODUCT_HANDLE = 'karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie';
/** Karykatura 50 rocznica slubu — domyślna liczba 50 w prompcie gdy pole YEARS puste. */
const ROCZNICA_50_SLUBU_PRODUCT_HANDLE = 'karykatura-na-50-rocznice-slubu-prezent-na-50-lecie';
const ROCZNICA_40_SLUBU_PRODUCT_HANDLE = 'karykatura-na-40-rocznice-slubu-obraz-ze-zdjecia-na-40-lecie';



/** Domyślne wartości "Opis osoby" per produkt — na stałe, niezależne od tytułu. Gdy pole puste, używamy tej wartości. */
const DEFAULT_PERSONALIZATION_PER_PRODUCT = {};

// 🏷️ Rozbudowane nazwy rodzajów wydruku (koszyk, zamówienie) – jedno źródło prawdy
const PRODUCT_TYPE_LABELS = {
  plakat: 'Plakat – wydruk na papierze fotograficznym',
  canvas: 'Obraz na płótnie (canvas)',
  szklo: 'Wydruk na szkle',
  digital: 'Plik cyfrowy do pobrania',
  spotify_frame: 'Ramka Spotify ze zdjęciem',
  etui: 'Etui na telefon z Twoim zdjęciem'
};

class CustomifyEmbed {
  _reportToSentry(error, context, extra = {}) {
    try {
      const msg = String(error?.message || '');
      // Walidacja pól — oczekiwane, nie bug
      if (msg.startsWith('Uzupełnij wymagane pola')) return;
      // Moderacja AI — komunikat dla usera
      if (msg.includes('odrzucone przez system bezpieczeństwa') || msg.includes('filtr bezpieczeństwa')) return;
      // Timeout modelu — oczekiwany
      if (msg.includes('Request timed out') || msg.includes('model took too long')) return;
      // Limit poprawek AI — expected business, nie bug
      if (
        (msg.includes('Wykorzystano limit') || msg.includes('Osiągnięto limit'))
        && msg.includes('poprawek')
      ) return;

      if (typeof Sentry !== 'undefined' && Sentry.captureException) {
        Sentry.withScope(scope => {
          scope.setTag('customify_area', context || 'unknown');
          scope.setTag('customify_style', this.selectedStyle || 'none');
          scope.setTag('customify_product', this.getProductHandle ? this.getProductHandle() : 'unknown');
          scope.setTag('is_online', navigator.onLine ? 'yes' : 'no');
          const net = this._networkInfo();
          if (net) {
            scope.setTag('network_type', net.effectiveType || 'unknown');
            scope.setExtra('network', net);
          }
          scope.setExtra('url', window.location.href);
          scope.setExtra('selectedSize', this.selectedSize || 'none');
          scope.setExtra('selectedProductType', this.selectedProductType || 'none');
          scope.setExtra('hasUploadedFile', !!this.uploadedFile);
          scope.setExtra('hasTransformedImage', !!this.transformedImage);
          if (extra) {
            Object.entries(extra).forEach(([k, v]) => scope.setExtra(k, v));
          }
          scope.setLevel(error instanceof ReferenceError || error instanceof TypeError ? 'error' : 'warning');
          Sentry.captureException(error);
        });
      }
    } catch (_) {}
  }

  _sentryCrumb(category, message, data) {
    try {
      if (typeof Sentry !== 'undefined' && Sentry.addBreadcrumb) {
        Sentry.addBreadcrumb({ category: 'customify.' + category, message, data, level: 'info' });
      }
    } catch (_) {}
  }

  _reportCartAddFailure(errMsg, addResult, extra = {}) {
    try {
      if (typeof Sentry === 'undefined' || !Sentry.captureMessage) return;
      const productHandle = (this.getProductHandle && this.getProductHandle()) ||
        (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || 'unknown';
      const props = extra.lineProperties || {};
      const propKeys = Object.keys(props);
      const propsCharLength = propKeys.reduce((sum, k) => sum + String(props[k] || '').length, 0);
      const payloadJson = extra.payloadJson || '';
      Sentry.withScope(scope => {
        scope.setLevel('error');
        scope.setTag('error_type', 'cart_add_failed');
        scope.setTag('customify_style', this.selectedStyle || 'unknown');
        scope.setTag('product_handle', productHandle);
        scope.setTag('cart_http_status', String(extra.httpStatus || 'unknown'));
        scope.setTag('properties_count', String(propKeys.length));
        scope.setContext('cart_add_failure', {
          variantId: extra.variantId,
          productId: extra.productId,
          productHandle,
          selectedProductType: this.selectedProductType || 'unknown',
          selectedSize: this.selectedSize || 'none',
          propertiesCount: propKeys.length,
          propertiesKeys: propKeys.join(', ').substring(0, 300),
          propertiesTotalChars: propsCharLength,
          payloadBytesApprox: payloadJson.length || undefined,
          shopifyError: errMsg,
          shopifyResponse: JSON.stringify(addResult || {}).substring(0, 500),
          httpStatus: extra.httpStatus,
          rawBody: extra.rawBody ? String(extra.rawBody).substring(0, 300) : undefined,
          attemptsMade: extra.attemptsMade,
          url: window.location.href
        });
        Sentry.captureMessage(
          `Cart add failed (HTTP ${extra.httpStatus || 'unknown'}, ${extra.attemptsMade || '?'}/${extra.maxAttempts || '?'} prób): ${errMsg}`,
          'error'
        );
      });
    } catch (_) {}
  }

  _base64SizeBytes(base64) {
    if (!base64 || typeof base64 !== 'string') return 0;
    const cleanBase64 = base64.includes(',') ? base64.split(',').pop() : base64;
    const padding = cleanBase64.endsWith('==') ? 2 : cleanBase64.endsWith('=') ? 1 : 0;
    return Math.max(0, Math.floor((cleanBase64.length * 3) / 4) - padding);
  }

  _browserDiagnostics() {
    const ua = navigator.userAgent || '';
    return {
      userAgent: ua,
      isIOS: /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
      isSafari: /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(ua),
      isOnline: typeof navigator.onLine === 'boolean' ? navigator.onLine : null
    };
  }

  _isOffline() {
    // navigator.onLine potrafi zwracać false mimo działającego internetu
    // (szczególnie na mobile/Safari/VPN). Nie blokujemy requestu z góry;
    // realny fetch poniżej i tak pokaże błąd sieci, jeśli połączenie faktycznie padło.
    return false;
  }

  _networkInfo() {
    try {
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn) return { effectiveType: conn.effectiveType, downlink: conn.downlink, rtt: conn.rtt };
    } catch (_) {}
    return null;
  }

  constructor() {
    this.uploadArea = document.getElementById('uploadArea');
    this.fileInput = document.getElementById('fileInput');
    this.previewArea = document.getElementById('previewArea');
    this.previewImage = document.getElementById('previewImage');
    this.previewObjectUrl = null;
    this.stylesArea = document.getElementById('stylesArea');
    this.sizeArea = document.getElementById('sizeArea');
    this.productTypeArea = document.getElementById('productTypeArea');
    this.actionsArea = document.getElementById('actionsArea');
    this.loadingArea = document.getElementById('loadingArea');
    this.resultArea = document.getElementById('resultArea');
    this.resultImage = document.getElementById('resultImage');
    this.errorMessage = document.getElementById('errorMessage');
    this.errorMessageBottom = document.getElementById('errorMessageBottom');
    this.errorMessageTransform = document.getElementById('errorMessageTransform');
    this.successMessage = document.getElementById('successMessage');

    // 🎨 Pilotaż wieloetapowej edycji AI — wyłącznie produkt Hip-Hop o niskim ruchu
    this.pilotEditBtn = document.getElementById('pilotEditBtn');
    this.pilotEditPanel = document.getElementById('pilotEditPanel');
    this.pilotEditInstruction = document.getElementById('pilotEditInstruction');
    this.pilotEditStatus = document.getElementById('pilotEditStatus');
    this.pilotEditLimitHint = document.getElementById('pilotEditLimitHint');
    this.pilotEditSubmitBtn = document.getElementById('pilotEditSubmitBtn');
    this.pilotEditUndoBtn = document.getElementById('pilotEditUndoBtn');
    this.pilotEditAcceptBtn = document.getElementById('pilotEditAcceptBtn');
    this.pilotEditLoading = document.getElementById('pilotEditLoading');
    this.pilotEditVersionSlider = document.getElementById('pilotEditVersionSlider');
    this.pilotEditViewingIndex = -1;
    this.pilotEditSessionToken = null;
    /** pathname obrazu, dla którego wydano bieżący token (grant — tylko ten URL) */
    this.pilotEditTokenImageKey = null;
    /** Ostatni podpisany token łańcucha (session/grant) — do kontynuacji grantu po zmianie URL */
    this.pilotEditContinuationToken = null;
    this._pilotEditUsedCount = null;
    this._pilotEditUsageLimit = LUMLY_PILOT_EDIT_MAX_EDITS;
    this.pilotEditHistory = [];
    this.pilotEditBaseImageKey = null;
    this.pilotEditAnchorKey = null;
    this.pilotEditAnchorImageUrl = null;
    this.pilotEditInFlight = false;
    this.pilotEditAbortController = null;
    this.ensurePilotEditDom();
    this.applyPilotEditCohortVisibility();

    // 🆕 Tekst na obrazie (pilotaż)
    this.textOverlayPanel = document.getElementById('textOverlayPanel');
    this.textOverlayInput = document.getElementById('textOverlayInput');
    this.textOverlayCounter = document.getElementById('textOverlayCounter');
    this.textOverlaySaveBtn = document.getElementById('textOverlaySaveBtn');
    this.textOverlayHint = document.getElementById('textOverlayHint');
    this.textOverlayColorSelect = document.getElementById('textOverlayColorSelect');
    this.textOverlayFontSelect = document.getElementById('textOverlayFontSelect');
    this.textOverlaySizeSelect = document.getElementById('textOverlaySizeSelect');
    this.textOverlayToggleBtn = document.getElementById('textOverlayToggleBtn');
    this.textOverlayEnabled = this.isTextOverlayProduct();
    this.textOverlayState = {
      text: '',
      preset: 'classic',
      color: null,
      font: null,
      size: null,
      applied: false,
      previewUrl: null
    };
    this.textOverlayBaseImage = null; // Oryginał bez tekstu (URL z Blob)
    this.textOverlayWatermarkedUrl = null;
    this.textOverlayOriginalWatermarked = null;
    this.textOverlayDebounceTimer = null; // Timer dla debounce preview

    // 🎵 Spotify frame fields
    this.spotifyFieldsPanel = document.getElementById('spotifyFieldsPanel');
    this.spotifyTitleInput = document.getElementById('spotifyTitle');
    this.spotifyArtistInput = document.getElementById('spotifyArtist');
    this.spotifyCropModal = document.getElementById('spotifyCropModal');
    this.spotifyCropImage = document.getElementById('spotifyCropImage');
    this.spotifyCropConfirmBtn = document.getElementById('spotifyCropConfirmBtn');
    this.spotifyCropCancelBtn = document.getElementById('spotifyCropCancelBtn');
    this.spotifyCropper = null;
    this.spotifyCropSourceUrl = null;
    this.spotifyCropConfirmed = false;
    
    // 📱 Telefon - cropper
    this.phoneCropModal = document.getElementById('phoneCropModal');
    this.phoneCropImage = document.getElementById('phoneCropImage');
    this.phoneCropConfirmBtn = document.getElementById('phoneCropConfirmBtn');
    this.phoneCropCancelBtn = document.getElementById('phoneCropCancelBtn');
    this.phoneCropper = null;
    this.phoneCropSourceUrl = null;
    this.phoneCropConfirmed = false;
    this.phoneCropDataUrl = null;
    this.originalPhoneFile = null;
    
    // 📱 Telefon (etui) - osobny cropper
    this.phonePhotoCropModal = document.getElementById('phonePhotoCropModal');
    this.phonePhotoCropImage = document.getElementById('phonePhotoCropImage');
    this.phonePhotoCropConfirmBtn = document.getElementById('phonePhotoCropConfirmBtn');
    this.phonePhotoCropCancelBtn = document.getElementById('phonePhotoCropCancelBtn');
    this.phonePhotoCropper = null;
    this.phonePhotoCropSourceUrl = null;
    this.phonePhotoCropConfirmed = false;
    this.phonePhotoCropDataUrl = null;
    this.phonePhotoCropSourceIsWatermarked = false;
    this.originalPhonePhotoFile = null;

    // 👨‍👩‍👧 Portret rodzinny — crop poziomy per slot (jedna osoba)
    this.familyPortraitCropModal = document.getElementById('familyPortraitCropModal');
    this.familyPortraitCropImage = document.getElementById('familyPortraitCropImage');
    this.familyPortraitCropper = null;
    this.familyPortraitCropSourceUrl = null;
    this.familyPortraitCropPendingSlot = null;
    this.familyPortraitCropInputEl = null;

    this.selectedPhoneBrand = null;
    this.selectedPhoneModel = null;
    this.phoneModelsData = null;

    this.uploadedFile = null;
    this.selectedStyle = null;
    this.selectedSize = null;
    this.selectedProductType = 'plakat'; // Domyślny wybór: Plakat
    // Produkty tylko cyfrowe: wymuś digital zanim policzymy cenę
    if (this.isDigitalOnlyProduct && this.isDigitalOnlyProduct()) {
      this.selectedProductType = 'digital';
    }
    this.transformedImage = null;

    // 📸 Multi-upload (dodaj-osobe / kolaż MAMA)
    this.multiUploadFiles = Array(8).fill(null);
    this.multiUploadPreviews = Array(8).fill(null);
    
    // 🎨 GLFX Filters
    this.glfxInitialized = false;
    this.originalCroppedImage = null; // Oryginał przed filtrami
    this.filterConfig = null; // Konfiguracja filtrów z API
    this.filterConfigLoading = false; // Flaga ładowania
    
    // ✅ PENDING WATERMARK UPLOAD: Dane do wysłania jeśli użytkownik zmieni stronę
    this.pendingWatermarkUpload = null; // { generationId, watermarkedImage, customerId, email }
    this.watermarkUploadInProgress = false;
    this.sizePricing = {
      plakat: {
        a4: 0,   // Domyślny rozmiar - bez dopłaty
        a3: 9,
        a2: 30,
        a0: 45,  // Nowy rozmiar 50×75 cm
        a1: 60
      },
      canvas: {
        a4: 49,
        a3: 99,
        a2: 149,
        a0: 170,  // Nowy rozmiar 50×75 cm
        a1: 199
      },
      szklo: {               // 🆕 NOWY TYP: Nadruk na szkle
        a5: 0,               // Domyślny rozmiar - bez dopłaty (A5 = ~15×21 cm)
        a4: 30               // A4 dodaje 30 zł
      },
      spotify_frame: {
        a4: 0,   // Domyślny rozmiar - bez dopłaty
        a3: 9,
        a2: 30,
        a0: 45,
        a1: 60
      },
      etui: { etui: 0 }  // 📱 Etui - jeden rozmiar, cena z produktu
    };
    
    // Ceny ramek w zależności od rozmiaru (plakat)
    this.framePricing = {
      a4: 29,
      a3: 45,
      a2: 90,  // 40×60 cm, +20 zł
      a0: 105, // 50×75 cm, +20 zł
      a1: 110  // 60×90 cm, +10 zł
    };
    
    // Ceny ramek American Box dla obrazu na płótnie (canvas)
    this.canvasFramePricing = {
      a4: 79,   // 20x30
      a3: 119,  // 30x45
      a2: 149,  // 40x60
      a0: 189,  // 50x75
      a1: 229   // 60x90
    };
    
    // 🆕 Ceny podstawek (tylko dla szkła) - jedna cena dla wszystkich rozmiarów
    this.standPricing = {
      none: 0,             // Brak podstawki
      wood: 29,            // Podstawka drewniana/metalowa
      led: 39.90           // Podstawka z LED
    };
    
    if (window.LumlyPricingPreview) {
      window.LumlyPricingPreview.apply(this, window.LumlyPricingQAGroup);
    }
    this.init();

    // Udostępnij instancję globalnie do aktualizacji ceny z zewnątrz (np. wybór ramki)
    window.__customify = this;
    
    // ✅ PAGE UNLOAD PROTECTION: Obsługa zmiany/zamknięcia strony podczas upload watermarku
    this.setupPageUnloadProtection();
  }

  setupPageUnloadProtection() {
    // ✅ pagehide event - bardziej niezawodny niż beforeunload
    window.addEventListener('pagehide', (event) => {
      if (!event.persisted) {
        this._trackGenerationWaitLeave();
        // 📊 A/B pilot edycji: user zamknął stronę w trakcie poprawki AI (cicha rezygnacja)
        if (this.pilotEditInFlight && typeof window.trackProductAbMetric === 'function') {
          window.trackProductAbMetric('edit_leave');
        }
      }
      if (this.pendingWatermarkUpload && this.watermarkUploadInProgress) {
        console.warn('⚠️ [WATERMARK] Strona się zamyka - próbuję wysłać watermark przed zamknięciem...');
        
        // Spróbuj wysłać przez fetch z keepalive: true (kontynuuje request po zamknięciu strony)
        // ⚠️ LIMIT: keepalive ma limit ~64KB, ale spróbujemy (watermark może być większy)
        const payload = JSON.stringify({
          generationId: this.pendingWatermarkUpload.generationId,
          watermarkedImage: this.pendingWatermarkUpload.watermarkedImage,
          customerId: this.pendingWatermarkUpload.customerId,
          email: this.pendingWatermarkUpload.email
        });
        
        // Tylko jeśli payload jest mniejszy niż ~50KB (bezpieczny limit)
        if (payload.length < 50000) {
          try {
            navigator.sendBeacon(
              'https://customify-s56o.vercel.app/api/update-generation-watermark',
              new Blob([payload], { type: 'application/json' })
            );
            console.log('✅ [WATERMARK] Watermark wysłany przez sendBeacon przed zamknięciem strony');
          } catch (beaconError) {
            console.warn('⚠️ [WATERMARK] sendBeacon failed, próbuję fetch z keepalive...', beaconError);
            // Fallback: fetch z keepalive (może działać dla większych payloads)
            fetch('https://customify-s56o.vercel.app/api/update-generation-watermark', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: payload,
              keepalive: true // Kontynuuj request po zamknięciu strony
            }).catch(err => {
              console.warn('⚠️ [WATERMARK] Fetch z keepalive też nie zadziałał:', err);
            });
          }
        } else {
          console.warn('⚠️ [WATERMARK] Payload za duży dla sendBeacon/fetch keepalive (~' + Math.round(payload.length/1024) + 'KB) - watermark może nie zostać zapisany');
        }
      }
    });
  }

  /**
   * Stary overlay „Dodać napis?” po generacji (canvas w przeglądarce).
   * TYLKO karykatura-prezent-na-rocznice: styl „Karykatura” (Segmind) nie dokleja napisu do promptu.
   */
  isTextOverlayProduct() {
    return this.getProductHandle() === 'karykatura-prezent-na-rocznice-prezent-ze-zdjecia';
  }

  isSpotifyProduct() {
    const currentUrl = window.location.pathname.toLowerCase();
    return currentUrl.includes('ramka-spotify') || currentUrl.includes('zdjecie-na-szkle-ramka-spotify');
  }

  // ============================================================
  // CUSTOM FIELDS – pola personalizacji per produkt
  // ============================================================

  /** Zwraca handle produktu z URL (np. "obraz-ze-zdjecia-karykatura-na-50-ta-rocznice") */
  getProductHandle() {
    const parts = window.location.pathname.toLowerCase().split('/');
    const idx = parts.indexOf('products');
    return (idx !== -1 && parts[idx + 1]) ? parts[idx + 1].split('?')[0] : null;
  }

  /** Zwraca config pól dla bieżącego produktu lub null */
  getCustomFieldConfig() {
    const handle = this.getProductHandle();
    if (!handle) return null;
    if (handle === 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk') {
      const base = PRODUCT_FIELD_CONFIGS[handle];
      if (!base) return null;
      return {
        ...base,
        fields: [
          {
            id: 'family_background',
            label: 'Wybierz tło',
            type: 'family-select',
            defaultValue: 'studio',
            options: [
              ['photo', 'Z pierwszego zdjęcia'],
              ['studio', 'Jasne studio'],
              ['home', 'Przytulny dom'],
              ['garden', 'Ogród o zachodzie'],
              ['custom', 'Własna idea']
            ]
          },
          {
            id: 'family_background_desc',
            label: 'Opisz tło',
            type: 'text',
            placeholder: 'np. nasza ulubiona plaża o zachodzie słońca',
            required: false
          },
          {
            id: 'family_style',
            label: 'Styl portretu',
            type: 'family-select',
            defaultValue: 'photo',
            options: [
              ['photo', 'Naturalne zdjęcie'],
              ['watercolor', 'Akwarela'],
              ['oil', 'Olej'],
              ['sketch', 'Szkic']
            ]
          },
          {
            id: 'family_clothing',
            label: 'Wybierz stroje',
            type: 'family-select',
            defaultValue: 'original',
            options: [
              ['original', 'Zachowaj ubrania ze zdjęć'],
              ['casual', 'Spójne stroje casual'],
              ['elegant', 'Spójne stroje eleganckie']
            ]
          },
          {
            id: 'dedykacja',
            label: 'Napis / dedykacja (opcjonalnie)',
            type: 'text',
            placeholder: 'np. Zawsze razem',
            required: false
          }
        ]
      };
    }
    if (this.isCouplePortraitProduct()) {
      const coupleEffectDefault = handle.endsWith('-szkic')
        ? 'sketch'
        : handle.endsWith('-akwarela')
          ? 'watercolor'
          : 'photo';
      return {
        title: 'Personalizacja',
        multiUpload: true,
        maxImages: 2,
        fields: [
          {
            id: 'family_background',
            label: 'Wybierz tło',
            type: 'family-select',
            defaultValue: 'studio',
            options: [
              ['photo', 'Z pierwszego zdjęcia'],
              ['studio', 'Jasne studio'],
              ['home', 'Przytulny dom'],
              ['garden', 'Ogród o zachodzie słońca'],
              ['custom', 'Własny pomysł']
            ]
          },
          {
            id: 'family_background_desc',
            label: 'Opisz tło',
            type: 'text',
            placeholder: 'np. plaża o zachodzie słońca',
            required: false
          },
          {
            id: 'family_style',
            label: 'Wybierz efekt',
            type: 'family-select',
            defaultValue: coupleEffectDefault,
            options: [
              ['photo', 'Naturalne zdjęcie'],
              ['watercolor', 'Akwarela'],
              ['oil', 'Obraz olejny'],
              ['sketch', 'Szkic']
            ]
          },
          {
            id: 'family_clothing',
            label: 'Wybierz stroje',
            type: 'family-select',
            defaultValue: 'original',
            options: [
              ['original', 'Zachowaj ubrania ze zdjęć'],
              ['casual', 'Spójne stroje codzienne'],
              ['elegant', 'Spójne stroje eleganckie']
            ]
          },
          {
            id: 'dedykacja',
            label: 'Napis / dedykacja (opcjonalnie)',
            type: 'text',
            placeholder: 'np. Anna i Marek · 14.02.2020',
            required: false
          }
        ]
      };
    }
    return PRODUCT_FIELD_CONFIGS[handle] || null;
  }

  isCouplePortraitProduct() {
    const h = this.getProductHandle();
    return h === 'polacz-pare-na-wspolnym-obrazie-prezent-na-rocznice'
      || h === 'polacz-pare-na-wspolnym-obrazie-prezent-na-rocznice-akwarela'
      || h === 'polacz-pare-na-wspolnym-obrazie-prezent-na-rocznice-szkic';
  }

  isFamilyPortraitProduct() {
    return this.getProductHandle() === 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk'
      || this.isCouplePortraitProduct();
  }

  getFamilyPortraitCropConfig() {
    return {
      aspectRatio: 1,
      width: 1024,
      height: 1024,
      filePrefix: 'family-person-crop'
    };
  }

  /** Portret rodzinny: CropperJS nie jest w theme (limit 256KB) — ładujemy przy uploadzie jak na Gifted Photo */
  _ensureCropperJsLoaded() {
    if (typeof Cropper !== 'undefined') return Promise.resolve();
    if (this._cropperJsLoadPromise) return this._cropperJsLoadPromise;
    this._cropperJsLoadPromise = new Promise((resolve, reject) => {
      const cssId = 'customify-cropperjs-css';
      if (!document.getElementById(cssId)) {
        const link = document.createElement('link');
        link.id = cssId;
        link.rel = 'stylesheet';
        link.href = 'https://unpkg.com/cropperjs@1.6.2/dist/cropper.min.css';
        document.head.appendChild(link);
      }
      const existing = document.querySelector('script[data-customify-cropper]');
      if (existing) {
        if (typeof Cropper !== 'undefined') {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => reject(new Error('CropperJS load failed')), { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/cropperjs@1.6.2/dist/cropper.min.js';
      script.defer = true;
      script.dataset.customifyCropper = '1';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('CropperJS load failed'));
      document.head.appendChild(script);
    });
    return this._cropperJsLoadPromise;
  }

  getPersonalizationFieldValue(fieldId) {
    const cfg = this.getCustomFieldConfig();
    const field = cfg?.fields?.find((f) => f.id === fieldId);
    const el = document.getElementById(`customField_${fieldId}`);
    let value = el ? el.value.trim() : '';
    if (!value && field?.defaultValue) value = String(field.defaultValue).trim();
    return value;
  }

  /** Renderuje sekcję z polami personalizacji – wstawia przed actionsArea */
  renderCustomFields() {
    const config = this.getCustomFieldConfig();
    if (!config || !config.fields || config.fields.length === 0) return;
    if (document.getElementById('customFieldsArea')) return; // już wyrenderowane

    const actionsArea = document.getElementById('actionsArea');
    if (!actionsArea) return;

    const container = document.createElement('div');
    container.id = 'customFieldsArea';
    container.style.cssText = [
      'padding: 12px 16px',
      'margin: 8px 0 0 0',
      'border-top: 1px solid #e5e5e5',
      'border-bottom: 1px solid #e5e5e5',
      'background: #fafafa',
      'border-radius: 4px'
    ].join(';');

    // Placeholder bledszy — wstrzykuj styl (gwarantowane działanie)
    if (!document.getElementById('customify-placeholder-style')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'customify-placeholder-style';
      styleEl.textContent = '.customify-personalization-input::placeholder { color: #999 !important; opacity: 0.95 !important; }';
      document.head.appendChild(styleEl);
    }
    if (!document.getElementById('customify-orientation-radio-style')) {
      const orientStyle = document.createElement('style');
      orientStyle.id = 'customify-orientation-radio-style';
      orientStyle.textContent = `
#customify-app-container .customify-orientation-radio {
  display: flex;
  gap: 20px;
  margin-top: 6px;
  flex-wrap: wrap;
}
#customify-app-container .customify-orientation-radio__option {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  margin: 0;
  cursor: pointer;
  color: #222;
}
#customify-app-container .customify-orientation-radio__input {
  appearance: auto !important;
  -webkit-appearance: radio !important;
  display: inline-block !important;
  position: static !important;
  opacity: 1 !important;
  visibility: visible !important;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  padding: 0 !important;
  flex: 0 0 16px;
  accent-color: #777;
  cursor: pointer;
}
#customify-app-container .customify-orientation-radio__input:focus-visible {
  outline: 2px solid #222 !important;
  outline-offset: 3px;
}
#customify-app-container .customify-orientation-radio__icon {
  display: inline-block;
  flex-shrink: 0;
  border: 2px solid #333 !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-sizing: border-box;
}
#customify-app-container .customify-orientation-radio__icon--portrait {
  width: 20px;
  height: 28px;
}
#customify-app-container .customify-orientation-radio__icon--landscape {
  width: 28px;
  height: 20px;
}
#customify-app-container .customify-orientation-radio__label {
  font-size: 14px;
  font-weight: 500;
  color: #222;
  line-height: 1.2;
}`;
      document.head.appendChild(orientStyle);
    }

    const title = document.createElement('h4');
    title.textContent = config.title || 'Personalizacja';
    title.style.cssText = 'margin: 0 0 10px 0; font-size: 14px; font-weight: 600; color: #222;';
    container.appendChild(title);

    config.fields.forEach(field => {
      if (field.id === 'family_background_desc') return;

      const group = document.createElement('div');
      group.style.cssText = 'margin-bottom: 10px;';

      const label = document.createElement(field.type === 'orientation-radio' ? 'span' : 'label');
      if (label.tagName === 'LABEL') label.htmlFor = `customField_${field.id}`;
      label.textContent = field.label + (field.required ? ' *' : '');
      label.style.cssText = 'display: block; font-size: 13px; font-weight: 500; margin-bottom: 4px; color: #444;';
      group.appendChild(label);
      if (field.showWhen && field.showWhen.select && field.showWhen.value) {
        group.style.display = 'none';
        group.dataset.showWhenSelect = field.showWhen.select;
        group.dataset.showWhenValue = field.showWhen.value;
      }

      let input;
      if (field.type === 'orientation-radio') {
        const opts = (field.options || []).map((o) => (
          typeof o === 'string'
            ? { value: o, label: o, shape: o === 'Poziomy' ? 'landscape' : 'portrait' }
            : o
        ));
        input = document.createElement('input');
        input.type = 'hidden';
        input.id = `customField_${field.id}`;
        input.dataset.fieldId = field.id;
        if (field.required) input.dataset.required = 'true';
        const defaultVal = field.defaultValue || opts[0]?.value || '';
        input.value = opts.some((o) => o.value === defaultVal) ? defaultVal : (opts[0]?.value || '');

        const row = document.createElement('div');
        row.className = 'customify-orientation-radio';
        row.setAttribute('role', 'radiogroup');
        row.setAttribute('aria-label', field.label || 'Format obrazu');

        const syncOrientationRadios = () => {
          row.querySelectorAll('.customify-orientation-radio__input').forEach((radio) => {
            radio.checked = radio.value === input.value;
          });
        };

        opts.forEach((opt, index) => {
          const option = document.createElement('label');
          option.className = 'customify-orientation-radio__option';
          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.className = 'customify-orientation-radio__input';
          radio.name = `customify_orientation_${field.id}`;
          radio.id = `customField_${field.id}_${index}`;
          radio.value = opt.value;
          option.htmlFor = radio.id;

          const icon = document.createElement('span');
          icon.className = `customify-orientation-radio__icon customify-orientation-radio__icon--${opt.shape || 'portrait'}`;
          icon.setAttribute('aria-hidden', 'true');

          const caption = document.createElement('span');
          caption.className = 'customify-orientation-radio__label';
          caption.textContent = opt.label || opt.value;

          option.appendChild(radio);
          option.appendChild(icon);
          option.appendChild(caption);
          radio.addEventListener('change', () => {
            if (!radio.checked) return;
            input.value = radio.value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          row.appendChild(option);
        });

        input.addEventListener('change', syncOrientationRadios);
        syncOrientationRadios();
        group.appendChild(input);
        group.appendChild(row);
        container.appendChild(group);
        return;
      }
      if (field.type === 'family-select') {
        input = document.createElement('select');
        input.style.cssText = 'width: 100%; padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; background: white; cursor: pointer;';
        (field.options || []).forEach(([value, optionLabel]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = optionLabel;
          if (value === field.defaultValue) option.selected = true;
          input.appendChild(option);
        });
        input.id = `customField_${field.id}`;
        input.dataset.fieldId = field.id;
        group.appendChild(input);
        if (field.id === 'family_background') {
          const descField = config.fields.find((f) => f.id === 'family_background_desc');
          const customWrap = document.createElement('div');
          customWrap.id = 'familyBackgroundDescWrap';
          customWrap.style.cssText = 'display: none; margin-top: 8px;';
          const customLabel = document.createElement('label');
          customLabel.htmlFor = 'customField_family_background_desc';
          customLabel.style.cssText = 'display: block; font-size: 13px; font-weight: 500; margin-bottom: 4px; color: #444;';
          customLabel.textContent = 'Opisz tło *';
          const customInput = document.createElement('input');
          customInput.type = 'text';
          customInput.id = 'customField_family_background_desc';
          customInput.dataset.fieldId = 'family_background_desc';
          const ph = descField?.placeholder || 'np. nasza ulubiona plaża o zachodzie słońca';
          customInput.placeholder = ph;
          customInput.dataset.placeholder = ph;
          customInput.className = 'customify-personalization-input';
          customInput.style.cssText = 'width: 100%; padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; box-sizing: border-box;';
          customInput.addEventListener('focus', () => { customInput.placeholder = ''; });
          customInput.addEventListener('blur', () => {
            if (!customInput.value.trim()) customInput.placeholder = customInput.dataset.placeholder || ph;
          });
          const syncCustomBackgroundField = () => {
            const show = input.value === 'custom';
            customWrap.style.display = show ? 'block' : 'none';
            customInput.dataset.required = show ? 'true' : 'false';
          };
          input.addEventListener('change', syncCustomBackgroundField);
          syncCustomBackgroundField();
          customWrap.appendChild(customLabel);
          customWrap.appendChild(customInput);
          group.appendChild(customWrap);
        }
        container.appendChild(group);
        return;
      }
      if (field.type === 'select') {
        input = document.createElement('select');
        input.id = `customField_${field.id}`;
        input.style.cssText = 'width: 100%; padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; background: white; cursor: pointer;';
        if (!field.required) {
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = '-- wybierz --';
          input.appendChild(placeholder);
        }
        const populateOptions = (options) => {
          input.querySelectorAll('option:not(:first-child)').forEach(option => option.remove());
          (options || []).forEach(opt => {
            const option = document.createElement('option');
            option.value = opt;
            option.textContent = opt;
            input.appendChild(option);
          });
        };
        const getOptions = () => {
          if (!field.optionsByValue) return field.options;
          const parent = document.getElementById(`customField_${field.dependsOn}`);
          return field.optionsByValue[parent?.value] || [];
        };
        populateOptions(getOptions());
        if (field.defaultValue && getOptions().includes(field.defaultValue)) input.value = field.defaultValue;
        if (field.tileOptions) {
          input.style.display = 'none';
          const tiles = document.createElement('div');
          tiles.style.cssText = 'display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin: 6px 0 2px;';
          const syncTiles = () => {
            tiles.querySelectorAll('[data-session-tile]').forEach(tile => {
              const active = tile.dataset.sessionTile === input.value;
              tile.style.borderColor = active ? '#111' : '#d5d5d5';
              tile.style.boxShadow = active ? '0 0 0 2px rgba(17,17,17,.12)' : 'none';
            });
          };
          field.tileOptions.forEach(tileConfig => {
            const tile = document.createElement('button');
            tile.type = 'button';
            tile.dataset.sessionTile = tileConfig.value;
            tile.style.cssText = 'display: block; padding: 0; overflow: hidden; border: 2px solid #d5d5d5; border-radius: 8px; background: #fff; cursor: pointer; text-align: left; transition: border-color .15s, box-shadow .15s;';
            const image = document.createElement('img');
            image.src = tileConfig.image;
            image.alt = tileConfig.value;
            image.style.cssText = 'display: block; width: 100%; aspect-ratio: 3 / 4; object-fit: cover;';
            const tileText = document.createElement('span');
            tileText.style.cssText = 'display: block; padding: 8px 9px 9px; color: #222;';
            tileText.innerHTML = `<strong style="display:block; font-size:13px;">${tileConfig.value}</strong><small style="display:block; margin-top:3px; color:#666; font-size:11px; line-height:1.3;">${tileConfig.description || ''}</small>`;
            tile.appendChild(image);
            tile.appendChild(tileText);
            tile.addEventListener('click', () => {
              input.value = tileConfig.value;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              const background = document.getElementById('customField_tlo');
              if (background && tileConfig.backgroundOptions) {
                background.querySelectorAll('option:not(:first-child)').forEach(option => option.remove());
                tileConfig.backgroundOptions.forEach(optionValue => {
                  const option = document.createElement('option');
                  option.value = optionValue;
                  option.textContent = optionValue;
                  background.appendChild(option);
                });
                background.value = tileConfig.backgroundOptions[0] || '';
                background.dispatchEvent(new Event('change', { bubbles: true }));
              }
              syncTiles();
            });
            tiles.appendChild(tile);
          });
          input.addEventListener('change', syncTiles);
          group.appendChild(tiles);
          syncTiles();
        }
        if (field.optionsByValue && field.dependsOn) {
          const parent = document.getElementById(`customField_${field.dependsOn}`);
          parent?.addEventListener('change', () => {
            populateOptions(getOptions());
            input.value = getOptions()[0] || '';
            input.dispatchEvent(new Event('change'));
          });
        }
        if (field.customInput) {
          const customInput = document.createElement('input');
          customInput.type = 'text';
          customInput.id = `customField_${field.customInput.id}`;
          customInput.placeholder = field.customInput.placeholder || '';
          customInput.dataset.placeholder = customInput.placeholder;
          customInput.className = 'customify-personalization-input';
          customInput.style.cssText = 'display: none; width: 100%; margin-top: 6px; padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; box-sizing: border-box;';
          input.addEventListener('change', () => {
            customInput.style.display = input.value === 'Własny' || input.value === 'Własne' ? 'block' : 'none';
          });
          customInput.addEventListener('focus', () => { customInput.placeholder = ''; });
          customInput.addEventListener('blur', () => {
            if (!customInput.value.trim()) customInput.placeholder = customInput.dataset.placeholder || '';
          });
          group.appendChild(input);
          group.appendChild(customInput);
          container.appendChild(group);
          return;
        }
      } else {
        input = document.createElement('input');
        input.type = 'text';
        const ph = field.placeholder || '';
        input.placeholder = ph;
        input.dataset.placeholder = ph;
        input.className = 'customify-personalization-input';
        input.style.cssText = 'width: 100%; padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; box-sizing: border-box;';
        if (field.defaultValue) input.value = field.defaultValue;
        // Placeholder znika od razu przy focus (kliknięciu), wraca przy blur gdy puste
        input.addEventListener('focus', () => { input.placeholder = ''; });
        input.addEventListener('blur', () => { if (!input.value.trim()) input.placeholder = input.dataset.placeholder || ph; });
      }
      input.id = `customField_${field.id}`;
      input.dataset.fieldId = field.id;
      if (field.required) input.dataset.required = 'true';

      group.appendChild(input);
      container.appendChild(group);
    });

    const showWhenGroups = container.querySelectorAll('[data-show-when-select]');
    if (showWhenGroups.length > 0) {
      const updateConditionalFieldGroups = () => {
        showWhenGroups.forEach((grp) => {
          const selectId = grp.dataset.showWhenSelect;
          const wantValue = grp.dataset.showWhenValue;
          const sel = selectId ? document.getElementById(`customField_${selectId}`) : null;
          const show = !!(sel && sel.value === wantValue);
          grp.style.display = show ? 'block' : 'none';
          const inp = grp.querySelector('input, textarea, select');
          if (inp) inp.dataset.required = show ? 'true' : 'false';
          const lbl = grp.querySelector('label');
          const fieldId = inp?.dataset?.fieldId;
          const fieldDef = fieldId ? config.fields.find((f) => f.id === fieldId) : null;
          if (lbl && fieldDef) {
            lbl.textContent = show
              ? `${fieldDef.label} *`
              : fieldDef.label + (fieldDef.required ? ' *' : '');
          }
        });
      };
      const watchedSelectIds = new Set();
      showWhenGroups.forEach((grp) => {
        const id = grp.dataset.showWhenSelect;
        if (id) watchedSelectIds.add(id);
      });
      watchedSelectIds.forEach((selectId) => {
        const sel = document.getElementById(`customField_${selectId}`);
        if (sel) sel.addEventListener('change', updateConditionalFieldGroups);
      });
      updateConditionalFieldGroups();
    }

    // Odśwież pola zależne także po wyrenderowaniu całej sekcji.
    // Dzięki temu domyślna sesja od razu pokazuje właściwe tło.
    config.fields.filter(field => field.optionsByValue && field.dependsOn).forEach(field => {
      const parent = document.getElementById(`customField_${field.dependsOn}`);
      const dependent = document.getElementById(`customField_${field.id}`);
      if (!parent || !dependent) return;
      const refreshDependent = () => {
        const options = field.optionsByValue[parent.value] || [];
        dependent.querySelectorAll('option:not(:first-child)').forEach(option => option.remove());
        options.forEach(optionValue => {
          const option = document.createElement('option');
          option.value = optionValue;
          option.textContent = optionValue;
          dependent.appendChild(option);
        });
        dependent.value = field.defaultValue && options.includes(field.defaultValue)
          ? field.defaultValue
          : (options[0] || '');
        dependent.dispatchEvent(new Event('change', { bubbles: true }));
      };
      parent.addEventListener('change', refreshDependent);
      refreshDependent();
    });

    actionsArea.parentNode.insertBefore(container, actionsArea);
    console.log('🎛️ [CUSTOM-FIELDS] Wyrenderowano pola personalizacji dla:', this.getProductHandle());
  }

  /**
   * Zbiera wartości pól i buduje promptAddition.
   * Rzuca Error jeśli wymagane pole jest puste.
   * Zwraca null jeśli nie ma konfiguracji dla bieżącego produktu.
   */
  collectCustomFieldsPrompt() {
    const config = this.getCustomFieldConfig();
    if (!config) return null;

    const missingLabels = [];
    config.fields.forEach(field => {
      const el = document.getElementById(`customField_${field.id}`);
      const value = el ? el.value.trim() : '';
      const isRequired = field.required || el?.dataset?.required === 'true';
      if (isRequired && !value) missingLabels.push(field.label);
      if (field.customInput && (value === 'Własny' || value === 'Własne')) {
        const customEl = document.getElementById(`customField_${field.customInput.id}`);
        if (!customEl || !customEl.value.trim()) missingLabels.push(field.customInput.label);
      }
    });
    if (missingLabels.length > 0) {
      throw new Error(`Uzupełnij wymagane pola: ${missingLabels.join(', ')}`);
    }

    return null;
  }

  isCropperProduct() {
    return this.isSpotifyProduct() || this.isPhoneCaseProduct() || this.isPhonePhotoCaseProduct();
  }

  // 🎵 Produkt Spotify BEZ generacji AI - od razu do koszyka po kadrowanie
  isSpotifyNoAIProduct() {
    const currentUrl = window.location.pathname.toLowerCase();
    return currentUrl.includes('zdjecie-na-szkle-ramka-spotify');
  }

  // 📱 Produkt telefon
  isPhoneCaseProduct() {
    const currentUrl = window.location.pathname.toLowerCase();
    const isPhone = currentUrl.includes('personalizowane-etui-na-telefon-z-twoim-zdjeciem-karykatura');
    console.log('📱 [DEBUG] isPhoneCaseProduct:', { currentUrl, isPhone });
    return isPhone;
  }
  
  // 📱 Produkt etui (zdjęcie) - osobny cropper
  isPhonePhotoCaseProduct() {
    const currentUrl = window.location.pathname.toLowerCase();
    return currentUrl.includes('personalizowane-etui-na-telefon-z-twoim-zdjeciem') &&
      !currentUrl.includes('personalizowane-etui-na-telefon-z-twoim-zdjeciem-karykatura');
  }

  // 📸 Produkt multi-upload (dodaj osobę / kolaż)
  isMultiUploadProduct() {
    const h = this.getProductHandle();
    return h === 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk'
      || this.isCouplePortraitProduct()
      || h === 'kolaz-ze-zdjec-prezent-dla-mamy'
      || h === 'generator-zdjec-profilowych-ai';
  }

  getMultiUploadStyle() {
    const h = this.getProductHandle();
    if (h === 'kolaz-ze-zdjec-prezent-dla-mamy') return 'kolaz-mama';
    if (h === 'generator-zdjec-profilowych-ai') return 'linkedin-headshot';
    if (this.isCouplePortraitProduct()) return 'polacz-pare';
    return 'dodaj-osobe';
  }

  getMultiUploadMaxImages() {
    const config = this.getCustomFieldConfig();
    return config?.multiUpload ? (config.maxImages || 4) : 4;
  }

  requiresExactMultiUploadCount() {
    return this.getProductHandle() === 'kolaz-ze-zdjec-prezent-dla-mamy'
      || this.isCouplePortraitProduct();
  }

  isLinkedinHeadshotProduct() {
    return this.getProductHandle() === 'generator-zdjec-profilowych-ai';
  }

  setupMultiUpload() {
    if (!this.isMultiUploadProduct()) return;
    const grid = document.querySelector('.multi-upload-grid');
    if (!grid) return;
    const maxImages = parseInt(grid.dataset.maxImages, 10) || this.getMultiUploadMaxImages();
    this.multiUploadFiles = Array(maxImages).fill(null);
    this.multiUploadPreviews = Array(maxImages).fill(null);
    this.familyPhotoCaptions = Array(maxImages).fill('');
    const maxCounter = document.getElementById('multiUploadMax');
    if (maxCounter) maxCounter.textContent = String(maxImages);
    if (this.isFamilyPortraitProduct()) {
      grid.classList.add('multi-upload-grid--square');
      const modal = document.getElementById('familyPortraitCropModal');
      if (modal && modal.parentElement !== document.body) {
        document.body.appendChild(modal);
        this.familyPortraitCropModal = modal;
        this.familyPortraitCropImage = document.getElementById('familyPortraitCropImage');
      }
      this._ensureCropperJsLoaded().catch(() => {});
    }
    grid.querySelectorAll('.multi-upload-slot').forEach((slot, idx) => {
      const input = slot.querySelector('.multi-slot-input');
      const placeholder = slot.querySelector('.multi-slot-placeholder');
      const removeBtn = slot.querySelector('.multi-slot-remove');
      if (placeholder) {
        placeholder.addEventListener('click', () => input && input.click());
      }
      if (input) {
        input.addEventListener('change', (e) => {
          if (e.target.files && e.target.files[0]) {
            this.handleMultiFileSelect(e.target.files[0], idx);
          }
        });
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.removeMultiFile(idx);
        });
      }
    });
    console.log(`📸 [MULTI-UPLOAD] Setup complete, ${maxImages} slots ready`);
  }

  setupFamilyPhotoCaption(slot, idx) {
    const wrapper = document.createElement('div');
    wrapper.style.minWidth = '0';
    slot.parentNode.insertBefore(wrapper, slot);
    wrapper.appendChild(slot);
    const input = document.createElement('textarea');
    input.id = `familyPhotoCaption${idx}`;
    input.rows = 2;
    input.maxLength = 300;
    input.disabled = true;
    input.placeholder = this.isCouplePortraitProduct()
      ? 'np. tylko osoba po lewej'
      : 'np. babcia — tylko kobieta po lewej';
    input.style.cssText = 'display:block;box-sizing:border-box;width:100%;min-height:64px;margin-top:8px;font-size:16px;padding:8px;border:1px solid #ccc;border-radius:4px;resize:vertical;';
    input.addEventListener('input', () => { this.familyPhotoCaptions[idx] = input.value.slice(0, 300); });
    if (this.isCouplePortraitProduct()) {
      const label = document.createElement('label');
      label.htmlFor = input.id;
      label.textContent = `Kogo wziąć ze zdjęcia ${idx + 1}? (opcjonalnie)`;
      label.style.cssText = 'display:block;font-size:12px;line-height:1.35;margin:8px 0 4px;';
      input.style.marginTop = '0';
      wrapper.append(label, input);
    } else {
      wrapper.append(input);
    }
  }

  getFamilyPhotoEntries() {
    return this.multiUploadFiles.flatMap((file, index) => file ? [{
      file, caption: (this.familyPhotoCaptions?.[index] || '').trim().slice(0, 300)
    }] : []);
  }

  async handleMultiFileSelect(file, slotIndex) {
    if (!this._isImageFile(file)) {
      this.trackStatsEvent('image_upload_failed', {
        errorCode: 'INVALID_FILE_TYPE',
        errorMessage: 'Wybrany plik nie jest obrazem'
      });
      this.showError('Wybierz plik graficzny (JPG, PNG)', 'upload');
      return;
    }
    if (file.size > 15 * 1024 * 1024) {
      this.trackStatsEvent('image_upload_failed', {
        errorCode: 'FILE_TOO_LARGE',
        errorMessage: 'Plik jest za duży'
      });
      this.showError('Plik jest za duży (max 15MB)', 'upload');
      return;
    }
    try {
      file = await this._prepareUploadFile(file);
    } catch (error) {
      console.error('❌ [MULTI-UPLOAD] normalize failed:', error);
      this._reportToSentry(error, 'upload_normalize_multi', this.getUploadStatsContext(file, { slotIndex }));
      this.showError(error.message || 'Nie udało się wczytać zdjęcia. Spróbuj wybrać je jeszcze raz.', 'upload');
      return;
    }
    if (this.isFamilyPortraitProduct()) {
      const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
      this.familyPortraitCropPendingSlot = slotIndex;
      this.familyPortraitCropInputEl = slot?.querySelector('.multi-slot-input') || null;
      try {
        await this._ensureCropperJsLoaded();
      } catch (cropErr) {
        console.error('❌ [FAMILY-PORTRAIT] CropperJS:', cropErr);
        this.showError('Nie udało się załadować kadrowania. Odśwież stronę i spróbuj ponownie.', 'upload');
        if (this.familyPortraitCropInputEl) this.familyPortraitCropInputEl.value = '';
        this.familyPortraitCropPendingSlot = null;
        this.familyPortraitCropInputEl = null;
        return;
      }
      this.openFamilyPortraitCropper(file);
      return;
    }
    this.assignMultiUploadSlot(file, slotIndex);
  }

  assignMultiUploadSlot(file, slotIndex) {
    this.trackStatsEvent('image_upload');
    this.multiUploadFiles[slotIndex] = file;
    if (this.isFamilyPortraitProduct()) {
      // A replacement is a new reference: do not carry another person's description over.
      this.familyPhotoCaptions[slotIndex] = '';
      const captionInput = document.getElementById(`familyPhotoCaption${slotIndex}`);
      if (captionInput) { captionInput.value = ''; captionInput.disabled = false; }
      this.uploadedFile = this.getMultiUploadFiles()[0];
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      this.multiUploadPreviews[slotIndex] = e.target.result;
      const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
      if (slot) {
        const preview = slot.querySelector('.multi-slot-preview');
        const placeholder = slot.querySelector('.multi-slot-placeholder');
        const removeBtn = slot.querySelector('.multi-slot-remove');
        if (preview) {
          preview.style.backgroundImage = `url(${e.target.result})`;
          preview.style.display = 'block';
        }
        if (placeholder) placeholder.style.display = 'none';
        if (removeBtn) removeBtn.style.display = 'flex';
      }
      this.updateMultiUploadCounter();
      if (!this.uploadedFile) {
        this.uploadedFile = file;
      }
      this.trackStatsEvent('image_upload_preview_ready');
    };
    reader.onerror = () => {
      this.trackStatsEvent('image_upload_failed', {
        errorCode: 'FILE_READ_ERROR',
        errorMessage: 'Nie udało się odczytać pliku'
      });
      this.showError('Nie udało się odczytać pliku. Wybierz inne zdjęcie.', 'upload');
    };
    reader.readAsDataURL(file);
  }

  openFamilyPortraitCropper(file) {
    const modal = this.familyPortraitCropModal || document.getElementById('familyPortraitCropModal');
    const img = this.familyPortraitCropImage || document.getElementById('familyPortraitCropImage');
    if (!modal || !img) {
      console.warn('⚠️ [FAMILY-PORTRAIT] Brak modala crop — przypisuję plik bez kadrowania');
      const slotIndex = this.familyPortraitCropPendingSlot ?? 0;
      this.familyPortraitCropPendingSlot = null;
      this.familyPortraitCropInputEl = null;
      this.assignMultiUploadSlot(file, slotIndex);
      return;
    }
    if (typeof Cropper === 'undefined') {
      console.warn('⚠️ [FAMILY-PORTRAIT] CropperJS niedostępny po ensure');
      this.showError('Nie udało się uruchomić kadrowania. Odśwież stronę i spróbuj ponownie.', 'upload');
      if (this.familyPortraitCropInputEl) this.familyPortraitCropInputEl.value = '';
      this.familyPortraitCropPendingSlot = null;
      this.familyPortraitCropInputEl = null;
      return;
    }
    if (this.familyPortraitCropper) {
      this.familyPortraitCropper.destroy();
      this.familyPortraitCropper = null;
    }
    if (this.familyPortraitCropSourceUrl) {
      URL.revokeObjectURL(this.familyPortraitCropSourceUrl);
      this.familyPortraitCropSourceUrl = null;
    }
    this.familyPortraitCropSourceUrl = URL.createObjectURL(file);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const cropConfig = this.getFamilyPortraitCropConfig();
    const initCropper = () => {
      if (this.familyPortraitCropper) return;
      this.familyPortraitCropper = new Cropper(img, {
        aspectRatio: cropConfig.aspectRatio,
        viewMode: 1,
        autoCropArea: 0.9,
        responsive: true,
        movable: true,
        zoomable: true,
        zoomOnTouch: true,
        zoomOnWheel: false,
        background: false
      });
    };
    img.onload = () => {
      img.onload = null;
      requestAnimationFrame(() => requestAnimationFrame(initCropper));
    };
    img.src = this.familyPortraitCropSourceUrl;
    setTimeout(() => {
      const canvas = modal.querySelector('.phone-photo-crop-canvas');
      if (canvas && !document.getElementById('familyPortraitCropperHandlesStyle')) {
        const style = document.createElement('style');
        style.id = 'familyPortraitCropperHandlesStyle';
        style.textContent = '#familyPortraitCropModal .phone-photo-crop-canvas .cropper-point{width:20px!important;height:20px!important;background:#39f!important;border:2px solid #fff!important;box-shadow:0 0 0 1px rgba(0,0,0,.2)!important;z-index:10!important}#familyPortraitCropModal .phone-photo-crop-canvas .cropper-line,#familyPortraitCropModal .phone-photo-crop-canvas .cropper-face{border-color:#39f!important;border-width:2px!important;z-index:5!important}';
        document.head.appendChild(style);
      }
    }, 100);
  }

  closeFamilyPortraitCropper() {
    if (this.familyPortraitCropper) {
      this.familyPortraitCropper.destroy();
      this.familyPortraitCropper = null;
    }
    if (this.familyPortraitCropSourceUrl) {
      URL.revokeObjectURL(this.familyPortraitCropSourceUrl);
      this.familyPortraitCropSourceUrl = null;
    }
    const modal = this.familyPortraitCropModal || document.getElementById('familyPortraitCropModal');
    if (modal) {
      if (document.activeElement && modal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
    const img = this.familyPortraitCropImage || document.getElementById('familyPortraitCropImage');
    if (img) img.removeAttribute('src');
  }

  confirmFamilyPortraitCrop() {
    if (!this.familyPortraitCropper) return;
    const slotIndex = this.familyPortraitCropPendingSlot;
    if (slotIndex == null) return;
    const cropConfig = this.getFamilyPortraitCropConfig();
    const canvas = this.familyPortraitCropper.getCroppedCanvas({
      width: cropConfig.width,
      height: cropConfig.height,
      imageSmoothingQuality: 'high'
    });
    canvas.toBlob((blob) => {
      if (!blob) {
        this.showError('Nie udało się przyciąć zdjęcia', 'upload');
        return;
      }
      const croppedFile = new File(
        [blob],
        `${cropConfig.filePrefix}-slot${slotIndex + 1}-${Date.now()}.jpg`,
        { type: 'image/jpeg' }
      );
      this.closeFamilyPortraitCropper();
      this.familyPortraitCropPendingSlot = null;
      this.familyPortraitCropInputEl = null;
      this.assignMultiUploadSlot(croppedFile, slotIndex);
      this.hideError();
    }, 'image/jpeg', 0.9);
  }

  cancelFamilyPortraitCrop() {
    const slotIndex = this.familyPortraitCropPendingSlot;
    if (this.familyPortraitCropInputEl) {
      this.familyPortraitCropInputEl.value = '';
    } else if (slotIndex != null) {
      const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
      const input = slot?.querySelector('.multi-slot-input');
      if (input) input.value = '';
    }
    this.familyPortraitCropPendingSlot = null;
    this.familyPortraitCropInputEl = null;
    this.closeFamilyPortraitCropper();
  }

  removeMultiFile(slotIndex) {
    this.multiUploadFiles[slotIndex] = null;
    if (this.isFamilyPortraitProduct()) {
      this.familyPhotoCaptions[slotIndex] = '';
      const captionInput = document.getElementById(`familyPhotoCaption${slotIndex}`);
      if (captionInput) { captionInput.value = ''; captionInput.disabled = true; }
    }
    this.multiUploadPreviews[slotIndex] = null;
    const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
    if (slot) {
      const preview = slot.querySelector('.multi-slot-preview');
      const placeholder = slot.querySelector('.multi-slot-placeholder');
      const removeBtn = slot.querySelector('.multi-slot-remove');
      const input = slot.querySelector('.multi-slot-input');
      if (preview) { preview.style.backgroundImage = ''; preview.style.display = 'none'; }
      if (placeholder) placeholder.style.display = 'flex';
      if (removeBtn) removeBtn.style.display = 'none';
      if (input) input.value = '';
    }
    this.updateMultiUploadCounter();
    const remaining = this.getMultiUploadFiles();
    if (remaining.length === 0) this.uploadedFile = null;
    else this.uploadedFile = remaining[0];
  }

  updateMultiUploadCounter() {
    const counter = document.getElementById('multiUploadCount');
    if (counter) {
      const count = this.multiUploadFiles.filter(f => f !== null).length;
      counter.textContent = count;
    }
    const maxCounter = document.getElementById('multiUploadMax');
    if (maxCounter) {
      maxCounter.textContent = String(this.multiUploadFiles.length || this.getMultiUploadMaxImages());
    }
  }

  getMultiUploadFiles() {
    return this.multiUploadFiles.filter(f => f !== null);
  }

  // 💝 Produkty "dla niej" + Biznes Woman — jeden styl (caricature-new), bez wyboru, generacja bez klikania w miniaturkę
  isDlaNiejProduct() {
    const h = this.getProductHandle();
    return h === 'prezent-z-okazji-dnia-matki-personalizowany-fotoobraz-ze-zdjecia' || h === 'prezent-z-okazji-dnia-matki-personalizowany-plakat-pierwsze-nasze-swieto' || h === 'prezent-z-okazji-dnia-matki-kocia-mama-fotoobraz' || h === 'prezent-z-okazji-dnia-matki-personalizowany-obraz-supermama' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania' || h === 'obraz-ze-zdjecia-karykatura-dla-kelnerki' || h === 'obraz-ze-zdjecia-karykatura-kelnera' || h === 'obraz-ze-zdjecia-karykatura-rowerzysty-kolarza' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-policjantka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-rolniczka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-lekarka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-psycholog' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-kucharka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-fitness' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-szefowa' || h === 'karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny' || h === 'karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem' || h === 'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata' || h === 'motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego' || h === 'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny' || h === 'karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta' || h === 'personalizowany-obraz-karykatura-elektryka-ze-zdjecia-wyjatkowy-prezent' || h === 'portret-ze-zdjecia-hydraulik' || h === 'personalizowany-obraz-karykatura-ze-zdjecia-dla-mysliwego-wyjatkowy-prezent' || h === 'portret-spawacza-personalizowany-obraz-karykatura-ze-zdjecia-wyjatkowy-prezent' || h === 'personalizowany-obraz-karykatura-ze-zdjecia-dla-zolnierza-i-super-prezent' || h === 'pary-na-motocyklu-personalizowany-obraz-wyjatkowy-prezent-dla-motocyklistow' || h === 'karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty' || h === 'obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta' || h === 'obraz-ze-zdjecia-karykatura-szefa' || h === 'obraz-w-stylu-forbes-gold-ze-zdjecia-personalizowany-prezent-dla-mezczyzny' || h === 'plakat-w-stylu-forbes-silver-dla-mezczyzny-personalizowany-prezent-ze-zdjecia' || h === 'portret-w-stylu-elle-ze-zdjecia-personalizowany-prezent-dla-dziewczyny' || h === 'obraz-w-stylu-vogue-ceo-ze-zdjecia-personalizowany-prezent-dla-kobiety' || h === 'obraz-w-stylu-vogue-ze-zdjecia-classic-gold-personalizowany-prezent-dla-dziewczyny' || h === 'obraz-w-stylu-vogue-ze-zdjecia-party-personalizowany-prezent-dla-dziewczyny' || h === 'obraz-w-stylu-time-ze-zdjecia-personalizowany-prezent-dla-faceta' || h === 'plakat-w-stylu-time-ze-zdjecia-personalizowany-prezent-dla-kobiety' || h === 'plakat-w-stylu-mens-health-ze-zdjecia-personalizowany-prezent-dla-niego' || h === DIAMENTOWE_GODY_PRODUCT_HANDLE || h === WIESELI_STARUSZKOWIE_PRODUCT_HANDLE || h === PODROZNICY_PARA_PRODUCT_HANDLE || h === MLODA_PARA_SLUB_PRODUCT_HANDLE || h === ROCZNICA_SLUBU_PARA_PRODUCT_HANDLE || h === ROCZNICA_50_SLUBU_PRODUCT_HANDLE || h === ROCZNICA_40_SLUBU_PRODUCT_HANDLE || h === 'fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza' || h === 'portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka' || h === 'prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty' || h === 'prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz' || h === 'obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz' || h === 'active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle' || h === 'active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy' || h === 'portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa' || h === 'portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle' || h === 'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan' || h === 'portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent' || h === 'portret-dla-nauczycielki-ze-zdjecia-na-zkaonczenie-podziekowanie-prezent' || h === 'portret-nauczyciela-ze-zdjecia-na-zakonczenie-roku-podziekowanie' || h === 'obraz-ze-zdjecia-biznes-woman-personalizowany-prezent' || h === 'obraz-ze-zdjecia-prezent-na-30-urodziny-dla-kobiety-biznes-woman' || h === 'obraz-ze-zdjecia-prezent-na-50-urodziny-dla-kobiety-biznes-woman' || h === 'wydruk-na-szkle-biznes-woman-prezent-na-urodziny-dla-kobiety';
  }

  // 🦸 Produkt Superbohater dla chłopca — ukryty wybór, pole dedykacji
  isSuperheroBoyProduct() {
    return this.getProductHandle() === 'portret-ze-zdjecia-superbohater-prezent-dla-chlopca';
  }

  // 🦸 Produkt Superman — ukryty wybór, pole dedykacji
  isSupermanProduct() {
    return this.getProductHandle() === 'portret-superbohater-obraz-na-plotnie-z-twojego-zdjecia-superman';
  }

  // 🌹 Produkt Love Rose — jeden styl (love-rose), ukryty wybór, pole na napis zastępujący LOVE
  isLoveRoseProduct() {
    return this.getProductHandle() === 'prezent-na-walentynki-obraz-na-plotnie-z-twojego-zdjecia';
  }

  // 💕 Produkt Royal Love — jeden styl (royal-love), ukryty wybór, pole na napis zastępujący Neverending Love
  isRoyalLoveProduct() {
    return this.getProductHandle() === 'portret-zakochana-para-krolewska-prezent-na-walentynki-personalizowany';
  }

  // 🎮 Produkt GTA — jeden styl (gta), ukryty wybór, pole na napis na dole obrazka
  isGTAProduct() {
    return this.getProductHandle() === 'portret-w-stylu-gta-obraz-na-plotnie-z-twojego-zdjecia-super-prezent';
  }

  // ⚙️ Produkt Steampunk — jeden styl (steampunk), ukryty wybór, prompt jak GTA (GPT-Image-1.5)
  isSteampunkProduct() {
    return this.getProductHandle() === 'obraz-w-stylu-steampunk-personalizowany-z-twojego-zdjecia-na-prezent';
  }

  getActiveThemedPortraitStyle() {
    const h = this.getProductHandle();
    return (h && ACTIVE_THEMED_PORTRAIT_STYLE_BY_HANDLE[h]) || null;
  }

  isActiveThemedPortraitProduct() {
    return !!this.getActiveThemedPortraitStyle();
  }

  // 🎤 Produkt Hip-Hop — jeden styl (hiphop), ukryty wybór stylu
  isHipHopProduct() {
    const h = this.getProductHandle();
    return h === 'portret-w-stylu-hip-hop-obraz-na-plotnie-z-twojego-zdjecia' || h === 'portret-ze-zdjecia-hip-hop-personalizowany-obraz-na-plotnie';
  }

  isPilotEditCohortHandle() {
    const h = String(this.getProductHandle() || '').toLowerCase();
    return LUMLY_PILOT_EDIT_CORE_HANDLES.some((handle) => String(handle).toLowerCase() === h);
  }

  isPilotImageEditProduct() {
    if (!this.isPilotEditCohortHandle()) return false;
    const ab = typeof window.lumlyPilotAbActive === 'function' ? window.lumlyPilotAbActive() : null;
    return !!(
      ab
      && ab.experiment === LUMLY_PILOT_COHORT_EXPERIMENT_ID
      && ab.variant === 'B'
    );
  }

  ensurePilotEditDom() {
    if (!this.pilotEditBtn) this.pilotEditBtn = document.getElementById('pilotEditBtn');
    if (!this.pilotEditPanel) this.pilotEditPanel = document.getElementById('pilotEditPanel');
    if (!this.pilotEditInstruction) this.pilotEditInstruction = document.getElementById('pilotEditInstruction');
    if (!this.pilotEditStatus || !this.pilotEditStatus.isConnected) {
      this.pilotEditStatus = document.getElementById('pilotEditStatus');
    }
    if (!this.pilotEditLimitHint) this.pilotEditLimitHint = document.getElementById('pilotEditLimitHint');
    if (!this.pilotEditSubmitBtn) this.pilotEditSubmitBtn = document.getElementById('pilotEditSubmitBtn');
    if (!this.pilotEditAcceptBtn) this.pilotEditAcceptBtn = document.getElementById('pilotEditAcceptBtn');
    if (!this.pilotEditLoading) this.pilotEditLoading = document.getElementById('pilotEditLoading');
    if (!this.pilotEditVersionSlider) this.pilotEditVersionSlider = document.getElementById('pilotEditVersionSlider');
    if (!this.pilotEditStatus && this.pilotEditPanel) {
      const status = document.createElement('div');
      status.id = 'pilotEditStatus';
      status.className = 'pilot-edit-status';
      status.setAttribute('role', 'status');
      const after = this.pilotEditPanel.querySelector('#pilotEditInstructionBlock, .pilot-edit-instruction-block');
      if (after && after.parentNode === this.pilotEditPanel) after.after(status);
      else this.pilotEditPanel.insertBefore(status, this.pilotEditPanel.firstChild);
      this.pilotEditStatus = status;
    }
  }

  /** Kohorta A (kontrola): ukryj markup edycji z Liquid — tylko wariant B widzi UI. */
  applyPilotEditCohortVisibility() {
    if (!this.isPilotEditCohortHandle() || this.isPilotImageEditProduct()) return;
    const hide = (node) => {
      if (node) node.style.display = 'none';
    };
    hide(this.pilotEditBtn);
    hide(this.pilotEditPanel);
    hide(this.pilotEditLoading);
    hide(document.getElementById('pilotEditVersionSlider'));
  }

  normalizePilotEditImageKey(imageUrl) {
    if (!imageUrl || typeof imageUrl !== 'string' || !imageUrl.startsWith('http')) return '';
    try {
      return new URL(imageUrl).pathname.toLowerCase();
    } catch (_) {
      return imageUrl.split('?')[0].toLowerCase();
    }
  }

  getPilotEditSessionStore() {
    try {
      const raw = localStorage.getItem('customify_pilot_edit_sessions_v1');
      const parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (_) {
      return {};
    }
  }

  savePilotEditSessionStore(store) {
    try {
      const entries = Object.values(store || {}).filter((s) => s && s.anchorKey);
      entries.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
      const trimmed = {};
      entries.slice(0, 30).forEach((snap) => {
        trimmed[snap.anchorKey] = snap;
      });
      localStorage.setItem('customify_pilot_edit_sessions_v1', JSON.stringify(trimmed));
    } catch (e) {
      console.warn('[PILOT-EDIT-STORE] save failed', e);
    }
  }

  slimPilotEditHistoryEntry(state) {
    if (!state || typeof state !== 'object') return null;
    return {
      transformedImage: state.transformedImage || null,
      watermarkedImageUrl: state.watermarkedImageUrl || null,
      editSessionToken: state.editSessionToken || null
    };
  }

  decodePilotEditTokenPayload(token) {
    if (!token || typeof token !== 'string') return null;
    try {
      const encoded = token.split('.')[0];
      if (!encoded) return null;
      let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4) base64 += '=';
      return JSON.parse(atob(base64));
    } catch (_) {
      return null;
    }
  }

  getPilotEditUsageRequestBody() {
    const customerInfo = this.getCustomerInfo();
    return {
      customerId: customerInfo?.customerId || null,
      customerAccessToken: customerInfo?.customerAccessToken || null,
      productHandle: this.getProductHandle(),
      ...this.getLumlyAbRequestFields()
    };
  }

  applyPilotEditUsageFromApi(data) {
    if (!data || typeof data !== 'object') return;
    if (Number.isFinite(Number(data.usedCount))) {
      this._pilotEditUsedCount = Number(data.usedCount);
    }
    if (Number.isFinite(Number(data.totalLimit))) {
      this._pilotEditUsageLimit = Number(data.totalLimit);
    }
    this._pilotEditMaxReached = this.getPilotEditTotalUsed() >= this.getPilotEditUsageLimit();
  }

  getPilotEditUsageLimit() {
    return this._pilotEditUsageLimit || LUMLY_PILOT_EDIT_MAX_EDITS;
  }

  getPilotEditTotalUsed() {
    if (Number.isFinite(this._pilotEditUsedCount)) return this._pilotEditUsedCount;
    return 0;
  }

  async refreshPilotEditUsageFromServer() {
    if (!this.isPilotImageEditProduct()) return null;
    try {
      const resp = await fetch('https://customify-s56o.vercel.app/api/check-pilot-edit-usage', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(this.getPilotEditUsageRequestBody())
      });
      const data = await resp.json().catch(() => ({}));
      if (resp.ok && data.success) {
        this.applyPilotEditUsageFromApi(data);
        return data;
      }
    } catch (e) {
      console.warn('[PILOT-EDIT-USAGE]', e?.message || e);
    }
    return null;
  }

  getPilotEditChainEditCount() {
    return this.getPilotEditTotalUsed();
  }

  syncPilotEditChainMetaFromToken(token) {
    const payload = this.decodePilotEditTokenPayload(token);
    if (!payload) return;
    if (payload.type === 'session' || payload.type === 'grant') {
      this.pilotEditContinuationToken = token;
    }
  }

  setPilotEditSessionToken(token, imageUrlForToken) {
    this.pilotEditSessionToken = token || null;
    if (!token) {
      this.pilotEditTokenImageKey = null;
      return;
    }
    const raw = imageUrlForToken || this.transformedImage;
    if (raw && typeof raw === 'string' && !raw.startsWith('http') && raw.includes('/')) {
      this.pilotEditTokenImageKey = raw.toLowerCase();
    } else {
      this.pilotEditTokenImageKey = this.normalizePilotEditImageKey(raw);
    }
    this.syncPilotEditChainMetaFromToken(token);
  }

  /** Grant jest przypięty do jednego URL; sesja (po poprawce) — nie. */
  invalidatePilotEditTokenIfImageMismatch() {
    if (!this.pilotEditSessionToken || !this.transformedImage?.startsWith('http')) return;
    const curKey = this.normalizePilotEditImageKey(this.transformedImage);
    if (!curKey) return;

    const payload = this.decodePilotEditTokenPayload(this.pilotEditSessionToken);
    if (payload?.type === 'session') return;

    const tokenKey =
      this.pilotEditTokenImageKey
      || this.normalizePilotEditImageKey(this.pilotEditAnchorImageUrl);
    if (tokenKey && tokenKey !== curKey) {
      this.pilotEditContinuationToken = this.pilotEditSessionToken || this.pilotEditContinuationToken;
      this.syncPilotEditChainMetaFromToken(this.pilotEditContinuationToken);
      this.pilotEditSessionToken = null;
      this.pilotEditTokenImageKey = null;
    }
  }

  async fetchPilotEditGrantIfNeeded() {
    if (!this.isPilotImageEditProduct()) return false;
    if (!this.transformedImage?.startsWith('http')) return false;
    if (this.getPilotEditTotalUsed() >= this.getPilotEditUsageLimit()) return false;
    await this.refreshPilotEditUsageFromServer();
    if (this.getPilotEditTotalUsed() >= this.getPilotEditUsageLimit()) return false;
    this.invalidatePilotEditTokenIfImageMismatch();
    if (this.pilotEditSessionToken) return true;

    const continuationToken = this.pilotEditContinuationToken || null;

    try {
      const resp = await fetch('https://customify-s56o.vercel.app/api/pilot-edit-grant', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          productHandle: this.getProductHandle(),
          imageUrl: this.transformedImage,
          continuationToken,
          ...this.getPilotEditUsageRequestBody()
        })
      });
      const data = await resp.json().catch(() => ({}));
      if (resp.status === 429 && data.error === 'EDIT_LIMIT_REACHED') {
        this.applyPilotEditUsageFromApi({
          usedCount: data.usedCount ?? LUMLY_PILOT_EDIT_MAX_EDITS,
          totalLimit: data.totalLimit ?? LUMLY_PILOT_EDIT_MAX_EDITS
        });
        return false;
      }
      if (resp.ok && data.pilotEditSessionToken) {
        this.applyPilotEditUsageFromApi(data);
        this.setPilotEditSessionToken(data.pilotEditSessionToken, this.transformedImage);
        if (!this.pilotEditAnchorKey) {
          this.pilotEditAnchorKey = this.normalizePilotEditImageKey(this.transformedImage);
          this.pilotEditAnchorImageUrl = this.transformedImage;
          this.pilotEditBaseImageKey = this.pilotEditAnchorKey;
        }
        this.persistPilotEditSessionToStore();
        return true;
      }
      return false;
    } catch (e) {
      console.error('❌ [PILOT-GRANT]', e);
      return false;
    }
  }

  findPilotEditSnapshotForImage(imageUrl) {
    const key = this.normalizePilotEditImageKey(imageUrl);
    if (!key) return null;
    const store = this.getPilotEditSessionStore();
    if (store[key]) return store[key];
    for (const snap of Object.values(store)) {
      if (!snap || typeof snap !== 'object') continue;
      if (this.normalizePilotEditImageKey(snap.currentTransformedImage) === key) return snap;
      if (snap.anchorKey === key) return snap;
      if (
        Array.isArray(snap.history)
        && snap.history.some((h) => this.normalizePilotEditImageKey(h?.transformedImage) === key)
      ) {
        return snap;
      }
    }
    return null;
  }

  applyPilotEditSnapshot(snap, imageUrlForViewIndex) {
    if (!snap) return;
    this.pilotEditAnchorKey = snap.anchorKey || null;
    this.pilotEditBaseImageKey = snap.anchorKey || null;
    this.pilotEditAnchorImageUrl = snap.anchorImageUrl || null;
    this.pilotEditHistory = (Array.isArray(snap.history) ? snap.history : [])
      .map((h) => this.slimPilotEditHistoryEntry(h))
      .filter(Boolean);
    this.pilotEditContinuationToken = snap.chainContinuationToken || null;
    this.applyPilotEditUsageFromApi({
      usedCount: snap.chainEditCount,
      totalLimit: LUMLY_PILOT_EDIT_MAX_EDITS
    });
    this.setPilotEditSessionToken(
      snap.editSessionToken || null,
      snap.tokenImageKey || snap.currentTransformedImage || imageUrlForViewIndex || this.transformedImage
    );
    if (!this.pilotEditContinuationToken && snap.editSessionToken) {
      this.syncPilotEditChainMetaFromToken(snap.editSessionToken);
    }
    this.invalidatePilotEditTokenIfImageMismatch();

    const curKey = this.normalizePilotEditImageKey(imageUrlForViewIndex || this.transformedImage);
    let viewIdx = this.pilotEditHistory.length;
    for (let i = 0; i < this.pilotEditHistory.length; i += 1) {
      if (this.normalizePilotEditImageKey(this.pilotEditHistory[i].transformedImage) === curKey) {
        viewIdx = i;
        break;
      }
    }
    if (this.normalizePilotEditImageKey(snap.currentTransformedImage) === curKey) {
      viewIdx = this.pilotEditHistory.length;
    }
    this.pilotEditViewingIndex = viewIdx;
  }

  persistPilotEditSessionToStore() {
    if (!this.isPilotImageEditProduct()) return;
    const anchorKey =
      this.pilotEditAnchorKey
      || this.normalizePilotEditImageKey(this.pilotEditAnchorImageUrl || this.transformedImage);
    if (!anchorKey || !this.transformedImage?.startsWith('http')) return;

    const store = this.getPilotEditSessionStore();
    store[anchorKey] = {
      anchorKey,
      anchorImageUrl: this.pilotEditAnchorImageUrl || this.transformedImage,
      currentTransformedImage: this.transformedImage,
      currentWatermarkedImageUrl: this.watermarkedImageUrl || null,
      editSessionToken: this.pilotEditSessionToken || null,
      tokenImageKey: this.pilotEditTokenImageKey || null,
      chainContinuationToken: this.pilotEditContinuationToken || null,
      chainEditCount: this.getPilotEditTotalUsed(),
      history: this.pilotEditHistory.map((h) => this.slimPilotEditHistoryEntry(h)).filter(Boolean),
      updatedAt: Date.now()
    };
    this.savePilotEditSessionStore(store);
  }

  restorePilotEditSessionFromStore(imageUrl) {
    const snap = this.findPilotEditSnapshotForImage(imageUrl);
    if (!snap) return false;
    this.applyPilotEditSnapshot(snap, imageUrl);
    this.updatePilotEditVersionUI();
    return true;
  }

  generationUrlInLocalGallery(imageUrl) {
    const key = this.normalizePilotEditImageKey(imageUrl);
    if (!key) return false;
    return this.getAIGenerations().some(
      (g) => this.normalizePilotEditImageKey(g.transformedImage) === key
    );
  }

  postSaveGenerationV2ForPilotEdit({ transformedImage, watermarkedImageUrl, style, productType, galleryLabel }) {
    const customerInfo = this.getCustomerInfo();
    const ab = this.getLumlyAbRequestFields();
    const payload = {
      customerId: customerInfo?.customerId || null,
      email: customerInfo?.email || null,
      imageUrl: transformedImage,
      watermarkedImageUrl: watermarkedImageUrl || null,
      style: style || this.selectedStyle || 'unknown',
      size: this.selectedSize || 'a4',
      productType: productType || this.getProductTypeFromStyle(this.selectedStyle),
      productHandle: this.getProductHandle(),
      generationSource: 'pilot_edit',
      pilotEditAnchorKey: this.pilotEditAnchorKey || null,
      galleryLabel: galleryLabel || null,
      abExperiment: ab.abExperiment || null,
      abVariant: ab.abVariant || null
    };
    fetch('https://customify-s56o.vercel.app/api/save-generation-v2', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch((err) => console.warn('[PILOT-EDIT] save-generation-v2:', err?.message || err));
  }

  async savePilotEditAsGeneration({ transformedImage, watermarkedImageUrl, galleryLabel }) {
    if (!transformedImage?.startsWith('http')) return;
    if (this.generationUrlInLocalGallery(transformedImage)) return;
    const style = this.selectedStyle || 'caricature-new';
    const productType = this.getProductTypeFromStyle(style);
    const size = this.selectedSize || 'a4';
    const anchorKey =
      this.pilotEditAnchorKey
      || this.normalizePilotEditImageKey(this.pilotEditAnchorImageUrl || transformedImage);
    await this.saveAIGeneration(
      null,
      transformedImage,
      style,
      size,
      productType,
      watermarkedImageUrl || null,
      null,
      {
        isPilotEdit: true,
        galleryLabel: galleryLabel || 'Poprawka',
        pilotEditAnchorKey: anchorKey
      }
    );
    this.postSaveGenerationV2ForPilotEdit({
      transformedImage,
      watermarkedImageUrl,
      style,
      productType,
      galleryLabel
    });
  }

  async syncPilotEditVersionsToGallery() {
    if (!this.isPilotImageEditProduct()) return;
    const total = this.pilotEditHistory.length + 1;
    for (let i = 0; i < this.pilotEditHistory.length; i += 1) {
      const h = this.pilotEditHistory[i];
      const label = i === 0 && total <= 2 ? 'Wersja początkowa' : `Wersja ${i + 1}`;
      await this.savePilotEditAsGeneration({
        transformedImage: h.transformedImage,
        watermarkedImageUrl: h.watermarkedImageUrl,
        galleryLabel: label
      });
    }
    if (this.transformedImage?.startsWith('http')) {
      await this.savePilotEditAsGeneration({
        transformedImage: this.transformedImage,
        watermarkedImageUrl: this.watermarkedImageUrl,
        galleryLabel: total === 1 ? 'Generacja' : `Wersja ${total}`
      });
    }
  }

  /**
   * Wersje poprawek są przypisane do jednego obrazu bazowego.
   * Inny obraz = inna sesja; powrót do tego samego = odtworzenie miniaturek z localStorage.
   */
  resetPilotEditForNewBaseImage(options = {}) {
    if (!this.isPilotImageEditProduct()) return;
    const {
      closeEditor = true,
      newBaseUrl = null,
      clearInstruction = true
    } = options;

    this.persistPilotEditSessionToStore();

    this.pilotEditSessionToken = null;
    this.pilotEditTokenImageKey = null;
    this.pilotEditContinuationToken = null;
    this.pilotEditHistory = [];
    this.pilotEditViewingIndex = -1;
    this.pilotEditAnchorKey = null;
    this.pilotEditAnchorImageUrl = null;
    this.pilotEditBaseImageKey = null;

    if (clearInstruction && this.pilotEditInstruction) {
      this.pilotEditInstruction.value = '';
      this.updatePilotEditInstructionHighlight();
    }

    if (newBaseUrl) {
      const restored = this.restorePilotEditSessionFromStore(newBaseUrl);
      if (!restored) {
        this.pilotEditBaseImageKey = this.normalizePilotEditImageKey(newBaseUrl);
      }
    }

    if (closeEditor && this.pilotEditPanel?.classList.contains('is-open')) {
      this.closePilotImageEditor();
    } else {
      this.updatePilotEditVersionUI();
    }
    this.updatePilotEditUndoButton();
    this.syncPilotEditEntryUi();
  }

  /** Zwraca true, gdy trzeba nowego grantu (token wygasł / brak). */
  ensurePilotEditMatchesCurrentImage() {
    if (!this.isPilotImageEditProduct()) return false;
    const key = this.normalizePilotEditImageKey(this.transformedImage);
    if (!key) return false;

    const snap = this.findPilotEditSnapshotForImage(this.transformedImage);
    if (snap) {
      if (this.pilotEditAnchorKey !== snap.anchorKey || this.pilotEditHistory.length !== (snap.history || []).length) {
        this.applyPilotEditSnapshot(snap, this.transformedImage);
        this.updatePilotEditVersionUI();
      } else {
        this.invalidatePilotEditTokenIfImageMismatch();
      }
      return !this.pilotEditSessionToken;
    }

    if (this.pilotEditAnchorKey) {
      this.resetPilotEditForNewBaseImage({
        closeEditor: false,
        newBaseUrl: this.transformedImage,
        clearInstruction: false
      });
      this.invalidatePilotEditTokenIfImageMismatch();
      return !this.pilotEditSessionToken;
    }

    this.pilotEditBaseImageKey = key;
    this.invalidatePilotEditTokenIfImageMismatch();
    return !this.pilotEditSessionToken;
  }

  getLumlyAbRequestFields() {
    const ab = typeof window.getLumlyProductAbActive === 'function'
      ? window.getLumlyProductAbActive()
      : (typeof window.lumlyAbActive === 'function' ? window.lumlyAbActive() : null);
    if (!ab) return {};
    return {
      abExperiment: ab.experiment,
      abVariant: ab.variant,
      abVisitorId: ab.visitorId
    };
  }

  /** fresh = po generacji na stronie (CTA w zielonym komunikacie); gallery = reuse z galerii (przycisk pod obrazem) */
  setPilotEditEntryMode(mode) {
    this.pilotEditEntryMode = mode || null;
    this.syncPilotEditEntryUi();
  }

  getPilotEditFreshSuccessCtaHtml({ loggedIn = false } = {}) {
    const savedWhere = loggedIn
      ? 'Obraz wygenerowany poprawnie, zapisany w sekcji <a href="https://lumly.pl/pages/my-generations" target="_blank" rel="noopener">Moje obrazy</a>.'
      : 'Obraz wygenerowany poprawnie, zapisany w sekcji Twoje obrazy — poniżej.';
    return (
      '<div class="pilot-edit-success-cta">' +
      '<p class="pilot-edit-success-lead">' +
      '<span class="pilot-edit-success-check" aria-hidden="true">✓</span> ' +
      savedWhere +
      '<br>Możesz go <strong>zamówić</strong> lub jeszcze coś <strong>poprawić</strong>, usunąć (np. kolory, ubranie, tło, detale).' +
      '</p>' +
      '<button type="button" class="customify-btn customify-btn-secondary pilot-edit-success-btn" id="pilotEditSuccessBtn">Popraw obraz</button>' +
      '</div>'
    );
  }

  getPilotEditSavedSuccessMessage({ loggedIn = false } = {}) {
    return this.getPilotEditFreshSuccessCtaHtml({ loggedIn });
  }

  bindPilotEditSuccessButton() {
    if (!this.isPilotImageEditProduct() || !this.successMessage) return;
    const btn = document.getElementById('pilotEditSuccessBtn');
    if (!btn) return;
    if (btn.dataset.pilotBound === '1') return;
    btn.dataset.pilotBound = '1';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.openPilotImageEditor({ scrollToPanel: true });
    });
  }

  ensurePilotEditSuccessClickDelegation() {
    if (!this.isPilotImageEditProduct() || !this.successMessage) return;
    if (this.successMessage.dataset.pilotSuccessDelegated === '1') return;
    this.successMessage.dataset.pilotSuccessDelegated = '1';
    this.successMessage.addEventListener('click', (e) => {
      const btn = e.target.closest('#pilotEditSuccessBtn, .pilot-edit-success-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      this.openPilotImageEditor({ scrollToPanel: true });
    });
  }

  getPilotEditOpenErrorEl() {
    let el = document.getElementById('pilotEditOpenError');
    if (!el) {
      el = document.createElement('p');
      el.id = 'pilotEditOpenError';
      el.className = 'pilot-edit-open-error';
      el.setAttribute('role', 'alert');
    }
    return el;
  }

  showPilotEditOpenError(message, options = {}) {
    const raw = String(message || '').trim();
    const el = this.getPilotEditOpenErrorEl();
    if (options.html) {
      el.innerHTML = raw;
    } else {
      el.textContent = raw;
    }
    el.hidden = !raw;
    el.style.display = raw ? 'block' : 'none';
    if (!raw) return;

    const successBtn = document.getElementById('pilotEditSuccessBtn');
    const successCta = successBtn?.closest('.pilot-edit-success-cta');
    const bannerVisible = this.successMessage && this.successMessage.style.display !== 'none';
    const actionsWrap = document.getElementById('pilotUnderImageActions');
    if (bannerVisible && successCta) {
      successCta.appendChild(el);
    } else if (actionsWrap && actionsWrap.style.display !== 'none') {
      actionsWrap.after(el);
    } else if (this.pilotEditBtn?.parentNode) {
      this.pilotEditBtn.after(el);
    }
    const plain = options.html ? el.textContent.trim() : raw;
    this.setPilotEditStatus(plain, true);
    try {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } catch (_) {}
  }

  clearPilotEditOpenError() {
    const el = document.getElementById('pilotEditOpenError');
    if (el) {
      el.textContent = '';
      el.hidden = true;
      el.style.display = 'none';
    }
    this.setPilotEditStatus('');
  }

  syncPilotEditEntryUi() {
    if (!this.isPilotImageEditProduct() || !this.pilotEditBtn) return;
    this.syncPilotUnderImageActions();
  }

  layoutPilotUnderImageActions() {
    if (!this.isPilotImageEditProduct() || !this.pilotEditBtn) return;
    const imageWrap = document.getElementById('pilotEditImageWrap');
    if (!imageWrap) return;

    let actionsWrap = document.getElementById('pilotUnderImageActions');
    if (!actionsWrap) {
      actionsWrap = document.createElement('div');
      actionsWrap.id = 'pilotUnderImageActions';
      actionsWrap.className = 'pilot-under-image-actions';
    }

    const anchor = this.pilotEditVersionSlider || imageWrap;
    if (anchor.nextSibling !== actionsWrap) {
      anchor.after(actionsWrap);
    }

    actionsWrap.appendChild(this.pilotEditBtn);

    const tryAgainBtn = document.getElementById('tryAgainBtn');
    if (tryAgainBtn) {
      tryAgainBtn.textContent = 'Wgraj inne zdjęcie';
      tryAgainBtn.classList.add('pilot-upload-other-btn');
      actionsWrap.appendChild(tryAgainBtn);
    }

    if (this.pilotEditPanel && actionsWrap.nextSibling !== this.pilotEditPanel) {
      actionsWrap.after(this.pilotEditPanel);
    }

    this.syncPilotUnderImageActions();
  }

  syncPilotUnderImageActions() {
    if (!this.isPilotImageEditProduct()) return;
    const tryAgainBtn = document.getElementById('tryAgainBtn');
    const actionsWrap = document.getElementById('pilotUnderImageActions');
    const panelOpen = !!this.pilotEditPanel?.classList.contains('is-open');
    const hasResult = !!(this.transformedImage && String(this.transformedImage).startsWith('http'));
    const resultVisible =
      !!this.resultArea &&
      this.resultArea.style.display !== 'none' &&
      hasResult;
    const showEdit =
      this.pilotEditEntryMode === 'gallery' && !panelOpen && hasResult;
    const showTryAgain = resultVisible && !panelOpen;

    if (this.pilotEditBtn) {
      this.pilotEditBtn.style.display = showEdit ? '' : 'none';
    }
    if (tryAgainBtn) {
      tryAgainBtn.style.display = showTryAgain ? '' : 'none';
    }
    if (actionsWrap) {
      const showBar = !panelOpen && resultVisible && (showEdit || showTryAgain);
      actionsWrap.style.display = showBar ? 'flex' : 'none';
      actionsWrap.classList.toggle(
        'pilot-under-image-actions--solo',
        showTryAgain && !showEdit
      );
    }
  }

  hidePilotEditFreshBanner() {
    if (!this.isPilotImageEditProduct()) return;
    this.hideSuccess();
  }

  /** Kohorta edycji: personalizacja tylko przed generacją i po „Wgraj inne zdjęcie”. */
  setPilotEditPersonalizationFieldsVisible(visible) {
    if (!this.isPilotImageEditProduct()) return;
    const el = document.getElementById('customFieldsArea');
    if (el) el.style.display = visible ? '' : 'none';
  }

  syncPilotEditPersonalizationVisibility() {
    if (!this.isPilotImageEditProduct()) return;
    const hide =
      !!this.pilotEditPanel?.classList.contains('is-open')
      || !!this.pilotEditInFlight;
    this.setPilotEditPersonalizationFieldsVisible(!hide);
  }

  // 📷 Produkt Retusz starych zdjęć (prezent dla dziadków)
  isRetuszStarychZdjecProduct() {
    return this.getProductHandle() === 'prezent-dla-dziadkow-retusz-starych-zdjec';
  }

  // 🧑‍💼 Produkty tylko cyfrowe (bez druku)
  isDigitalOnlyProduct() {
    const h = this.getProductHandle();
    return h === 'prezent-dla-dziadkow-retusz-starych-zdjec'
      || h === 'generator-zdjec-profilowych-ai';
  }

  // ✏️ Produkt Szkic ołówkowy
  isSzkicOlowekProduct() {
    return this.getProductHandle() === 'szkic-ze-zdjecia-obraz-na-plotnie-plakat-ramka';
  }

  getFourWatercolourDefaultStyle() {
    const defaults = {
      'portret-ze-zdjecia-4-style-akwareli': 'watercolor-soft-wash',
      'obraz-ze-zdjecia-subtelna-akwarela': 'watercolor-soft-wash',
      'obraz-ze-zdjecia-akwarela-color-splash': 'watercolor-color-splash',
      'obraz-ze-zdjecia-akwarela-minimalistyczna': 'watercolor-delicate',
      'obraz-ze-zdjecia-klasyczna-akwarela': 'watercolor-classic-realistic',
    };
    return Object.prototype.hasOwnProperty.call(defaults, this.getProductHandle()) ? defaults[this.getProductHandle()] : null;
  }

  isFourWatercolourProduct() {
    return this.getFourWatercolourDefaultStyle() !== null;
  }

  setupFourWatercolourStyles() {
    if (!this.isFourWatercolourProduct() || !this.stylesArea) return;
    const styles = [
      ['watercolor-soft-wash', 'Subtelna akwarela'],
      ['watercolor-color-splash', 'Color Splash'],
      ['watercolor-delicate', 'Minimalistyczna'],
      ['watercolor-classic-realistic', 'Klasyczna akwarela']
    ];
    this.stylesArea.innerHTML = '<style>#stylesArea .customify-watercolour-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px}#stylesArea .customify-watercolour-grid .customify-style-card{min-width:0}#stylesArea .customify-watercolour-grid .style-name{display:block;font-size:13px;line-height:1.3;padding:6px 2px}@media(max-width:767px){#stylesArea .customify-watercolour-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}</style><h3>Wybierz styl portretu</h3><div class="customify-styles-grid customify-watercolour-grid">' + styles.map(([id, label]) =>
      `<button type="button" class="customify-style-card" data-style="${id}" style="display:block;width:100%;font:inherit;color:inherit;cursor:pointer"><img src="https://customify-s56o.vercel.app/watercolor-styles/${id}.jpg" alt="${label}" width="300" height="300" style="width:100%;height:auto;aspect-ratio:1;object-fit:cover;border-radius:8px"><span class="style-name">${label}</span></button>`
    ).join('') + '</div>';
    this.selectedStyle = this.getFourWatercolourDefaultStyle();
    this.stylesArea.querySelector(`[data-style="${this.selectedStyle}"]`).classList.add('active');
  }

  // 🎨 Produkt Akwarela — jeden styl (watercolor_ok), bez wyboru miniaturki
  isWatercolorAkwarelaProduct() {
    return this.getProductHandle() === 'obraz-ze-zdjecia-akwarela';
  }

  // 🎨 Prezent dla niej — Farby Olejne (oil-paints), napis w promptcie
  isOilPaintsHerProduct() {
    return this.getProductHandle() === 'obraz-ze-zdjecia-personalizowany-prezent-dla-niej-akwarela';
  }

  // Płaskie obrazy z napisem w AI (bez starego overlay po generacji)
  isFloatingTextPromptProduct() {
    return this.isWatercolorAkwarelaProduct()
      || this.isFourWatercolourProduct()
      || this.isSzkicOlowekProduct()
      || this.isOilPaintsHerProduct()
      || this.isActiveThemedPortraitProduct()
      || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-olowkiem-na-zamowienie';
  }

  getCropConfig() {
    return { aspectRatio: 1, width: 1024, height: 1024, filePrefix: 'spotify-crop' };
  }

  getPhoneCropConfig() {
    return { aspectRatio: 2 / 1, width: 2048, height: 1024, filePrefix: 'phone-crop' };
  }
  
  getPhonePhotoCropConfig() {
    return { aspectRatio: 1 / 2, width: 1000, height: 2000, filePrefix: 'phone-photo-crop' };
  }

  /** 📱 TYLKO etui: Inicjalizacja selektorów marka/model */
  async setupPhoneSelectors() {
    const slot = document.getElementById('phone-selectors-slot');
    if (!slot || !this.isPhonePhotoCaseProduct()) return;

    this.selectedPhoneBrand = null;
    this.selectedPhoneModel = null;
    this.phoneModelsData = null;

    try {
      const res = await fetch('https://customify-s56o.vercel.app/api/phone-models');
      if (!res.ok) throw new Error('HTTP ' + res.status);
      this.phoneModelsData = await res.json();
    } catch (err) {
      console.error('❌ [PHONE] Nie można załadować listy modeli:', err);
      this._reportToSentry(err, 'phone-models-load');
      slot.innerHTML = '<p class="customify-error">Nie można załadować listy modeli. Odśwież stronę.</p>';
      return;
    }

    const brands = this.phoneModelsData.brands || [];
    const modelsByBrand = this.phoneModelsData.models || {};
    if (brands.length === 0) {
      slot.innerHTML = '<p class="customify-error">Brak listy marek.</p>';
      return;
    }

    const wrap = document.createElement('div');
    wrap.className = 'phone-selectors-wrap';

    const brandField = document.createElement('div');
    brandField.className = 'phone-selector-field';
    const brandLabel = document.createElement('label');
    brandLabel.htmlFor = 'phoneBrandSelect';
    brandLabel.textContent = 'Wybierz markę telefonu';
    brandField.appendChild(brandLabel);
    const brandSelect = document.createElement('select');
    brandSelect.id = 'phoneBrandSelect';
    brandSelect.className = 'phone-selector-select';
    const brandOpt0 = document.createElement('option');
    brandOpt0.value = '';
    brandOpt0.textContent = 'Wybierz markę';
    brandSelect.appendChild(brandOpt0);
    brands.forEach(b => {
      const opt = document.createElement('option');
      opt.value = b.id;
      opt.textContent = b.name;
      brandSelect.appendChild(opt);
    });
    brandField.appendChild(brandSelect);
    wrap.appendChild(brandField);

    const modelField = document.createElement('div');
    modelField.className = 'phone-selector-field';
    const modelLabel = document.createElement('label');
    modelLabel.htmlFor = 'phoneModelSelect';
    modelLabel.textContent = 'Wybierz model telefonu';
    modelField.appendChild(modelLabel);
    const modelSelect = document.createElement('select');
    modelSelect.id = 'phoneModelSelect';
    modelSelect.className = 'phone-selector-select';
    modelSelect.disabled = true;
    const modelOpt0 = document.createElement('option');
    modelOpt0.value = '';
    modelOpt0.textContent = 'Najpierw wybierz markę';
    modelSelect.appendChild(modelOpt0);
    modelField.appendChild(modelSelect);
    wrap.appendChild(modelField);

    const populateModels = (brandId) => {
      modelSelect.innerHTML = '';
      const models = modelsByBrand[brandId] || [];
      if (!brandId || models.length === 0) {
        const ph = document.createElement('option');
        ph.value = '';
        ph.textContent = 'Najpierw wybierz markę';
        modelSelect.appendChild(ph);
        modelSelect.disabled = true;
        this.selectedPhoneModel = null;
        return;
      }
      const def = document.createElement('option');
      def.value = '';
      def.textContent = 'Wybierz model';
      modelSelect.appendChild(def);
      models.forEach(m => {
        const opt = document.createElement('option');
        opt.value = m.id;
        opt.textContent = m.name;
        modelSelect.appendChild(opt);
      });
      modelSelect.disabled = false;
    };

    brandSelect.addEventListener('change', () => {
      this.selectedPhoneBrand = brandSelect.value || null;
      this.selectedPhoneModel = null;
      populateModels(this.selectedPhoneBrand);
      this.hideError();
    });

    modelSelect.addEventListener('change', () => {
      this.selectedPhoneModel = modelSelect.value || null;
      if (this.selectedPhoneModel) this.hideError();
    });

    populateModels(null);
    slot.innerHTML = '';
    slot.appendChild(wrap);
    console.log('📱 [PHONE] Selektory marka/model zainicjalizowane');
  }

  getPhoneBrandLabel() {
    if (!this.selectedPhoneBrand || !this.phoneModelsData?.brands) return null;
    const b = this.phoneModelsData.brands.find(x => x.id === this.selectedPhoneBrand);
    return b ? b.name : this.selectedPhoneBrand;
  }

  getPhoneModelLabel() {
    if (!this.selectedPhoneBrand || !this.selectedPhoneModel || !this.phoneModelsData?.models) return null;
    const models = this.phoneModelsData.models[this.selectedPhoneBrand] || [];
    const m = models.find(x => x.id === this.selectedPhoneModel);
    return m ? m.name : this.selectedPhoneModel;
  }

  init() {
    if (!document.getElementById('uploadArea')) {
      return; // Jeśli nie ma elementów, nie rób nic
    }
    
    // ✅ STATS: Wyświetlenie strony produktu (każda odsłona = 1)
    try {
      const productPath = window.location.pathname || '';
      fetch('https://customify-s56o.vercel.app/api/admin/login-modal-stats', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventType: 'login_modal_page_entry',
          productUrl: productPath,
          timestamp: new Date().toISOString()
        })
      }).catch(() => {});
    } catch (_) {}
    
    this.setupFourWatercolourStyles();
    this.setupEventListeners();
    this.setupMultiUpload(); // 📸 Multi-upload slots (jeśli produkt je obsługuje)
    this.positionApp();
    this.showStyles(); // Pokaż style od razu
    this.renderCustomFields(); // Pola personalizacji (jeśli produkt je obsługuje)
    if (this.isFourWatercolourProduct()) {
      const dedication = document.getElementById('customField_imiona');
      if (dedication) dedication.maxLength = 80;
    }
    // filterStylesForProduct() USUNIĘTE - logika przeniesiona na server-side (Shopify Liquid)
    
    // Setup expandable description USUNIĘTE - opisy produktów są teraz pełne
    
    // Setup accordion for product details - BEZ setTimeout!
    this.setupAccordion();
    
    // ✅ USAGE LIMITS: Pokaż licznik użyć
    console.log('🔍 [INIT] Calling showUsageCounter()...');
    this.showUsageCounter().catch(error => {
      console.error('❌ [INIT] Error in showUsageCounter:', error);
    });
    
    // 🎨 GALERIA: Załaduj galerię przy starcie (jeśli są zapisane generacje)
    console.log('🎨 [GALLERY] Calling updateGallery from init()');
    this.updateGallery().catch(error => {
      console.error('❌ [GALLERY] Error updating gallery on init:', error);
    });
    
    // 💰 CENA: Ustaw domyślny rozmiar i aktualizuj cenę
    this.initializeDefaultPrice();

    // 🎯 SYNC: Zsynchronizuj początkowy typ produktu i rozmiar z aktywnymi przyciskami w DOM
    try {
      // ✅ Dla WSZYSTKICH produktów: użyj domyślnego z HTML (Plakat)
      const activeTypeBtn = document.querySelector('.customify-product-type-btn.active');
      if (activeTypeBtn && activeTypeBtn.dataset.productType) {
        this.selectedProductType = activeTypeBtn.dataset.productType;
        console.log('🔄 [INIT] Synced selectedProductType from DOM:', this.selectedProductType);
      }
      if (this.isDigitalOnlyProduct()) {
        this.selectedProductType = 'digital';
        console.log('📦 [INIT] Digital-only product → selectedProductType=digital');
      }
      const activeSizeBtn = document.querySelector('.customify-size-btn.active');
      if (activeSizeBtn && activeSizeBtn.dataset.size) {
        this.selectedSize = activeSizeBtn.dataset.size;
        console.log('🔄 [INIT] Synced selectedSize from DOM:', this.selectedSize);
      }
    } catch(e) {
      console.warn('⚠️ [INIT] Failed to sync initial selections from DOM:', e);
      this._reportToSentry(e, 'init-sync');
    }

    if (this.isSpotifyProduct()) {
      const szkloBtn = document.querySelector('.customify-product-type-btn[data-product-type="szklo"]');
      if (szkloBtn) {
        this.productTypeArea?.querySelectorAll('.customify-product-type-btn').forEach(btn => btn.classList.remove('active'));
        szkloBtn.classList.add('active');
        this.selectedProductType = 'szklo';
        console.log('🎵 [SPOTIFY] Ustawiam selectedProductType = szklo');
      }
      // 🎵 Ustaw domyślny rozmiar A5 (najtańszy) dla produktów Spotify
      const a5Btn = document.querySelector('.customify-size-btn[data-size="a5"]');
      if (a5Btn) {
        this.sizeArea?.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
        a5Btn.classList.add('active');
        this.selectedSize = 'a5';
        console.log('🎵 [SPOTIFY] Ustawiam domyślny rozmiar = a5 (15×21)');
      }
    }
    // 🎯 Rocznica 50-ta / Dla niej: domyślnie wydruk na szkle + rozmiar A5
    if (this.getProductHandle() === 'obraz-ze-zdjecia-pary-na-50-ta-rocznice-wydruk-na-szkle' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-na-50-ta-rocznice' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-kelnerki' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-kelnera' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-rowerzysty-kolarza' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-policjantka' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-rolniczka' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-lekarka' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-psycholog' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-kucharka' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-fitness' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-szefowa' || this.getProductHandle() === 'karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny' || this.getProductHandle() === 'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny' || this.getProductHandle() === 'karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta' || this.getProductHandle() === 'personalizowany-obraz-karykatura-elektryka-ze-zdjecia-wyjatkowy-prezent' || this.getProductHandle() === 'portret-ze-zdjecia-hydraulik' || this.getProductHandle() === 'personalizowany-obraz-karykatura-ze-zdjecia-dla-mysliwego-wyjatkowy-prezent' || this.getProductHandle() === 'portret-spawacza-personalizowany-obraz-karykatura-ze-zdjecia-wyjatkowy-prezent' || this.getProductHandle() === 'personalizowany-obraz-karykatura-ze-zdjecia-dla-zolnierza-i-super-prezent' || this.getProductHandle() === 'pary-na-motocyklu-personalizowany-obraz-wyjatkowy-prezent-dla-motocyklistow' || this.getProductHandle() === 'karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem' || this.getProductHandle() === 'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata' || this.getProductHandle() === 'motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego' || this.getProductHandle() === 'karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta' || this.getProductHandle() === 'obraz-ze-zdjecia-karykatura-szefa' || this.getProductHandle() === DIAMENTOWE_GODY_PRODUCT_HANDLE || this.getProductHandle() === WIESELI_STARUSZKOWIE_PRODUCT_HANDLE || this.getProductHandle() === PODROZNICY_PARA_PRODUCT_HANDLE || this.getProductHandle() === MLODA_PARA_SLUB_PRODUCT_HANDLE || this.getProductHandle() === ROCZNICA_SLUBU_PARA_PRODUCT_HANDLE || this.getProductHandle() === 'fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza' || this.getProductHandle() === 'portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka' || this.getProductHandle() === 'prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty' || this.getProductHandle() === 'prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz' || this.getProductHandle() === 'obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz' || this.getProductHandle() === 'active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle' || this.getProductHandle() === 'active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy' || this.getProductHandle() === 'portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa' || this.getProductHandle() === 'portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle' || this.getProductHandle() === 'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan' || this.getProductHandle() === 'portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent' || this.getProductHandle() === 'portret-dla-nauczycielki-ze-zdjecia-na-zkaonczenie-podziekowanie-prezent' || this.getProductHandle() === 'portret-nauczyciela-ze-zdjecia-na-zakonczenie-roku-podziekowanie' || this.getProductHandle() === 'obraz-ze-zdjecia-prezent-na-50-urodziny-dla-kobiety-biznes-woman' || this.getProductHandle() === 'wydruk-na-szkle-biznes-woman-prezent-na-urodziny-dla-kobiety') {
      const szkloBtn = document.querySelector('.customify-product-type-btn[data-product-type="szklo"]');
      if (szkloBtn) {
        this.productTypeArea?.querySelectorAll('.customify-product-type-btn').forEach(btn => btn.classList.remove('active'));
        szkloBtn.classList.add('active');
        this.selectedProductType = 'szklo';
      }
      const a5Btn = document.querySelector('.customify-size-btn[data-size="a5"]');
      if (a5Btn) {
        this.sizeArea?.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
        a5Btn.classList.add('active');
        this.selectedSize = 'a5';
        console.log('🎯 [ROCZnica] Domyślnie: wydruk na szkle, rozmiar A5');
      }
    }
    this.updateSpotifyFrameScale();
    window.addEventListener('resize', () => this.updateSpotifyFrameScale());

    // Zaktualizuj dostępność rozmiarów po początkowej synchronizacji
    this.updateSizeAvailability();

    // Po synchronizacji wymuś przeliczenie cen (uwzględnia ramkę, jeśli plakat)
    this.updateProductPrice();
    this.updateCartPrice();

    // 📱 Phone case: Hide main cart price (phone case has its own price display)
    if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
      const cartPriceDisplay = document.getElementById('cartPriceDisplay');
      if (cartPriceDisplay) cartPriceDisplay.style.display = 'none';
      const phoneCaseCartPriceDisplay = document.getElementById('phoneCaseCartPriceDisplay');
      if (phoneCaseCartPriceDisplay) phoneCaseCartPriceDisplay.style.setProperty('display','none','important');
      const phoneCaseCartActions = document.getElementById('phoneCaseCartActions');
      if (phoneCaseCartActions) phoneCaseCartActions.style.setProperty('display','none','important');
      this.setupPhoneSelectors().catch(err => console.error('❌ [PHONE] setupPhoneSelectors error:', err));
    }

    // 🆕 Inicjalizacja napisów (pilotaż)
    this.setupTextOverlayUI();
  }
  

  // ===== USAGE LIMITS FUNCTIONS =====
  
  /**
   * Pobiera informacje o zalogowanym użytkowniku Shopify
   * @returns {Object|null} {customerId, email, customerAccessToken} lub null jeśli niezalogowany
   */
  getCustomerInfo() {
    // ⚠️ KRYTYCZNE: Jeśli Shopify Liquid mówi że użytkownik NIE jest zalogowany,
    // to NIE sprawdzaj fallbacków - po prostu zwróć null
    // Sprawdź czy window.ShopifyCustomer istnieje i ma wartość (nie null, nie undefined, nie false)
    if (!window.ShopifyCustomer || window.ShopifyCustomer === null) {
      return null;
    }
    
    const sanitizeId = (value) => {
      if (value === null || value === undefined) {
        return null;
      }
      if (typeof value === 'object' && value.id) {
        return sanitizeId(value.id);
      }
      const idStr = String(value).trim();
      if (!idStr || idStr.toLowerCase() === 'null' || idStr.toLowerCase() === 'undefined') {
        return null;
      }
      return idStr;
    };
    
    const sanitizeEmail = (value) => {
      if (!value) {
        return null;
      }
      const emailStr = String(value).trim();
      if (!emailStr || emailStr.toLowerCase() === 'null' || emailStr.toLowerCase() === 'undefined') {
        return null;
      }
      return emailStr;
    };
    
    const getStoredValue = (key) => {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    };
    
    const persistCustomerContext = (info, source) => {
      if (!info || !info.customerId) {
        return null;
      }
      try {
        localStorage.setItem('customify_last_customer_id', info.customerId);
        if (info.email) {
          localStorage.setItem('customify_last_customer_email', info.email);
        }
      } catch (e) {
        // Ignore storage errors (Safari private mode etc.)
      }
      if (source) {
        // ⚠️ DEBUG: Sprawdź czy window.ShopifyCustomer jest null przed logowaniem
        if (window.ShopifyCustomer === null) {
          console.warn(`⚠️ [CUSTOMER DETECT] BŁĄD: Próba użycia ${source} gdy window.ShopifyCustomer === null!`);
          console.warn(`⚠️ [CUSTOMER DETECT] window.ShopifyCustomer:`, window.ShopifyCustomer);
          console.warn(`⚠️ [CUSTOMER DETECT] Zwracam null zamiast info z ${source}`);
          return null; // ⚠️ ZWRÓĆ NULL jeśli window.ShopifyCustomer jest null!
        }
        // Klient zidentyfikowany (bez logowania customerId)
      }
      return info;
    };
    const buildCustomerInfo = (idCandidate, emailCandidate, source) => {
      // ⚠️ KRYTYCZNE: Jeśli window.ShopifyCustomer jest null, NIE buduj customerInfo z fallbacków
      if (window.ShopifyCustomer === null || window.ShopifyCustomer === undefined) {
        console.warn(`⚠️ [CUSTOMER DETECT] buildCustomerInfo zablokowane - window.ShopifyCustomer jest null/undefined (source: ${source})`);
        return null;
      }
      
      const customerId = sanitizeId(idCandidate);
      if (!customerId) {
        return null;
      }
      const fallbackEmail = sanitizeEmail(emailCandidate) ||
        sanitizeEmail(getStoredValue('customify_last_customer_email')) ||
        'no-email@shopify.com';
      return persistCustomerContext({
        customerId,
        email: fallbackEmail,
        firstName: window.ShopifyCustomer?.firstName || '',
        lastName: window.ShopifyCustomer?.lastName || '',
        customerAccessToken: 'oauth_session'
      }, source);
    };
    const getShopifyCustomerField = (field) => {
      if (!window.ShopifyCustomer) {
        return null;
      }
      if (field in window.ShopifyCustomer) {
        return window.ShopifyCustomer[field];
      }
      const lowerField = field.toLowerCase();
      for (const key of Object.keys(window.ShopifyCustomer)) {
        if (key.toLowerCase() === lowerField) {
          return window.ShopifyCustomer[key];
        }
      }
      return null;
    };
    
    // METODA 1: NOWY SYSTEM - window.ShopifyCustomer (z Liquid w theme.liquid)
    // ⚠️ Sprawdź czy window.ShopifyCustomer istnieje i NIE jest null/undefined
    if (window.ShopifyCustomer && window.ShopifyCustomer !== null && (getShopifyCustomerField('id') || getShopifyCustomerField('customerId'))) {
      const shopifyId = getShopifyCustomerField('id') || getShopifyCustomerField('customerId');
      const shopifyEmail = getShopifyCustomerField('email') || null;
      return buildCustomerInfo(shopifyId, shopifyEmail, 'ShopifyCustomer');
    }
    
    // METODA 1B: Shopify Analytics (fallback)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nie null)
    if (window.ShopifyCustomer !== null && window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
      const analyticsMeta = window.ShopifyAnalytics.meta;
      const analyticsId =
        analyticsMeta.page?.customerId ??
        analyticsMeta.customerId ??
        analyticsMeta.page?.customer_id ??
        analyticsMeta.customer_id ??
        null;
      const analyticsEmail =
        analyticsMeta.page?.customerEmail ??
        analyticsMeta.customerEmail ??
        analyticsMeta.page?.customer_email ??
        analyticsMeta.customer_email ??
        null;
      
      const analyticsInfo = buildCustomerInfo(analyticsId, analyticsEmail, 'ShopifyAnalytics.meta');
      if (analyticsInfo) {
        return analyticsInfo;
      }
    }
    
    // METODA 1C: window.meta (Shopify storefront meta object)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nie null)
    if (window.ShopifyCustomer !== null && window.meta) {
      const metaId = window.meta.page?.customerId ?? window.meta.customerId ?? null;
      const metaEmail = window.meta.page?.customerEmail ?? window.meta.customerEmail ?? null;
      
      const metaInfo = buildCustomerInfo(metaId, metaEmail, 'window.meta');
      if (metaInfo) {
        return metaInfo;
      }
    }
    
    // METODA 1D: Shopify tracking object (__st)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nie null)
    if (window.ShopifyCustomer !== null) {
      const shopifyTrackingId = window.__st ? window.__st.cid : null;
      if (shopifyTrackingId) {
        const trackingInfo = buildCustomerInfo(shopifyTrackingId, getStoredValue('customify_last_customer_email'), '__st.cid');
        if (trackingInfo) {
          return trackingInfo;
        }
      }
    }
    
    // METODA 2: FALLBACK - Sprawdź cookie Shopify (customer_id)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nie null)
    if (window.ShopifyCustomer !== null) {
      const cookies = document.cookie.split(';').map(c => c.trim());
      if (cookies.length > 0) {
        const customerIdCookie = cookies.find(c => c.startsWith('customer_id='));
        if (customerIdCookie) {
          const cookieId = sanitizeId(customerIdCookie.split('=')[1]);
          const cookieInfo = buildCustomerInfo(cookieId, getStoredValue('customify_last_customer_email') || window.ShopifyCustomer?.email, 'customer_id cookie');
          if (cookieInfo) {
            return cookieInfo;
          }
        }
      }
    }
    
    // METODA 3: Pamięć lokalna (ostatni znany zalogowany użytkownik)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nawet jeśli nie ma ID)
    // Jeśli window.ShopifyCustomer jest null = użytkownik NIE jest zalogowany w Shopify
    if (window.ShopifyCustomer !== null && window.ShopifyCustomer !== undefined) {
      const storedId = sanitizeId(getStoredValue('customify_last_customer_id'));
      if (storedId) {
        return buildCustomerInfo(storedId, getStoredValue('customify_last_customer_email'), 'localStorage');
      }
    }
    
    // METODA 4: STARY SYSTEM - window.Shopify.customerEmail (Classic Customer Accounts)
    if (window.Shopify && window.Shopify.customerEmail) {
      const legacyId = sanitizeId(window.meta?.customer?.id || window.ShopifyCustomer?.id || getStoredValue('customify_last_customer_id'));
      const legacyEmail = sanitizeEmail(window.Shopify.customerEmail) || getStoredValue('customify_last_customer_email');
      const legacyToken = getStoredValue('shopify_customer_access_token') || 'oauth_session';
      
      if (legacyId) {
        return persistCustomerContext({
          customerId: legacyId,
          email: legacyEmail || 'legacy-user@shopify.com',
          customerAccessToken: legacyToken
        }, 'Shopify.customerEmail');
      }
    }
    
    // No customer detected
    return null;
  }

  /**
   * Sprawdza liczbę użyć z localStorage (dla niezalogowanych)
   * @returns {number} Liczba użyć
   */
  /**
   * Określa productType na podstawie STRONY (URL) - to jest najważniejsze!
   * Strona = Produkt = Cena (król ma inną cenę niż boho)
   */
  getProductTypeFromStyle(style) {
    if (this.isFourWatercolourProduct() || /^watercolor-(soft-wash|color-splash|delicate|classic-realistic)$/.test(style || '')) return 'caricature-new';
    // 🎯 PRIORYTET 1: Sprawdź URL strony (NAJWAŻNIEJSZE - określa cenę!)
    const currentUrl = window.location.pathname.toLowerCase();
    
    console.log('🔍 [PRODUCT-TYPE] Sprawdzam URL:', currentUrl);

    const activeThemedStyle = this.getActiveThemedPortraitStyle();
    if (activeThemedStyle) {
      return activeThemedStyle;
    }
    
    // Mapuj URL → productType (określa który produkt Shopify = jaka cena)
    if (currentUrl.includes('krol-portret') || currentUrl.includes('krol-personalizowany') || currentUrl.includes('portret-krola-polski')) {
      console.log('👑 [PRODUCT-TYPE] URL = Król → productType: king');
      return 'king';
    }
    if (currentUrl.includes('koty-krolewskie') || currentUrl.includes('krolewskie-portrety-kotow')) {
      console.log('🐱 [PRODUCT-TYPE] URL = Koty → productType: cats');
      return 'cats';
    }
    if (currentUrl.includes('obraz-w-stylu-pop-art-z-twojego-zdjecia-personalizowany-na-prezent')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Pop Art → productType: pop_art');
      return 'pop_art';
    }

    if (currentUrl.includes('personalizowany-obraz-3d-cartoon-ilustracja-z-twojego-zdjecia')) {
      console.log('🎨 [PRODUCT-TYPE] URL = 3D Cartoon → productType: 3d_cartoon');
      return '3d_cartoon';
    }

    if (currentUrl.includes('portret-z-efektem-farb-olejnych-z-twojego-zdjecia-na-prezent')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Farby Olejne → productType: oil_paints');
      return 'oil_paints';
    }

    if (currentUrl.includes('obraz-olejny-portret-na-plotnie-z-twojego-zdjecia')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Obraz Olejny → productType: oil_painting');
      return 'oil_painting';
    }

    if (currentUrl.includes('obraz-ze-zdjecia-personalizowany-prezent-dla-niej-akwarela')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Prezent dla Niej (Farby Olejne) → productType: oil_paints');
      return 'oil_paints';
    }
    if (currentUrl.includes('personalizowany-portret-w-stylu-boho')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Boho → productType: boho');
      return 'boho';
    }
    if (currentUrl.includes('portret-superbohater-obraz-na-plotnie-z-twojego-zdjecia-superman')) {
      console.log('🦸 [PRODUCT-TYPE] URL = Superman → productType: superman');
      return 'superman';
    }
    if (currentUrl.includes('superbohater') || currentUrl.includes('portret-ze-zdjecia-superbohater-prezent-dla-chlopca')) {
      console.log('🦸 [PRODUCT-TYPE] URL = Superbohater → productType: superhero');
      return 'superhero';
    }
    if (currentUrl.includes('plakat-ze-zdjecia-w-stylu-komiks')) {
      console.log('🖍️ [PRODUCT-TYPE] URL = Komiks (test) → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-pary-na-50-ta-rocznice-wydruk-na-szkle')) {
      console.log('💑 [PRODUCT-TYPE] URL = Para rocznica wydruk na szkle → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-na-50-ta-rocznice')) {
      console.log('🎂 [PRODUCT-TYPE] URL = Karykatura 50-ta rocznica → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-biznes-woman-personalizowany-prezent')) {
      console.log('👩‍💼 [PRODUCT-TYPE] URL = Biznes Woman → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('wydruk-na-szkle-biznes-woman-prezent-na-urodziny-dla-kobiety')) {
      console.log('👩‍💼 [PRODUCT-TYPE] URL = Wydruk na szkle Biznes Woman → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-prezent-na-50-urodziny-dla-kobiety-biznes-woman')) {
      console.log('👩‍💼 [PRODUCT-TYPE] URL = Biznes Woman 50 urodziny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-prezent-na-30-urodziny-dla-kobiety-biznes-woman')) {
      console.log('👩‍💼 [PRODUCT-TYPE] URL = Prezent 30 urodziny Biznes Woman → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('prezent-z-okazji-dnia-matki-personalizowany-fotoobraz-ze-zdjecia')) {
      console.log('💐 [PRODUCT-TYPE] URL = Dzień Matki → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('prezent-z-okazji-dnia-matki-personalizowany-plakat-pierwsze-nasze-swieto')) {
      console.log('💐 [PRODUCT-TYPE] URL = Dzień Matki Pierwsze Święto → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('prezent-z-okazji-dnia-matki-kocia-mama-fotoobraz')) {
      console.log('💐 [PRODUCT-TYPE] URL = Dzień Matki Kocia Mama → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('prezent-z-okazji-dnia-matki-personalizowany-obraz-supermama')) {
      console.log('💐 [PRODUCT-TYPE] URL = Dzień Matki SuperMama → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania')) {
      console.log('💝 [PRODUCT-TYPE] URL = Karykatura dla niej → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-kelnerki')) {
      console.log('🍽️ [PRODUCT-TYPE] URL = Karykatura kelnerka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-kelnera')) {
      console.log('🍽️ [PRODUCT-TYPE] URL = Karykatura kelner → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-rowerzysty-kolarza')) {
      console.log('🚴 [PRODUCT-TYPE] URL = Karykatura rowerzysta / kolarz → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-policjantka')) {
      console.log('👮 [PRODUCT-TYPE] URL = Karykatura dla niej policjantka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-rolniczka')) {
      console.log('🌾 [PRODUCT-TYPE] URL = Karykatura dla niej rolniczka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-lekarka')) {
      console.log('🩺 [PRODUCT-TYPE] URL = Karykatura dla niej lekarka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka')) {
      console.log('✈️ [PRODUCT-TYPE] URL = Karykatura dla niej podróżniczka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-psycholog')) {
      console.log('🧠 [PRODUCT-TYPE] URL = Karykatura dla niej psycholog → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-kucharka')) {
      console.log('👩‍🍳 [PRODUCT-TYPE] URL = Karykatura dla niej kucharka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-fitness')) {
      console.log('💪 [PRODUCT-TYPE] URL = Karykatura dla niej fitness → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-szefowa')) {
      console.log('🛒 [PRODUCT-TYPE] URL = Karykatura dla niej szefowa → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny')) {
      console.log('🎣 [PRODUCT-TYPE] URL = Karykatura rolnik dla mężczyzny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem')) {
      console.log('🚜 [PRODUCT-TYPE] URL = Karykatura polski rolnik z ciągnikiem → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata')) {
      console.log('🔧 [PRODUCT-TYPE] URL = Karykatura mechanik samochodowy → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego')) {
      console.log('🏍️ [PRODUCT-TYPE] URL = Karykatura motocyklista → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz')) {
      console.log('⚽ [PRODUCT-TYPE] URL = Piłkarz chłopiec → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza')) {
      console.log('🔥 [PRODUCT-TYPE] URL = Strażak → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka')) {
      console.log('🩺 [PRODUCT-TYPE] URL = Lekarz → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty')) {
      console.log('🏗️ [PRODUCT-TYPE] URL = Budowlaniec → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz')) {
      console.log('🚛 [PRODUCT-TYPE] URL = Kierowca tira → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta')) {
      console.log('👮 [PRODUCT-TYPE] URL = Karykatura policjant → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-szefa')) {
      console.log('👔 [PRODUCT-TYPE] URL = Karykatura szef → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-w-stylu-forbes-gold-ze-zdjecia-personalizowany-prezent-dla-mezczyzny')) {
      console.log('📰 [PRODUCT-TYPE] URL = Forbes Gold → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('plakat-w-stylu-forbes-silver-dla-mezczyzny-personalizowany-prezent-ze-zdjecia')) {
      console.log('📰 [PRODUCT-TYPE] URL = Forbes Silver → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-w-stylu-elle-ze-zdjecia-personalizowany-prezent-dla-dziewczyny')) {
      console.log('📰 [PRODUCT-TYPE] URL = ELLE → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-w-stylu-vogue-ceo-ze-zdjecia-personalizowany-prezent-dla-kobiety')) {
      console.log('📰 [PRODUCT-TYPE] URL = Vogue CEO → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-w-stylu-vogue-ze-zdjecia-classic-gold-personalizowany-prezent-dla-dziewczyny')) {
      console.log('📰 [PRODUCT-TYPE] URL = Vogue Classic Gold → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-w-stylu-vogue-ze-zdjecia-party-personalizowany-prezent-dla-dziewczyny')) {
      console.log('📰 [PRODUCT-TYPE] URL = Vogue Party → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-w-stylu-time-ze-zdjecia-personalizowany-prezent-dla-faceta')) {
      console.log('📰 [PRODUCT-TYPE] URL = TIME men → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('plakat-w-stylu-time-ze-zdjecia-personalizowany-prezent-dla-kobiety')) {
      console.log('📰 [PRODUCT-TYPE] URL = TIME women → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('plakat-w-stylu-mens-health-ze-zdjecia-personalizowany-prezent-dla-niego')) {
      console.log('📰 [PRODUCT-TYPE] URL = Men\'s Health → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-pary-na-diamentowe-gody-ze-zdjecia-60-rocznica-slubu')) {
      console.log('💎 [PRODUCT-TYPE] URL = Diamentowe Gody para → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-dziadkow-ze-zdjecia-wesola-para-personalizowany-prezent')) {
      console.log('👴👵 [PRODUCT-TYPE] URL = Weseli staruszkowie → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-pary-podroznikow-ze-zdjecia-personalizowany-prezent-dla-pary')) {
      console.log('✈️ [PRODUCT-TYPE] URL = Para podróżników → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary')) {
      console.log('💒 [PRODUCT-TYPE] URL = Młoda para ślub → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie')) {
      console.log('💍 [PRODUCT-TYPE] URL = Rocznica ślubu 25/30/40/50 → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-na-50-rocznice-slubu-prezent-na-50-lecie')) {
      console.log('🥇 [PRODUCT-TYPE] URL = 50 rocznica slubu → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-na-40-rocznice-slubu-obraz-ze-zdjecia-na-40-lecie')) {
      console.log('💎 [PRODUCT-TYPE] URL = 40 rocznica slubu → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta')) {
      console.log('🎣 [PRODUCT-TYPE] URL = Karykatura wędkarz → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('personalizowany-obraz-karykatura-elektryka-ze-zdjecia-wyjatkowy-prezent')) {
      console.log('⚡ [PRODUCT-TYPE] URL = Karykatura elektryk → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-ze-zdjecia-hydraulik')) {
      console.log('🔧 [PRODUCT-TYPE] URL = Karykatura hydraulik → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('personalizowany-obraz-karykatura-ze-zdjecia-dla-mysliwego-wyjatkowy-prezent')) {
      console.log('🦌 [PRODUCT-TYPE] URL = Karykatura myśliwy → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-spawacza-personalizowany-obraz-karykatura-ze-zdjecia-wyjatkowy-prezent')) {
      console.log('🔥 [PRODUCT-TYPE] URL = Karykatura spawacz → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('personalizowany-obraz-karykatura-ze-zdjecia-dla-zolnierza-i-super-prezent')) {
      console.log('🪖 [PRODUCT-TYPE] URL = Karykatura żołnierz → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('pary-na-motocyklu-personalizowany-obraz-wyjatkowy-prezent-dla-motocyklistow')) {
      console.log('🏍️ [PRODUCT-TYPE] URL = Para na motocyklu → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty')) {
      console.log('⚽ [PRODUCT-TYPE] URL = Karykatura piłkarz → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny')) {
      console.log('💪 [PRODUCT-TYPE] URL = Karykatura kulturysta dla mężczyzny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle')) {
      console.log('🏋️ [PRODUCT-TYPE] URL = Active woman fitness → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy')) {
      console.log('🎂 [PRODUCT-TYPE] URL = Active woman 18 urodziny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa')) {
      console.log('💅 [PRODUCT-TYPE] URL = Szefowa salon spa → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan')) {
      console.log('🎀 [PRODUCT-TYPE] URL = 40 urodziny czerwony dywan → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle')) {
      console.log('✨ [PRODUCT-TYPE] URL = Magic 18 urodziny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent')) {
      console.log('📚 [PRODUCT-TYPE] URL = Nauczycielka 30 rocznica → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-dla-nauczycielki-ze-zdjecia-na-zkaonczenie-podziekowanie-prezent')) {
      console.log('📚 [PRODUCT-TYPE] URL = Nauczycielka zakończenie roku → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-nauczyciela-ze-zdjecia-na-zakonczenie-roku-podziekowanie')) {
      console.log('📚 [PRODUCT-TYPE] URL = Nauczyciel zakończenie roku → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-pary-z-okazji-rocznicy-z-twojego-zdjecia')) {
      console.log('🤴👸 [PRODUCT-TYPE] URL = Para królewska → productType: para_krolewska');
      return 'para_krolewska';
    }
    if (currentUrl.includes('portret-pary-w-stylu-anime-obraz-ze-zdjecia')) {
      console.log('🎌 [PRODUCT-TYPE] URL = Anime → productType: anime');
      return 'anime';
    }
    if (currentUrl.includes('ramka-spotify') || currentUrl.includes('zdjecie-na-szkle-ramka-spotify')) {
      console.log('🎵 [PRODUCT-TYPE] URL = Ramka Spotify → productType: spotify_frame');
      return 'spotify_frame';
    }
    if (currentUrl.includes('personalizowane-etui-na-telefon-z-twoim-zdjeciem') && !currentUrl.includes('-karykatura')) {
      console.log('📱 [PRODUCT-TYPE] URL = Etui na telefon → productType: etui');
      return 'etui';
    }
    if (currentUrl.includes('portret-z-twojego-zdjecia-neon-lights-dla-dziewczyny-prezent')) {
      console.log('💡 [PRODUCT-TYPE] URL = Neon Lights → productType: neo');
      return 'neo';
    }
    if (currentUrl.includes('personalizowany-obraz-z-twojego-zdjecia-dla-mezczyzny-w-stylu-western-wanted')) {
      console.log('🤠 [PRODUCT-TYPE] URL = Western Wanted → productType: wanted');
      return 'wanted';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-dla-kobiety-w-stylu-western-wanted-poszukiwana')) {
      console.log('🤠 [PRODUCT-TYPE] URL = Western Wanted (kobieta) → productType: wanted_k');
      return 'wanted_k';
    }
    if (currentUrl.includes('portret-dziecka-w-stroju-jednorozca') || currentUrl.includes('jednorozec')) {
      console.log('🦄 [PRODUCT-TYPE] URL = Jednorożec → productType: unicorn');
      return 'unicorn';
    }
    if (currentUrl.includes('portret-dziecka-w-stroju-misia') || currentUrl.includes('mis')) {
      console.log('🧸 [PRODUCT-TYPE] URL = Miś → productType: teddy_bear');
      return 'teddy_bear';
    }
    if (currentUrl.includes('portret-ze-zdjecia-dla-dziewczynki-zimowa-ksiezniczka') || currentUrl.includes('zimowa-ksiezniczka')) {
      console.log('❄️ [PRODUCT-TYPE] URL = Zimowa Księżniczka → productType: winter_princess');
      return 'winter_princess';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-krolowa-sniegu') || currentUrl.includes('krolowa-sniegu')) {
      console.log('❄️👑 [PRODUCT-TYPE] URL = Królowa Śniegu → productType: snow_queen');
      return 'snow_queen';
    }
    if (currentUrl.includes('portret-krolowej-obraz-ze-zdjecia-prezent-dla-niej')) {
      console.log('👑 [PRODUCT-TYPE] URL = Portret królowej prezent → productType: queen_prezent');
      return 'queen_prezent';
    }
    if (currentUrl.includes('prezent-na-walentynki-obraz-na-plotnie-z-twojego-zdjecia')) {
      console.log('🌹 [PRODUCT-TYPE] URL = Love Rose → productType: love_rose');
      return 'love_rose';
    }
    if (currentUrl.includes('portret-zakochana-para-krolewska-prezent-na-walentynki-personalizowany')) {
      console.log('💕 [PRODUCT-TYPE] URL = Royal Love → productType: royal_love');
      return 'royal_love';
    }
    if (currentUrl.includes('prezent-na-walentynki-superpara-obraz-na-plotnie-z-twojego-zdjecia')) {
      console.log('🦸 [PRODUCT-TYPE] URL = Superpara → productType: superpara');
      return 'superpara';
    }
    if (currentUrl.includes('portret-w-stylu-gta-obraz-na-plotnie-z-twojego-zdjecia-super-prezent') || currentUrl.includes('portret-w-stylu-gta')) {
      console.log('🎮 [PRODUCT-TYPE] URL = GTA → productType: gta');
      return 'gta';
    }
    if (currentUrl.includes('obraz-w-stylu-steampunk-personalizowany-z-twojego-zdjecia-na-prezent') || currentUrl.includes('steampunk')) {
      console.log('⚙️ [PRODUCT-TYPE] URL = Steampunk → productType: steampunk');
      return 'steampunk';
    }
    if (currentUrl.includes('portret-w-stylu-hip-hop-obraz-na-plotnie') || currentUrl.includes('portret-ze-zdjecia-hip-hop')) {
      console.log('🎤 [PRODUCT-TYPE] URL = Hip-Hop → productType: hiphop');
      return 'hiphop';
    }
    if (currentUrl.includes('polacz-pare-na-wspolnym-obrazie-prezent-na-rocznice')) {
      console.log('💑 [PRODUCT-TYPE] URL = Połącz parę → productType: polacz_pare');
      return 'polacz_pare';
    }
    if (currentUrl.includes('dodaj-osobe-do-zdjecia-naturalny-efekt')) {
      console.log('📸 [PRODUCT-TYPE] URL = Dodaj osobę → productType: dodaj_osobe');
      return 'dodaj_osobe';
    }
    if (currentUrl.includes('kolaz-ze-zdjec-prezent-dla-mamy')) {
      console.log('📸 [PRODUCT-TYPE] URL = Kolaż dla mamy → productType: kolaz_mama');
      return 'kolaz_mama';
    }
    if (currentUrl.includes('generator-zdjec-profilowych-ai')) {
      console.log('🧑‍💼 [PRODUCT-TYPE] URL = Headshot LinkedIn → productType: linkedin_headshot');
      return 'linkedin_headshot';
    }
    if (currentUrl.includes('prezent-dla-dziadkow-retusz-starych-zdjec')) {
      console.log('📷 [PRODUCT-TYPE] URL = Retusz starych zdjęć → productType: retusz_starych_zdjec');
      return 'retusz_starych_zdjec';
    }
    if (currentUrl.includes('szkic-ze-zdjecia-obraz-na-plotnie-plakat-ramka')) {
      console.log('✏️ [PRODUCT-TYPE] URL = Szkic ołówkowy → productType: szkic_olowek');
      return 'szkic_olowek';
    }

    // 🔄 PRIORYTET 2: Fallback - sprawdź styl (tylko dla starych generacji bez URL)
    console.log('⚠️ [PRODUCT-TYPE] Nie rozpoznano URL, sprawdzam styl:', style);
    
    const styleToProductType = {
      'pop-art': 'pop_art',
      '3d-cartoon': '3d_cartoon',
      'oil-paints': 'oil_paints',
      'oil-painting': 'oil_painting',
      'minimalistyczny': 'boho',
      'realistyczny': 'boho',
      'krol-krolewski': 'king',
      'krol-majestatyczny': 'king',
      'krol-triumfalny': 'king',
      'krol-imponujacy': 'king',
      'krol-polski': 'king',
      'krol-polski-krolewski': 'king',
      'krolowa-styl-1': 'queen',
      'krolowa-styl-2': 'queen',
      'krolowa-styl-3': 'queen',
      'krolowa-styl-4': 'queen',
      'krolowa-prezent-1': 'queen_prezent',
      'krolowa-prezent-2': 'queen_prezent',
      'krolewski': 'cats',
      'na-tronie': 'cats',
      'wojenny': 'cats',
      'wiktorianski': 'cats',
      'renesansowy': 'cats',
      'zamkowy': 'para_krolewska',
      'krolewski-para': 'para_krolewska',
      'superhero_kid': 'superhero',
      'superhero_boy': 'superhero',
      'karykatura': 'caricature',
      'caricature-new': 'caricature-new',
      'karykatura-olowek': 'caricature-new',
      'karykatura-prezent-szkic': 'caricature-new',
      'rocznica-real': 'caricature-new',
      'olowkiem-zam-karykatura': 'caricature',
      'olowkiem-zam-nowoczesna': 'caricature-new',
      'olowkiem-zam-szkic': 'caricature-new',
      'watercolor_ok': 'caricature-new',
      'swieta': 'caricature-new',
      'swieta_2': 'caricature-new',
      'akwarela': 'watercolor',
      'openai-art': 'openai-art', // Openai Art
      'love-rose': 'love_rose', // Love Rose
      'royal-love': 'royal_love', // Royal Love
      'gta': 'gta', // GTA
      'steampunk': 'steampunk', // Steampunk
      'hiphop': 'hiphop', // Hip-Hop
      'szkic-love': 'szkic_love', // Szkic Love
      'jak-z-bajki': 'jak_z_bajki', // Jak z bajki
      'superpara': 'superpara', // Superpara
      'jednorozec': 'unicorn',
      'mis': 'teddy_bear',
      'zimowa-ksiezniczka': 'winter_princess',
      'krolowa-sniegu': 'snow_queen',
      'neo': 'neo',
      'wanted': 'wanted',
      'wanted_k': 'wanted_k',
      'anime': 'anime',
      'superman': 'superman',
      'dodaj-osobe': 'dodaj_osobe',
      'polacz-pare': 'polacz_pare',
      'kolaz-mama': 'kolaz_mama',
      'linkedin-headshot': 'linkedin_headshot',
      'retusz-starych-zdjec': 'retusz_starych_zdjec',
      'szkic-olowek': 'szkic_olowek',
      'pirates': 'pirates',
      'bonnie-clyde': 'bonnie-clyde',
      'cowboys': 'cowboys',
      'minecraft': 'minecraft',
      'brick-figures': 'brick-figures',
      'cubist': 'cubist',
      'japanese': 'japanese',
      'victorian-lady': 'victorian-lady',
      'headdress-portrait': 'headdress-portrait'
    };

    const productType = styleToProductType[style] || 'other';
    console.log('🔄 [PRODUCT-TYPE] Styl:', style, '→ productType:', productType);
    
    return productType;
  }

  getLocalUsageCount(productType) {
    if (!productType) {
      // Fallback: suma wszystkich typów (backward compatibility)
      const allTypes = ['boho', 'king', 'cats', 'caricature', 'watercolor', 'other'];
      const total = allTypes.reduce((sum, type) => {
        const count = parseInt(localStorage.getItem(`customify_usage_${type}`) || '0', 10);
        if (count > 0) {
          console.log(`📊 [LOCAL-STORAGE] ${type}: ${count}`);
        }
        return sum + count;
      }, 0);
      console.log(`📊 [LOCAL-STORAGE] Total (bez productType): ${total}`);
      return total;
    }
    const key = `customify_usage_${productType}`;
    const count = parseInt(localStorage.getItem(key) || '0', 10);
    console.log(`📊 [LOCAL-STORAGE] ${productType}: ${count} (key: ${key})`);
    return count;
  }

  /**
   * Inkrementuje licznik w localStorage (dla niezalogowanych) - PER PRODUCTTYPE
   */
  incrementLocalUsage(productType) {
    if (!productType) {
      productType = 'other'; // Fallback
    }
    const key = `customify_usage_${productType}`;
    const currentCount = this.getLocalUsageCount(productType);
    const newCount = currentCount + 1;
    localStorage.setItem(key, newCount.toString());
    // Usage count incremented per productType
    this.showUsageCounter(); // Odśwież licznik w UI
  }

  /**
   * Zapisuje generację AI w localStorage
   */
  async saveAIGeneration(originalImage, transformedImage, style, size, productType = null, watermarkedImageUrl = null, watermarkedImageBase64 = null, extra = {}) {
    console.log('💾 [CACHE] Saving AI generation to localStorage...');
    
    // ⚠️ NIE zapisuj ponownie do Vercel Blob - już jest zapisane w transform.js jako generation-{timestamp}.jpg
    // Używamy URL z API response (generation-{timestamp}.jpg) zamiast duplikować jako ai-{timestamp}.jpg.jpg
    let transformedImageUrl = transformedImage; // Użyj URL z API (generation-{timestamp}.jpg lub base64)
    
    console.log('✅ [CACHE] Using existing URL from transform.js (no duplicate upload):', transformedImageUrl?.substring(0, 50));

    // ✅ DODAJ productType jeśli nie został przekazany (fallback dla starych generacji)
    if (!productType && style) {
      productType = this.getProductTypeFromStyle(style);
      console.log('🔄 [CACHE] ProductType wywnioskowany z stylu:', productType);
    }

    const cleanImageUrl = typeof transformedImageUrl === 'string' && transformedImageUrl.startsWith('http')
      ? transformedImageUrl
      : null;
    const thumbnailUrl = watermarkedImageUrl || cleanImageUrl;

    const generation = this.slimGenerationForStorage({
      id: Date.now(),
      timestamp: new Date().toISOString(),
      originalImage: null, // nie zapisuj base64 — localStorage ma limit ~5MB
      transformedImage: cleanImageUrl,
      watermarkedImageUrl: watermarkedImageUrl || null,
      watermarkedImageBase64: null, // sesja ma base64 w pamięci; localStorage tylko URL-e
      style: style,
      size: size,
      productType: productType,
      productHandle: typeof this.getProductHandle === 'function' ? this.getProductHandle() : null,
      thumbnail: thumbnailUrl,
      isPilotEdit: !!extra.isPilotEdit,
      galleryLabel: extra.galleryLabel || null,
      pilotEditAnchorKey: extra.pilotEditAnchorKey || null
    });

    if (!generation.thumbnail && !generation.transformedImage) {
      console.warn('⚠️ [GALLERY] Brak URL do zapisu w galerii — pomijam localStorage');
      return;
    }

    const existingGenerations = this.getAIGenerations().map(g => this.slimGenerationForStorage(g));
    existingGenerations.unshift(generation);
    const limitedGenerations = this.persistGenerations(existingGenerations.slice(0, 8));
    
    console.log('🎨 [GALLERY] Saved AI generation:', generation.id, style, size);
    
    // Odśwież galerię
    this.updateGallery().catch(error => {
      console.error('❌ [GALLERY] Error updating gallery after save:', error);
    });
  }

  /**
   * Pobiera zapisane generacje AI
   */
  getAIGenerations() {
    try {
      const stored = localStorage.getItem('customify_ai_generations');
      if (!stored) return [];
      
      const parsed = JSON.parse(stored);
      console.log('🎨 [GALLERY] Loaded generations from localStorage:', parsed.length);
      
      // TYMCZASOWO: zwróć wszystkie generacje bez filtrowania
      return parsed;
    } catch (error) {
      console.error('❌ [GALLERY] Error loading generations:', error);
      this._reportToSentry(error, 'getAIGenerations');
      return [];
    }
  }

  /**
   * URL strony Moje obrazy — niezalogowany trafia od razu na login z powrotem na listę.
   */
  getMyGenerationsPageUrl() {
    const listPath = '/pages/my-generations';
    if (window.ShopifyCustomer && window.ShopifyCustomer.loggedIn) {
      return listPath;
    }
    return `/customer_authentication/login?return_to=${encodeURIComponent(listPath)}`;
  }

  /**
   * Aktualizuje galerię ostatnich generacji
   */
  async updateGallery() {
    console.log('🎨 [GALLERY] updateGallery called');
    
    // 🧹 CLEANUP: Usuń niedziałające generacje
    const generations = await this.cleanupBrokenGenerations();
    console.log('🎨 [GALLERY] After cleanup, generations:', generations.length);
    
    if (generations.length === 0) {
      // Ukryj galerię jeśli brak generacji
      const gallery = document.getElementById('aiGallery');
      if (gallery) {
        gallery.style.display = 'none';
      }
      console.log('🎨 [GALLERY] No generations, hiding gallery');
      return;
    }

    // Znajdź lub stwórz kontener galerii
    let gallery = document.getElementById('aiGallery');
    if (!gallery) {
      gallery = this.createGalleryContainer();
    }

    // Wyczyść poprzednie elementy
    gallery.innerHTML = '';

    // Dodaj nagłówek z linkiem do pełnej listy (Moje obrazy)
    const headerRow = document.createElement('div');
    headerRow.className = 'customify-gallery-header';
    headerRow.style.cssText = `
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 6px 14px;
      margin: 0 0 15px 0;
    `;

    const header = document.createElement('h4');
    header.textContent = 'Twoje obrazy - wybierz najlepszy';
    header.style.cssText = `
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: #333;
      text-align: center;
    `;

    const seeAllLink = document.createElement('a');
    seeAllLink.href = this.getMyGenerationsPageUrl();
    seeAllLink.textContent = 'Zobacz wszystkie';
    seeAllLink.className = 'customify-gallery-see-all';
    seeAllLink.style.cssText = `
      font-size: 0.92rem;
      font-weight: 500;
      color: #2563eb;
      text-decoration: underline;
      text-underline-offset: 2px;
      white-space: nowrap;
    `;

    headerRow.appendChild(header);
    headerRow.appendChild(seeAllLink);
    gallery.appendChild(headerRow);

    // Stwórz grid z generacjami
    const grid = document.createElement('div');
    grid.style.cssText = `
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
      gap: 12px;
      margin-bottom: 20px;
    `;

    generations.forEach(generation => {
      const item = this.createGalleryItem(generation);
      if (item) grid.appendChild(item);
    });

    gallery.appendChild(grid);

    if (grid.children.length === 0) {
      gallery.style.display = 'none';
      console.log('🎨 [GALLERY] No working images after render, hiding gallery');
      return;
    }

    gallery.style.display = 'block';
  }

  /**
   * Tworzy kontener galerii
   */
  createGalleryContainer() {
    const gallery = document.createElement('div');
    gallery.id = 'aiGallery';
    gallery.style.cssText = `
      margin: 20px 0;
      padding: 20px;
      background: #f8f9fa;
      border-radius: 8px;
      border: 1px solid #e9ecef;
    `;

    // Wstaw galerię przed accordion
    const accordion = document.querySelector('.product-details-accordion');
    console.log('🎨 [GALLERY] Looking for accordion:', accordion);
    if (accordion) {
      accordion.parentNode.insertBefore(gallery, accordion);
      console.log('🎨 [GALLERY] Gallery inserted before accordion');
    } else {
      // Fallback - wstaw w kontener aplikacji
      const appContainer = document.getElementById('customify-app-container');
      if (appContainer) {
        appContainer.appendChild(gallery);
        console.log('🎨 [GALLERY] Gallery inserted in app container');
      } else {
        // Ostatni fallback - wstaw na końcu body
        document.body.appendChild(gallery);
        console.log('🎨 [GALLERY] Gallery inserted at end of body (fallback)');
      }
    }

    return gallery;
  }

  /**
   * Tworzy element galerii dla pojedynczej generacji
   */
  createGalleryItem(generation) {
    const candidates = this.getGalleryImageUrls(generation);
    if (candidates.length === 0) {
      this.removeGenerationFromStorage(generation.id);
      return null;
    }

    const item = document.createElement('div');
    item.style.cssText = `
      position: relative;
      cursor: pointer;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      transition: transform 0.2s ease;
    `;

    const img = document.createElement('img');
    img.loading = 'lazy';
    img.style.cssText = `
      width: 100%;
      height: 120px;
      object-fit: cover;
      display: block;
    `;
    img.alt = `${generation.style} - ${generation.size}`;

    let candidateIndex = 0;
    const tryNextUrl = () => {
      if (candidateIndex >= candidates.length) {
        console.warn('🗑️ [GALLERY] Wszystkie URL-e martwe, usuwam generację:', generation.id);
        this.removeGenerationFromStorage(generation.id);
        item.remove();
        this.checkGalleryEmpty();
        return;
      }
      img.src = candidates[candidateIndex++];
    };

    img.onerror = () => {
      console.warn('❌ [GALLERY] Image failed:', img.src?.substring(0, 80));
      tryNextUrl();
    };

    img.onload = () => {
      console.log('✅ [GALLERY] Image loaded:', img.src?.substring(0, 80));
    };

    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 4px 6px;
      font-size: 10px;
      font-weight: 600;
      color: #fff;
      background: linear-gradient(transparent, rgba(0,0,0,0.65));
      text-align: center;
      pointer-events: none;
    `;
    if (generation.galleryLabel) {
      overlay.textContent = generation.galleryLabel;
      overlay.style.display = 'block';
    } else if (generation.isPilotEdit) {
      overlay.textContent = 'Poprawka';
      overlay.style.display = 'block';
    } else {
      overlay.style.display = 'none';
    }

    item.addEventListener('mouseenter', () => {
      item.style.transform = 'translateY(-4px)';
    });
    item.addEventListener('mouseleave', () => {
      item.style.transform = 'translateY(0)';
    });

    item.addEventListener('click', () => {
      this.reuseGeneration(generation);
    });

    item.appendChild(img);
    item.appendChild(overlay);
    tryNextUrl();

    return item;
  }

  checkGalleryEmpty() {
    const gallery = document.getElementById('aiGallery');
    if (!gallery) return;
    const grid = gallery.querySelector('div');
    if (!grid || grid.children.length === 0) {
      gallery.style.display = 'none';
    }
  }

  /**
   * Zwraca URL bezpieczny dla canvas (proxy dla Vercel Blob - CORS)
   * Używane w text overlay / Spotify compose / etui — NIE w zwykłym podglądzie <img>
   */
  getCanvasSafeImageUrl(url) {
    if (!url || typeof url !== 'string') return url;
    if (url.startsWith('data:')) return url;
    if (url.includes('blob.vercel-storage.com')) {
      return `https://customify-s56o.vercel.app/api/proxy-image?url=${encodeURIComponent(url)}`;
    }
    return url;
  }

  /**
   * URL proxy dla Blob — tylko fallback gdy bezpośredni podgląd zawiedzie
   * albo gdy operacja wymaga canvas/fetch (CORS).
   */
  getProxyImageUrl(url) {
    if (!url || typeof url !== 'string') return url;
    if (url.startsWith('data:') || url.includes('/api/proxy-image?')) return url;
    if (url.includes('blob.vercel-storage.com')) {
      return `https://customify-s56o.vercel.app/api/proxy-image?url=${encodeURIComponent(url)}`;
    }
    return url;
  }

  /**
   * Podgląd wyniku: bezpośredni Blob URL (taniej — bez Fast Origin Transfer).
   * Przy błędzie ładowania: 1× fallback na proxy + Sentry (tag: blob-preview-proxy-fallback).
   * ROLLBACK: zawsze używać getProxyImageUrl(url) zamiast setPreviewImageWithFallback.
   */
  setPreviewImageWithFallback(imgEl, url, context = 'showResult') {
    if (!imgEl || !url) return;
    const directUrl = url;
    const needsBlobWatch = typeof url === 'string' && url.includes('blob.vercel-storage.com') && !url.includes('/api/proxy-image?');

    imgEl.removeAttribute('data-proxy-fallback-tried');
    imgEl.src = directUrl;

    if (!needsBlobWatch) return;

    imgEl.onerror = () => {
      if (imgEl.getAttribute('data-proxy-fallback-tried') === '1') return;
      imgEl.setAttribute('data-proxy-fallback-tried', '1');
      const proxyUrl = this.getProxyImageUrl(directUrl);
      console.error('⚠️ [BLOB-PREVIEW] Direct Blob failed — fallback to proxy', {
        context,
        url: directUrl.substring(0, 120)
      });
      this._sentryCrumb('blob-preview', 'Direct Blob preview failed, using proxy fallback', {
        context,
        urlPrefix: directUrl.substring(0, 100)
      });
      this._reportToSentry(
        new Error('Direct Blob preview failed — proxy fallback'),
        'blob-preview-proxy-fallback',
        { context, urlPrefix: directUrl.substring(0, 120), productHandle: this.getProductHandle ? this.getProductHandle() : null }
      );
      imgEl.src = proxyUrl;
    };
  }

  /**
   * background-image (np. etui): ustaw bezpośredni Blob; przy błędzie — proxy + Sentry.
   */
  setPreviewBackgroundWithFallback(el, url, context = 'phonePreview') {
    if (!el || !url) return;
    const needsBlobWatch = typeof url === 'string' && url.includes('blob.vercel-storage.com') && !url.includes('/api/proxy-image?');
    if (!needsBlobWatch) {
      el.style.backgroundImage = `url(${url})`;
      return;
    }

    el.style.backgroundImage = `url(${url})`;
    const probe = new Image();
    probe.onload = () => {};
    probe.onerror = () => {
      if (el.getAttribute('data-proxy-fallback-tried') === '1') return;
      el.setAttribute('data-proxy-fallback-tried', '1');
      const proxyUrl = this.getProxyImageUrl(url);
      console.error('⚠️ [BLOB-PREVIEW] Direct Blob background failed — fallback to proxy', {
        context,
        url: url.substring(0, 120)
      });
      this._sentryCrumb('blob-preview', 'Direct Blob background failed, using proxy fallback', {
        context,
        urlPrefix: url.substring(0, 100)
      });
      this._reportToSentry(
        new Error('Direct Blob background failed — proxy fallback'),
        'blob-preview-proxy-fallback',
        { context, urlPrefix: url.substring(0, 120) }
      );
      el.style.backgroundImage = `url(${proxyUrl})`;
    };
    probe.src = url;
  }

  /**
   * Konwertuje URL na File object
   * Dla Vercel Blob używa proxy (CORS blokuje bezpośredni fetch)
   */
  urlToFile(url, filename) {
    const fetchUrl = (url && url.includes('blob.vercel-storage.com'))
      ? `https://customify-s56o.vercel.app/api/proxy-image?url=${encodeURIComponent(url)}`
      : url;
    return new Promise((resolve, reject) => {
      fetch(fetchUrl)
        .then(response => {
          if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
          return response.blob();
        })
        .then(blob => {
          const file = new File([blob], filename, { type: blob.type || 'image/jpeg' });
          resolve(file);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  /**
   * Konwertuje URL na base64 string
   */
  async urlToBase64(url) {
    try {
      console.log('🔄 [CACHE] Converting URL to base64:', url);
      const response = await fetch(url);
      const blob = await response.blob();
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          console.log('✅ [CACHE] URL converted to base64 successfully');
          resolve(reader.result);
        };
        reader.onerror = () => {
          console.error('❌ [CACHE] Error reading blob to base64');
          reject(new Error('Failed to convert blob to base64'));
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('❌ [CACHE] Error converting URL to base64:', error);
      throw error;
    }
  }

  /**
   * Kompresuje obraz base64 do małego thumbnail (150x150px)
   * Zwraca kompresowany base64 string (~50-100KB zamiast 2-5MB)
   */
  async compressBase64Thumbnail(base64String, maxWidth = 150, maxHeight = 150, quality = 0.6) {
    return new Promise((resolve, reject) => {
      try {
        console.log('🗜️ [COMPRESS] Compressing thumbnail to', maxWidth, 'x', maxHeight, 'px');
        
        const img = new Image();
        img.onload = () => {
          // Oblicz nowe wymiary zachowując proporcje
          let width = img.width;
          let height = img.height;
          
          if (width > maxWidth || height > maxHeight) {
            const ratio = Math.min(maxWidth / width, maxHeight / height);
            width = Math.round(width * ratio);
            height = Math.round(height * ratio);
          }
          
          // Stwórz canvas i narysuj skompresowany obraz
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          
          // Konwertuj do base64 z kompresją
          const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
          
          const originalSize = Math.round(base64String.length / 1024); // KB
          const compressedSize = Math.round(compressedBase64.length / 1024); // KB
          const compressionRatio = Math.round((1 - compressedSize / originalSize) * 100);
          
          console.log(`✅ [COMPRESS] Compressed: ${originalSize}KB → ${compressedSize}KB (${compressionRatio}% reduction)`);
          
          resolve(compressedBase64);
        };
        
        img.onerror = () => {
          console.error('❌ [COMPRESS] Failed to load image for compression');
          reject(new Error('Failed to compress image'));
        };
        
        img.src = base64String;
      } catch (error) {
        console.error('❌ [COMPRESS] Error compressing thumbnail:', error);
        reject(error);
      }
    });
  }

  /**
   * Zapisuje obraz base64 do Vercel Blob Storage i zwraca URL
   */
  async saveToVercelBlob(base64String, filename) {
    const maxAttempts = 3;
    const isRetryable = (err) => err?.message && (
      err.message.includes('Failed to fetch') ||
      err.message.includes('NetworkError') ||
      err.message.includes('Load failed') ||
      err.message.includes('Error completing request') ||
      err.message.includes('network failure')
    );

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        console.log(`📤 [VERCEL-BLOB] Upload attempt ${attempt}/${maxAttempts}...`);
        const response = await fetch('https://customify-s56o.vercel.app/api/upload-temp-image', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            imageData: base64String,
            filename: filename,
          }),
        });

        if (!response.ok) {
          throw new Error(`Failed to upload: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        if (result.success && result.url) {
          console.log('✅ [VERCEL-BLOB] Uploaded successfully:', result.url);
          return result.url;
        }
        throw new Error('No URL in response');
      } catch (error) {
        console.warn(`❌ [VERCEL-BLOB] Attempt ${attempt}/${maxAttempts} failed:`, error?.message || error);
        if (attempt < maxAttempts && isRetryable(error)) {
          const delay = attempt * 1500;
          console.log(`🔄 [VERCEL-BLOB] Retrying in ${delay}ms...`);
          await new Promise(r => setTimeout(r, delay));
        } else {
          throw error;
        }
      }
    }
  }

  /**
   * Czysty obraz BEZ napisu — zawsze na tym rysujemy overlay.
   * Po pierwszym Zapisz transformedImage/watermarked mają już tekst.
   */
  getTextOverlayCleanBaseUrl() {
    if (this.isPhonePhotoCaseProduct() && this.phonePhotoCropConfirmed && this.phonePhotoCropDataUrl) {
      return this.phonePhotoCropDataUrl;
    }
    return this.textOverlayBaseImage || this.transformedImage;
  }

  /**
   * Nakłada napis na obraz i zapisuje na Vercel Blob (pilotaż)
   */
  async previewTextOverlay() {
    if (!this.textOverlayEnabled) return;
    if (!this.getTextOverlayCleanBaseUrl()) {
      this.showError('Brak obrazu do podglądu napisu', 'cart');
      return;
    }

    const text = (this.textOverlayInput?.value || '').trim();
    this.textOverlayState = { ...this.textOverlayState, text };

    // Jeśli tekst pusty – wróć do oryginału BEZ napisu (nie do ostatniej wersji z tekstem)
    if (!text) {
      this.textOverlayState = { ...this.textOverlayState, text: '', previewUrl: null };
      this.updateTextOverlayHint('Pole jest puste');
      const restoreUrl = this.textOverlayOriginalWatermarked || this.watermarkedImageUrl;
      if (this.resultImage && restoreUrl) {
        const url = this.getCanvasSafeImageUrl(restoreUrl);
        if (this.isPhonePhotoCaseProduct()) {
          const photoBg = document.getElementById('phoneCasePhotoBg');
          const resultBg = document.getElementById('phoneCaseResultBg');
          if (photoBg) photoBg.style.backgroundImage = `url(${url})`;
          if (resultBg) resultBg.style.backgroundImage = `url(${url})`;
        }
        this.resultImage.src = url;
      }
      return;
    }

    const options = {
      preset: this.textOverlayState.preset || 'classic',
      color: this.textOverlayState.color || 'white',
      font: this.textOverlayState.font || 'sans',
      size: this.textOverlayState.size || 'medium'
    };

    let baseUrl = this.getCanvasSafeImageUrl(this.getTextOverlayCleanBaseUrl());
    const base64WithText = await this.renderTextOverlayPreview(baseUrl, text, options);

    // ✅ PREVIEW: ZAWSZE z watermarkem - user nie może widzieć obrazu bez watermarku
    let toDisplay = base64WithText;
    try {
      toDisplay = await this.addWatermark(base64WithText);
    } catch (e) {
      console.warn('⚠️ [TEXT-OVERLAY] addWatermark preview failed:', e);
    }
    this.textOverlayState = { ...this.textOverlayState, previewUrl: base64WithText };

    if (this.resultImage) {
      // 📱 Phone case: aktualizuj oba (preview + result) - podgląd napisu Z watermarkem
      if (this.isPhonePhotoCaseProduct() && toDisplay) {
        const photoBg = document.getElementById('phoneCasePhotoBg');
        const resultBg = document.getElementById('phoneCaseResultBg');
        if (photoBg) photoBg.style.backgroundImage = `url(${toDisplay})`;
        if (resultBg) resultBg.style.backgroundImage = `url(${toDisplay})`;
      }
      this.resultImage.src = toDisplay;
    }
  }

  /**
   * Zapisuje napis na Vercel Blob (po zatwierdzeniu)
   */
  async saveTextOverlay() {
    if (!this.textOverlayEnabled) return;
    if (!this.transformedImage) {
      this.showError('Brak obrazu do zapisania napisu', 'cart');
      return;
    }

    const text = (this.textOverlayInput?.value || '').trim();
    this.textOverlayState = { ...this.textOverlayState, text };

    if (!text) {
      this.showError('Wpisz tekst przed zapisem', 'cart');
      return;
    }

    const options = {
      preset: this.textOverlayState.preset || 'classic',
      color: this.textOverlayState.color || 'white',
      font: this.textOverlayState.font || 'sans',
      size: this.textOverlayState.size || 'medium'
    };

    let baseUrl = this.getCanvasSafeImageUrl(this.getTextOverlayCleanBaseUrl());
    if (!baseUrl) {
      this.showError('Brak obrazu do zapisania napisu', 'cart');
      return;
    }
    console.log('📝 [TEXT-OVERLAY] Rozpoczynam renderowanie napisu na obrazie:', baseUrl.substring(0, 100) + '...');
    const base64WithText = await this.renderTextOverlay(baseUrl, text, options);
    console.log('✅ [TEXT-OVERLAY] Napis wyrenderowany pomyślnie (base64 length:', base64WithText.length, ')');

    // Upload wersji z napisem
    const filename = `text-overlay-${Date.now()}.jpg`;
    console.log('📤 [TEXT-OVERLAY] Wysyłam wersję z napisem do Vercel Blob...');
    const overlayUrl = await this.saveToVercelBlob(base64WithText, filename);
    console.log('✅ [TEXT-OVERLAY] Wersja z napisem zapisana:', overlayUrl);

    // Watermark na wersji z tekstem
    console.log('🎨 [TEXT-OVERLAY] Nakładam watermark na wersję z napisem...');
    const watermarkedBase64 = await this.addWatermark(base64WithText);
    console.log('✅ [TEXT-OVERLAY] Watermark nałożony (base64 length:', watermarkedBase64.length, ')');
    
    console.log('📤 [TEXT-OVERLAY] Wysyłam wersję z watermarkiem do Vercel Blob...');
    const watermarkedUrl = await this.saveToVercelBlob(watermarkedBase64, `text-overlay-watermarked-${Date.now()}.jpg`);
    console.log('✅ [TEXT-OVERLAY] Wersja z watermarkiem zapisana:', watermarkedUrl);

    // Aktualizuj stan (dopiero po zapisie)
    this.transformedImage = overlayUrl;
    this.watermarkedImageUrl = watermarkedUrl;
    this.watermarkedImageBase64 = watermarkedBase64;
    this.textOverlayWatermarkedUrl = watermarkedUrl;
    this.textOverlayState = { ...this.textOverlayState, text, applied: true, previewUrl: null };
    this.updateTextOverlayHint('Napis zapisany – dodasz go do zamówienia');

    // Zamknij panel po zapisie
    const toggleBtn = this.textOverlayToggleBtn;
    if (this.textOverlayPanel && toggleBtn) {
      this.textOverlayPanel.style.display = 'none';
      toggleBtn.setAttribute('data-overlay-open', 'false');
    }

    if (this.resultImage) {
      // 📱 Phone case: aktualizuj oba (preview + result) - po zapisie napisu (proxy dla Vercel Blob)
      const imageUrl = this.getCanvasSafeImageUrl(watermarkedUrl || overlayUrl);
      if (this.isPhonePhotoCaseProduct()) {
        const photoBg = document.getElementById('phoneCasePhotoBg');
        const resultBg = document.getElementById('phoneCaseResultBg');
        if (photoBg && imageUrl) photoBg.style.backgroundImage = `url(${imageUrl})`;
        if (resultBg && imageUrl) resultBg.style.backgroundImage = `url(${imageUrl})`;
      }
      this.resultImage.src = imageUrl;
    }

    // Zaktualizuj najnowszą generację w localStorage
    try {
      const generations = this.getAIGenerations();
      if (generations.length > 0) {
        generations[0] = this.slimGenerationForStorage({
          ...generations[0],
          transformedImage: overlayUrl?.startsWith('http') ? overlayUrl : generations[0].transformedImage,
          watermarkedImageUrl: watermarkedUrl,
          watermarkedImageBase64: null,
          textOverlayBaseImage: this.textOverlayBaseImage,
          textOverlayOriginalWatermarked: this.textOverlayOriginalWatermarked,
          textOverlay: {
            text,
            ...options
          }
        });
        this.persistGenerations(generations.slice(0, 8));
        console.log('✅ [TEXT-OVERLAY] Zapisano overlay w localStorage');
      }
    } catch (err) {
      console.warn('⚠️ [TEXT-OVERLAY] Nie udało się zaktualizować localStorage:', err);
    }
  }

  /**
   * Szybki preview tekstu overlay (bez czekania na fonty, bez watermarku)
   * Używany TYLKO podczas wpisywania tekstu - finalny render używa renderTextOverlay()
   */
  async renderTextOverlayPreview(imageUrl, text, options) {
    return new Promise(async (resolve, reject) => {
      try {
        // ✅ PREVIEW: NIE CZEKAJ na fonty - użyj system font stack natychmiast
        const img = new Image();
        if (imageUrl && !imageUrl.startsWith('data:')) {
          img.crossOrigin = 'anonymous';
        }
        img.onload = async () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const padding = canvas.width * 0.06;
            const areaHeight = canvas.height * 0.22;
            const baseY = canvas.height - areaHeight * 0.35;
            const maxWidth = canvas.width - padding * 2;

            const sizeMap = { small: 0.05, medium: 0.075, large: 0.11 };
            const fontSize = Math.max(32, canvas.height * (sizeMap[options.size] || sizeMap.medium));

            // ✅ PREVIEW: Te same czcionki co w renderTextOverlay(), ale bez czekania na fonty
    const fontMapPreview = {
      serif: `700 ${fontSize}px "Times New Roman", "Georgia", serif`,
      sans: `700 ${fontSize}px "Montserrat", "Poppins", "Inter", Arial, sans-serif`,
      script: `700 ${fontSize}px "Dancing Script", "Pacifico", cursive`,
      script2: `700 ${fontSize}px "Pacifico", "Dancing Script", cursive`,
      script3: `700 ${fontSize}px "Satisfy", "Dancing Script", cursive`,
      script4: `700 ${fontSize}px "Great Vibes", "Satisfy", cursive`,
      script5: `700 ${fontSize}px "Indie Flower", "Pacifico", cursive`,
      western_1: `700 ${fontSize}px "Rye", "Times New Roman", serif`,
      western_2: `700 ${fontSize}px "Creepster", "Rye", "Times New Roman", serif`,
      hiphop: `400 ${fontSize}px "Rubik Wet Paint", "Creepster", "Rye", "Times New Roman", serif`
    };
            const font = fontMapPreview[options.font] || fontMapPreview.sans;

            const colorMap = {
              white: '#ffffff',
              black: '#111111',
              gold: '#d6b36a',
              red: '#dc2626',
              green: '#16a34a',
              blue: '#2563eb',
              yellow: '#eab308',
              brown: '#92400e'
            };
            const fillColor = colorMap[options.color] || '#ffffff';

            ctx.font = font;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            const words = text.split(' ');
            const lines = [];
            let current = '';
            words.forEach(word => {
              const testLine = current ? `${current} ${word}` : word;
              const { width } = ctx.measureText(testLine);
              if (width > maxWidth && current) {
                lines.push(current);
                current = word;
              } else {
                current = testLine;
              }
            });
            if (current) lines.push(current);
            const limitedLines = lines.slice(0, 2);

            // 🛟 Safety: nie pozwól spaść niżej niż 10% od dołu
            const lineYs = limitedLines.map((_, idx) =>
              baseY + (idx - (limitedLines.length - 1) / 2) * (fontSize * 1.2)
            );
            const maxAllowedY = canvas.height * 0.90;
            const shiftY = Math.max(0, Math.max(...lineYs) - maxAllowedY);

            // Skorygowane pozycje linii
            const correctedLineYs = lineYs.map(y => y - shiftY);

            if (options.preset === 'banner') {
              const topLineY = Math.min(...correctedLineYs);
              const bottomLineY = Math.max(...correctedLineYs);
              const bannerPadding = fontSize * 0.5;
              const bannerTop = topLineY - fontSize * 0.6 - bannerPadding;
              const bannerBottom = bottomLineY + fontSize * 0.6 + bannerPadding;
              const bannerHeight = bannerBottom - bannerTop;
              const bannerBg = options.color === 'black' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'gold' ? 'rgba(40,25,15,0.45)' :
                               options.color === 'red' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'green' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'blue' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'yellow' ? 'rgba(0,0,0,0.4)' :
                               options.color === 'brown' ? 'rgba(255,255,255,0.4)' :
                               'rgba(0,0,0,0.4)';
              ctx.fillStyle = bannerBg;
              ctx.fillRect(padding * 0.9, bannerTop, canvas.width - padding * 1.8, bannerHeight);
            }

            limitedLines.forEach((line, idx) => {
              const lineY = correctedLineYs[idx];

              if (options.preset === '3d') {
                const shadowColor =
                  options.color === 'white' ? 'rgba(0,0,0,0.45)' :
                  options.color === 'black' ? 'rgba(255,255,255,0.45)' :
                  options.color === 'gold' ? 'rgba(95, 70, 30, 0.55)' :
                  options.color === 'red' ? 'rgba(0,0,0,0.4)' :
                  options.color === 'green' ? 'rgba(0,0,0,0.4)' :
                  options.color === 'blue' ? 'rgba(0,0,0,0.4)' :
                  options.color === 'yellow' ? 'rgba(0,0,0,0.4)' :
                  options.color === 'brown' ? 'rgba(0,0,0,0.4)' :
                  'rgba(0,0,0,0.45)';
                ctx.fillStyle = shadowColor;
                ctx.fillText(line, canvas.width / 2 + Math.max(2, fontSize * 0.04), lineY + Math.max(2, fontSize * 0.04));
              }

              const strokeColor =
                options.color === 'white' ? 'rgba(0,0,0,0.65)' :
                options.color === 'black' ? 'rgba(255,255,255,0.65)' :
                options.color === 'gold' ? 'rgba(95, 70, 30, 0.75)' :
                options.color === 'red' ? 'rgba(0,0,0,0.5)' :
                options.color === 'green' ? 'rgba(0,0,0,0.5)' :
                options.color === 'blue' ? 'rgba(0,0,0,0.5)' :
                options.color === 'yellow' ? 'rgba(0,0,0,0.5)' :
                options.color === 'brown' ? 'rgba(255,255,255,0.5)' :
                'rgba(0,0,0,0.65)';
              ctx.strokeStyle = strokeColor;
              ctx.lineWidth = Math.max(2.5, fontSize * 0.09);
              ctx.strokeText(line, canvas.width / 2, lineY);

              ctx.fillStyle = fillColor;
              ctx.fillText(line, canvas.width / 2, lineY);
            });

            const result = canvas.toDataURL('image/jpeg', 0.92);
            resolve(result);
          } catch (err) {
            reject(err);
          }
        };
        img.onerror = (err) => reject(err);
        img.src = imageUrl;
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Renderuje napis na kanwie
   */
  async renderTextOverlay(imageUrl, text, options) {
    return new Promise(async (resolve, reject) => {
      try {
        // ✅ CZEKAJ NA ZAŁADOWANIE CZCIONEK (Google Fonts)
        if (document.fonts && document.fonts.status !== 'loaded') {
          console.log('🔤 [TEXT-OVERLAY] Czekam na document.fonts.ready...');
          await document.fonts.ready;
          console.log('✅ [TEXT-OVERLAY] Fonty załadowane!');
        }

        const img = new Image();
        if (imageUrl && !imageUrl.startsWith('data:')) {
          img.crossOrigin = 'anonymous';
        }
        img.onload = async () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const padding = canvas.width * 0.06;
            const areaHeight = canvas.height * 0.22;
            const baseY = canvas.height - areaHeight * 0.35;
            const maxWidth = canvas.width - padding * 2;

    const sizeMap = { small: 0.05, medium: 0.075, large: 0.11 };
    const fontSize = Math.max(32, canvas.height * (sizeMap[options.size] || sizeMap.medium));

    // Mapowanie nazw czcionek do nazw Google Fonts
    const fontNameMap = {
      serif: 'Times New Roman', // Systemowa
      sans: 'Montserrat',
      script: 'Dancing Script',
      script2: 'Pacifico',
      script3: 'Satisfy',
      script4: 'Great Vibes',
      script5: 'Indie Flower',
      western_1: 'Rye',
      western_2: 'Creepster',
      hiphop: 'Rubik Wet Paint'
    };
    
    const fontName = fontNameMap[options.font] || fontNameMap.sans;
    const fontWeight = options.font === 'hiphop' ? '400' : '700';
    
    // ✅ SPRAWDŹ CZY KONKRETNA CZCIONKA JEST ZAŁADOWANA (przed użyciem w canvas)
    if (document.fonts && fontName !== 'Times New Roman') {
      const fontSpec = `${fontWeight} ${fontSize}px "${fontName}"`;
      try {
        const isLoaded = document.fonts.check(fontSpec);
        if (!isLoaded) {
          console.log(`🔤 [TEXT-OVERLAY] Czekam na czcionkę "${fontName}"...`);
          // Czekaj maksymalnie 3 sekundy na załadowanie konkretnej czcionki
          let attempts = 0;
          while (!document.fonts.check(fontSpec) && attempts < 30) {
            await new Promise(resolve => setTimeout(resolve, 100));
            attempts++;
          }
          if (document.fonts.check(fontSpec)) {
            console.log(`✅ [TEXT-OVERLAY] Czcionka "${fontName}" załadowana!`);
          } else {
            console.warn(`⚠️ [TEXT-OVERLAY] Czcionka "${fontName}" nie załadowała się w czasie, używam fallback`);
          }
        }
      } catch (e) {
        console.warn('⚠️ [TEXT-OVERLAY] Błąd podczas sprawdzania czcionki:', e);
      }
    }

    const fontMap = {
      serif: `700 ${fontSize}px "Times New Roman", "Georgia", serif`,
      sans: `700 ${fontSize}px "Montserrat", "Poppins", "Inter", Arial, sans-serif`,
      script: `700 ${fontSize}px "Dancing Script", "Pacifico", cursive`,
      script2: `700 ${fontSize}px "Pacifico", "Dancing Script", cursive`,
      script3: `700 ${fontSize}px "Satisfy", "Dancing Script", cursive`,
      script4: `700 ${fontSize}px "Great Vibes", "Satisfy", cursive`,
      script5: `700 ${fontSize}px "Indie Flower", "Pacifico", cursive`,
      western_1: `700 ${fontSize}px "Rye", "Times New Roman", serif`,
      western_2: `700 ${fontSize}px "Creepster", "Rye", "Times New Roman", serif`,
      hiphop: `400 ${fontSize}px "Rubik Wet Paint", "Creepster", "Rye", "Times New Roman", serif`
    };
            const font = fontMap[options.font] || fontMap.sans;

    const colorMap = {
      white: '#ffffff',
      black: '#111111',
      gold: '#d6b36a',
      red: '#dc2626',      // Czerwony
      green: '#16a34a',    // Zielony
      blue: '#2563eb',     // Niebieski
      yellow: '#eab308',   // Żółty
      brown: '#92400e'     // Brązowy
    };
    const fillColor = colorMap[options.color] || '#ffffff';

            ctx.font = font;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            const words = text.split(' ');
            const lines = [];
            let current = '';
            words.forEach(word => {
              const testLine = current ? `${current} ${word}` : word;
              const { width } = ctx.measureText(testLine);
              if (width > maxWidth && current) {
                lines.push(current);
                current = word;
              } else {
                current = testLine;
              }
            });
            if (current) lines.push(current);
            const limitedLines = lines.slice(0, 2);

            // 🛟 Safety: nie pozwól spaść niżej niż 10% od dołu
            const lineYs = limitedLines.map((_, idx) =>
              baseY + (idx - (limitedLines.length - 1) / 2) * (fontSize * 1.2)
            );
            const maxAllowedY = canvas.height * 0.90;
            const shiftY = Math.max(0, Math.max(...lineYs) - maxAllowedY);

            // Skorygowane pozycje linii
            const correctedLineYs = lineYs.map(y => y - shiftY);

            if (options.preset === 'banner') {
              // Oblicz banner na podstawie faktycznych pozycji linii
              const topLineY = Math.min(...correctedLineYs);
              const bottomLineY = Math.max(...correctedLineYs);
              const bannerPadding = fontSize * 0.5;
              const bannerTop = topLineY - fontSize * 0.6 - bannerPadding;
              const bannerBottom = bottomLineY + fontSize * 0.6 + bannerPadding;
              const bannerHeight = bannerBottom - bannerTop;
              // Kolor tła zależy od koloru tekstu: biały→czarne, czarny→białe, złoty→ciemnobrązowe
              const bannerBg = options.color === 'black' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'gold' ? 'rgba(40,25,15,0.45)' :
                               options.color === 'red' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'green' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'blue' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'yellow' ? 'rgba(0,0,0,0.4)' :
                               options.color === 'brown' ? 'rgba(255,255,255,0.4)' :
                               'rgba(0,0,0,0.4)'; // fallback
              ctx.fillStyle = bannerBg;
              ctx.fillRect(padding * 0.9, bannerTop, canvas.width - padding * 1.8, bannerHeight);
            }

            limitedLines.forEach((line, idx) => {
              const lineY = correctedLineYs[idx];

      if (options.preset === '3d') {
        const shadowColor =
          options.color === 'white' ? 'rgba(0,0,0,0.45)' :
          options.color === 'black' ? 'rgba(255,255,255,0.45)' :
          options.color === 'gold' ? 'rgba(95, 70, 30, 0.55)' :
          options.color === 'red' ? 'rgba(0,0,0,0.4)' :
          options.color === 'green' ? 'rgba(0,0,0,0.4)' :
          options.color === 'blue' ? 'rgba(0,0,0,0.4)' :
          options.color === 'yellow' ? 'rgba(0,0,0,0.4)' :
          options.color === 'brown' ? 'rgba(0,0,0,0.4)' :
          'rgba(0,0,0,0.45)'; // fallback
        ctx.fillStyle = shadowColor;
        ctx.fillText(line, canvas.width / 2 + Math.max(2, fontSize * 0.04), lineY + Math.max(2, fontSize * 0.04));
      }

      // Stroke for better contrast per color
      const strokeColor =
        options.color === 'white' ? 'rgba(0,0,0,0.65)' :
        options.color === 'black' ? 'rgba(255,255,255,0.65)' :
        options.color === 'gold' ? 'rgba(95, 70, 30, 0.75)' :
        options.color === 'red' ? 'rgba(0,0,0,0.5)' :
        options.color === 'green' ? 'rgba(0,0,0,0.5)' :
        options.color === 'blue' ? 'rgba(0,0,0,0.5)' :
        options.color === 'yellow' ? 'rgba(0,0,0,0.5)' :
        options.color === 'brown' ? 'rgba(255,255,255,0.5)' :
        'rgba(0,0,0,0.65)'; // fallback
      ctx.strokeStyle = strokeColor;
      ctx.lineWidth = Math.max(2.5, fontSize * 0.09);
      ctx.strokeText(line, canvas.width / 2, lineY);

              ctx.fillStyle = fillColor;
              ctx.fillText(line, canvas.width / 2, lineY);
            });

            const result = canvas.toDataURL('image/jpeg', 0.92);
            resolve(result);
          } catch (err) {
            reject(err);
          }
        };
        img.onerror = (err) => reject(err);
        img.src = imageUrl;
      } catch (error) {
        reject(error);
      }
    });
  }

  getGalleryImageUrls(generation) {
    const urls = [];
    const add = (url) => {
      if (!url || typeof url !== 'string') return;
      if (url.startsWith('data:') && url.length > 200000) return;
      if (!urls.includes(url)) urls.push(url);
    };
    add(generation.watermarkedImageUrl);
    add(generation.thumbnail);
    add(generation.transformedImage);
    return urls.filter(url => url.startsWith('http') || url.startsWith('data:'));
  }

  slimGenerationForStorage(generation) {
    if (!generation || typeof generation !== 'object') return generation;
    const slim = { ...generation };
    if (slim.originalImage && typeof slim.originalImage === 'string' && slim.originalImage.length > 500) {
      slim.originalImage = null;
    }
    if (slim.watermarkedImageBase64) {
      slim.watermarkedImageBase64 = null;
    }
    if (slim.transformedImage?.startsWith('data:') && slim.transformedImage.length > 500) {
      slim.transformedImage = null;
    }
    if (slim.thumbnail?.startsWith('data:') && slim.thumbnail.length > 500) {
      slim.thumbnail = slim.watermarkedImageUrl || slim.transformedImage || null;
    }
    return slim;
  }

  persistGenerations(generations) {
    const slimList = generations.map(g => this.slimGenerationForStorage(g));
    for (const maxItems of [8, 5, 3, 1]) {
      const attempt = slimList.slice(0, maxItems);
      try {
        localStorage.setItem('customify_ai_generations', JSON.stringify(attempt));
        if (maxItems < slimList.length) {
          console.warn(`🧹 [GALLERY] Quota localStorage — zapisano ${maxItems}/${slimList.length} generacji`);
        }
        return attempt;
      } catch (error) {
        console.warn('⚠️ [GALLERY] localStorage quota exceeded, retry:', maxItems, error?.message);
      }
    }
    try {
      localStorage.removeItem('customify_ai_generations');
    } catch (_) {}
    return [];
  }

  removeGenerationFromStorage(generationId) {
    if (!generationId) return;
    const remaining = this.getAIGenerations().filter(g => g.id !== generationId);
    if (remaining.length === this.getAIGenerations().length) return;
    this.persistGenerations(remaining);
    console.log('🗑️ [GALLERY] Removed generation from localStorage:', generationId);
  }

  canLoadImageUrl(url) {
    return new Promise((resolve) => {
      if (!url || typeof url !== 'string') {
        resolve(false);
        return;
      }
      const img = new Image();
      const timeout = setTimeout(() => {
        img.onload = null;
        img.onerror = null;
        resolve(false);
      }, 8000);
      img.onload = () => {
        clearTimeout(timeout);
        resolve(true);
      };
      img.onerror = () => {
        clearTimeout(timeout);
        resolve(false);
      };
      img.src = url;
    });
  }

  /**
   * Usuwa niedziałające generacje z localStorage
   */
  async cleanupBrokenGenerations() {
    console.log('🧹 [CLEANUP] Checking for broken generations...');
    const generations = this.getAIGenerations().map(g => this.slimGenerationForStorage(g));
    const workingGenerations = [];

    for (const generation of generations) {
      const urls = this.getGalleryImageUrls(generation);
      if (urls.length === 0) {
        console.log('🗑️ [CLEANUP] Brak URL — usunięto:', generation.id);
        continue;
      }

      let isWorking = false;
      for (const url of urls) {
        if (await this.canLoadImageUrl(url)) {
          isWorking = true;
          break;
        }
      }

      if (isWorking) {
        workingGenerations.push(generation);
        console.log('✅ [CLEANUP] Working generation kept:', generation.id);
      } else {
        console.log('🗑️ [CLEANUP] Broken generation removed:', generation.id);
      }
    }

    const persisted = this.persistGenerations(workingGenerations);
    if (persisted.length !== generations.length) {
      console.log(`🧹 [CLEANUP] Cleaned up: ${generations.length} → ${persisted.length} generations`);
    }

    return persisted;
  }

  /**
   * Konwertuje base64 na File object
   */
  base64ToFile(base64String, filename) {
    return new Promise((resolve, reject) => {
      try {
        // Sprawdź czy to już jest string (base64)
        if (typeof base64String !== 'string') {
          reject(new Error('originalImage is not a base64 string'));
          return;
        }
        
        // Wyciągnij typ MIME i dane z base64
        const [header, data] = base64String.split(',');
        const mimeMatch = header.match(/data:([^;]+)/);
        if (!mimeMatch) {
          reject(new Error('Invalid base64 data URI format'));
          return;
        }
        const mimeType = mimeMatch[1];
        
        // Konwertuj base64 na binary
        const binaryString = atob(data);
        const bytes = new Uint8Array(binaryString.length);
        
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        
        // Utwórz File object
        const file = new File([bytes], filename, { type: mimeType });
        resolve(file);
      } catch (error) {
        reject(error);
      }
    });
  }

  dataUrlToBlob(dataUrl) {
    if (!dataUrl || !dataUrl.startsWith('data:')) return null;
    try {
      const [header, data] = dataUrl.split(',');
      const mimeMatch = header.match(/data:([^;]+)/);
      if (!mimeMatch) return null;
      const binary = atob(data);
      const arr = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
      return new Blob([arr], { type: mimeMatch[1] });
    } catch (e) {
      return null;
    }
  }

  /**
   * Używa ponownie wybraną generację
   */
  reuseGeneration(generation) {
    console.log('🔄 [GALLERY] Reusing generation:', generation.id);
    console.log('🔄 [GALLERY] Generation data:', generation);
    console.log('🔄 [GALLERY] originalImage type:', typeof generation.originalImage);
    console.log('🔄 [GALLERY] originalImage value:', generation.originalImage);
    console.log('🔄 [GALLERY] transformedImage type:', typeof generation.transformedImage);
    console.log('🔄 [GALLERY] transformedImage length:', generation.transformedImage?.length);
    console.log('🔄 [GALLERY] transformedImage preview:', generation.transformedImage?.substring(0, 100));
    console.log('🔄 [GALLERY] watermarkedImageUrl:', generation.watermarkedImageUrl?.substring(0, 100) || 'brak');
    
    // Pokaż wynik AI (transformedImage) w result area
    if (generation.transformedImage) {
      console.log('🔄 [GALLERY] Showing AI result in result area:', generation.transformedImage);
      
      // ✅ KLUCZOWE: Ustaw this.transformedImage żeby addToCart() działało
      this.transformedImage = generation.transformedImage;
      console.log('✅ [GALLERY] Set this.transformedImage for addToCart:', this.transformedImage?.substring(0, 100));
      console.log('✅ [GALLERY] this.transformedImage is base64?', this.transformedImage?.startsWith('data:'));
      console.log('✅ [GALLERY] this.transformedImage is URL?', this.transformedImage?.startsWith('http'));
      
      // ✅ KLUCZOWE: Ustaw this.watermarkedImageUrl z galerii (backend watermark)
      this.watermarkedImageUrl = generation.watermarkedImageUrl || null;
      console.log('✅ [GALLERY] Set this.watermarkedImageUrl from generation:', this.watermarkedImageUrl?.substring(0, 100) || 'brak');
      if (!this.watermarkedImageUrl) {
        console.warn('⚠️ [GALLERY] Stara generacja bez watermarkedImageUrl - showResult() pokaże bez watermarku');
      }
      
      // ✅ NOWE: Ustaw this.watermarkedImageBase64 z galerii (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
      this.watermarkedImageBase64 = generation.watermarkedImageBase64 || null;
      console.log('✅ [GALLERY] Set this.watermarkedImageBase64 from generation:', this.watermarkedImageBase64 ? `${this.watermarkedImageBase64.length} chars` : 'brak');

      // 🆕 Tekst na obrazie - odtwórz stan z generacji (tylko produkt pilota)
      if (this.textOverlayEnabled) {
        this.watermarkedImageUrl = generation.watermarkedImageUrl || generation.transformedImage;
        this.textOverlayBaseImage = generation.textOverlayBaseImage
          || (!generation.textOverlay ? generation.transformedImage : this.textOverlayBaseImage)
          || generation.transformedImage;
        this.textOverlayOriginalWatermarked = generation.textOverlayOriginalWatermarked
          || (!generation.textOverlay ? generation.watermarkedImageUrl : this.textOverlayOriginalWatermarked)
          || null;
        const textOverlay = generation.textOverlay || null;
        if (this.textOverlayInput) {
          this.textOverlayInput.value = textOverlay?.text || '';
          this.updateTextOverlayCounter();
        }
        this.textOverlayState = {
          ...this.textOverlayState,
          text: textOverlay?.text || '',
          preset: textOverlay?.preset || 'classic',
          color: textOverlay?.color || 'white',
          font: textOverlay?.font || 'sans',
          size: textOverlay?.size || 'medium',
          applied: !!textOverlay
        };
        if (this.textOverlayPanel) {
          this.textOverlayPanel.style.display = 'none';
          this.textOverlayToggleBtn?.setAttribute('data-overlay-open', 'false');
        }
        if (textOverlay?.text) {
          this.updateTextOverlayHint('Napis dodany. Możesz go zmienić i ponownie zastosować.');
        } else {
          this.updateTextOverlayHint('');
        }
      }
      
      // ✅ KLUCZOWE: Ustaw this.originalImageFromGallery żeby addToCart() działało
      this.originalImageFromGallery = generation.originalImage;
      console.log('✅ [GALLERY] Set this.originalImageFromGallery for addToCart:', this.originalImageFromGallery);
      
      this.showResult(generation.transformedImage);
      this.hideError();
    } else {
      console.error('❌ [GALLERY] No transformedImage in generation');
      this.showError('Brak wyniku AI w generacji.');
    }
    
    // Ustaw styl - bezpośrednio z generacji
    console.log('🎨 [GALLERY] Setting style:', generation.style);
    if (generation.style) {
      this.selectedStyle = generation.style;
      console.log('✅ [GALLERY] Style set directly from generation:', this.selectedStyle);
      
      // Opcjonalnie: zaznacz też element w DOM jeśli istnieje
      const styleCard = document.querySelector(`[data-style="${generation.style}"]`);
      if (styleCard) {
        this.stylesArea.querySelectorAll('.customify-style-card').forEach(card => card.classList.remove('active'));
        styleCard.classList.add('active');
        console.log('✅ [GALLERY] Style card also highlighted in DOM');
      }
    } else {
      console.warn('⚠️ [GALLERY] No style in generation');
    }
    
    // Ustaw rozmiar
    if (generation.size) {
      const sizeBtn = document.querySelector(`[data-size="${generation.size}"]`);
      if (sizeBtn) {
        this.selectSize(sizeBtn);
      }
    }

    // Po reuse: zsynchronizuj rozmiar z aktualnym typem wydruku (np. A5 ze szkła → A4 na plakacie)
    try {
      this.updateSizeAvailability();
      this.syncActiveSizeButton();
      this.updateProductPrice();
      this.updateCartPrice();
    } catch (e) {
      console.warn('⚠️ [GALLERY] reuseGeneration price/sync:', e);
    }

    if (this.isPilotImageEditProduct()) {
      this.resetPilotEditForNewBaseImage({
        closeEditor: true,
        newBaseUrl: generation.transformedImage,
        clearInstruction: true
      });
      if (generation.pilotEditAnchorKey) {
        const store = this.getPilotEditSessionStore();
        const snap = store[generation.pilotEditAnchorKey];
        if (snap) {
          this.applyPilotEditSnapshot(snap, generation.transformedImage);
          this.updatePilotEditVersionUI();
        }
      }
      this.hidePilotEditFreshBanner();
      this.setPilotEditEntryMode('gallery');
      this.refreshPilotEditUsageFromServer().catch(() => {});
    }

    // Komunikat usunięty - nie potrzebny
  }

  /**
   * Sprawdza czy użytkownik może wykonać transformację
   * @returns {Promise<boolean>} true jeśli może, false jeśli przekroczył limit
   */
  async checkUsageLimit() {
    const customerInfo = this.getCustomerInfo();
    
    // ✅ ZABEZPIECZENIE: Jeśli selectedStyle jest null, nie sprawdzaj limitu (pozwól wybrać styl)
    if (!this.selectedStyle) {
      console.warn(`⚠️ [USAGE-LIMIT] selectedStyle jest null - pomijam sprawdzanie limitu (user musi najpierw wybrać styl)`);
      return true; // Pozwól wybrać styl
    }
    
    // Pobierz productType z aktualnie wybranego stylu
    const productType = this.getProductTypeFromStyle(this.selectedStyle);
    
    console.log(`🔍 [USAGE-LIMIT] Sprawdzam limit:`, {
      selectedStyle: this.selectedStyle,
      productType: productType,
      isLoggedIn: !!customerInfo
    });
    
    if (!customerInfo) {
      // Niezalogowany - sprawdź localStorage (limit 1 per productType)
      const localCount = this.getLocalUsageCount(productType);
      const FREE_LIMIT = 1;
      
      console.log(`🔍 [USAGE-LIMIT] Niezalogowany: ${localCount}/${FREE_LIMIT} dla ${productType}`);
      
      // Usage limit check for anonymous users per productType
      
      if (localCount >= FREE_LIMIT) {
        console.log(`❌ [USAGE-LIMIT] Limit przekroczony dla ${productType}: ${localCount} >= ${FREE_LIMIT}`);
        this.showLoginModal(localCount, FREE_LIMIT, productType);
        return false;
      }
      
      return true;
    } else {
      // Zalogowany - sprawdź Shopify Metafields przez API (per productType)
      // Checking usage limit via API for logged-in user
      
      try {
        const response = await fetch('https://customify-s56o.vercel.app/api/check-usage', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            customerId: customerInfo.customerId,
            customerAccessToken: customerInfo.customerAccessToken,
            productType: productType // ✅ Przekaż productType
          })
        });
        
        if (!response.ok) {
          console.error(`❌ [USAGE] API error: ${response.status} ${response.statusText}`);
          // ⚠️ KRYTYCZNE: Jeśli błąd API, BLOKUJ (bezpieczniejsze niż pozwalanie)
          this.showError(`Błąd sprawdzania limitu użycia. Spróbuj ponownie za chwilę.`, 'transform');
          return false;
        }
        
        const data = await response.json();
        
        if (data.remainingCount <= 0) {
          console.error(`❌ [USAGE] Limit przekroczony - przerwano transformację`);
          this.showError(`Wykorzystałeś wszystkie transformacje dla ${productType} (${data.totalLimit}). Skontaktuj się z nami dla więcej.`, 'transform');
          return false;
        }
        
        // Limit OK - remainingCount > 0
        return true;
      } catch (error) {
        console.error('❌ [USAGE] Błąd sprawdzania limitu:', error);
        this._reportToSentry(error, 'checkUsageLimit');
        // ⚠️ KRYTYCZNE: Jeśli błąd, BLOKUJ (bezpieczniejsze niż pozwalanie)
        // Użytkownik może spróbować ponownie, ale nie może obejść limitu przez błąd
        this.showError(`Błąd sprawdzania limitu użycia. Spróbuj ponownie za chwilę.`, 'transform');
        return false;
      }
    }
  }

  /**
   * Pokazuje modal z wymogiem rejestracji + auto-redirect
   */
  showLoginModal(usedCount, limit, productType = null) {
    // Return URL - wróć na tę samą stronę po rejestracji
    const returnUrl = window.location.pathname + window.location.search;
    
    // ⚠️ DEBUG: Pokaż dokładnie co zapisujemy
    console.log('🔍 [DEBUG] window.location.pathname:', window.location.pathname);
    console.log('🔍 [DEBUG] window.location.search:', window.location.search);
    console.log('🔍 [DEBUG] returnUrl (złożony):', returnUrl);
    console.log('🔍 [DEBUG] window.location.href (pełny):', window.location.href);
    
    // Zapisz return URL w localStorage (Shopify może ignorować return_url parameter)
    localStorage.setItem('customify_return_url', returnUrl);
    localStorage.setItem('customify_return_url_timestamp', Date.now().toString());
    console.log('💾 [USAGE] Saved return URL to localStorage:', returnUrl);
    console.log('💾 [USAGE] Timestamp:', Date.now());
    
    // Nowe Customer Accounts Shopify (account.lumly.pl) wymagają /customer_authentication/login?return_to=ŚCIEŻKA
    // Dokumentacja: https://shopify.dev/docs/storefronts/themes/login (changelog Dec 19, 2024)
    // WAŻNE: return_to przyjmuje TYLKO ścieżkę względną (nie pełny URL)
    const encodedReturnPath = encodeURIComponent(returnUrl);
    console.log('🔐 [DEBUG] Encoded return path:', encodedReturnPath);
    
    // Jeden endpoint dla rejestracji i logowania (nowe konta Shopify nie mają osobnego /register)
    const registerUrl = `/customer_authentication/login?return_to=${encodedReturnPath}`;
    const loginUrl = `/customer_authentication/login?return_to=${encodedReturnPath}`;
    
    console.log('🔗 [DEBUG] Login/Register URL:', loginUrl);
    
    const markAuthIntent = (type) => {
      try {
        localStorage.setItem('customify_auth_intent', type);
        localStorage.setItem('customify_auth_intent_timestamp', Date.now().toString());
        localStorage.setItem('customify_auth_source', window.location.pathname + window.location.search);
        console.log('🔐 [AUTH] Marked auth intent:', type);
      } catch (error) {
        console.warn('⚠️ [AUTH] Failed to mark auth intent:', error);
      }
    };
    
    const modalHTML = `
      <div id="loginModal" class="notranslate" translate="no" style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.75);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        animation: fadeIn 0.3s ease;
      ">
        <div style="
          background: white;
          padding: 50px 40px;
          border-radius: 16px;
          max-width: 550px;
          text-align: center;
          box-shadow: 0 20px 60px rgba(0,0,0,0.4);
          animation: slideUp 0.3s ease;
          position: relative;
        ">
          <button onclick="window.customifyLoginModal.cancel()" style="
            position: absolute;
            top: 15px;
            right: 15px;
            background: transparent;
            border: none;
            font-size: 24px;
            color: #999;
            cursor: pointer;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: all 0.2s;
            padding: 0;
            line-height: 1;
          " onmouseover="this.style.background='#f5f5f5'; this.style.color='#333'" onmouseout="this.style.background='transparent'; this.style.color='#999'">
            ×
          </button>
          <h2 style="
            margin-bottom: 15px; 
            color: #333; 
            font-size: 18px;
            font-weight: 600;
            line-height: 1.5;
          ">Chcesz wygenerować kolejną wersję?</h2>
          
          <p style="
            margin-bottom: 30px;
            color: #666;
            font-size: 15px;
            line-height: 1.5;
          ">Zaloguj się – darmowe generację, zapis swoich projektów</p>
          
          <div style="
            display: flex; 
            gap: 12px; 
            justify-content: center;
            flex-wrap: wrap;
          ">
            <a href="${registerUrl}" onclick="window.customifyLoginModal.trackRegisterClick()" style="
              background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
              color: white;
              padding: 14px 32px;
              border-radius: 8px;
              text-decoration: none;
              font-weight: bold;
              font-size: 16px;
              display: inline-block;
              box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
              transition: transform 0.2s;
            " onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">
              Tak, chcę korzystać
            </a>
            
            <button onclick="window.customifyLoginModal.cancel()" style="
              background: #f5f5f5;
              color: #666;
              padding: 14px 32px;
              border-radius: 8px;
              border: 2px solid #ddd;
              font-weight: bold;
              font-size: 16px;
              cursor: pointer;
              transition: all 0.2s;
            " onmouseover="this.style.background='#e0e0e0'" onmouseout="this.style.background='#f5f5f5'">
              Nie teraz
            </button>
          </div>
          
          <div style="
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #eee;
            text-align: center;
          ">
            <p style="
              color: #666;
              font-size: 14px;
              margin: 0;
            ">
              Szybkie logowanie przez Google lub e-mail.
            </p>
          </div>
        </div>
      </div>
    `;
    
    // CSS Animations
    const styleEl = document.createElement('style');
    styleEl.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes slideUp {
        from { transform: translateY(50px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `;
    document.head.appendChild(styleEl);
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // ✅ ŚLEDZENIE: Wyświetlenie modala logowania
    // GA4
    if (typeof gtag !== 'undefined') {
      gtag('event', 'login_modal_shown', {
        'event_category': 'Customify',
        'event_label': 'Usage Limit Reached',
        'used_count': usedCount,
        'limit': limit,
        'product_url': window.location.pathname,
        'is_logged_in': false
      });
      console.log('📊 [GA4] Event sent: login_modal_shown', {
        usedCount: usedCount,
        limit: limit,
        url: window.location.pathname
      });
    }
    
    // Własny endpoint (widoczne na żywo)
    fetch('https://customify-s56o.vercel.app/api/admin/login-modal-stats', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventType: 'login_modal_shown',
        usedCount: usedCount,
        limit: limit,
        productUrl: window.location.pathname,
        timestamp: new Date().toISOString()
      })
    }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
    
    // Auto-redirect do REJESTRACJI po 5 sekundach (bez widocznego countdown)
    const countdownInterval = setInterval(() => {
      // Sprawdź czy modal nadal istnieje
      const modal = document.getElementById('loginModal');
      if (!modal) {
        clearInterval(countdownInterval);
        return;
      }
      
      // Po 5 sekundach przekieruj
      clearInterval(countdownInterval);
      markAuthIntent('register_auto_redirect');
      
      // ✅ ŚLEDZENIE: Auto-redirect do rejestracji (po 5 sekundach)
      // GA4
      if (typeof gtag !== 'undefined') {
        gtag('event', 'login_modal_auto_redirect', {
          'event_category': 'Customify',
          'event_label': 'Auto Redirect to Register',
          'used_count': usedCount,
          'limit': limit,
          'product_url': window.location.pathname
        });
        console.log('📊 [GA4] Event sent: login_modal_auto_redirect');
      }
      
      // Własny endpoint
      fetch('https://customify-s56o.vercel.app/api/admin/login-modal-stats', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventType: 'login_modal_auto_redirect',
          usedCount: usedCount,
          limit: limit,
          productUrl: window.location.pathname,
          timestamp: new Date().toISOString()
        })
      }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
      
      window.location.href = registerUrl;
    }, 5000);
    
    // Global function to close modal
    window.customifyLoginModal = {
      cancel: () => {
        // ✅ ŚLEDZENIE: Kliknięcie w Anuluj
        // GA4
        if (typeof gtag !== 'undefined') {
          gtag('event', 'login_modal_cancel_click', {
            'event_category': 'Customify',
            'event_label': 'Modal Cancelled',
            'used_count': usedCount,
            'limit': limit,
            'product_url': window.location.pathname
          });
          console.log('📊 [GA4] Event sent: login_modal_cancel_click');
        }
        
        // Własny endpoint
        fetch('https://customify-s56o.vercel.app/api/admin/login-modal-stats', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: 'login_modal_cancel_click',
            usedCount: usedCount,
            limit: limit,
            productUrl: window.location.pathname,
            timestamp: new Date().toISOString()
          })
        }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
        
        clearInterval(countdownInterval);
        document.getElementById('loginModal')?.remove();
        console.log('🚫 [USAGE] Użytkownik zamknął modal');
      },
      
      trackRegisterClick: () => {
        markAuthIntent('register_click');
        // ✅ ŚLEDZENIE: Kliknięcie w Kontynuuj (rejestracja)
        // GA4
        if (typeof gtag !== 'undefined') {
          gtag('event', 'login_modal_register_click', {
            'event_category': 'Customify',
            'event_label': 'Register Button Clicked',
            'used_count': usedCount,
            'limit': limit,
            'product_url': window.location.pathname
          });
          console.log('📊 [GA4] Event sent: login_modal_register_click');
        }
        
        // Własny endpoint
        fetch('https://customify-s56o.vercel.app/api/admin/login-modal-stats', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: 'login_modal_register_click',
            usedCount: usedCount,
            limit: limit,
            productUrl: window.location.pathname,
            timestamp: new Date().toISOString()
          })
        }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
      },
      
      trackLoginClick: () => {
        markAuthIntent('login_click');
        // ✅ ŚLEDZENIE: Kliknięcie w Zaloguj się
        // GA4
        if (typeof gtag !== 'undefined') {
          gtag('event', 'login_modal_login_click', {
            'event_category': 'Customify',
            'event_label': 'Login Link Clicked',
            'used_count': usedCount,
            'limit': limit,
            'product_url': window.location.pathname
          });
          console.log('📊 [GA4] Event sent: login_modal_login_click');
        }
        
        // Własny endpoint
        fetch('https://customify-s56o.vercel.app/api/admin/login-modal-stats', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: 'login_modal_login_click',
            usedCount: usedCount,
            limit: limit,
            productUrl: window.location.pathname,
            timestamp: new Date().toISOString()
          })
        }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
      }
    };
  }

  /**
   * Limit zalogowanego: pierwsza ściana = formularz + doładowanie; kolejne = komunikat o mailu następnego dnia.
   */
  showLimitWallModal(customerInfo, errorJson = {}) {
    const existing = document.getElementById('limitWallModal');
    if (existing) existing.remove();

    const tier = errorJson.wallTier || 'unknown';
    const isFirstWall = tier === 'first_wall';

    const introFirst =
      'Wykorzystałeś dostępne generacje. Napisz, co możemy poprawić — w ciągu ok. 5 minut dodamy Ci kolejne 4 generacje.';
    const introRetry =
      errorJson.message ||
      'Wykorzystałeś wszystkie dostępne generacje. Następnego dnia możemy zwiększyć limit i wyślemy Ci maila z informacją.';

    const formBlock = isFirstWall
      ? `
          <form id="limitWallForm">
            <label style="display:block; font-size: 14px; font-weight: 600; color: #444; margin-bottom: 6px;">
              Co poprawić na naszej stronie, żebyś chętniej kupował? <span style="color:#c00">*</span>
            </label>
            <textarea name="fixImage" required minlength="10" rows="3" style="
              width: 100%; box-sizing: border-box; padding: 10px 12px; border: 1px solid #ddd; border-radius: 8px;
              font-size: 14px; margin-bottom: 14px; resize: vertical; font-family: inherit;
            " placeholder="Np. twarz, kolorystyka, tło…"></textarea>

            <label style="display:block; font-size: 14px; font-weight: 600; color: #444; margin-bottom: 6px;">
              Nie ma prezentu którego szukasz? Jakiego?
            </label>
            <textarea name="giftSearch" rows="2" style="
              width: 100%; box-sizing: border-box; padding: 10px 12px; border: 1px solid #ddd; border-radius: 8px;
              font-size: 14px; margin-bottom: 14px; resize: vertical; font-family: inherit;
            " placeholder="Opcjonalnie — pomoże nam dopasować ofertę"></textarea>

            <p id="limitWallFormError" style="display:none; color:#c00; font-size: 14px; margin: 0 0 12px;"></p>
            <div style="display: flex; gap: 10px; flex-wrap: wrap; justify-content: flex-end;">
              <button type="button" onclick="window.customifyLimitWallModal.close()" style="
                background: #f5f5f5; color: #666; padding: 12px 22px; border-radius: 8px; border: 2px solid #ddd;
                font-weight: 600; font-size: 15px; cursor: pointer;
              ">Zamknij</button>
              <button type="submit" id="limitWallSubmit" style="
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: white; padding: 12px 22px; border-radius: 8px; border: none;
                font-weight: 600; font-size: 15px; cursor: pointer;
              ">Wyślij i doładuj konto</button>
            </div>
          </form>`
      : `
          <p style="margin: 0 0 22px; color: #555; font-size: 15px; line-height: 1.55;">${introRetry.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</p>
          <div style="text-align: right;">
            <button type="button" onclick="window.customifyLimitWallModal.close()" style="
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white; padding: 12px 22px; border-radius: 8px; border: none;
              font-weight: 600; font-size: 15px; cursor: pointer;
            ">Rozumiem</button>
          </div>`;

    const modalHTML = `
      <div id="limitWallModal" style="
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0,0,0,0.75); display: flex; align-items: center; justify-content: center;
        z-index: 99999; padding: 16px; box-sizing: border-box;
      ">
        <div style="
          background: white; padding: 32px 26px; border-radius: 16px; max-width: 520px; width: 100%;
          text-align: left; box-shadow: 0 20px 60px rgba(0,0,0,0.4); position: relative; max-height: 90vh; overflow-y: auto;
        ">
          <button type="button" onclick="window.customifyLimitWallModal.close()" style="
            position: absolute; top: 10px; right: 10px; background: transparent; border: none;
            font-size: 24px; color: #999; cursor: pointer; width: 32px; height: 32px; line-height: 1;
          ">×</button>
          <h2 style="margin: 0 0 12px; color: #333; font-size: 18px; font-weight: 600;">Odbierz darmowe generacje</h2>
          ${isFirstWall ? `<p style="margin: 0 0 18px; color: #666; font-size: 15px; line-height: 1.55;">${introFirst.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</p>` : ''}
          ${formBlock}
        </div>
      </div>`;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    window.customifyLimitWallModal = {
      close: () => document.getElementById('limitWallModal')?.remove(),
    };

    if (!isFirstWall) return;

    const form = document.getElementById('limitWallForm');
    const errEl = document.getElementById('limitWallFormError');
    const submitBtn = document.getElementById('limitWallSubmit');
    if (!form || !errEl || !submitBtn) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errEl.style.display = 'none';
      errEl.textContent = '';
      const fd = new FormData(form);
      const body = {
        customerId: customerInfo.customerId,
        fixImage: (fd.get('fixImage') || '').trim(),
        giftSearch: (fd.get('giftSearch') || '').trim(),
        productUrl: window.location.pathname + window.location.search,
      };
      submitBtn.disabled = true;
      submitBtn.textContent = 'Wysyłanie…';
      try {
        const r = await fetch('https://customify-s56o.vercel.app/api/limit-wall-feedback', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) {
          errEl.textContent = data.message || data.error || 'Nie udało się wysłać. Spróbuj ponownie.';
          errEl.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Wyślij i doładuj konto';
          return;
        }
        window.customifyLimitWallModal.close();
        this.showSuccess(data.message || 'Dziękujemy! Konto zostało doładowane — sprawdź maila.', { html: false });
      } catch (err) {
        console.error('❌ [LIMIT-WALL] Submit failed:', err);
        this._reportToSentry(err, 'limit-wall-submit');
        errEl.textContent = 'Błąd sieci. Spróbuj ponownie.';
        errEl.style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Wyślij i doładuj konto';
      }
    });
  }

  /**
   * Pokazuje licznik użyć w UI
   */
  async showUsageCounter() {
    // Licznik ukryty - użytkownik zobaczy komunikat dopiero gdy wyczerpie limit
    return;
    
    // Usage counter initialization
    const customerInfo = this.getCustomerInfo();
    console.log('🔍 [USAGE] Customer info:', customerInfo ? 'logged in' : 'not logged in');
    let counterHTML = '';
    
    if (!customerInfo) {
      // Niezalogowany - UKRYJ licznik (nie pokazuj komunikatu)
      console.log(`🔍 [USAGE] Not logged in - hiding usage counter`);
      counterHTML = ''; // Nie pokazuj komunikatu dla niezalogowanych
    } else {
      // Zalogowany - pobierz z API
      console.log('🔍 [USAGE] Fetching usage data from API...');
      try {
        const response = await fetch('https://customify-s56o.vercel.app/api/check-usage', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            customerId: customerInfo.customerId,
            customerAccessToken: customerInfo.customerAccessToken
          })
        });
        
        if (response.ok) {
          const data = await response.json();
          const remaining = data.remainingCount || 0;
          const totalLimit = data.totalLimit || 3;
          
          console.log(`🔍 [USAGE] API response - remaining: ${remaining}, totalLimit: ${totalLimit}`);
          
          if (remaining > 0) {
            // Niebieski - zalogowany, pozostało transformacji
            counterHTML = `
              <div id="usageCounter" class="usage-counter usage-counter-blue">
                ✅ Zalogowany: ${remaining}/${totalLimit} transformacji
              </div>
            `;
          } else {
            // Czerwony - limit wykorzystany
            counterHTML = `
              <div id="usageCounter" class="usage-counter usage-counter-red">
                ❌ Wykorzystano ${totalLimit}/${totalLimit} transformacji
              </div>
            `;
          }
        } else {
          console.warn('⚠️ [USAGE] Failed to fetch usage data:', response.status);
          // Fallback - pokaż że jest zalogowany ale nie wiemy ile ma transformacji
          counterHTML = `
            <div id="usageCounter" class="usage-counter usage-counter-blue">
              ✅ Zalogowany - sprawdzanie limitów...
            </div>
          `;
        }
      } catch (error) {
        console.error('❌ [USAGE] Error fetching usage counter:', error);
        this._reportToSentry(error, 'usage-counter');
        // Fallback - pokaż że jest zalogowany ale nie wiemy ile ma transformacji
        counterHTML = `
          <div id="usageCounter" class="usage-counter usage-counter-blue">
            ✅ Zalogowany - sprawdzanie limitów...
          </div>
        `;
      }
    }
    
    console.log('🔍 [USAGE] counterHTML generated:', counterHTML ? 'YES' : 'NO', counterHTML.substring(0, 100));
    
    // Wstaw licznik do DOM (przed upload area)
    const uploadArea = document.getElementById('uploadArea');
    console.log('🔍 [USAGE] uploadArea found:', !!uploadArea);
    
    if (uploadArea && counterHTML) {
      // Usuń stary licznik jeśli istnieje
      const oldCounter = document.getElementById('usageCounter');
      if (oldCounter) {
        oldCounter.remove();
        console.log('🔍 [USAGE] Removed old counter');
      }
      
      // Wstaw nowy licznik przed upload area
      uploadArea.insertAdjacentHTML('beforebegin', counterHTML);
      console.log('✅ [USAGE] Usage counter displayed successfully');
    } else {
      if (!uploadArea) {
        console.warn('⚠️ [USAGE] Upload area not found - counter not displayed');
      }
      if (!counterHTML) {
        console.warn('⚠️ [USAGE] counterHTML is empty - counter not displayed');
      }
    }
  }

  // filterStylesForProduct() USUNIĘTE - logika przeniesiona na server-side (Shopify Liquid)

  // ETSY-STYLE EXPANDABLE DESCRIPTION USUNIĘTE - opisy produktów są teraz pełne

  // ACCORDION: SZCZEGÓŁY PRODUKTU
  setupAccordion() {
    if (!window.location.pathname.includes('/products/')) {
      return;
    }

    console.log('🎯 [CUSTOMIFY] Setting up accordion...');
    
    // Znajdź accordion items tylko w aplikacji produktowej (nie na stronie FAQ)
    const accordionItems = document.querySelectorAll('#customify-app-container .accordion-item');
    
    if (!accordionItems || accordionItems.length === 0) {
      console.log('⚠️ [CUSTOMIFY] No accordion items found');
      return;
    }
    
    console.log('✅ [CUSTOMIFY] Found', accordionItems.length, 'accordion items');
    
    // Dodaj event listener do każdego accordion header
    accordionItems.forEach((item, index) => {
      const header = item.querySelector('.accordion-header');
      
      if (!header) {
        console.log('⚠️ [CUSTOMIFY] No header found for item', index);
        return;
      }
      
      // Event listener - TYLKO toggle klasy (BEZ DOM manipulation)
      header.addEventListener('click', () => {
        const isExpanded = item.classList.contains('expanded');
        
        if (isExpanded) {
          // Zwiń
          item.classList.remove('expanded');
          console.log('🔽 [CUSTOMIFY] Collapsed:', item.dataset.accordion);
        } else {
          // Rozwiń (opcjonalnie: zwiń inne)
          // accordionItems.forEach(otherItem => otherItem.classList.remove('expanded'));
          item.classList.add('expanded');
          console.log('🔼 [CUSTOMIFY] Expanded:', item.dataset.accordion);
        }
      });
      
      console.log('✅ [CUSTOMIFY] Accordion item', index, 'setup complete');
    });
    
    console.log('✅ [CUSTOMIFY] Accordion setup complete!');
  }

  // WSTRZYJ APLIKACJĘ DO KOLUMNY 2
  positionApp() {
    if (!window.location.pathname.includes('/products/')) {
      return;
    }

    const appContainer = document.getElementById('customify-app-container');
    if (!appContainer) return;

    // Znajdź kolumnę 2 (detale produktu)
    const productDetails = document.querySelector('#ProductInformation-template--26351135293765__main') || 
                          document.querySelector('.product-details') ||
                          document.querySelector('.product__info');

    if (productDetails) {
      console.log('🎯 [CUSTOMIFY] Found product details column, inserting app at top');
      
      // Dodaj elementy pod tytułem
      this.addProductBadges();
      
      // Pokaż aplikację
      appContainer.style.display = 'block';
      
      // Wstaw na górę kolumny 2
      productDetails.insertBefore(appContainer, productDetails.firstChild);
      
      // USTAW FINALNY UKŁAD ELEMENTÓW
      this.setFinalLayout();
    } else {
      console.warn('⚠️ [CUSTOMIFY] Could not find product details column');
    }
  }


  // USTAW FINALNY UKŁAD ELEMENTÓW - JEDNA FUNKCJA, BEZ HISTORII PRZENIESIEŃ
  setFinalLayout() {
    console.log('🎯 [LAYOUT] Ustawiam finalny układ elementów...');
    
    // 1. ZNAJDŹ GŁÓWNY KONTENER
    const productInfoColumn = document.querySelector('[id^="ProductInformation-"]');
    if (!productInfoColumn) {
      console.warn('⚠️ [LAYOUT] Nie znaleziono ProductInformation');
      return;
    }

    // 2. ZNAJDŹ WSZYSTKIE ELEMENTY
    const titleElement = document.querySelector('.group-block[data-testid="group-block"] [class*="product_title"]')?.parentElement?.parentElement;
    const descriptionElement = document.querySelector('rte-formatter');
    const priceElement = document.querySelector('product-price');
    const productTypeArea = document.getElementById('productTypeArea');
    const sizeArea = document.getElementById('sizeArea');

    console.log('📦 [LAYOUT] Znalezione elementy:', {
      title: !!titleElement,
      description: !!descriptionElement,
      price: !!priceElement,
      productType: !!productTypeArea,
      sizes: !!sizeArea
    });

    // 3. UTWÓRZ KONTENER DLA UPORZĄDKOWANYCH ELEMENTÓW
    let orderedContainer = productInfoColumn.querySelector('.customify-ordered-layout');
    if (!orderedContainer) {
      orderedContainer = document.createElement('div');
      orderedContainer.className = 'customify-ordered-layout';
      orderedContainer.style.cssText = `
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
      `;
      productInfoColumn.appendChild(orderedContainer);
    }

    // 4. USTAW KOLEJNOŚĆ: TYTUŁ > OPIS > CENA > TYPY > ROZMIARY
    if (titleElement && !titleElement.classList.contains('layout-set')) {
      orderedContainer.appendChild(titleElement);
      titleElement.classList.add('layout-set');
      console.log('✅ [LAYOUT] Tytuł ustawiony');
    }

    if (descriptionElement && !descriptionElement.classList.contains('layout-set')) {
      orderedContainer.appendChild(descriptionElement);
      descriptionElement.classList.add('layout-set');
      console.log('✅ [LAYOUT] Opis ustawiony');
    }

    const phoneHelp = document.getElementById('customifyPhoneOrderHelp');
    if (phoneHelp && descriptionElement && descriptionElement.nextElementSibling !== phoneHelp) {
      descriptionElement.insertAdjacentElement('afterend', phoneHelp);
      phoneHelp.classList.add('is-placed');
    }

    if (priceElement && !priceElement.classList.contains('layout-set')) {
      orderedContainer.appendChild(priceElement);
      priceElement.classList.add('layout-set');
      console.log('✅ [LAYOUT] Cena ustawiona');
    }

    if (productTypeArea && !productTypeArea.classList.contains('layout-set')) {
      orderedContainer.appendChild(productTypeArea);
      productTypeArea.classList.add('layout-set');
      console.log('✅ [LAYOUT] Typy materiału ustawione');
    }

    if (sizeArea && !sizeArea.classList.contains('layout-set')) {
      orderedContainer.appendChild(sizeArea);
      sizeArea.classList.add('layout-set');
      console.log('✅ [LAYOUT] Rozmiary ustawione');
    }

    console.log('🎉 [LAYOUT] Finalny układ ustawiony!');

    // NIE ukrywamy ceny - zostawiamy oryginalną pozycję Shopify
    // (usunięto klonowanie ceny ze względu na potencjalne problemy z cloakingiem Google)

    // DODAJ DIVIDER POD ROZMIARAMI
    this.addDividerAfterSizes();

    console.log('✅ [CUSTOMIFY] Title moved to top successfully!');
  }



  // DODAJ DIVIDER POD ROZMIARAMI
  addDividerAfterSizes() {
    // Sprawdź czy już nie ma dividera
    if (document.querySelector('.customify-title-divider')) {
      console.log('🎯 [CUSTOMIFY] Divider already exists');
      return;
    }

    // Znajdź kontener z rozmiarami
    const sizeArea = document.getElementById('sizeArea');
    if (!sizeArea) {
      console.warn('⚠️ [CUSTOMIFY] Could not find sizeArea for divider');
      return;
    }

    // Stwórz divider
    const divider = document.createElement('div');
    divider.className = 'customify-title-divider';
    divider.style.cssText = `
      width: 100%;
      height: 1px;
      background-color: #ccc;
      margin: 15px 0;
      border-radius: 0.5px;
    `;

    // Dodaj divider po rozmiarach
    sizeArea.parentNode.insertBefore(divider, sizeArea.nextSibling);

    console.log('✅ [CUSTOMIFY] Divider added after sizes');
  }

  // FUNKCJA USUNIĘTA: showPriceBelowApp()
  // Powód: Potencjalne problemy z cloakingiem Google (klonowanie elementów DOM)
  // Cena pozostaje w oryginalnej pozycji Shopify

  // DODAJ GWIAZDKI DO OPISU PRODUKTU (rte-formatter)
  addProductBadges() {
    console.log('🎯 [CUSTOMIFY] Dodaję gwiazdki do opisu produktu...');
    
    // Znajdź opis produktu (rte-formatter)
    const descriptionElement = document.querySelector('rte-formatter');
    if (!descriptionElement) {
      console.log('⚠️ [CUSTOMIFY] Nie znaleziono rte-formatter');
      return;
    }

    // Sprawdź czy już nie ma badge'ów
    if (document.querySelector('.product-badges')) {
      console.log('⚠️ [CUSTOMIFY] Badge\'y już istnieją');
      return;
    }

    // Stwórz kontener dla badge'ów
    const badgesContainer = document.createElement('div');
    badgesContainer.className = 'product-badges';
    badgesContainer.style.cssText = 'margin-bottom: 16px; display: block;';

    // Dodaj sekcję z gwiazdkami
    const ratingSection = document.createElement('div');
    ratingSection.className = 'rating-section';

    const stars = document.createElement('div');
    stars.className = 'stars';
    for (let i = 0; i < 5; i++) {
      const star = document.createElement('span');
      star.className = 'star';
      star.innerHTML = '★';
      stars.appendChild(star);
    }

    const reviewCount = document.createElement('span');
    reviewCount.className = 'review-count';
    reviewCount.textContent = '(143)';

    ratingSection.appendChild(stars);
    ratingSection.appendChild(reviewCount);

    // Dodaj do kontenera
    badgesContainer.appendChild(ratingSection);

    // DODAJ GWIAZDKI NA POCZĄTEK OPISU (przed tekstem w rte-formatter)
    descriptionElement.insertBefore(badgesContainer, descriptionElement.firstChild);
    
    // DODAJ MARGINES DO TEKSTU OPISU (aby gwiazdki nie zasłaniały)
    const descriptionText = descriptionElement.querySelector('p, .p1');
    if (descriptionText) {
      descriptionText.style.setProperty('margin-top', '24px', 'important');
      console.log('✅ [CUSTOMIFY] Margines dodany do tekstu opisu: 24px');
    }
    
    console.log('✅ [CUSTOMIFY] Gwiazdki dodane do opisu produktu');
  }

  setupEventListeners() {
    this.uploadArea.addEventListener('click', () => {
      const input = document.getElementById('fileInput');
      if (input) input.click();
    });
    // 🔧 Delegacja na document - działa nawet gdy fileInput jest przeniesiony w DOM (po tryAgain/showResult)
    document.addEventListener('change', (e) => {
      if (e.target.id === 'fileInput' && e.target.files?.length > 0) {
        this.handleFileSelect(e.target.files[0]);
      }
    });
    
    this.uploadArea.addEventListener('dragover', (e) => {
      e.preventDefault();
      this.uploadArea.classList.add('dragover');
    });
    
    this.uploadArea.addEventListener('dragleave', () => {
      this.uploadArea.classList.remove('dragover');
    });
    
    this.uploadArea.addEventListener('drop', (e) => {
      e.preventDefault();
      this.uploadArea.classList.remove('dragover');
      this.handleFileSelect(e.dataTransfer.files[0]);
    });

    this.stylesArea.addEventListener('click', (e) => {
      console.log('🖱️ [CLICK] Kliknięcie w stylesArea:', e.target);
      console.log('🖱️ [CLICK] Czy to customify-style-card?', e.target.classList.contains('customify-style-card'));
      console.log('🖱️ [CLICK] Czy closest?', e.target.closest('.customify-style-card'));
      
      if (e.target.classList.contains('customify-style-card') || 
          e.target.closest('.customify-style-card')) {
        const card = e.target.classList.contains('customify-style-card') ? 
                    e.target : e.target.closest('.customify-style-card');
        console.log('🖱️ [CLICK] Znaleziona karta:', card);
        console.log('🖱️ [CLICK] data-style:', card?.dataset?.style);
        this.selectStyle(card);
      } else {
        console.log('🖱️ [CLICK] Kliknięcie poza kartą stylu');
      }
    });

    // Event listener dla rozmiarów - sprawdź zarówno główny jak i w resultArea
    document.addEventListener('click', (e) => {
      const sizeBtn = e.target.closest('.customify-size-btn');
      if (sizeBtn) {
        if (sizeBtn.classList.contains('disabled')) {
          e.preventDefault();
          return;
        }
        this.selectSize(sizeBtn);
      }
    });

    // Event listener dla wyboru typu produktu (Plakat vs Canvas)
    document.addEventListener('click', (e) => {
      if (e.target.id === 'textOverlayToggleBtn') {
        return; // nie traktuj toggle jako wyboru typu produktu
      }
      if (e.target.classList.contains('customify-product-type-btn')) {
        this.selectProductType(e.target);
      }
    });

    document.getElementById('transformBtn').addEventListener('click', () => this.transformImage());
    document.getElementById('resetBtn').addEventListener('click', () => this.reset());
    document.getElementById('addToCartBtn').addEventListener('click', () => this.addToCart());
    document.getElementById('addToCartBtnMain').addEventListener('click', () => this.addToCart());
    const addToCartBtnPhoneCase = document.getElementById('addToCartBtnPhoneCase');
    if (addToCartBtnPhoneCase) addToCartBtnPhoneCase.addEventListener('click', () => this.addToCart());
    document.getElementById('tryAgainBtn').addEventListener('click', () => this.tryAgain());

    if (this.isPilotImageEditProduct()) {
      this.ensurePilotEditDom();
      if (this.pilotEditBtn && this.pilotEditPanel) this.initPilotImageEditor();
    }

    if (this.spotifyCropConfirmBtn) {
      this.spotifyCropConfirmBtn.addEventListener('click', () => this.confirmSpotifyCrop());
    }
    if (this.spotifyCropCancelBtn) {
      this.spotifyCropCancelBtn.addEventListener('click', () => this.cancelSpotifyCrop());
    }
    
    // 📱 Telefon - event listenery dla croppera (sprawdź w momencie użycia)
    const phoneCropConfirmBtn = document.getElementById('phoneCropConfirmBtn');
    const phoneCropCancelBtn = document.getElementById('phoneCropCancelBtn');
    if (phoneCropConfirmBtn) {
      phoneCropConfirmBtn.addEventListener('click', () => this.confirmPhoneCrop());
    }
    if (phoneCropCancelBtn) {
      phoneCropCancelBtn.addEventListener('click', () => this.cancelPhoneCrop());
    }
    
    // 📱 Telefon (etui) - event listenery dla croppera
    const phonePhotoCropConfirmBtn = document.getElementById('phonePhotoCropConfirmBtn');
    const phonePhotoCropCancelBtn = document.getElementById('phonePhotoCropCancelBtn');
    if (phonePhotoCropConfirmBtn) {
      phonePhotoCropConfirmBtn.addEventListener('click', () => this.confirmPhonePhotoCrop());
    }
    if (phonePhotoCropCancelBtn) {
      phonePhotoCropCancelBtn.addEventListener('click', () => this.cancelPhonePhotoCrop());
    }

    const familyPortraitCropConfirmBtn = document.getElementById('familyPortraitCropConfirmBtn');
    const familyPortraitCropCancelBtn = document.getElementById('familyPortraitCropCancelBtn');
    if (familyPortraitCropConfirmBtn) {
      familyPortraitCropConfirmBtn.addEventListener('click', () => this.confirmFamilyPortraitCrop());
    }
    if (familyPortraitCropCancelBtn) {
      familyPortraitCropCancelBtn.addEventListener('click', () => this.cancelFamilyPortraitCrop());
    }
    
    // 🎵 Kliknięcie w preview image otwiera cropper ponownie (ponowne kadrowanie)
    if (this.isCropperProduct()) {
      if (this.isPhonePhotoCaseProduct()) {
        // 📱 Phone case: click na preview (przed AI) i result (po AI) - ponowne kadrowanie
        const photoBg = document.getElementById('phoneCasePhotoBg');
        const resultBg = document.getElementById('phoneCaseResultBg');
        [photoBg, resultBg].forEach(el => {
          if (el) {
            el.style.cursor = 'pointer';
            el.title = 'Kliknij aby ponownie wykadrować zdjęcie';
            el.addEventListener('click', () => this.reopenPhonePhotoCropper());
          }
        });
      } else if (this.previewImage) {
        this.previewImage.style.cursor = 'pointer';
        this.previewImage.title = 'Kliknij aby ponownie wykadrować zdjęcie';
        if (this.isPhoneCaseProduct()) {
          this.previewImage.addEventListener('click', () => this.reopenPhoneCropper());
        } else {
          this.previewImage.addEventListener('click', () => this.reopenSpotifyCropper());
        }
      }
    }
    
    // 📱 Phone case preview initialization (background-image mode)
    if (this.isPhonePhotoCaseProduct()) {
      console.log('📱 [PHONE PREVIEW] Initializing phone case preview (background-image mode)...');
      const photoBg = document.getElementById('phoneCasePhotoBg');
      if (photoBg) {
        console.log(`📱 [PHONE PREVIEW] Found preview background div`);
      } else {
        console.warn('⚠️ [PHONE PREVIEW] No preview background div found - HTML may not be updated');
      }
      
      // Debug: Log rendered sizes
      setTimeout(() => {
        const inner = document.querySelector('#customify-app-container .phone-case-inner');
        const overlay = document.querySelector('#customify-app-container .phone-case-overlay');
        const photoBgEl = document.getElementById('phoneCasePhotoBg');
        if (inner) {
          const innerRect = inner.getBoundingClientRect();
          console.log('[PHONE PREVIEW] inner rect', {
            width: innerRect.width,
            height: innerRect.height,
            aspectRatio: innerRect.width / innerRect.height,
            expectedRatio: 559 / 1154
          });
        }
        if (overlay) {
          const overlayRect = overlay.getBoundingClientRect();
          console.log('[PHONE PREVIEW] overlay rect', {
            width: overlayRect.width,
            height: overlayRect.height,
            aspectRatio: overlayRect.width / overlayRect.height,
            expectedRatio: 559 / 1154
          });
        }
        if (photoBgEl) {
          const photoBgRect = photoBgEl.getBoundingClientRect();
          console.log('[PHONE PREVIEW] photo-bg rect', {
            width: photoBgRect.width,
            height: photoBgRect.height,
            aspectRatio: photoBgRect.width / photoBgRect.height
          });
        }
      }, 500);
    }
  }
  
  // 🎵 Ponowne otwarcie croppera z oryginalnym zdjęciem
  reopenSpotifyCropper() {
    if (!this.originalSpotifyFile) {
      console.warn('⚠️ [SPOTIFY] Brak oryginalnego zdjęcia do ponownego kadrowania');
      return;
    }
    console.log('🎵 [SPOTIFY] Ponowne otwieranie croppera z oryginalnym zdjęciem');
    
    // Resetuj flagę spotifyBezZmianActive żeby syncPosition znów działał
    window.spotifyBezZmianActive = false;
    
    // Otwórz cropper z oryginalnym zdjęciem
    this.openSpotifyCropper(this.originalSpotifyFile);
  }

  /**
   * Inicjalizacja UI napisów (tylko produkt z przeglądarkowym overlay)
   */
  setupTextOverlayUI() {
    if (this.textOverlayEnabled) {
      this.textOverlayPanel = document.getElementById('textOverlayPanel') || this.textOverlayPanel;
      this.textOverlayInput = document.getElementById('textOverlayInput') || this.textOverlayInput;
      this.textOverlayCounter = document.getElementById('textOverlayCounter') || this.textOverlayCounter;
      this.textOverlaySaveBtn = document.getElementById('textOverlaySaveBtn') || this.textOverlaySaveBtn;
      this.textOverlayHint = document.getElementById('textOverlayHint') || this.textOverlayHint;
      this.textOverlayColorSelect = document.getElementById('textOverlayColorSelect') || this.textOverlayColorSelect;
      this.textOverlayFontSelect = document.getElementById('textOverlayFontSelect') || this.textOverlayFontSelect;
      this.textOverlaySizeSelect = document.getElementById('textOverlaySizeSelect') || this.textOverlaySizeSelect;
      this.textOverlayToggleBtn = document.getElementById('textOverlayToggleBtn') || this.textOverlayToggleBtn;
    }

    if (!this.textOverlayEnabled) {
      if (this.textOverlayPanel) {
        this.textOverlayPanel.style.display = 'none';
      }
      return;
    }

    if (this.textOverlayInput && this.textOverlayCounter) {
      this.textOverlayInput.addEventListener('input', () => {
        this.updateTextOverlayCounter();
        this.textOverlayState.applied = false;
        
        // ✅ DEBOUNCE: Opóźnij preview o 80ms żeby nie renderować przy każdym znaku
        if (this.textOverlayDebounceTimer) {
          clearTimeout(this.textOverlayDebounceTimer);
        }
        this.textOverlayDebounceTimer = setTimeout(() => {
          this.previewTextOverlay().catch(err => {
            console.error('❌ [TEXT-OVERLAY] auto-preview error:', err);
          });
        }, 80);
      });
      this.updateTextOverlayCounter();
    }

    const bindSelect = (selectEl, key) => {
      if (!selectEl) return;
      selectEl.addEventListener('change', () => {
        // Specjalna logika dla kolorów: opcje z "-banner" wymuszają tło
        if (selectEl === this.textOverlayColorSelect) {
          const value = selectEl.value;
          const isBanner = value?.endsWith('-banner');
          const baseColor = isBanner ? value.replace('-banner', '') : value;
          this.textOverlayState.color = baseColor;
          this.textOverlayState.preset = isBanner ? 'banner' : 'classic';
        } else {
          this.textOverlayState[key] = selectEl.value;
        }
        this.textOverlayState.applied = false;
        
        // ✅ DEBOUNCE: Opóźnij preview o 80ms (tak samo jak dla input)
        if (this.textOverlayDebounceTimer) {
          clearTimeout(this.textOverlayDebounceTimer);
        }
        this.textOverlayDebounceTimer = setTimeout(() => {
          this.previewTextOverlay().catch(err => {
            console.error('❌ [TEXT-OVERLAY] auto-preview error:', err);
          });
        }, 80);
      });
    };

    bindSelect(this.textOverlayColorSelect, 'color');
    bindSelect(this.textOverlayFontSelect, 'font');
    bindSelect(this.textOverlaySizeSelect, 'size');

    if (this.textOverlayToggleBtn && this.textOverlayPanel) {
      this.textOverlayToggleBtn.addEventListener('click', () => {
        const isOpen = this.textOverlayPanel.style.display !== 'none';
        if (isOpen) {
          this.textOverlayPanel.style.display = 'none';
          this.textOverlayToggleBtn.setAttribute('data-overlay-open', 'false');
        } else {
          this.textOverlayPanel.style.display = 'block';
          this.textOverlayToggleBtn.setAttribute('data-overlay-open', 'true');
        }
      });
    }

    if (this.textOverlaySaveBtn) {
      this.textOverlaySaveBtn.addEventListener('click', () => {
        this.saveTextOverlay().catch(err => {
          console.error('❌ [TEXT-OVERLAY] save error:', err);
          this.showError('Nie udało się zapisać napisu. Spróbuj ponownie.', 'cart');
        });
      });
    }

    this.textOverlayState = {
      ...this.textOverlayState,
      preset: 'classic',
      color: this.textOverlayColorSelect?.value || null,
      font: this.textOverlayFontSelect?.value || null,
      size: this.textOverlaySizeSelect?.value || null
    };

    if (this.textOverlayPanel) {
      this.textOverlayPanel.style.display = 'none';
    }
  }

  updateTextOverlayCounter() {
    if (!this.textOverlayInput || !this.textOverlayCounter) return;
    const current = this.textOverlayInput.value.length;
    const max = this.textOverlayInput.maxLength || 80;
    this.textOverlayCounter.textContent = `${current}/${max}`;
  }

  updateTextOverlayHint(message = '') {
    if (!this.textOverlayHint) return;
    if (message) {
      this.textOverlayHint.textContent = message;
      this.textOverlayHint.style.display = 'block';
    } else {
      this.textOverlayHint.style.display = 'none';
    }
  }

  updateSpotifyFrameScale(retryCount = 0) {
    if (!this.isSpotifyProduct()) return;
    const containers = document.querySelectorAll('.spotify-frame-preview, .spotify-frame-result');
    if (!containers.length) return;

    let needsRetry = false;
    containers.forEach(container => {
      const inner = container.querySelector('.spotify-frame-inner');
      if (!inner) return;
      const styles = window.getComputedStyle(container);
      const padX = parseFloat(styles.paddingLeft || '0') + parseFloat(styles.paddingRight || '0');
      const padY = parseFloat(styles.paddingTop || '0') + parseFloat(styles.paddingBottom || '0');
      const availableWidth = Math.max(0, container.clientWidth - padX);
      
      // Jeśli container nie ma jeszcze wymiarów, zaplanuj retry
      if (availableWidth <= 0) {
        needsRetry = true;
        return;
      }
      
      const scale = availableWidth / 1024;
      inner.style.transform = `scale(${scale})`;
      container.style.height = `${1536 * scale + padY}px`;
    });
    
    // Retry max 10 razy co 50ms jeśli container nie ma wymiarów
    if (needsRetry && retryCount < 10) {
      setTimeout(() => this.updateSpotifyFrameScale(retryCount + 1), 50);
    }
  }

  /**
   * 🎵 Komponuje finalny obraz dla ramka-spotify
   * Zawiera: tło + zdjęcie użytkownika + maska spotify + teksty
   * @returns {Promise<string>} Base64 skomponowanego obrazu
   */
  async composeSpotifyImage() {
    return new Promise((resolve, reject) => {
      console.log('🎵 [SPOTIFY COMPOSE] Starting image composition...');
      
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Wymiary ramki spotify
      canvas.width = 1024;
      canvas.height = 1536;
      
      // 1. Przezroczyste tło (dla druku na szkle - podświetlane ramki)
      // Canvas domyślnie ma przezroczyste tło
      
      // 2. Zdjęcie użytkownika (wykadrowane)
      const userImage = new Image();
      userImage.crossOrigin = 'anonymous';
      
      // Użyj wykadrowanego zdjęcia (base64) lub transformedImage (URL – przez proxy przy Vercel Blob)
      let imageSource = this.spotifyCropDataUrl || this.transformedImage;
      if (imageSource && typeof imageSource === 'string' && imageSource.startsWith('http')) {
        imageSource = this.getCanvasSafeImageUrl(imageSource);
      }
      if (!imageSource) {
        reject(new Error('Brak zdjęcia do kompozycji'));
        return;
      }
      
      userImage.onload = () => {
        console.log('🎵 [SPOTIFY COMPOSE] User image loaded:', userImage.width, 'x', userImage.height);
        
        // Rysuj zdjęcie użytkownika w pozycji 61,61 o rozmiarze 902x902
        ctx.drawImage(userImage, 61, 61, 902, 902);
        
        // 3. Nałóż maskę spotify
        const maskImage = new Image();
        maskImage.crossOrigin = 'anonymous';
        maskImage.src = 'https://customify-s56o.vercel.app/spotify/biale_male.png';
        
        maskImage.onload = () => {
          console.log('🎵 [SPOTIFY COMPOSE] Mask loaded');
          ctx.drawImage(maskImage, 0, 0, canvas.width, canvas.height);
          
          // 4. Dodaj teksty
          const titleInput = document.getElementById('spotifyTitle');
          const artistInput = document.getElementById('spotifyArtist');
          const titleText = titleInput ? titleInput.value : '';
          const artistText = artistInput ? artistInput.value : '';
          
          // Pozycja tekstów (między zdjęciem a kontrolerami) - zgodna z CSS (top: 1000px)
          // Używamy textBaseline = 'top' żeby pozycjonować od góry tekstu (jak w CSS)
          ctx.textBaseline = 'top';
          const textY = 1000; // Zgodne z CSS .spotify-text-overlay { top: 1000px; }
          
          // Nagłówek - gruby, BIAŁY, wyrównany do lewej
          if (titleText) {
            ctx.font = 'bold 72px Arial, sans-serif';
            ctx.fillStyle = '#ffffff';
            ctx.textAlign = 'left';
            ctx.fillText(titleText, 61, textY);
            console.log('🎵 [SPOTIFY COMPOSE] Title added:', titleText);
          }
          
          // Podpis - cieńszy, BIAŁY, wyrównany do lewej
          // Oblicz pozycję na podstawie wysokości nagłówka (72px) + odstęp (6px jak w CSS margin-bottom)
          if (artistText) {
            ctx.font = '48px Arial, sans-serif';
            ctx.fillStyle = '#ffffff';
            ctx.textAlign = 'left';
            ctx.fillText(artistText, 61, textY + 72 + 6); // 72px (wysokość nagłówka) + 6px (margin-bottom z CSS)
            console.log('🎵 [SPOTIFY COMPOSE] Artist added:', artistText);
          }
          
          // 5. Eksportuj jako PNG (przezroczystość dla druku na szkle!)
          const composedImagePNG = canvas.toDataURL('image/png');
          console.log('🎵 [SPOTIFY COMPOSE] PNG for print, size:', composedImagePNG.length);
          
          // 6. Eksportuj również JPEG z ciemniejszym szarym tłem (dla podglądu w koszyku - lepiej widać białe napisy)
          ctx.globalCompositeOperation = 'destination-over';
          ctx.fillStyle = '#9a9a9a';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          const composedImagePreview = canvas.toDataURL('image/jpeg', 0.92);
          console.log('🎵 [SPOTIFY COMPOSE] JPEG preview, size:', composedImagePreview.length);
          
          // Zwróć oba obrazy
          const composedImage = { png: composedImagePNG, preview: composedImagePreview };
          
          resolve(composedImage);
        };
        
        maskImage.onerror = (err) => {
          console.error('🎵 [SPOTIFY COMPOSE] Failed to load mask:', err);
          reject(new Error('Nie udało się załadować maski spotify'));
        };
      };
      
      userImage.onerror = (err) => {
        console.error('🎵 [SPOTIFY COMPOSE] Failed to load user image:', err);
        reject(new Error('Nie udało się załadować zdjęcia'));
      };
      
      userImage.src = imageSource;
    });
  }

  getTextOverlayPayload() {
    if (!this.textOverlayEnabled || !this.textOverlayState.applied) return null;
    return {
      text: (this.textOverlayState.text || '').trim(),
      preset: this.textOverlayState.preset,
      color: this.textOverlayState.color,
      font: this.textOverlayState.font,
      size: this.textOverlayState.size
    };
  }

  openSpotifyCropper(file) {
    if (!this.spotifyCropModal || !this.spotifyCropImage) {
      this.showPreview(file);
      return;
    }
    if (typeof Cropper === 'undefined') {
      console.warn('⚠️ [SPOTIFY] CropperJS not loaded, fallback to normal preview');
      this.showPreview(file);
      return;
    }

    // 🎵 Zachowaj oryginalne zdjęcie do ponownego kadrowania
    this.originalSpotifyFile = file;
    console.log('🎵 [SPOTIFY] Zapisano oryginalne zdjęcie do ponownego kadrowania');

    this.spotifyCropConfirmed = false;
    if (this.spotifyCropper) {
      this.spotifyCropper.destroy();
      this.spotifyCropper = null;
    }
    if (this.spotifyCropSourceUrl) {
      URL.revokeObjectURL(this.spotifyCropSourceUrl);
      this.spotifyCropSourceUrl = null;
    }

    this.spotifyCropSourceUrl = URL.createObjectURL(file);
    this.spotifyCropImage.src = this.spotifyCropSourceUrl;
    this.spotifyCropModal.classList.add('is-open');
    this.spotifyCropModal.setAttribute('aria-hidden', 'false');

    const cropConfig = this.getCropConfig();
    this.spotifyCropper = new Cropper(this.spotifyCropImage, {
      aspectRatio: cropConfig.aspectRatio,
      viewMode: 1,
      autoCropArea: 1,
      responsive: true,
      movable: true,
      zoomable: true,
      zoomOnTouch: true,
      zoomOnWheel: true,
      background: false
    });
  }

  closeSpotifyCropper() {
    if (this.spotifyCropper) {
      this.spotifyCropper.destroy();
      this.spotifyCropper = null;
    }
    if (this.spotifyCropSourceUrl) {
      URL.revokeObjectURL(this.spotifyCropSourceUrl);
      this.spotifyCropSourceUrl = null;
    }
    if (this.spotifyCropModal) {
      this.spotifyCropModal.classList.remove('is-open');
      this.spotifyCropModal.setAttribute('aria-hidden', 'true');
    }
  }

  confirmSpotifyCrop() {
    if (!this.spotifyCropper) return;
    const cropConfig = this.getCropConfig();
    const canvas = this.spotifyCropper.getCroppedCanvas({
      width: cropConfig.width,
      height: cropConfig.height,
      imageSmoothingQuality: 'high'
    });
    canvas.toBlob((blob) => {
      if (!blob) {
        this.showError('Nie udało się przyciąć zdjęcia', 'transform');
        return;
      }
      const croppedFile = new File([blob], `${cropConfig.filePrefix}-${Date.now()}.jpg`, { type: 'image/jpeg' });
      this.uploadedFile = croppedFile;
      this.spotifyCropConfirmed = true;
      this.spotifyCropDataUrl = canvas.toDataURL('image/jpeg', 0.9); // Zapisz dla composeSpotifyImage
      this.closeSpotifyCropper();
      this.showPreview(croppedFile);
      this.hideError();
      
      // 🎵 Produkt bez AI - automatycznie aktywuj flow "bez-zmian" po kadrowanie
      if (this.isSpotifyNoAIProduct()) {
        console.log('🎵 [SPOTIFY NO-AI] Automatyczne przejście do koszyka po kadrowanie');
        this.selectedStyle = 'bez-zmian'; // Ustaw styl na "bez-zmian"
        setTimeout(() => this.handleBezZmianStyle(), 100); // Poczekaj na showPreview
      }
    }, 'image/jpeg', 0.9);
  }

  cancelSpotifyCrop() {
    this.uploadedFile = null;
    this.spotifyCropConfirmed = false;
    if (this.fileInput) {
      this.fileInput.value = '';
    }
    this.closeSpotifyCropper();
  }

  // 📱 TELEFON - Otwórz cropper
  openPhoneCropper(file) {
    // Sprawdź elementy w momencie użycia (nie w konstruktorze - mogą nie być w DOM)
    const phoneCropModal = document.getElementById('phoneCropModal');
    const phoneCropImage = document.getElementById('phoneCropImage');
    
    if (!phoneCropModal || !phoneCropImage) {
      console.warn('⚠️ [PHONE] Brak elementów croppera, fallback do normalnego preview');
      this.showPreview(file);
      return;
    }
    
    if (typeof Cropper === 'undefined') {
      console.warn('⚠️ [PHONE] CropperJS not loaded, fallback to normal preview');
      this.showPreview(file);
      return;
    }

    this.originalPhoneFile = file;
    console.log('📱 [PHONE] Zapisano oryginalne zdjęcie do ponownego kadrowania');

    this.phoneCropConfirmed = false;
    if (this.phoneCropper) {
      this.phoneCropper.destroy();
      this.phoneCropper = null;
    }
    if (this.phoneCropSourceUrl) {
      URL.revokeObjectURL(this.phoneCropSourceUrl);
      this.phoneCropSourceUrl = null;
    }

    this.phoneCropSourceUrl = URL.createObjectURL(file);
    phoneCropImage.src = this.phoneCropSourceUrl;
    phoneCropModal.classList.add('is-open');
    phoneCropModal.setAttribute('aria-hidden', 'false');

    const cropConfig = this.getPhoneCropConfig();
    this.phoneCropper = new Cropper(phoneCropImage, {
      aspectRatio: cropConfig.aspectRatio,
      viewMode: 1,
      autoCropArea: 1,
      responsive: true,
      movable: true,
      zoomable: true,
      zoomOnTouch: true,
      zoomOnWheel: true,
      background: false
    });
  }

  // 📱 TELEFON - Zamknij cropper
  closePhoneCropper() {
    if (this.phoneCropper) {
      this.phoneCropper.destroy();
      this.phoneCropper = null;
    }
    if (this.phoneCropSourceUrl) {
      URL.revokeObjectURL(this.phoneCropSourceUrl);
      this.phoneCropSourceUrl = null;
    }
    const phoneCropModal = document.getElementById('phoneCropModal');
    if (phoneCropModal) {
      phoneCropModal.classList.remove('is-open');
      phoneCropModal.setAttribute('aria-hidden', 'true');
    }
  }

  // 📱 TELEFON - Potwierdź kadrowanie
  confirmPhoneCrop() {
    if (!this.phoneCropper) return;
    const cropConfig = this.getPhoneCropConfig();
    const canvas = this.phoneCropper.getCroppedCanvas({
      width: cropConfig.width,
      height: cropConfig.height,
      imageSmoothingQuality: 'high'
    });
    canvas.toBlob((blob) => {
      if (!blob) {
        this.showError('Nie udało się przyciąć zdjęcia', 'transform');
        return;
      }
      const croppedFile = new File([blob], `${cropConfig.filePrefix}-${Date.now()}.jpg`, { type: 'image/jpeg' });
      this.uploadedFile = croppedFile;
      this.phoneCropConfirmed = true;
      this.phoneCropDataUrl = canvas.toDataURL('image/jpeg', 0.9);
      this.closePhoneCropper();
      this.showPreview(croppedFile);
      this.hideError();
    }, 'image/jpeg', 0.9);
  }

  // 📱 TELEFON - Anuluj kadrowanie
  cancelPhoneCrop() {
    this.uploadedFile = null;
    this.phoneCropConfirmed = false;
    if (this.fileInput) {
      this.fileInput.value = '';
    }
    this.closePhoneCropper();
  }

  // 📱 TELEFON - Ponowne otwarcie croppera
  reopenPhoneCropper() {
    if (!this.originalPhoneFile) {
      console.warn('⚠️ [PHONE] Brak oryginalnego zdjęcia do ponownego kadrowania');
      return;
    }
    console.log('📱 [PHONE] Ponowne otwieranie croppera z oryginalnym zdjęciem');
    this.openPhoneCropper(this.originalPhoneFile);
  }
  
  // 📱 TELEFON (ETUI) - Otwórz cropper
  openPhonePhotoCropper(file) {
    const phonePhotoCropModal = document.getElementById('phonePhotoCropModal');
    const phonePhotoCropImage = document.getElementById('phonePhotoCropImage');
    
    if (!phonePhotoCropModal || !phonePhotoCropImage) {
      console.warn('⚠️ [PHONE-PHOTO] Brak elementów croppera, fallback do normalnego preview');
      this.showPreview(file);
      return;
    }
    
    if (typeof Cropper === 'undefined') {
      console.warn('⚠️ [PHONE-PHOTO] CropperJS not loaded, fallback to normal preview');
      this.showPreview(file);
      return;
    }
    
    this.originalPhonePhotoFile = file;
    console.log('📱 [PHONE-PHOTO] Zapisano oryginalne zdjęcie do ponownego kadrowania');
    
    this.phonePhotoCropConfirmed = false;
    if (this.phonePhotoCropper) {
      this.phonePhotoCropper.destroy();
      this.phonePhotoCropper = null;
    }
    if (this.phonePhotoCropSourceUrl) {
      URL.revokeObjectURL(this.phonePhotoCropSourceUrl);
      this.phonePhotoCropSourceUrl = null;
    }
    
    this.phonePhotoCropSourceUrl = URL.createObjectURL(file);
    
    // Hide watermark overlay initially (will be shown in reopenPhonePhotoCropper if needed)
    const watermarkOverlay = document.getElementById('phonePhotoCropWatermark');
    if (watermarkOverlay) {
      watermarkOverlay.style.display = 'none';
    }
    
    phonePhotoCropModal.classList.add('is-open');
    phonePhotoCropModal.setAttribute('aria-hidden', 'false');
    
    const cropConfig = this.getPhonePhotoCropConfig();
    const initCropper = () => {
      if (this.phonePhotoCropper) return;
      this.phonePhotoCropper = new Cropper(phonePhotoCropImage, {
        aspectRatio: cropConfig.aspectRatio,
        viewMode: 1,
        autoCropArea: 1,
        responsive: true,
        movable: true,
        zoomable: true,
        zoomOnTouch: true,
        zoomOnWheel: false,
        background: false
      });
    };
    phonePhotoCropImage.onload = () => {
      phonePhotoCropImage.onload = null;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          initCropper();
        });
      });
    };
    phonePhotoCropImage.src = this.phonePhotoCropSourceUrl;
    
    // Powiększone uchwyty croppera - z-index nad watermark, widoczne
    setTimeout(() => {
      const canvas = phonePhotoCropModal.querySelector('.phone-photo-crop-canvas');
      if (canvas) {
        const style = document.createElement('style');
        style.textContent = '.phone-photo-crop-canvas .cropper-point{width:20px!important;height:20px!important;background:#39f!important;border:2px solid #fff!important;box-shadow:0 0 0 1px rgba(0,0,0,.2)!important;z-index:10!important}.phone-photo-crop-canvas .cropper-line,.phone-photo-crop-canvas .cropper-face{border-color:#39f!important;border-width:2px!important;z-index:5!important}';
        document.head.appendChild(style);
      }
    }, 100);
  }
  
  // 📱 TELEFON (ETUI) - Zamknij cropper
  closePhonePhotoCropper() {
    if (this.phonePhotoCropper) {
      this.phonePhotoCropper.destroy();
      this.phonePhotoCropper = null;
    }
    if (this.phonePhotoCropSourceUrl) {
      URL.revokeObjectURL(this.phonePhotoCropSourceUrl);
      this.phonePhotoCropSourceUrl = null;
    }
    const phonePhotoCropModal = document.getElementById('phonePhotoCropModal');
    if (phonePhotoCropModal) {
      if (document.activeElement && phonePhotoCropModal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      phonePhotoCropModal.classList.remove('is-open');
      phonePhotoCropModal.setAttribute('aria-hidden', 'true');
    }
  }
  
  // 📱 TELEFON (ETUI) - Potwierdź kadrowanie
  confirmPhonePhotoCrop() {
    if (!this.phonePhotoCropper) return;
    const cropConfig = this.getPhonePhotoCropConfig();
    
    const finishWithCropped = (printDataUrl, displayDataUrl) => {
      displayDataUrl = displayDataUrl || printDataUrl;
      this.phonePhotoCropDataUrl = printDataUrl;
      this.closePhonePhotoCropper();
      if (this.transformedImage) {
        const resultBg = document.getElementById('phoneCaseResultBg');
        const photoBg = document.getElementById('phoneCasePhotoBg');
        if (resultBg) resultBg.style.backgroundImage = `url(${displayDataUrl})`;
        if (photoBg) photoBg.style.backgroundImage = `url(${displayDataUrl})`;
        if (this.resultImage) this.resultImage.src = displayDataUrl;
        this.transformedImage = printDataUrl;
        this.textOverlayBaseImage = printDataUrl; // 📱 Napis na wykadrowanym, nie na pełnym
      } else {
        const blob = this.dataUrlToBlob(printDataUrl);
        if (blob) this.showPreview(new File([blob], `${cropConfig.filePrefix}-${Date.now()}.jpg`, { type: 'image/jpeg' }));
        else this.showError('Nie udało się przygotować zdjęcia', 'transform');
      }
      this.phonePhotoCropConfirmed = true;
      const blob = this.dataUrlToBlob(printDataUrl);
      this.uploadedFile = blob ? new File([blob], `${cropConfig.filePrefix}-${Date.now()}.jpg`, { type: 'image/jpeg' }) : null;
      this.hideError();
    };
    
    if (this.phonePhotoCropSourceIsWatermarked && this.transformedImage) {
      const data = this.phonePhotoCropper.getData();
      const displayDataUrl = this.phonePhotoCropper.getCroppedCanvas({ width: cropConfig.width, height: cropConfig.height, imageSmoothingQuality: 'high' }).toDataURL('image/jpeg', 0.9);
      const cleanUrl = this.transformedImage.startsWith('http') ? this.getCanvasSafeImageUrl(this.transformedImage) : this.transformedImage;
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const c = document.createElement('canvas');
        c.width = cropConfig.width;
        c.height = cropConfig.height;
        const ctx = c.getContext('2d');
        ctx.drawImage(img, data.x, data.y, data.width, data.height, 0, 0, c.width, c.height);
        finishWithCropped(c.toDataURL('image/jpeg', 0.9), displayDataUrl);
      };
      img.onerror = () => finishWithCropped(displayDataUrl, displayDataUrl);
      img.src = cleanUrl;
      return;
    }
    
    const canvas = this.phonePhotoCropper.getCroppedCanvas({
      width: cropConfig.width,
      height: cropConfig.height,
      imageSmoothingQuality: 'high'
    });
    canvas.toBlob((blob) => {
      if (!blob) {
        this.showError('Nie udało się przyciąć zdjęcia', 'transform');
        return;
      }
      const dataUrl = canvas.toDataURL('image/jpeg', 0.9);
      finishWithCropped(dataUrl);
    }, 'image/jpeg', 0.9);
  }
  
  // 📱 TELEFON (ETUI) - Anuluj kadrowanie
  cancelPhonePhotoCrop() {
    this.uploadedFile = null;
    this.phonePhotoCropConfirmed = false;
    if (this.fileInput) {
      this.fileInput.value = '';
    }
    this.closePhonePhotoCropper();
  }
  
  // 📱 TELEFON (ETUI) - Ponowne otwarcie croppera
  async reopenPhonePhotoCropper() {
    // 📱 ZAWSZE watermark widoczny: ładujemy obraz Z watermarkem do croppera
    // Przy zapisie: stosujemy ten sam crop do czystego obrazu (dla druku)
    const watermarkedSource = this.watermarkedImageBase64 || this.watermarkedImageUrl;
    
    if (watermarkedSource && this.transformedImage) {
      try {
        let file;
        if (watermarkedSource.startsWith('data:')) {
          file = await this.base64ToFile(watermarkedSource, 'phone-photo-watermarked.jpg');
        } else if (watermarkedSource.startsWith('http') || watermarkedSource.includes('blob.vercel-storage.com')) {
          file = await this.urlToFile(this.getCanvasSafeImageUrl(watermarkedSource), 'phone-photo-watermarked.jpg');
        } else {
          // Backend zwraca raw base64 (bez prefiksu) dla etui
          const dataUrl = `data:image/jpeg;base64,${watermarkedSource}`;
          file = await this.base64ToFile(dataUrl, 'phone-photo-watermarked.jpg');
        }
        this.phonePhotoCropSourceIsWatermarked = true;
        this.openPhonePhotoCropper(file);
      } catch (error) {
        console.error('❌ [PHONE-PHOTO] Błąd ładowania watermarked:', error);
        this._reportToSentry(error, 'phone-photo-load');
        this.showError('Nie udało się załadować obrazu do edycji. Odśwież stronę i spróbuj ponownie.', 'transform');
      }
    } else if (this.originalPhonePhotoFile) {
      this.phonePhotoCropSourceIsWatermarked = false;
      this.openPhonePhotoCropper(this.originalPhonePhotoFile);
    } else {
      console.warn('⚠️ [PHONE-PHOTO] Brak obrazu do kadrowania');
    }
  }

  async handleFileSelect(file) {
    if (!file) return;
    this._sentryCrumb('upload', 'Upload zdjęcia', { type: file.type, size: file.size });
    if (!this._isImageFile(file)) {
      this.trackStatsEvent('image_upload_failed', {
        errorCode: 'INVALID_FILE_TYPE',
        errorMessage: 'Wybrany plik nie jest obrazem'
      });
      this.showError('Proszę wybrać plik obrazu (JPG, PNG, GIF)');
      return;
    }
    if (file.size > 15 * 1024 * 1024) {
      this.trackStatsEvent('image_upload_failed', {
        errorCode: 'FILE_TOO_LARGE',
        errorMessage: 'Plik jest za duży'
      });
      this.showError('Plik jest za duży. Maksymalny rozmiar to 15MB');
      return;
    }

    this.hideError();
    this.trackStatsEvent('image_upload');

    try {
      file = await this._prepareUploadFile(file);
    } catch (error) {
      console.error('❌ [UPLOAD] normalize failed:', error);
      this._reportToSentry(error, 'upload_normalize', this.getUploadStatsContext(file));
      this.showError(error.message || 'Nie udało się wczytać zdjęcia. Spróbuj wybrać je jeszcze raz.');
      if (this.fileInput) this.fileInput.value = '';
      return;
    }

    if (this.isCropperProduct()) {
      console.log('🔍 [DEBUG] isCropperProduct = true');
      if (this.isPhoneCaseProduct()) {
        console.log('📱 [DEBUG] isPhoneCaseProduct = true, otwieram phone cropper');
        this.phoneCropConfirmed = false;
        this.openPhoneCropper(file);
      } else if (this.isPhonePhotoCaseProduct()) {
        console.log('📱 [DEBUG] isPhonePhotoCaseProduct = true, otwieram phone photo cropper');
        this.phonePhotoCropConfirmed = false;
        this.phonePhotoCropSourceIsWatermarked = false;
        this.openPhonePhotoCropper(file);
      } else {
        console.log('🎵 [DEBUG] isPhoneCaseProduct = false, otwieram spotify cropper');
        this.spotifyCropConfirmed = false;
        this.openSpotifyCropper(file);
      }
      return;
    }
    console.log('🔍 [DEBUG] isCropperProduct = false, normalny upload');
    this.uploadedFile = file;
    this.showPreview(file);

    // 🔧 Reset fileInput.value żeby kolejny wybór (nawet tego samego pliku) zawsze odpalił change
    if (this.fileInput) this.fileInput.value = '';

    // ✅ Google Ads Conversion Tracking - Image Upload Event
    if (typeof gtag !== 'undefined') {
      // Wyślij konwersję Google Ads z właściwym send_to ID
      gtag('event', 'conversion', {
        'send_to': 'AW-858040473/1k70CIur7LQbEJnRkpkD',
        'event_category': 'Customify',
        'event_label': 'Image Uploaded',
        'product_url': window.location.pathname,
        'file_size': file.size,
        'file_type': file.type
      });
      console.log('📊 [GOOGLE ADS] Conversion event sent: image_upload', 'AW-858040473/1k70CIur7LQbEJnRkpkD');
    } else {
      console.warn('⚠️ [GOOGLE ADS] gtag not available - conversion not tracked');
    }
  }

  trackStatsEvent(eventType, extra = {}) {
    // DISABLED: Blob read/write per event was causing ~$108/mo Fast Origin Transfer
    return;
  }

  trackUiErrorShown(message, location = 'top', isHtml = false) {
    try {
      const text = String(message || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 300);

      this.trackStatsEvent('customify_ui_error_shown', {
        errorLocation: location,
        errorMessage: text,
        isHtml,
        selectedStyle: this.selectedStyle || null,
        selectedSize: this.selectedSize || null,
        selectedProductType: this.selectedProductType || null,
        productHandle: this.getProductHandle ? this.getProductHandle() : null,
        hasUploadedFile: !!this.uploadedFile,
        hasTransformedImage: !!this.transformedImage,
        isOnline: typeof navigator.onLine === 'boolean' ? navigator.onLine : null,
        userAgent: navigator.userAgent || null
      });
    } catch (err) {
      console.log('📊 [UI-ERROR] Tracking error:', err);
    }
  }

  revokePreviewObjectUrl() {
    if (this.previewObjectUrl && typeof URL !== 'undefined' && typeof URL.revokeObjectURL === 'function') {
      URL.revokeObjectURL(this.previewObjectUrl);
    }
    this.previewObjectUrl = null;
  }

  getUploadFileExtension(fileName) {
    if (!fileName || typeof fileName !== 'string' || !fileName.includes('.')) return null;
    return fileName.split('.').pop().toLowerCase().slice(0, 20) || null;
  }

  getUploadStatsContext(file, extra = {}) {
    const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : null;
    return {
      fileType: file?.type || null,
      fileSize: Number.isFinite(file?.size) ? file.size : null,
      fileExtension: this.getUploadFileExtension(file?.name),
      userAgent,
      ...extra
    };
  }

  _isHeicLike(file) {
    const fileType = (file?.type || '').toLowerCase();
    const fileExtension = this.getUploadFileExtension(file?.name);
    return fileType.includes('heic') || fileType.includes('heif') || fileExtension === 'heic' || fileExtension === 'heif';
  }

  _detectImageKindFromBuffer(buffer) {
    const u8 = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer || []);
    if (u8.length >= 3 && u8[0] === 0xFF && u8[1] === 0xD8 && u8[2] === 0xFF) return 'jpeg';
    if (u8.length >= 8 && u8[0] === 0x89 && u8[1] === 0x50 && u8[2] === 0x4E && u8[3] === 0x47) return 'png';
    if (u8.length >= 12 && u8[0] === 0x52 && u8[1] === 0x49 && u8[2] === 0x46 && u8[3] === 0x46) {
      const webp = String.fromCharCode(u8[8], u8[9], u8[10], u8[11]);
      if (webp === 'WEBP') return 'webp';
    }
    if (u8.length >= 12) {
      const brand = String.fromCharCode(u8[4], u8[5], u8[6], u8[7]);
      if (brand === 'ftyp') {
        const header = String.fromCharCode(...u8.slice(8, Math.min(u8.length, 24))).toLowerCase();
        if (/hei[cf]|mif1|msf1|hevc|hevx/.test(header)) return 'heic';
      }
    }
    return 'unknown';
  }

  _isImageFile(file) {
    if (!file) return false;
    const type = (file.type || '').toLowerCase();
    const ext = this.getUploadFileExtension(file.name);
    if (type.startsWith('image/')) return true;
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif', 'bmp', 'avif'].includes(ext);
  }

  _shouldNormalizeUpload(file) {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const type = (file?.type || '').toLowerCase();
    const ext = this.getUploadFileExtension(file?.name);
    if (/Android/i.test(ua)) return true;
    if (this._isHeicLike(file)) return true;
    if ((!type || type === 'application/octet-stream') && ext && ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif', 'bmp'].includes(ext)) {
      return true;
    }
    return false;
  }

  _normalizeFileName(name, newExt) {
    const base = (name || 'zdjecie').replace(/\.[^.]+$/, '').slice(0, 80);
    return `${base || 'zdjecie'}.${newExt}`;
  }

  _arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    const len = bytes.length;
    let binary = '';
    for (let i = 0; i < len; i += 32768) {
      const chunk = bytes.subarray(i, Math.min(i + 32768, len));
      binary += String.fromCharCode.apply(null, chunk);
    }
    return btoa(binary);
  }

  async _readFileAsArrayBuffer(file) {
    if (file && typeof file.arrayBuffer === 'function') {
      return await file.arrayBuffer();
    }
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error || new Error('FileReader arrayBuffer failed'));
      reader.readAsArrayBuffer(file);
    });
  }

  async _bitmapToJpegBlob(bitmap, quality = 0.9) {
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas 2d unavailable');
    ctx.drawImage(bitmap, 0, 0);
    if (typeof bitmap.close === 'function') bitmap.close();
    return await new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error('canvas.toBlob returned null'));
      }, 'image/jpeg', quality);
    });
  }

  _blobToJpegFile(blob, originalName, lastModified) {
    const normalized = new File([blob], this._normalizeFileName(originalName, 'jpg'), {
      type: 'image/jpeg',
      lastModified: lastModified || Date.now()
    });
    normalized._customifyNormalized = true;
    return normalized;
  }

  async _loadHeic2Any() {
    if (typeof window !== 'undefined' && window.heic2any) return window.heic2any;
    return await new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-customify-heic2any]');
      if (existing) {
        existing.addEventListener('load', () => resolve(window.heic2any));
        existing.addEventListener('error', () => reject(new Error('heic2any script failed to load')));
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
      script.async = true;
      script.setAttribute('data-customify-heic2any', '1');
      script.onload = () => resolve(window.heic2any);
      script.onerror = () => reject(new Error('heic2any script failed to load'));
      document.head.appendChild(script);
    });
  }

  async _convertHeicToJpeg(file) {
    const heic2any = await this._loadHeic2Any();
    const converted = await heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.9
    });
    const blob = Array.isArray(converted) ? converted[0] : converted;
    if (!blob) throw new Error('heic2any returned empty');
    console.log('✅ [UPLOAD] HEIC converted via heic2any');
    return this._blobToJpegFile(blob, file.name, file.lastModified);
  }

  async _normalizeViaCreateImageBitmap(file) {
    if (typeof createImageBitmap !== 'function') return null;
    const bitmap = await createImageBitmap(file);
    const blob = await this._bitmapToJpegBlob(bitmap);
    console.log('✅ [UPLOAD] normalized via createImageBitmap');
    return this._blobToJpegFile(blob, file.name, file.lastModified);
  }

  async _normalizeViaCanvasBlob(blob, originalName, lastModified) {
    const objectUrl = URL.createObjectURL(blob);
    try {
      const img = await new Promise((resolve, reject) => {
        const el = new Image();
        el.onload = () => resolve(el);
        el.onerror = () => reject(new Error('Image decode failed'));
        el.src = objectUrl;
      });
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth || img.width;
      canvas.height = img.naturalHeight || img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Canvas 2d unavailable');
      ctx.drawImage(img, 0, 0);
      const jpegBlob = await new Promise((resolve, reject) => {
        canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('toBlob null'))), 'image/jpeg', 0.9);
      });
      console.log('✅ [UPLOAD] normalized via canvas/decode');
      return this._blobToJpegFile(jpegBlob, originalName, lastModified);
    } finally {
      URL.revokeObjectURL(objectUrl);
    }
  }

  async normalizeUploadFile(file) {
    if (!file) throw new Error('Brak pliku');
    if (file._customifyNormalized) return file;

    // Android Chrome: po nieudanym createImageBitmap oryginalny File bywa
    // odłączony (NotReadableError). Czytamy bajty RAZ, dalej pracujemy na kopii.
    let buffer = null;
    try {
      buffer = await this._readFileAsArrayBuffer(file);
    } catch (err) {
      console.warn('⚠️ [UPLOAD] first arrayBuffer read failed:', err?.message || err);
    }

    const kind = buffer ? this._detectImageKindFromBuffer(buffer) : 'unknown';
    const mimeFromKind = kind === 'png' ? 'image/png' : kind === 'webp' ? 'image/webp' : kind === 'heic' ? 'image/heic' : 'image/jpeg';
    const declaredMime = (file.type || '').startsWith('image/') ? file.type : mimeFromKind;
    const workBlob = buffer && buffer.byteLength > 0
      ? new Blob([buffer], { type: kind === 'heic' ? 'image/heic' : declaredMime })
      : file;
    let sourceForHeic = workBlob;
    try {
      if (buffer && buffer.byteLength > 0) {
        sourceForHeic = new File([buffer], file.name || 'zdjecie.jpg', {
          type: kind === 'heic' ? 'image/heic' : declaredMime,
          lastModified: file.lastModified || Date.now()
        });
      }
    } catch (err) {
      sourceForHeic = workBlob;
    }

    const looksHeic = kind === 'heic' || this._isHeicLike(file) || (kind === 'unknown' && /Android/i.test(typeof navigator !== 'undefined' ? navigator.userAgent : ''));

    if (looksHeic) {
      try {
        return await this._convertHeicToJpeg(sourceForHeic);
      } catch (err) {
        console.warn('⚠️ [UPLOAD] HEIC conversion failed:', err?.message || err);
      }
    }

    try {
      const viaBitmap = await this._normalizeViaCreateImageBitmap(workBlob);
      if (viaBitmap) return viaBitmap;
    } catch (err) {
      console.warn('⚠️ [UPLOAD] createImageBitmap normalize failed:', err?.message || err);
    }

    try {
      if (workBlob) {
        return await this._normalizeViaCanvasBlob(workBlob, file.name, file.lastModified);
      }
    } catch (err) {
      console.warn('⚠️ [UPLOAD] arrayBuffer/canvas normalize failed:', err?.message || err);
    }

    if (!looksHeic) {
      try {
        return await this._convertHeicToJpeg(sourceForHeic);
      } catch (err) {
        console.warn('⚠️ [UPLOAD] HEIC fallback failed:', err?.message || err);
      }
    }

    throw new Error('Nie udało się wczytać zdjęcia. Spróbuj wybrać je jeszcze raz.');
  }

  async _prepareUploadFile(file) {
    if (!file || !this._shouldNormalizeUpload(file)) return file;
    this._sentryCrumb('upload', 'Normalizacja pliku (Android/mobile)', {
      type: file.type,
      size: file.size,
      name: file.name
    });
    return await this.normalizeUploadFile(file);
  }

  showPreview(file) {
    const minShortEdge = 250;
    const minArea = 70000;
    const recommendedShortEdge = 450;
    const recommendedArea = 220000;
    const canUseObjectUrl = typeof URL !== 'undefined' && typeof URL.createObjectURL === 'function';
    const baseUploadStats = this.getUploadStatsContext(file);

    const applyPreviewSource = (previewSrc, previewMethod) => {
      const img = new Image();
      img.onload = () => {
        const shortEdge = Math.min(img.width, img.height);
        const area = img.width * img.height;
        
        console.log(`🖼️ [IMAGE] Rozdzielczość: ${img.width}×${img.height}`);
        console.log(`🖼️ [IMAGE] Minimalny krótszy bok: ${minShortEdge}px`);
        console.log(`🖼️ [IMAGE] Minimalne pole obrazu: ${minArea}px²`);
        
        // Blokujemy tylko naprawdę małe pliki; słabsze, ale używalne zdjęcia przepuszczamy dalej.
        if (shortEdge < minShortEdge || area < minArea) {
          this.trackStatsEvent('image_upload_failed', {
            ...baseUploadStats,
            errorCode: 'IMAGE_TOO_SMALL',
            errorCategory: 'upload_rejected_quality',
            previewMethod,
            imageWidth: img.width,
            imageHeight: img.height,
            imageShortEdge: shortEdge,
            imageArea: area,
            errorMessage: `Zdjęcie jest za małe: ${img.width}x${img.height} (short:${shortEdge}, area:${area})`
          });
          this.showError(`Zdjęcie jest za małe. Wymagamy min. ${minShortEdge}px na krótszym boku i co najmniej ${minArea.toLocaleString('pl-PL')} pikseli łącznie. Twoje zdjęcie: ${img.width}×${img.height}px.`);
          this.previewArea.style.display = 'none';
          this.uploadedFile = null;
          this.revokePreviewObjectUrl();
          this.fileInput.value = '';
          return;
        }

        if (shortEdge < recommendedShortEdge || area < recommendedArea) {
          this.trackStatsEvent('image_upload_low_resolution', {
            ...baseUploadStats,
            previewMethod,
            imageWidth: img.width,
            imageHeight: img.height,
            imageShortEdge: shortEdge,
            imageArea: area,
            errorMessage: `Zdjęcie ma niską rozdzielczość: ${img.width}x${img.height} (short:${shortEdge}, area:${area})`
          });
          console.warn(`⚠️ [IMAGE] Niska rozdzielczość zdjęcia (${img.width}×${img.height}), ale upload nie jest blokowany.`);
        }
        
        // Zdjęcie OK - pokaż podgląd
        // 📱 Phone case: use background-image instead of img src
        if (this.isPhonePhotoCaseProduct()) {
          const photoBg = document.getElementById('phoneCasePhotoBg');
          const inner = document.querySelector('#customify-app-container .phone-case-inner');
          if (photoBg) {
            photoBg.style.backgroundImage = `url(${previewSrc})`;
            console.log('[PHONE PREVIEW] set background image', previewSrc.substring(0, 50) + '...');
            if (inner) {
              const innerRect = inner.getBoundingClientRect();
              console.log('[PHONE PREVIEW] inner rect', {
                width: innerRect.width,
                height: innerRect.height,
                aspectRatio: innerRect.width / innerRect.height
              });
            }
          }
          // Keep previewImage hidden but set src for compatibility
          if (this.previewImage) {
            this.previewImage.src = previewSrc;
          }
        } else {
          this.previewImage.src = previewSrc;
        }
        this.previewArea.style.display = 'block';
        console.log(`✅ [IMAGE] Rozdzielczość OK (short >= ${minShortEdge}px, area >= ${minArea}px²)`);

        // Przywróć wybór stylu i akcje po resecie („Wgraj inne zdjęcie”).
        // Używamy wspólnej logiki, aby produkty z ukrytym stylem nadal
        // automatycznie wybierały właściwy styl (np. caricature-new).
        this.showStyles();
        
        // 🎵 Spotify frame: przelicz skalę po pokazaniu preview (z opóźnieniem na layout)
        setTimeout(() => this.updateSpotifyFrameScale(), 50);
        
        // Ukryj "Dodaj do koszyka" i pokaż "Wgraj inne zdjęcie" po wgraniu zdjęcia
        const addToCartBtnMain = document.getElementById('addToCartBtnMain');
        const resetBtn = document.getElementById('resetBtn');
        if (addToCartBtnMain) {
          addToCartBtnMain.style.display = 'none';
        }
        // 🎵 Dla produktu bez AI nie pokazuj "Wgraj inne zdjęcie" - upload jest zawsze widoczny na górze
        if (resetBtn && !this.isSpotifyNoAIProduct()) {
          resetBtn.style.display = 'inline-block';
        }
        this.trackStatsEvent('image_upload_preview_ready');
        // Mobile: zdjęcie pod headerem, pola i „Zobacz Podgląd” na dole ekranu
        this.scrollMobileComposer('preview');
      };
      
      img.onerror = async () => {
        if (!file._customifyPreviewRetried) {
          file._customifyPreviewRetried = true;
          try {
            const normalized = await this.normalizeUploadFile(file);
            this.uploadedFile = normalized;
            this.revokePreviewObjectUrl();
            this.showPreview(normalized);
            return;
          } catch (retryError) {
            console.warn('⚠️ [UPLOAD] Preview retry normalize failed:', retryError?.message || retryError);
          }
        }
        const fileType = (baseUploadStats.fileType || '').toLowerCase();
        const fileExtension = (baseUploadStats.fileExtension || '').toLowerCase();
        const isHeicLike = fileType.includes('heic') || fileType.includes('heif') || fileExtension === 'heic' || fileExtension === 'heif';
        const loadErrorMessage = isHeicLike
          ? 'Nie udało się wczytać zdjęcia HEIC. Spróbuj wybrać je jeszcze raz.'
          : 'Nie udało się wczytać zdjęcia. Spróbuj wybrać je jeszcze raz.';
        this.trackStatsEvent('image_upload_failed', {
          ...baseUploadStats,
          errorCode: 'IMAGE_LOAD_ERROR',
          errorCategory: 'upload_technical',
          previewMethod,
          errorMessage: loadErrorMessage
        });
        this.showError(loadErrorMessage);
        this.uploadedFile = null;
        this.revokePreviewObjectUrl();
        this.fileInput.value = '';
      };
      
      img.src = previewSrc;
    };

    this.revokePreviewObjectUrl();

    if (canUseObjectUrl) {
      try {
        this.previewObjectUrl = URL.createObjectURL(file);
        applyPreviewSource(this.previewObjectUrl, 'object_url');
        return;
      } catch (error) {
        console.warn('⚠️ [UPLOAD] URL.createObjectURL failed, fallback to FileReader:', error);
      }
    }

    if (typeof FileReader === 'undefined') {
      console.error('❌ [UPLOAD] Brak wsparcia dla podglądu obrazu');
      this.trackStatsEvent('image_upload_failed', {
        ...baseUploadStats,
        errorCode: 'FILE_READER_UNSUPPORTED',
        errorCategory: 'upload_technical',
        previewMethod: 'unsupported',
        errorMessage: 'Przeglądarka nie obsługuje podglądu obrazu'
      });
      this.showError('Twoja przeglądarka nie obsługuje wgrywania zdjęć. Zaktualizuj przeglądarkę lub spróbuj na innym urządzeniu.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => applyPreviewSource(e.target.result, 'file_reader');
    reader.onerror = () => {
      this.trackStatsEvent('image_upload_failed', {
        ...baseUploadStats,
        errorCode: 'FILE_READ_ERROR',
        errorCategory: 'upload_technical',
        previewMethod: 'file_reader',
        readerErrorName: reader.error?.name || null,
        readerErrorMessage: reader.error?.message || null,
        errorMessage: `Nie udało się odczytać pliku (${file.type || 'unknown'}, ${file.size || 0} bytes)`
      });
      this.showError('Nie udało się odczytać pliku. Wybierz inne zdjęcie.');
      this.uploadedFile = null;
      if (this.fileInput) this.fileInput.value = '';
    };
    reader.onabort = () => {
      this.trackStatsEvent('image_upload_failed', {
        ...baseUploadStats,
        errorCode: 'FILE_READ_ABORTED',
        errorCategory: 'upload_technical',
        previewMethod: 'file_reader',
        errorMessage: 'Odczyt pliku został przerwany'
      });
    };
    reader.readAsDataURL(file);
  }

  showStyles() {
    if (this.isFourWatercolourProduct() && !this.selectedStyle) this.setupFourWatercolourStyles();
    // 🎵 Dla produktu bez AI nie pokazuj stylów
    if (!this.isSpotifyNoAIProduct()) {
      if (this.isMultiUploadProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = this.getMultiUploadStyle();
        console.log(`📸 [MULTI-UPLOAD] Ukryto wybór stylu, auto-select ${this.selectedStyle}`);
      } else if (this.isDlaNiejProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'caricature-new';
        console.log('💝 [DLA-NIEJ] Ukryto wybór stylu, auto-select caricature-new');
      } else if (this.isSuperheroBoyProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'superhero_boy';
        console.log('🦸 [SUPERHERO] Ukryto wybór stylu, auto-select superhero_boy');
      } else if (this.isSupermanProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'superman';
        console.log('🦸 [SUPERMAN] Ukryto wybór stylu, auto-select superman');
      } else if (this.isLoveRoseProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'love-rose';
        console.log('🌹 [LOVE-ROSE] Ukryto wybór stylu, auto-select love-rose');
      } else if (this.isRoyalLoveProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'royal-love';
        console.log('💕 [ROYAL-LOVE] Ukryto wybór stylu, auto-select royal-love');
      } else if (this.isGTAProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'gta';
        console.log('🎮 [GTA] Ukryto wybór stylu, auto-select gta');
      } else if (this.isSteampunkProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'steampunk';
        console.log('⚙️ [STEAMPUNK] Ukryto wybór stylu, auto-select steampunk');
      } else if (this.isHipHopProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'hiphop';
        console.log('🎤 [HIP-HOP] Ukryto wybór stylu, auto-select hiphop');
      } else if (this.isRetuszStarychZdjecProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'retusz-starych-zdjec';
        console.log('📷 [RETUSZ] Ukryto wybór stylu, auto-select retusz-starych-zdjec');
      } else if (this.isLinkedinHeadshotProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'linkedin-headshot';
        console.log('🧑‍💼 [HEADSHOT] Ukryto wybór stylu, auto-select linkedin-headshot');
      } else if (this.isSzkicOlowekProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'szkic-olowek';
        console.log('✏️ [SZKIC] Ukryto wybór stylu, auto-select szkic-olowek');
      } else if (this.isWatercolorAkwarelaProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'watercolor_ok';
        console.log('🎨 [AKWARELA] Ukryto wybór stylu, auto-select watercolor_ok');
      } else if (this.isOilPaintsHerProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'oil-paints';
        console.log('🖌️ [OIL-PAINTS] Ukryto wybór stylu, auto-select oil-paints');
      } else if (this.isActiveThemedPortraitProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = this.getActiveThemedPortraitStyle();
      } else {
        this.stylesArea.style.display = 'block';
      }
    }
    this.sizeArea.style.display = 'block'; // Pokaż rozmiary od razu
    
    // 🎵 Dla produktu bez AI ukryj przyciski "Zobacz podgląd" - upload jest zawsze widoczny
    if (this.isSpotifyNoAIProduct()) {
      this.actionsArea.style.display = 'none';
    } else {
      this.actionsArea.style.display = 'flex';
    }
    
    // Pokaż przycisk "Dodaj do koszyka" jeśli użytkownik nie wgrał zdjęcia
    const addToCartBtnMain = document.getElementById('addToCartBtnMain');
    if (addToCartBtnMain) {
      addToCartBtnMain.style.display = 'inline-block';
    }
    
  }

  selectStyle(styleCard) {
    this.stylesArea.querySelectorAll('.customify-style-card').forEach(card => card.classList.remove('active'));
    styleCard.classList.add('active');
    this.selectedStyle = styleCard.dataset.style;
    this._sentryCrumb('style', 'Wybrano styl: ' + this.selectedStyle);
    
    // ✅ DEBUG: Pokaż który styl został wybrany
    console.log('🎨 [STYLE-SELECT] ===== WYBÓR STYLU =====');
    console.log('🎨 [STYLE-SELECT] Wybrany styl:', this.selectedStyle);
    console.log('🎨 [STYLE-SELECT] data-style attribute:', styleCard.dataset.style);
    console.log('🎨 [STYLE-SELECT] styleCard element:', styleCard);
    console.log('🎨 [STYLE-SELECT] this.selectedStyle type:', typeof this.selectedStyle);
    console.log('🎨 [STYLE-SELECT] =========================');
    
    // Ukryj komunikat błędu po wyborze stylu
    this.hideError();
    
    // 🎵 SPOTIFY: Styl "bez-zmian" - od razu przejdź do koszyka (bez "Zobacz podgląd")
    if (this.selectedStyle === 'bez-zmian' && this.uploadedFile) {
      console.log('🎵 [SPOTIFY] Styl "bez-zmian" - automatyczne przejście do koszyka');
      this.handleBezZmianStyle();
    }
    
    // Rozmiary już są widoczne od razu
  }
  
  // 🎵 SPOTIFY: Obsługa stylu "bez-zmian"
  handleBezZmianStyle() {
    // 🎵 SPOTIFY: Ustaw flagę żeby syncPosition() nie przenosiło elementów z powrotem
    window.spotifyBezZmianActive = true;
    
    // Użyj wykadrowanego zdjęcia jako transformedImage (dla addToCart)
    const reader = new FileReader();
    reader.onload = (e) => {
      this.transformedImage = e.target.result;
      this.originalCroppedImage = e.target.result; // 🎨 Zachowaj oryginał dla filtrów
      this.watermarkedImageUrl = null; // Będzie generowany przy dodaniu do koszyka
      
      // Ukryj sekcje jak po normalnej generacji
      if (this.uploadArea) this.uploadArea.style.display = 'none';
      if (this.stylesArea) this.stylesArea.style.display = 'none';
      
      // Ukryj "Zobacz Podgląd" i "Wgraj inne" oraz główny przycisk koszyka z actionsArea
      const transformBtn = document.getElementById('transformBtn');
      const resetBtn = document.getElementById('resetBtn');
      const addToCartBtnMain = document.getElementById('addToCartBtnMain');
      if (transformBtn) transformBtn.style.display = 'none';
      if (resetBtn) resetBtn.style.display = 'none';
      if (addToCartBtnMain) addToCartBtnMain.style.display = 'none';
      
      // UKRYJ actionsArea - będziemy używać tylko przycisków z resultArea
      if (this.actionsArea) this.actionsArea.style.display = 'none';
      
      // 🎨 Pokaż panel filtrów dla produktu bez AI
      if (this.isSpotifyNoAIProduct()) {
        const filtersPanel = document.getElementById('spotifyFiltersPanel');
        if (filtersPanel) {
          filtersPanel.style.display = 'block';
          this.initGlfxFilters(); // Inicjalizuj glfx.js
        }
      }
      
      // 🎵 SPOTIFY: Przenieś elementy typu i rozmiaru pod preview (nie na górę strony!)
      const spotifySlot = document.getElementById('spotify-type-size-slot');
      if (spotifySlot && this.productTypeArea && this.sizeArea) {
        spotifySlot.style.display = 'block';
        spotifySlot.appendChild(this.productTypeArea);
        spotifySlot.appendChild(this.sizeArea);
        
        // Przenieś też cenę
        const cartPriceDisplay = document.getElementById('cartPriceDisplay');
        if (cartPriceDisplay) {
          spotifySlot.appendChild(cartPriceDisplay);
          cartPriceDisplay.style.display = 'block';
        }
        
        // Przenieś przyciski koszyka z resultArea
        const addToCartBtn = document.getElementById('addToCartBtn');
        const tryAgainBtn = document.getElementById('tryAgainBtn');
        if (addToCartBtn) {
          // Stwórz kontener na przyciski jeśli nie istnieje
          let btnContainer = document.getElementById('spotify-cart-buttons');
          if (!btnContainer) {
            btnContainer = document.createElement('div');
            btnContainer.id = 'spotify-cart-buttons';
            btnContainer.style.cssText = 'display: flex; gap: 10px; justify-content: center; margin-top: 15px;';
            spotifySlot.appendChild(btnContainer);
          }
          btnContainer.appendChild(addToCartBtn);
          addToCartBtn.style.display = 'inline-block';
          
          // 🎵 Dla produktu bez AI ukryj "Spróbuj ponownie" - upload jest zawsze widoczny na górze
          if (tryAgainBtn && !this.isSpotifyNoAIProduct()) {
            btnContainer.appendChild(tryAgainBtn);
            tryAgainBtn.style.display = 'inline-block';
          } else if (tryAgainBtn) {
            tryAgainBtn.style.display = 'none';
          }
        }
        
        console.log('✅ [SPOTIFY] Przeniesiono elementy typu/rozmiaru/ceny/przycisków pod preview');
      } else {
        console.error('❌ [SPOTIFY] Nie znaleziono spotify-type-size-slot lub elementów do przeniesienia');
        console.log('spotifySlot:', !!spotifySlot, 'productTypeArea:', !!this.productTypeArea, 'sizeArea:', !!this.sizeArea);
      }
      
      // Pokaż rozmiary i typ wydruku
      if (this.sizeArea) this.sizeArea.style.display = 'block';
      if (this.productTypeArea) this.productTypeArea.style.display = 'block';
      
      // Aktualizuj cenę
      this.updateCartPrice();
      
      // Komunikat sukcesu
      this.showSuccess('Projekt gotowy! Wybierz parametry wydruku i dodaj do koszyka.');
      
      console.log('✅ [SPOTIFY] Styl "bez-zmian" - widok koszyka aktywny');
    };
    reader.readAsDataURL(this.uploadedFile);
  }
  
  // 🎨 GLFX.JS: Ładowanie konfiguracji filtrów z API
  async loadFilterConfig() {
    if (this.filterConfig) {
      return this.filterConfig; // Już załadowane
    }
    
    if (this.filterConfigLoading) {
      // Czekaj na zakończenie ładowania
      return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (this.filterConfig) {
            clearInterval(checkInterval);
            resolve(this.filterConfig);
          }
        }, 100);
      });
    }
    
    this.filterConfigLoading = true;
    
    try {
      const res = await fetch('https://customify-s56o.vercel.app/api/admin/filter-config');
      if (res.ok) {
        const config = await res.json();
        this.filterConfig = config;
        console.log('✅ [GLFX] Konfiguracja filtrów załadowana z API');
        return config;
      } else {
        console.warn('⚠️ [GLFX] Błąd ładowania konfiguracji, używam domyślnej');
        return this.getDefaultFilterConfig();
      }
    } catch (err) {
      console.error('❌ [GLFX] Błąd ładowania konfiguracji:', err);
      this._reportToSentry(err, 'glfx-config');
      return this.getDefaultFilterConfig();
    } finally {
      this.filterConfigLoading = false;
    }
  }
  
  // 🎨 Domyślna konfiguracja (fallback)
  getDefaultFilterConfig() {
    return {
      brighten: { brightness: 0.15, contrast: 0.1 },
      vivid: { hue: 0, saturation: 0.2, vibrance: 0.2 },
      sharpen: { radius: 50, strength: 1.5 },
      warm: { hue: 0.05, saturation: 0.1, brightness: 0.05, contrast: 0.05 },
      bw: { saturation: -1, brightness: 0.05, contrast: 0.15 },
      vintage: { sepia: 0.3, vignetteSize: 0.3, vignetteAmount: 0.7, brightness: -0.05, contrast: 0.1 },
      dotScreen: { centerX: 0.5, centerY: 0.5, angle: 0, size: 3 }
    };
  }
  
  // 🎨 GLFX.JS: Inicjalizacja filtrów zdjęć
  async initGlfxFilters() {
    if (this.glfxInitialized) return;
    
    // Sprawdź czy glfx.js jest załadowane
    if (typeof fx === 'undefined') {
      console.warn('⚠️ [GLFX] Biblioteka glfx.js nie jest załadowana');
      return;
    }
    
    console.log('🎨 [GLFX] Inicjalizacja filtrów zdjęć...');
    
    // Załaduj konfigurację z API
    await this.loadFilterConfig();
    
    // Event listeners dla przycisków filtrów
    const filterBtns = document.querySelectorAll('.spotify-filter-btn');
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        // Usuń active ze wszystkich
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        
        const filter = btn.dataset.filter;
        console.log('🎨 [GLFX] Wybrano filtr:', filter);
        this.applyGlfxFilter(filter);
      });
    });
    
    this.glfxInitialized = true;
    console.log('✅ [GLFX] Filtry zainicjalizowane');
  }
  
  // 🎨 GLFX.JS: Aplikuj filtr na zdjęcie
  async applyGlfxFilter(filterName) {
    if (!this.originalCroppedImage) {
      console.warn('⚠️ [GLFX] Brak oryginalnego zdjęcia');
      return;
    }
    
    console.log('🎨 [GLFX] Aplikuję filtr:', filterName);
    
    // Upewnij się że konfiguracja jest załadowana
    if (!this.filterConfig) {
      await this.loadFilterConfig();
    }
    
    // Stwórz tymczasowy obraz z oryginalnego
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        // Stwórz canvas glfx
        const canvas = fx.canvas();
        const texture = canvas.texture(img);
        
        // Aplikuj filtry w zależności od wyboru
        // 🎨 Pobierz konfigurację z API (lub domyślną)
        const cfg = this.filterConfig || this.getDefaultFilterConfig();
        
        canvas.draw(texture);
        
        switch(filterName) {
          case 'none':
            // Bez filtra - oryginał
            break;
          case 'brighten':
            const b = cfg.brighten || { brightness: 0.15, contrast: 0.1 };
            canvas.brightnessContrast(b.brightness, b.contrast);
            break;
          case 'vivid':
            const v = cfg.vivid || { hue: 0, saturation: 0.2, vibrance: 0.2 };
            canvas.hueSaturation(v.hue, v.saturation);
            canvas.vibrance(v.vibrance);
            break;
          case 'sharpen':
            const sh = cfg.sharpen || { radius: 50, strength: 1.5 };
            canvas.unsharpMask(sh.radius, sh.strength);
            break;
          case 'warm':
            const w = cfg.warm || { hue: 0.05, saturation: 0.1, brightness: 0.05, contrast: 0.05 };
            canvas.hueSaturation(w.hue, w.saturation);
            canvas.brightnessContrast(w.brightness, w.contrast);
            break;
          case 'bw':
            const bw = cfg.bw || { saturation: -1, brightness: 0.05, contrast: 0.15 };
            canvas.hueSaturation(0, bw.saturation);
            canvas.brightnessContrast(bw.brightness, bw.contrast);
            break;
          case 'vintage':
            const vt = cfg.vintage || { sepia: 0.3, vignetteSize: 0.3, vignetteAmount: 0.7, brightness: -0.05, contrast: 0.1 };
            canvas.sepia(vt.sepia);
            canvas.vignette(vt.vignetteSize, vt.vignetteAmount);
            canvas.brightnessContrast(vt.brightness, vt.contrast);
            break;
          case 'dotScreen':
            const ds = cfg.dotScreen || { centerX: 0.5, centerY: 0.5, angle: 0, size: 3 };
            canvas.dotScreen(ds.centerX, ds.centerY, ds.angle, ds.size);
            break;
        }
        
        canvas.update();
        
        // Pobierz wynik jako data URL
        const filteredImage = canvas.toDataURL('image/jpeg', 0.92);
        
        // Zaktualizuj transformedImage (dla addToCart)
        this.transformedImage = filteredImage;
        
        // Zaktualizuj podgląd na stronie
        const previewImg = document.querySelector('.spotify-frame-inner img');
        if (previewImg) {
          previewImg.src = filteredImage;
        }
        
        console.log('✅ [GLFX] Filtr zastosowany:', filterName);
        
      } catch (err) {
        console.error('❌ [GLFX] Błąd aplikowania filtra:', err);
        this._reportToSentry(err, 'glfx-apply');
        this.applyCssFilter(filterName);
      }
    };
    
    img.onerror = () => {
      console.error('❌ [GLFX] Nie można załadować obrazu');
    };
    
    img.src = this.originalCroppedImage;
  }
  
  // 🎨 CSS Fallback: Jeśli glfx.js nie działa
  applyCssFilter(filterName) {
    const previewImg = document.querySelector('.spotify-frame-inner img');
    if (!previewImg) return;
    
    let filter = '';
    switch(filterName) {
      case 'none':
        filter = 'none';
        break;
      case 'brighten':
        filter = 'brightness(1.15) contrast(1.1)';
        break;
      case 'vivid':
        filter = 'saturate(1.4)';
        break;
      case 'sharpen':
        filter = 'contrast(1.1)';
        break;
      case 'warm':
        filter = 'sepia(0.2) saturate(1.1)';
        break;
      case 'bw':
        filter = 'grayscale(1) contrast(1.15)';
        break;
      case 'vintage':
        filter = 'sepia(0.4) contrast(1.1)';
        break;
      case 'dotScreen':
        filter = 'contrast(1.2)'; // Prosty fallback dla halftone
        break;
    }
    
    previewImg.style.filter = filter;
    console.log('🎨 [CSS] Fallback filtr:', filterName, filter);
  }

  selectSize(sizeBtn) {
    if (sizeBtn.classList.contains('disabled')) {
      console.log('⚠️ [SIZE] Attempted to select disabled size:', sizeBtn.dataset.size);
      return;
    }
    
    // 🚨 WALIDACJA: Dla szkła tylko A5 i A4 są dozwolone
    const size = sizeBtn.dataset.size;
    if (this.selectedProductType === 'szklo') {
      const allowedSizes = ['a5', 'a4'];
      if (!allowedSizes.includes(size.toLowerCase())) {
        console.error('❌ [SIZE] Invalid size for szklo:', size);
        this.showError('Dla wydruku na szkle dostępne są tylko rozmiary: 15×21 cm (A5) i 20×30 cm (A4). Wybierz jeden z dostępnych rozmiarów.', 'size');
        return;
      }
    }
    
    this.sizeArea.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
    sizeBtn.classList.add('active');
    this.selectedSize = sizeBtn.dataset.size;
    this._sentryCrumb('size', 'Wybrano rozmiar: ' + this.selectedSize);
    console.log('📏 [SIZE] Selected size:', this.selectedSize);
    
    // Ukryj błąd jeśli rozmiar jest poprawny
    this.hideError();
    
    // Aktualizuj cenę po wyborze rozmiaru
    this.updateProductPrice();
    this.updateCartPrice(); // ✅ Dodaj aktualizację ceny nad przyciskiem
    this.syncActiveSizeButton();
  }

  selectProductType(typeBtn) {
    this.productTypeArea.querySelectorAll('.customify-product-type-btn').forEach(btn => btn.classList.remove('active'));
    typeBtn.classList.add('active');
    this.selectedProductType = typeBtn.dataset.productType;
    console.log('🎨 [PRODUCT-TYPE] Selected product type:', this.selectedProductType);

    // Aktualizuj ceny po zmianie typu (ramka dostępna tylko dla plakatu)
    const sizeAdjusted = this.updateSizeAvailability();
    this.updateProductPrice();
    this.updateCartPrice();
    if (sizeAdjusted) {
      console.log('📏 [SIZE] Adjusted selection after product type change:', this.selectedSize || 'none');
    }
    console.log('🖼️ [FRAME] Type changed -> recalculated price with frame:', {
      selectedProductType: this.selectedProductType,
      frame: window.CustomifyFrame?.color || 'none'
    });
  }

  /**
   * Aktualizuje dostępność poszczególnych rozmiarów w zależności od typu produktu
   * Dla szkła: tylko A5 i A4 widoczne. Dla plakat/canvas/digital: A4, A3, A2, A0, A1.
   * Zwraca true, jeśli wybrany rozmiar został zmieniony
   */
  updateSizeAvailability() {
    if (!this.sizeArea) {
      return false;
    }

    // Produkt cyfrowy nie używa rozmiarów — nie narzucaj fallbacku a4 (psuje cenę: +49 canvas)
    if (this.selectedProductType === 'digital' || (this.isDigitalOnlyProduct && this.isDigitalOnlyProduct())) {
      this.selectedSize = null;
      return false;
    }

    const sizeButtons = Array.from(this.sizeArea.querySelectorAll('.customify-size-btn'));
    const szkloSizes = ['a5', 'a4'];
    const plakatSizes = ['a4', 'a3', 'a2', 'a0', 'a1'];

    if (this.selectedProductType === 'szklo') {
      sizeButtons.forEach(btn => {
        const size = btn.dataset.size?.toLowerCase();
        const isForSzklo = szkloSizes.includes(size);
        btn.style.display = isForSzklo ? '' : 'none';
        btn.classList.remove('disabled');
        btn.removeAttribute('aria-disabled');
      });
    } else {
      sizeButtons.forEach(btn => {
        const size = btn.dataset.size?.toLowerCase();
        const isForPlakat = plakatSizes.includes(size);
        btn.style.display = isForPlakat ? '' : 'none';
        btn.classList.remove('disabled');
        btn.removeAttribute('aria-disabled');
      });
    }

    const visibleSizes = this.selectedProductType === 'szklo' ? szkloSizes : plakatSizes;
    let selectionChanged = false;
    if (!visibleSizes.includes(this.selectedSize?.toLowerCase())) {
      const fallback = visibleSizes[0];
      this.selectedSize = fallback;
      selectionChanged = true;
    }

    this.syncActiveSizeButton();
    return selectionChanged;
  }

  /**
   * Synchronizuje klasę .active przycisków rozmiarów z aktualnie wybranym rozmiarem
   */
  syncActiveSizeButton() {
    if (!this.sizeArea) {
      return;
    }

    const sizeButtons = this.sizeArea.querySelectorAll('.customify-size-btn');
    sizeButtons.forEach(btn => {
      if (btn.classList.contains('disabled')) {
        btn.classList.remove('active');
        return;
      }
      const shouldBeActive = this.selectedSize && btn.dataset.size === this.selectedSize;
      btn.classList.toggle('active', !!shouldBeActive);
    });
  }

  /**
   * Aktualizuje cenę nad przyciskiem "Dodaj do koszyka"
   */
  updateCartPrice() {
    try {
      // Produkt cyfrowy: cena z pakietu, bez dopłat za rozmiar
      if (this.selectedProductType === 'digital' || (this.isDigitalOnlyProduct && this.isDigitalOnlyProduct())) {
        this.selectedProductType = 'digital';
        window.CustomifyDigitalPackage = window.CustomifyDigitalPackage || { count: 1, price: 69 };
        const digitalProductPrice = (window.CustomifyDigitalPackage && window.CustomifyDigitalPackage.price) || 69;
        const cartPriceElement = document.getElementById('cartPriceValue');
        if (cartPriceElement) {
          cartPriceElement.textContent = `${Number(digitalProductPrice).toFixed(2)} zł`;
          console.log('✅ [CART-PRICE] Digital product - package price:', digitalProductPrice, 'zł');
          this.showCartPrice();
        } else {
          console.warn('⚠️ [CART-PRICE] Cart price element not found');
        }
        return;
      }

      // Sprawdź czy mamy wybrany rozmiar
      if (!this.selectedSize) {
        console.log('🔍 [CART-PRICE] No selectedSize, hiding cart price');
        this.hideCartPrice();
        return;
      }

      // Pobierz oryginalną bazową cenę
      if (!this.originalBasePrice) {
        this.originalBasePrice = 49.00; // Fallback
        console.log(`💰 [CART-PRICE] Using fallback base price: ${this.originalBasePrice} zł`);
      }

      // Pobierz cenę rozmiaru
      const sizePrice = this.getSizePrice(this.selectedSize);
      
      const frameColor = (window.CustomifyFrame && window.CustomifyFrame.color) ? window.CustomifyFrame.color : 'none';
      const frameSurcharge = this.getFrameSurcharge(frameColor);
      const frameSelected = frameSurcharge > 0;
      
      // Oblicz końcową cenę (bazowa + rozmiar + ramka)
      const finalPrice = this.originalBasePrice + sizePrice + frameSurcharge;

      // Price calculation completed

        // Znajdź element ceny w koszyku
        const cartPriceElement = document.getElementById('cartPriceValue');

        if (cartPriceElement) {
          cartPriceElement.textContent = `${finalPrice.toFixed(2)} zł`;
          console.log('✅ [CART-PRICE] Cart price updated:', finalPrice.toFixed(2), 'zł');
          console.log('🖼️ [FRAME] Cart price components:', {
            base: this.originalBasePrice,
            sizePrice,
            frameSelected,
            frame: window.CustomifyFrame?.color || 'none',
            frameSurcharge
          });

          // 📱 Phone case: Also update phone case specific price display (ONLY after AI generation)
          if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
            // Phone case has its own price display - don't show main cart price
            // (phone case price is shown/hidden separately in phoneCaseCartPriceDisplay)
          } else {
            // Pokaż element ceny (tylko dla innych produktów, nie phone case)
            this.showCartPrice();
          }
          
          // 📱 Phone case: Update phone case specific price display (ONLY after AI generation)
          if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
            const phoneCaseCartPriceValue = document.getElementById('phoneCaseCartPriceValue');
            if (phoneCaseCartPriceValue) {
              phoneCaseCartPriceValue.textContent = `${finalPrice.toFixed(2)} zł`;
              console.log('📱 [PHONE PREVIEW] Phone case cart price updated:', finalPrice.toFixed(2), 'zł');
            }
            // Show price and buttons ONLY if image is generated (after AI)
            const phoneCaseCartPriceDisplay = document.getElementById('phoneCaseCartPriceDisplay');
            const phoneCaseCartActions = document.getElementById('phoneCaseCartActions');
            if (this.transformedImage) {
              if (phoneCaseCartPriceDisplay) {
                phoneCaseCartPriceDisplay.style.display = 'block';
                console.log('📱 [PHONE PREVIEW] Cart price shown (after AI generation)');
              }
              if (phoneCaseCartActions) {
                phoneCaseCartActions.style.display = 'flex';
                console.log('📱 [PHONE PREVIEW] Cart actions shown (after AI generation)');
              }
            } else {
              if (phoneCaseCartPriceDisplay) phoneCaseCartPriceDisplay.style.display = 'none';
              if (phoneCaseCartActions) phoneCaseCartActions.style.display = 'none';
            }
          }
        } else {
          console.warn('⚠️ [CART-PRICE] Cart price element not found');
        }
    } catch (error) {
      console.error('❌ [CART-PRICE] Error updating cart price:', error);
      this._reportToSentry(error, 'cart-price');
    }
  }

  /**
   * Pokazuje element ceny nad przyciskiem
   */
  showCartPrice() {
    // Etui używa tego samego cartPriceDisplay (w resultArea) jak inne produkty
    const cartPriceDisplay = document.getElementById('cartPriceDisplay');
    if (cartPriceDisplay) {
      cartPriceDisplay.style.display = 'block';
      console.log('✅ [CART-PRICE] Cart price displayed');
    }
  }

  /**
   * Ukrywa element ceny nad przyciskiem
   */
  hideCartPrice() {
    const cartPriceDisplay = document.getElementById('cartPriceDisplay');
    if (cartPriceDisplay) {
      cartPriceDisplay.style.display = 'none';
      console.log('✅ [CART-PRICE] Cart price hidden');
    }
  }

  /**
   * Ustawia początkową cenę bazową (bez rozmiaru) przy starcie aplikacji
   */
  setInitialPrice() {
    try {
      const priceElement = this.getPriceElement();
      if (!priceElement) {
        console.warn('⚠️ [INIT-PRICE] Price element not found');
        return;
      }

      // Pobierz oryginalną bazową cenę (zapamiętaj przy pierwszym wywołaniu)
      if (!this.originalBasePrice) {
        // ✅ Użyj window.ShopifyProduct (niezmienione źródło) zamiast DOM
        this.originalBasePrice = this.getBasePriceFromShopify();
        
        if (this.originalBasePrice === null) {
          // Fallback: spróbuj z DOM jeśli window.ShopifyProduct nie dostępne
          const basePriceText = priceElement.textContent;
          this.originalBasePrice = this.extractBasePrice(basePriceText);
          
          if (this.originalBasePrice === null) {
            console.warn('⚠️ [INIT-PRICE] Could not get base price from Shopify or DOM, using fallback');
            this.originalBasePrice = 49.00;
            console.log(`💰 [INIT-PRICE] Using fallback base price: ${this.originalBasePrice} zł`);
          } else {
            console.log(`💰 [INIT-PRICE] Base price from DOM (fallback): ${this.originalBasePrice} zł`);
          }
        } else {
          console.log(`💰 [INIT-PRICE] Original base price saved: ${this.originalBasePrice} zł`);
        }
      }

      // Ustaw TYLKO cenę bazową (bez rozmiaru)
      this.applyProductPriceDisplay(this.originalBasePrice);
      console.log(`💰 [INIT-PRICE] Set initial base price: ${this.originalBasePrice} zł`);
      
    } catch (error) {
      console.error('❌ [INIT-PRICE] Error setting initial price:', error);
      this._reportToSentry(error, 'init-price');
    }
  }

  /**
   * Aktualizuje cenę na stronie produktu po wyborze rozmiaru
   */
  updateProductPrice() {
    try {
      // Produkt cyfrowy: cena z pakietu (1/3/5/10), bez dopłat za rozmiar/ramkę
      if (this.selectedProductType === 'digital' || (this.isDigitalOnlyProduct && this.isDigitalOnlyProduct())) {
        this.selectedProductType = 'digital';
        window.CustomifyDigitalPackage = window.CustomifyDigitalPackage || { count: 1, price: 69 };
        const digitalProductPrice = (window.CustomifyDigitalPackage && window.CustomifyDigitalPackage.price) || 69;
        this.applyProductPriceDisplay(digitalProductPrice);
        this.schedulePriceConsistency(digitalProductPrice);
        console.log('💰 [PRICE] Digital product - package price:', digitalProductPrice, 'zł');
        return;
      }

      const priceElement = this.getPriceElement();
      if (!priceElement) {
        console.warn('⚠️ [PRICE] Price element not found with any selector');
        return;
      }

      console.log('✅ [PRICE] Found price element:', priceElement, 'Text:', priceElement.textContent);

      // Pobierz oryginalną bazową cenę (zapamiętaj przy pierwszym wywołaniu)
      if (!this.originalBasePrice) {
        // ✅ Użyj window.ShopifyProduct (niezmienione źródło) zamiast DOM
        this.originalBasePrice = this.getBasePriceFromShopify();
        
        if (this.originalBasePrice === null) {
          // Fallback: spróbuj z DOM jeśli window.ShopifyProduct nie dostępne
          const basePriceText = priceElement.textContent;
          this.originalBasePrice = this.extractBasePrice(basePriceText);
          
          if (this.originalBasePrice === null) {
            console.warn('⚠️ [PRICE] Could not get base price from Shopify or DOM, using fallback');
            // Fallback - użyj domyślnej ceny
            this.originalBasePrice = 49.00;
            console.log(`💰 [PRICE] Using fallback base price: ${this.originalBasePrice} zł`);
          } else {
            console.log(`💰 [PRICE] Base price from DOM (fallback): ${this.originalBasePrice} zł`);
          }
        } else {
          console.log(`💰 [PRICE] Original base price saved: ${this.originalBasePrice} zł`);
        }
      }

      // Pobierz cenę rozmiaru
      const sizePrice = this.getSizePrice(this.selectedSize);
      
      const frameColor = (window.CustomifyFrame && window.CustomifyFrame.color) ? window.CustomifyFrame.color : 'none';
      const frameSurcharge = this.getFrameSurcharge(frameColor);
      const frameSelected = frameSurcharge > 0;
      
      // Oblicz końcową cenę (oryginalna cena + rozmiar + ramka)
      const finalPrice = this.originalBasePrice + sizePrice + frameSurcharge;
      
      // Aktualizuj cenę na stronie
      this.applyProductPriceDisplay(finalPrice);
      this.schedulePriceConsistency(finalPrice);
      
      console.log(`💰 [PRICE] Updated: base ${this.originalBasePrice} + size ${sizePrice} + frame ${frameSurcharge} = ${finalPrice} zł`);
      console.log('🖼️ [FRAME] Product price components:', {
        base: this.originalBasePrice,
        sizePrice,
        frameSelected,
        frame: window.CustomifyFrame?.color || 'none',
        frameSurcharge,
        finalPrice
      });
      
    } catch (error) {
      console.error('❌ [PRICE] Error updating product price:', error);
      this._reportToSentry(error, 'update-price');
    }
  }

  /**
   * Pobiera bazową cenę produktu z window.ShopifyProduct (niezmienione źródło)
   */
  getBasePriceFromShopify() {
    if (window.ShopifyProduct && window.ShopifyProduct.variants && window.ShopifyProduct.variants.length > 0) {
      // variants[0].price jest w groszach, konwertuj na złotówki
      const priceInGrosz = parseFloat(window.ShopifyProduct.variants[0].price);
      const priceInZl = priceInGrosz / 100;
      console.log(`💰 [BASE-PRICE] Pobrano z window.ShopifyProduct: ${priceInZl} zł (${priceInGrosz} groszy)`);
      return priceInZl;
    }
    console.warn('⚠️ [BASE-PRICE] window.ShopifyProduct.variants nie dostępne, używam fallback');
    return null;
  }

  /**
   * Wyciąga bazową cenę z tekstu ceny (stara metoda - tylko jako fallback)
   */
  extractBasePrice(priceText) {
    // Usuń "zł" i spacje, znajdź liczbę
    const match = priceText.match(/(\d+(?:\.\d+)?)/);
    return match ? parseFloat(match[1]) : null;
  }

  /**
   * Zwraca cenę dla wybranego rozmiaru
   */
  getSizePrice(size, productType = null) {
    const type = productType || this.selectedProductType || 'canvas';
    if (type === 'digital') return 0;
    const table = this.sizePricing[type] || this.sizePricing.canvas;
    return table[size] ?? 0;
  }

  getFrameSurcharge(frameColor = 'none') {
    const selectedFrame = (frameColor || 'none').toLowerCase();
    if (!this.selectedSize || selectedFrame === 'none') return 0;
    const activeType = document.querySelector('.customify-product-type-btn.active')?.dataset?.productType;
    const productType = activeType || this.selectedProductType;
    
    // Plakat: stara logika ramek (czarna/biała/drewno).
    if (productType === 'plakat') {
      return this.framePricing[this.selectedSize] || 29;
    }
    
    // Canvas: dopłata tylko dla American Box (czarna i drewno).
    if (productType === 'canvas' && (selectedFrame === 'black' || selectedFrame === 'wood')) {
      return this.canvasFramePricing[this.selectedSize] || 79;
    }
    
    return 0;
  }

  /**
   * Zwraca wymiar dla wybranego rozmiaru (np. "20×30 cm")
   */
  getSizeDimension(size) {
    const dimensions = {
      'a5': '15×21 cm',  // 🆕 Nowy rozmiar dla szkła
      'a4': '20×30 cm',
      'a3': '30×45 cm', 
      'a2': '40×60 cm',
      'a0': '50×75 cm',
      'a1': '60×90 cm',
      'etui': 'Etui na telefon'  // 📱 Etui - brak selektora rozmiaru
    };
    return dimensions[size] || size;
  }

  /**
   * Zwraca element ceny produktu
   */
  getPriceElement() {
    let priceElement = document.querySelector('product-price div');
    if (priceElement) {
      return priceElement;
    }

    priceElement = document.querySelector('.price');
    if (priceElement) {
      console.log('🔍 [PRICE] Using .price selector');
      return priceElement;
    }

    priceElement = document.querySelector('[class*="price"]');
    if (priceElement) {
      console.log('🔍 [PRICE] Using [class*="price"] selector');
      return priceElement;
    }

    return null;
  }

  /**
   * Ustawia cenę produktu w DOM
   */
  applyProductPriceDisplay(value) {
    const priceElement = this.getPriceElement();
    if (!priceElement) {
      console.warn('⚠️ [PRICE] Price element not found when applying display');
      return;
    }
    const formatted = `${value.toFixed(2)} zł`;
    priceElement.textContent = formatted;
    priceElement.setAttribute('data-customify-price', formatted);
  }

  /**
   * Dodatkowe zabezpieczenie przed nadpisaniem ceny przez motyw
   */
  schedulePriceConsistency(finalPrice) {
    if (this.priceConsistencyTimers) {
      this.priceConsistencyTimers.forEach(timer => clearTimeout(timer));
    }

    const delays = [50, 250, 500, 1000, 2000];
    this.priceConsistencyTimers = delays.map(delay => setTimeout(() => {
      try {
        const priceElement = this.getPriceElement();
        if (!priceElement) {
          return;
        }
        const displayed = this.extractBasePrice(priceElement.textContent);
        if (displayed === null || Math.abs(displayed - finalPrice) > 0.5) {
          console.log('♻️ [PRICE] Reapplying price after external update:', {
            displayed,
            finalPrice,
            delay
          });
          const formatted = `${finalPrice.toFixed(2)} zł`;
          priceElement.textContent = formatted;
          priceElement.setAttribute('data-customify-price', formatted);
        }
      } catch (error) {
        console.warn('⚠️ [PRICE] Error in price consistency timer:', error);
      }
    }, delay));
  }

  /**
   * Inicjalizuje domyślny rozmiar i cenę przy starcie aplikacji
   */
  initializeDefaultPrice() {
    try {
      if (this.isDigitalOnlyProduct && this.isDigitalOnlyProduct()) {
        this.selectedProductType = 'digital';
        this.selectedSize = null;
        window.CustomifyDigitalPackage = window.CustomifyDigitalPackage || { count: 1, price: 69 };
        const digitalPrice = (window.CustomifyDigitalPackage && window.CustomifyDigitalPackage.price) || 69;
        this.applyProductPriceDisplay(digitalPrice);
        this.schedulePriceConsistency(digitalPrice);
        this.updateCartPrice();
        console.log('💰 [INIT] Digital-only default package price:', digitalPrice, 'zł');
        return;
      }

      // Znajdź pierwszy dostępny rozmiar (domyślnie A4)
      const defaultSizeBtn = this.sizeArea?.querySelector('[data-size="a4"]') || 
                            this.sizeArea?.querySelector('.customify-size-btn');
      
      if (defaultSizeBtn) {
        // Ustaw domyślny rozmiar (bez podświetlania)
        this.selectedSize = defaultSizeBtn.dataset.size;
        // defaultSizeBtn.classList.add('active'); // USUNIĘTO - żaden rozmiar nie jest podświetlony domyślnie
        
        console.log('💰 [INIT] Default size selected (no highlight):', this.selectedSize);
        
        // Ustaw początkową cenę bazową (bez rozmiaru)
        this.setInitialPrice();
        this.updateCartPrice(); // ✅ Dodaj aktualizację ceny nad przyciskiem
      } else {
        console.warn('⚠️ [INIT] No size buttons found for default price');
      }
    } catch (error) {
      console.error('❌ [INIT] Error initializing default price:', error);
      this._reportToSentry(error, 'init-default-price');
    }
  }




  // ============================================================
  // ASYNC-TRANSFORM-FEATURE: generacja jako zadanie w tle + polling
  // Zamiast jednego POST /api/transform trzymanego 1-4 min (zrywanego przez
  // mobile backgrounding / NAT), robimy: krótki POST /api/transform-start
  // (zwraca jobId) + krótkie GET /api/transform-status co 3s.
  // Zwraca obiekt zgodny z interfejsem Response (ok/status/json/text),
  // albo null => caller używa starej ścieżki (fallback, np. backend bez
  // nowych endpointów albo ASYNC_UNAVAILABLE).
  // ROLLBACK: CUSTOMIFY_ASYNC_TRANSFORM = false (góra pliku) + npm run deploy
  // ============================================================
  async _transformViaPolling(requestBodyJson, signal) {
    const POLL_INTERVAL_MS = 3000;
    const POLL_REQUEST_TIMEOUT_MS = 15000;
    const MAX_CONSECUTIVE_POLL_FAILURES = 20; // ~1-2 min martwej sieci zanim się poddamy
    const OVERALL_DEADLINE_MS = 270000; // 4.5 min aktywnego czekania (czas w tle karty się nie liczy)
    const ABSOLUTE_DEADLINE_MS = 100 * 60 * 1000; // pod TTL joba w KV (2h) — nie pollujemy w nieskończoność
    const startedAt = Date.now();
    // Mobile chowa kartę i zamraża timery. Date.now() i 5-min AbortController
    // i tak dochodzą do limitu i ubijają polling, choć job na serwerze żyje.
    let hiddenStartedAt = (typeof document !== 'undefined' && document.visibilityState === 'hidden') ? Date.now() : 0;
    let hiddenMs = 0;
    const onPollVisibility = () => {
      if (typeof document === 'undefined') return;
      if (document.visibilityState === 'hidden') {
        if (!hiddenStartedAt) hiddenStartedAt = Date.now();
      } else if (hiddenStartedAt) {
        hiddenMs += Date.now() - hiddenStartedAt;
        hiddenStartedAt = 0;
      }
    };
    const activeElapsed = () => {
      const ongoingHidden = hiddenStartedAt ? (Date.now() - hiddenStartedAt) : 0;
      return Date.now() - startedAt - hiddenMs - ongoingHidden;
    };
    const markJobError = (err) => {
      if (err && typeof err === 'object') err.customifyJobStarted = true;
      return err;
    };
    // 1. Start zadania (krótki request - tylko upload zdjęcia + utworzenie joba)
    let jobId = null;
    const startController = new AbortController();
    const startTimeout = setTimeout(() => startController.abort(), 120000);
    let startResponse;
    try {
      startResponse = await fetch('https://customify-s56o.vercel.app/api/transform-start', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: requestBodyJson,
        signal: startController.signal
      });
    } finally {
      clearTimeout(startTimeout);
    }
    // Błąd sieci przy starcie rzuca wyjątek -> istniejący retry transformImage
    // (bezpieczne: zadanie jeszcze nie wystartowało, brak podwójnych generacji)

    if (startResponse.status !== 202) {
      console.warn('⚠️ [ASYNC-TRANSFORM] transform-start HTTP', startResponse.status, '- fallback na starą ścieżkę');
      this._sentryCrumb('transform_async', 'Async start unavailable - fallback to sync', { httpStatus: startResponse.status });
      return null;
    }
    try {
      const startData = await startResponse.json();
      jobId = startData.jobId || null;
    } catch (parseErr) {
      console.warn('⚠️ [ASYNC-TRANSFORM] transform-start zwrócił nie-JSON - fallback na starą ścieżkę');
      return null;
    }
    if (!jobId) return null;

    this._sentryCrumb('transform_async', 'Async transform job started', { jobId });
    console.log('🚀 [ASYNC-TRANSFORM] Job started:', jobId);

    // 2. Polling statusu - każde żądanie jest krótkie, chwilowy brak sieci
    //    (tło karty, przełączenie WiFi/4G) NIE przerywa generacji.
    //    5-min AbortController z transformImage nie ubija już tego joba:
    //    po starcie wynik jest w KV, więc wracamy do tego samego jobId.
    let consecutivePollFailures = 0;
    if (typeof document !== 'undefined') document.addEventListener('visibilitychange', onPollVisibility);
    try {
    while (true) {
      if (Date.now() - startedAt > ABSOLUTE_DEADLINE_MS) {
        throw markJobError(new Error('Generacja trwa zbyt długo. Spróbuj ponownie za chwilę.'));
      }
      if (activeElapsed() > OVERALL_DEADLINE_MS) {
        throw markJobError(new Error('Generacja trwa zbyt długo. Spróbuj ponownie za chwilę.'));
      }
      await new Promise(resolve => setTimeout(resolve, POLL_INTERVAL_MS));

      try {
        const pollController = new AbortController();
        const pollTimeout = setTimeout(() => pollController.abort(), POLL_REQUEST_TIMEOUT_MS);
        let pollResponse;
        try {
          pollResponse = await fetch(`https://customify-s56o.vercel.app/api/transform-status?jobId=${encodeURIComponent(jobId)}`, {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
            signal: pollController.signal
          });
        } finally {
          clearTimeout(pollTimeout);
        }

        if (pollResponse.status === 404) {
          // Job wygasł/nieznany - nie ponawiamy (wynik i tak przepadł)
          throw markJobError(Object.assign(new Error('Generacja wygasła. Spróbuj ponownie.'), { customifyFatalPoll: true }));
        }
        if (!pollResponse.ok) {
          consecutivePollFailures++;
          console.warn(`⚠️ [ASYNC-TRANSFORM] Poll HTTP ${pollResponse.status} (${consecutivePollFailures}/${MAX_CONSECUTIVE_POLL_FAILURES})`);
          if (consecutivePollFailures >= MAX_CONSECUTIVE_POLL_FAILURES) {
            throw markJobError(Object.assign(new Error('Nie udało się pobrać wyniku generacji. Spróbuj ponownie.'), { customifyFatalPoll: true }));
          }
          continue;
        }

        const pollData = await pollResponse.json();
        consecutivePollFailures = 0;

        if (pollData.status === 'done') {
          const finalStatus = (typeof pollData.httpStatus === 'number' && pollData.httpStatus > 0) ? pollData.httpStatus : 500;
          const finalBody = pollData.body || { error: 'AI transformation failed' };
          console.log(`✅ [ASYNC-TRANSFORM] Job done: ${jobId}, HTTP ${finalStatus}, elapsed ${Math.round((Date.now() - startedAt) / 1000)}s`);
          this._sentryCrumb('transform_async', 'Async transform job done', { jobId, httpStatus: finalStatus });
          // Obiekt zgodny z interfejsem Response - dalsza obsługa (sukces,
          // limity 403, moderacja 400, błędy 5xx) zostaje bez zmian
          return {
            ok: finalStatus >= 200 && finalStatus < 300,
            status: finalStatus,
            json: async () => finalBody,
            text: async () => JSON.stringify(finalBody)
          };
        }
        // status 'processing' -> czekamy dalej
      } catch (pollErr) {
        if (pollErr.customifyFatalPoll || pollErr.customifyJobStarted) throw pollErr;
        consecutivePollFailures++;
        console.warn(`⚠️ [ASYNC-TRANSFORM] Poll error (${consecutivePollFailures}/${MAX_CONSECUTIVE_POLL_FAILURES}):`, pollErr?.message || pollErr);
        if (consecutivePollFailures >= MAX_CONSECUTIVE_POLL_FAILURES) {
          throw markJobError(new Error('Utracono połączenie podczas generacji. Sprawdź internet i spróbuj ponownie.'));
        }
        // Chwilowy błąd sieci albo abort 5-min timera przy karcie w tle —
        // generacja na serwerze trwa, próbujemy dalej tego samego jobId
      }
    }
    } finally {
      if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', onPollVisibility);
    }
  }

  async transformImage(retryCount = 0) {
    if (this.isFamilyPortraitProduct() && this.familyPortraitCropPendingSlot != null) {
      this.showError('Zapisz lub anuluj kadrowanie przed utworzeniem podglądu.', 'transform');
      return;
    }
    // Freeze files and captions together so async uploads cannot change their pairing.
    const familyEntries = this.isFamilyPortraitProduct() ? this.getFamilyPhotoEntries() : null;
    if (this._isOffline()) {
      this.showError('Brak połączenia z internetem. Sprawdź sieć i spróbuj ponownie.', 'transform');
      return;
    }
    this._sentryCrumb('transform', 'Start transformImage', { style: this.selectedStyle, retry: retryCount });
    console.log(`🔍🔍🔍 [TRANSFORM] START transformImage:`, {
      selectedStyle: this.selectedStyle,
      selectedStyleType: typeof this.selectedStyle,
      productType: this.selectedStyle ? this.getProductTypeFromStyle(this.selectedStyle) : 'BRAK STYLU',
      uploadedFile: !!this.uploadedFile,
      uploadedFileName: this.uploadedFile?.name
    });
    
    if (this.isMultiUploadProduct()) {
      const multiFiles = this.getMultiUploadFiles();
      if (multiFiles.length === 0) {
        this.showError('Wgraj przynajmniej jedno zdjęcie', 'transform');
        return;
      }
      const requiredImages = this.getMultiUploadMaxImages();
      if (this.requiresExactMultiUploadCount() && multiFiles.length !== requiredImages) {
        this.showError(
          this.isCouplePortraitProduct()
            ? 'Wgraj oba zdjęcia — po jednym dla każdej osoby'
            : `Wgraj wszystkie ${requiredImages} zdjęcia`,
          'transform'
        );
        return;
      }
      if (familyEntries) this.uploadedFile = familyEntries[0]?.file;
      else if (!this.uploadedFile) this.uploadedFile = multiFiles[0];
    } else if (!this.uploadedFile || !this.selectedStyle) {
      console.error(`❌ [TRANSFORM] Brak wymaganych danych:`, {
        uploadedFile: !!this.uploadedFile,
        selectedStyle: this.selectedStyle
      });
      this.showError('Wgraj zdjęcie i wybierz styl', 'transform');
      return;
    }

    // Dla spotify: sprawdź czy zdjęcie zostało wykadrowane
    // - spotifyCropConfirmed = true (świeżo wykadrowane)
    // - lub uploadedFile.name zaczyna się od 'spotify-crop-' (już wykadrowane, po "spróbuj ponownie")
    const isSpotifyCropped = this.spotifyCropConfirmed || 
      (this.uploadedFile && this.uploadedFile.name && this.uploadedFile.name.startsWith('spotify-crop-'));
    
    if (this.isSpotifyProduct() && !isSpotifyCropped) {
      this.showError('Najpierw wykadruj zdjęcie', 'transform');
      return;
    }

    // 📱 Dla telefonu: sprawdź czy zdjęcie zostało wykadrowane
    const isPhoneCropped = this.phoneCropConfirmed || 
      (this.uploadedFile && this.uploadedFile.name && this.uploadedFile.name.startsWith('phone-crop-'));
    
    if (this.isPhoneCaseProduct() && !isPhoneCropped) {
      this.showError('Najpierw wykadruj zdjęcie', 'transform');
      return;
    }
    
    // 📱 Dla etui (zdjęcie): sprawdź czy zdjęcie zostało wykadrowane
    const isPhonePhotoCropped = this.phonePhotoCropConfirmed || 
      (this.uploadedFile && this.uploadedFile.name && this.uploadedFile.name.startsWith('phone-photo-crop-'));
    
    if (this.isPhonePhotoCaseProduct() && !isPhonePhotoCropped) {
      this.showError('Najpierw wykadruj zdjęcie', 'transform');
      return;
    }

      // 🎛️ CUSTOM FIELDS: Zbierz wartości pól personalizacji i zbuduj promptAddition
      let promptAddition = null;
      try {
        promptAddition = this.collectCustomFieldsPrompt();
      } catch (fieldError) {
        this.showError(fieldError.message, 'transform');
        this.hideLoading();
        return;
      }

      let spotifyPayload = null;
      if (this.isSpotifyProduct()) {
        const spotifyTitle = (this.spotifyTitleInput?.value || '').trim().slice(0, 60);
        const spotifyArtist = (this.spotifyArtistInput?.value || '').trim().slice(0, 60);
        spotifyPayload = { title: spotifyTitle, artist: spotifyArtist };
      }

    // 🎵 SPOTIFY: Styl "bez-zmian" - pomijamy AI, pokazujemy widok jak po generacji
    if (this.selectedStyle === 'bez-zmian') {
      console.log('🎵 [SPOTIFY] Styl "bez-zmian" - pomijamy transformację AI');
      this.showLoading();
      
      // Użyj wykadrowanego zdjęcia jako transformedImage (dla addToCart)
      const reader = new FileReader();
      reader.onload = (e) => {
        this.transformedImage = e.target.result;
        this.watermarkedImageUrl = null; // Będzie generowany przy dodaniu do koszyka
        
        // Ukryj sekcje jak po normalnej generacji
        if (this.uploadArea) this.uploadArea.style.display = 'none';
        if (this.stylesArea) this.stylesArea.style.display = 'none';
        if (this.actionsArea) this.actionsArea.style.display = 'none';
        
        // Pokaż przyciski koszyka
        if (this.cartActionsArea) this.cartActionsArea.style.display = 'flex';
        
        // Pokaż rozmiary i typ wydruku
        if (this.sizeArea) this.sizeArea.style.display = 'block';
        if (this.productTypeArea) this.productTypeArea.style.display = 'block';
        
        // Preview z maską pozostaje widoczny (nie zmieniamy na resultArea)
        // Komunikat sukcesu
        this.showSuccess('Projekt gotowy! Wybierz parametry wydruku i dodaj do koszyka.');
        this.hideLoading();
        
        console.log('✅ [SPOTIFY] Styl "bez-zmian" - widok jak po generacji, gotowe do koszyka');
      };
      reader.readAsDataURL(this.uploadedFile);
      return;
    }

    // ✅ DEBUG: Sprawdź selectedStyle przed checkUsageLimit
    console.log(`🔍 [TRANSFORM] Przed checkUsageLimit:`, {
      selectedStyle: this.selectedStyle,
      productType: this.getProductTypeFromStyle(this.selectedStyle),
      uploadedFile: !!this.uploadedFile
    });

    // ✅ USAGE LIMITS: Sprawdź limit PRZED transformacją (ZAWSZE, nawet przy retry)
      const canTransform = await this.checkUsageLimit();
      if (!canTransform) {
        console.log('❌ [USAGE] Limit przekroczony - przerwano transformację');
        return;
    }

    // ✅ Google Analytics Event Tracking - "Zobacz Podgląd" kliknięty
    if (retryCount === 0 && typeof gtag !== 'undefined') {
      gtag('event', 'zobacz_podglad_click', {
        'event_category': 'Customify',
        'event_label': this.selectedStyle,
        'style_name': this.selectedStyle,
        'product_url': window.location.pathname
      });
      console.log('📊 [GA4] Event sent: zobacz_podglad_click', {
        style: this.selectedStyle,
        url: window.location.pathname
      });
    }

    this.showLoading({ trackWait: true });
    this.hideError();
    if (this.isPilotImageEditProduct()) {
      this.hidePilotEditFreshBanner();
    }
    
    if (retryCount > 0) {
      console.log(`🔄 [MOBILE] Retry attempt ${retryCount}/3`);
    }

    // One terminal pricing outcome per attempt; cleanup is not a failure.
    let pricingOutcomeRecorded = false;
    const recordPricingOutcome = metric => {
      if (pricingOutcomeRecorded) return;
      pricingOutcomeRecorded = true;
      window.LumlyPricingPreview?.track(metric);
    };

    try {
      let imageSourceType = 'uploaded_file';
      const base64 = (this.isSpotifyProduct() && this.spotifyCropConfirmed && this.spotifyCropDataUrl)
        ? this.spotifyCropDataUrl
        : (this.isPhoneCaseProduct() && this.phoneCropConfirmed && this.phoneCropDataUrl)
        ? this.phoneCropDataUrl
        : (this.isPhonePhotoCaseProduct() && this.phonePhotoCropConfirmed && this.phonePhotoCropDataUrl)
        ? this.phonePhotoCropDataUrl
        : await this.fileToBase64(familyEntries ? familyEntries[0].file : this.uploadedFile);

      if (this.isSpotifyProduct() && this.spotifyCropConfirmed && this.spotifyCropDataUrl) {
        imageSourceType = 'spotify_crop_data_url';
      } else if (this.isPhoneCaseProduct() && this.phoneCropConfirmed && this.phoneCropDataUrl) {
        imageSourceType = 'phone_crop_data_url';
      } else if (this.isPhonePhotoCaseProduct() && this.phonePhotoCropConfirmed && this.phonePhotoCropDataUrl) {
        imageSourceType = 'phone_photo_crop_data_url';
      }
      
      // Create AbortController for timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 300000); // 5 minutes
      
      
      // ✅ Użyj productType z stylu (zgodne z backend - config.productType)
      const productType = this.getProductTypeFromStyle(this.selectedStyle);
      
      // ✅ USAGE LIMITS: Pobierz dane użytkownika do przekazania do API
      const customerInfo = this.getCustomerInfo();
      
      // ✅ Pobierz email z localStorage (jeśli był w formularzu) lub z customerInfo
      const email = customerInfo?.email || localStorage.getItem('customify_email_provided') || null;
      
      const abActive = typeof window.getLumlyProductAbActive === 'function'
        ? window.getLumlyProductAbActive()
        : (typeof window.lumlyAbActive === 'function' ? window.lumlyAbActive() : null);
      const requestBody = {
        imageData: base64,
        // ❌ USUNIĘTO: prompt - backend używa config.prompt z konfiguracji stylu (jak dla króla, kotów, etc.)
        style: this.selectedStyle, // ✅ STYL - API użyje tego do identyfikacji stylu i pobrania prompta z config
        productType: productType, // Przekaż typ produktu do API
        productHandle: this.getProductHandle(), // 📊 Statystyki per konkretny URL produktu
        customerId: customerInfo?.customerId || null,
        // ✅ EMAIL: ZAWSZE wysyłaj email jeśli dostępny (dla zalogowanych i niezalogowanych)
        // Backend użyje tego do ustawienia metafield generation_ready dla emaili Shopify Flow
        email: customerInfo?.email || email || null,
        // Model A/B: backend przełącza model po handle + wariancie (dowolny produkt z EXPERIMENTS).
        ...(abActive ? {
          abExperiment: abActive.experiment,
          abVariant: abActive.variant,
          abVisitorId: abActive.visitorId
        } : {})
        // ❌ USUNIĘTO: watermarkedImage - watermark generujemy PO transformacji AI, nie przed!
      };
      
      if (spotifyPayload) {
        requestBody.spotifyTitle = spotifyPayload.title;
        requestBody.spotifyArtist = spotifyPayload.artist;
      }

      if (promptAddition) {
        requestBody.promptAddition = promptAddition;
        const cfg = this.getCustomFieldConfig();
        if (cfg && cfg.promptTemplate) requestBody.replaceBasePrompt = true;
      }

      // 📊 PERSONALIZATION: surowe wartości pól — ZAWSZE gdy produkt ma konfigurację (backend buduje prompt)
      const cfgForLog = this.getCustomFieldConfig();
      if (cfgForLog && cfgForLog.fields) {
        const rawFields = {};
        cfgForLog.fields.forEach(field => {
          const el = document.getElementById(`customField_${field.id}`);
          let value = el ? el.value.trim() : '';
          if (!value && field.defaultValue) value = String(field.defaultValue).trim();
          if (value) rawFields[field.id] = value;
          if (field.customInput && (value === 'Własny' || value === 'Własne')) {
            const customEl = document.getElementById(`customField_${field.customInput.id}`);
            if (customEl && customEl.value && customEl.value.trim()) {
              rawFields[field.customInput.id] = customEl.value.trim();
            }
          }
        });
        if (this.isFamilyPortraitProduct()) {
          const bgEl = document.getElementById('customField_family_background');
          const bgVal = bgEl && bgEl.value.trim() ? bgEl.value.trim() : 'studio';
          rawFields.family_background = bgVal;
          if (bgVal === 'custom') {
            const descEl = document.getElementById('customField_family_background_desc');
            const descVal = descEl ? descEl.value.trim() : '';
            if (descVal) rawFields.family_background_desc = descVal;
            else delete rawFields.family_background_desc;
          } else {
            delete rawFields.family_background_desc;
          }
        }
        if (familyEntries) rawFields.family_photo_captions = JSON.stringify(familyEntries.map(entry => entry.caption));
        requestBody.personalizationFields = rawFields;
      }

      // 📸 MULTI-UPLOAD: Upload dodatkowych zdjęć do Vercel Blob i dodaj URL-e
      if (this.isMultiUploadProduct()) {
        const multiFiles = familyEntries ? familyEntries.map(entry => entry.file) : this.getMultiUploadFiles();
        const additionalImageUrls = [];
        for (let i = 1; i < multiFiles.length; i++) {
          const file = multiFiles[i];
          const fileBase64 = await this.fileToBase64(file);
          console.log(`📸 [MULTI-UPLOAD] Uploading image ${i+1}/${multiFiles.length} to Vercel Blob...`);
          try {
            const uploadResp = await fetch('https://customify-s56o.vercel.app/api/upload-temp-image', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ imageData: fileBase64, filename: `multi-upload-${Date.now()}-${i}.jpg` })
            });
            if (uploadResp.ok) {
              const uploadResult = await uploadResp.json();
              if (uploadResult.url) {
                additionalImageUrls.push(uploadResult.url);
                console.log(`📸 [MULTI-UPLOAD] Image ${i+1} uploaded:`, uploadResult.url.substring(0, 80));
              }
            }
          } catch (uploadErr) {
            console.warn(`⚠️ [MULTI-UPLOAD] Failed to upload image ${i+1}:`, uploadErr);
          }
        }
        if ((familyEntries || this.requiresExactMultiUploadCount()) && additionalImageUrls.length !== multiFiles.length - 1) {
          this.showError(`Nie udało się wysłać wszystkich ${multiFiles.length} zdjęć. Spróbuj ponownie.`, 'transform');
          return;
        }
        if (additionalImageUrls.length > 0) {
          requestBody.additionalImages = additionalImageUrls;
          console.log(`📸 [MULTI-UPLOAD] Total additional images: ${additionalImageUrls.length}; total images sent to API: ${additionalImageUrls.length + 1}`);
        }
      }
      
      // Logi diagnostyczne - bez promptu, personalizacji, emaila (prywatność)
      const requestBodyJson = JSON.stringify(requestBody);
      const uploadDiagnostics = {
        ...(this.lastUploadDiagnostics || {}),
        ...this._browserDiagnostics(),
        imageSourceType,
        base64Length: typeof base64 === 'string' ? base64.length : null,
        estimatedImageBytes: this._base64SizeBytes(base64),
        requestBodyBytes: requestBodyJson.length,
        retryCount,
        style: this.selectedStyle || null,
        productType,
        productHandle: this.getProductHandle()
      };
      this._sentryCrumb('transform_request', 'Transform request diagnostics', uploadDiagnostics);
      console.log('📏 [TRANSFORM] Request diagnostics:', uploadDiagnostics);
      this.lastTransformRequestDiagnostics = uploadDiagnostics;

      this.trackStatsEvent('ai_generation_attempt', {
        style: this.selectedStyle || null,
        retryCount,
        requestBodyBytes: uploadDiagnostics.requestBodyBytes,
        imageBytes: uploadDiagnostics.estimatedImageBytes,
        originalFileSize: uploadDiagnostics.originalFileSize || null,
        compressedFileSize: uploadDiagnostics.compressedFileSize || null,
        imageSourceType
      });

      if (typeof window.trackProductAbMetric === 'function') {
        window.trackProductAbMetric('gen_start');
        window.LumlyPricingPreview?.track('gen_start');
      }

      // 🔍 DIAGNOSTYKA: pomiar czasu fetch + czy karta była w tle podczas żądania (mobile backgrounding)
      this._lastTransformHttpStatus = null;
      this._transformWasHidden = (typeof document !== 'undefined' && document.visibilityState === 'hidden');
      this._transformVisHandler = () => { if (typeof document !== 'undefined' && document.visibilityState === 'hidden') this._transformWasHidden = true; };
      if (typeof document !== 'undefined') document.addEventListener('visibilitychange', this._transformVisHandler);
      this._transformFetchStartedAt = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();

      // ASYNC-TRANSFORM-FEATURE: najpierw ścieżka zadanie-w-tle + polling;
      // null = fallback na starą ścieżkę (np. backend bez nowych endpointów)
      let response = null;
      if (CUSTOMIFY_ASYNC_TRANSFORM) {
        response = await this._transformViaPolling(requestBodyJson, controller.signal);
      }
      if (!response) {
        response = await fetch('https://customify-s56o.vercel.app/api/transform', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: requestBodyJson,
          signal: controller.signal
        });
      }
      
      clearTimeout(timeoutId);
      this._lastTransformHttpStatus = response.status;

      if (!response.ok) {
        const errorText = await response.text();
        console.error('📱 [MOBILE] Response error:', errorText);

        let errorJson = null;
        try {
          errorJson = JSON.parse(errorText);
        } catch (parseError) {
          console.warn('⚠️ [MOBILE] Failed to parse error JSON:', parseError);
        }

        this.trackStatsEvent('ai_generation_failed', {
          status: response.status,
          errorCode: errorJson?.error || 'HTTP_ERROR',
          errorMessage: errorJson?.message || errorJson?.error || errorText,
          retryCount
        });

        const trackAbGenFail = () => {
          recordPricingOutcome('gen_fail_v2');
          if (typeof window.trackProductAbMetric === 'function') window.trackProductAbMetric('gen_fail');
        };

        if (response.status === 403 && errorJson?.error === 'Usage limit exceeded') {
          console.warn('⚠️ [USAGE] Limit exceeded response from API:', errorJson);

          if (!customerInfo) {
            const usedCount = typeof errorJson.usedCount === 'number' ? errorJson.usedCount : 1;
            const totalLimit = typeof errorJson.totalLimit === 'number' ? errorJson.totalLimit : 1;

            try {
              const FREE_LIMIT = 1;
              const enforcedCount = Math.max(usedCount, FREE_LIMIT);
              localStorage.setItem('customify_usage_count', enforcedCount.toString());
              console.log('💾 [USAGE] Synced local usage count to', enforcedCount);
            } catch (storageError) {
              console.warn('⚠️ [USAGE] Failed to sync local usage count:', storageError);
            }

            this.showLoginModal(usedCount, totalLimit);
          } else {
            this.trackLimitFunnelShowLimit(customerInfo, {
              wallTier: errorJson.wallTier || 'unknown',
              source: 'transform_403'
            });
            this.showLimitWallModal(customerInfo, errorJson);
          }

          return;
        }

        if (response.status === 403 && errorJson?.error === 'Image already used') {
          console.warn('⚠️ [IMAGE-HASH] Image already used response from API:', errorJson);
          const baseMessage = errorJson.message || 'Dla tego zdjęcia wynik jest już gotowy. Jeśli chcesz coś poprawić na obrazku, nasz grafik zrobi to za darmo. Zamów i napisz w polu Uwagi.';
          this.showErrorWithHTML(baseMessage, 'transform');
          return;
        }

        if (errorJson?.error === 'Invalid style' || String(errorText || '').includes('Dostępne style')) {
          trackAbGenFail();
          this.showError('Nie udało się uruchomić podglądu. Odśwież stronę i spróbuj ponownie.', 'transform');
          return;
        }

        if (errorJson?.error === 'CROPPED_FACE') {
          const msg = errorJson.message || 'Zdjęcie musi pokazywać całą twarz z przodu. Użyj zdjęcia, gdzie twarz jest w pełni widoczna i nie jest ucięta.';
          trackAbGenFail();
          this.showError(msg, 'transform');
          return;
        }

        if (response.status === 400) {
          const backendError = (errorJson?.error || '').toString();
          const normalizedError = backendError.toLowerCase();
          const isModerationError =
            normalizedError.includes('odrzucone przez system bezpieczeństwa') ||
            normalizedError.includes('filtr bezpieczeństwa') ||
            normalizedError.includes('nsfw') ||
            normalizedError.includes('content detected') ||
            normalizedError.includes('moderation');

          if (isModerationError) {
            trackAbGenFail();
            this.showError(
              'Zdjęcie zostało odrzucone przez filtr bezpieczeństwa. Użyj zdjęcia z wyraźną twarzą i neutralnym strojem.',
              'transform'
            );
            return;
          }
        }

        trackAbGenFail();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const result = await response.json();
      
      if (result.success) {
        if (this.isPilotImageEditProduct()) {
          this.resetPilotEditForNewBaseImage({
            closeEditor: true,
            newBaseUrl: result.transformedImage,
            clearInstruction: true
          });
          this.pilotEditAnchorImageUrl = result.transformedImage;
          this.pilotEditAnchorKey = this.normalizePilotEditImageKey(result.transformedImage);
          this.pilotEditBaseImageKey = this.pilotEditAnchorKey;
          this.pilotEditHistory = [];
          this.pilotEditViewingIndex = -1;
          this.setPilotEditSessionToken(
            result.pilotEditSessionToken || null,
            result.transformedImage
          );
          this.setPilotEditEntryMode('fresh');
          this.persistPilotEditSessionToStore();
        }
        this.transformedImage = result.transformedImage;
        if (customerInfo?.customerId) {
          this.trackLimitFunnelGenerationSuccess(customerInfo);
        }
        // ✅ STATS: Generacje AI zlicza backend (transform.js) – jedna źródło prawdy, bez podwójnego liczenia
        // ✅ ZAPISZ watermarkedImageUrl z backendu (jeśli dostępny)
        this.watermarkedImageUrl = result.watermarkedImageUrl || null;
        // ✅ NOWE: ZAPISZ watermarkedImageBase64 z backendu (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
        this.watermarkedImageBase64 = result.watermarkedImageBase64 || null;
        this.hideError(); // Ukryj komunikat błędu po udanej transformacji
        
        // ✅ AWAIT: Czekaj aż wynik zostanie pokazany
        // showResult() użyje watermarkedImageUrl jeśli dostępny, w przeciwnym razie transformedImage
        await this.showResult(result.transformedImage);
        // A/B generate liczy backend (transform.js) — bez frontu, bez dublowania
        if (!this.isPhonePhotoCaseProduct || !this.isPhonePhotoCaseProduct()) {
          if (customerInfo) {
            // Zalogowany: pokaż bazowy komunikat, potem dołącz liczbę pozostałych prób
            const savedMsg = this.isPilotImageEditProduct()
              ? this.getPilotEditSavedSuccessMessage({ loggedIn: true })
              : 'Obraz zapisany, jest dostępny w sekcji <a href="https://lumly.pl/pages/my-generations" target="_blank" rel="noopener">Moje obrazy</a>.<br><span style="font-size:0.88em;color:#555;">Jeśli na obrazku jest coś nie tak, np. napis, literówki — nasz grafik poprawi to ręcznie. Napisz przy składaniu zamówienia w polu Uwagi.</span>';
            this.showSuccess(savedMsg, { html: true });
            if (this.isPilotImageEditProduct()) this.bindPilotEditSuccessButton();
            fetch('https://customify-s56o.vercel.app/api/check-usage', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ customerId: customerInfo.customerId, customerAccessToken: customerInfo.customerAccessToken })
            }).then(r => r.ok ? r.json() : null).then(d => {
              if (d && this.successMessage && this.successMessage.style.display !== 'none') {
                const remaining = d.remainingCount || 0;
                const total = d.totalLimit || 4;
                const usageNote = remaining > 0
                  ? ` <span style="color:#888;font-size:0.88em">Pozostało <strong>${remaining} z ${total}</strong> prób.</span>`
                  : ` <span style="color:#c0392b;font-size:0.88em">Wykorzystano wszystkie próby (${total}/${total}). <a href="#" id="needMoreLink" style="color:#667eea;text-decoration:underline;cursor:pointer;">Potrzebujesz więcej?</a></span>`;
                this.successMessage.innerHTML += usageNote;
                if (this.isPilotImageEditProduct()) this.bindPilotEditSuccessButton();
                if (remaining <= 0) {
                  const needMoreEl = document.getElementById('needMoreLink');
                  if (needMoreEl) {
                    needMoreEl.addEventListener('click', (e) => {
                      e.preventDefault();
                      this.trackLimitFunnelShowLimit(customerInfo, { wallTier: 'first_wall', source: 'need_more_link' });
                      this.showLimitWallModal(customerInfo, { wallTier: 'first_wall', usedCount: total, totalLimit: total });
                    });
                  }
                }
              }
            }).catch(() => {});
          } else {
            const savedMsgGuest = this.isPilotImageEditProduct()
              ? this.getPilotEditSavedSuccessMessage({ loggedIn: false })
              : 'Obraz zapisany! Możesz go zobaczyć później w sekcji Twoje obrazy - Poniżej.<br><span style="font-size:0.88em;color:#555;">Jeśli na obrazku jest coś nie tak, np. napis, literówki — nasz grafik poprawi to ręcznie. Napisz przy składaniu zamówienia w polu Uwagi.</span>';
            this.showSuccess(savedMsgGuest, { html: true });
            if (this.isPilotImageEditProduct()) this.bindPilotEditSuccessButton();
          }
        }
        
        // ✅ UKRYJ PASEK POSTĘPU - obraz jest już widoczny, reszta działa w tle
        this._finishGenerationWait('done');
        recordPricingOutcome('generate');
        this.hideLoading();

        // 🆕 Tekst na obrazie – pokaż panel dopiero po generacji (tylko produkt pilota)
        if (this.textOverlayEnabled && this.textOverlayPanel) {
          this.watermarkedImageUrl = result.watermarkedImageUrl || result.transformedImage;
          this.textOverlayBaseImage = result.transformedImage || null;
          this.textOverlayOriginalWatermarked = result.watermarkedImageUrl || null;
          this.textOverlayState = { ...this.textOverlayState, text: '', applied: false };
          if (this.textOverlayInput) {
            this.textOverlayInput.value = '';
            this.updateTextOverlayCounter();
          }
          this.textOverlayPanel.style.display = 'none';
          this.textOverlayToggleBtn?.setAttribute('data-overlay-open', 'false');
          this.updateTextOverlayHint('');
        }
        
        // ✅ BACKEND WATERMARK: Backend już generuje watermark i zwraca watermarkedImageUrl w response
        // ✅ Backend zapisuje watermarkedImageUrl w save-generation-v2 automatycznie
        // ✅ NIE WYSYŁAMY już frontend watermarku do /api/update-generation-watermark (stary system)
        if (result.watermarkedImageUrl) {
        } else {
          console.warn('⚠️ [TRANSFORM] Backend watermark nie jest dostępny - frontend użyje fallback w showResult()');
        }
        
        // ✅ STARY KOD USUNIĘTY: Frontend watermark generation i /api/update-generation-watermark
        // ✅ Backend już generuje watermark i zwraca watermarkedImageUrl w response
        // ✅ showResult() w theme.liquid używa this.watermarkedImageUrl (ustawiony powyżej)
        
        // 🎨 GALERIA: Zapisz generację do localStorage z base64 cache
        // ✅ DODAJ productType do generacji (dla skalowalności)
        const productType = this.getProductTypeFromStyle(this.selectedStyle);
        this.saveAIGeneration(
          base64,                     // Oryginalne zdjęcie (base64)
          result.transformedImage,    // AI obraz URL
          this.selectedStyle,         // Styl (pixar, boho, etc)
          this.selectedSize,         // Rozmiar (a4, a3, etc)
          productType,                // ✅ ProductType (boho, king, cats, etc)
          result.watermarkedImageUrl || this.watermarkedImageUrl || null, // ✅ ZAPISZ watermarkedImageUrl (Vercel Blob z watermarkiem)
          result.watermarkedImageBase64 || this.watermarkedImageBase64 || null // ✅ NOWE: Base64 watermarku (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
        ).then(() => {
          console.log('✅ [CACHE] AI generation saved with base64 cache');
          
          // ✅ KLUCZOWE: Pobierz zapisany generation z historii i użyj jego URL (z Vercel Blob)
          const generations = this.getAIGenerations();
          if (generations.length > 0) {
            const lastGeneration = generations[0];
            if (lastGeneration.transformedImage) {
              console.log('✅ [CACHE] Using saved URL from history:', lastGeneration.transformedImage.substring(0, 100));
              this.transformedImage = lastGeneration.transformedImage; // Użyj URL z Vercel Blob zamiast oryginału
              console.log('✅ [CACHE] Updated this.transformedImage to saved URL');
            }
          }
        }).catch(error => {
          console.error('❌ [CACHE] Failed to save AI generation:', error);
        });
        
        // Niezalogowani: inkrementuj licznik lokalny (zalogowani: backend API robi auto)
        if (!customerInfo) {
          const productType = this.getProductTypeFromStyle(this.selectedStyle);
          this.incrementLocalUsage(productType);
        }
      } else {
        recordPricingOutcome('gen_fail_v2');
        this.trackStatsEvent('ai_generation_failed', {
          errorCode: result.error || 'UNKNOWN_RESULT_ERROR',
          errorMessage: result.error || 'Nieznany błąd',
          retryCount
        });
        if (typeof window.trackProductAbMetric === 'function') window.trackProductAbMetric('gen_fail');
        this.showError('Błąd podczas transformacji: ' + (result.error || 'Nieznany błąd'), 'transform');
      }
    } catch (error) {
      console.error('📱 [MOBILE] Transform error:', error);

      // Blad odczytu pliku (FileReader/arrayBuffer nie umie odczytac - np. Google Photos content URI)
      if (error?.name === 'FileReadError') {
        recordPricingOutcome('gen_fail_v2');
        this.showError(error.message, 'transform');
        return;
      }

      // Retry logic for network errors (w tym "Error completing request", "Load failed" z Sentry)
      const isNetworkError = error?.message && (
        error.message.includes('Failed to fetch') ||
        error.message.includes('NetworkError') ||
        error.message.includes('Load failed') ||
        error.message.includes('Error completing request') ||
        error.message.includes('network failure')
      );
      const _transformNow = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
      const transformDiagnostics = {
        ...(this.lastTransformRequestDiagnostics || {}),
        ...(this.lastUploadDiagnostics || {}),
        ...this._browserDiagnostics(),
        retryCount,
        elapsedMs: this._transformFetchStartedAt ? Math.round(_transformNow - this._transformFetchStartedAt) : null,
        visibilityState: (typeof document !== 'undefined') ? document.visibilityState : null,
        wasHiddenDuringRequest: !!this._transformWasHidden,
        httpStatus: (typeof this._lastTransformHttpStatus === 'number') ? this._lastTransformHttpStatus : null,
        style: this.selectedStyle || null,
        productHandle: this.getProductHandle ? this.getProductHandle() : null
      };
      if (isNetworkError || error.name === 'AbortError') {
        this._reportToSentry(error, 'transformImage_network', {
          ...transformDiagnostics,
          isAbort: error.name === 'AbortError'
        });
      } else {
        this._reportToSentry(error, 'transformImage', transformDiagnostics);
      }
      // Job już wystartował — ponowny transformImage zużyłby drugą generację.
      if (retryCount < 3 && !error.customifyJobStarted && (error.name === 'AbortError' || isNetworkError)) {
        const retryDelay = (retryCount + 1) * 2000;
        console.log(`🔄 [MOBILE] Retrying in ${retryDelay}ms... (attempt ${retryCount + 1}/3)`);
        this.showError(`🔄 Błąd sieci — ponawiam próbę ${retryCount + 1}/3...`, 'transform');
        this._generationWaitRetrying = true;
        setTimeout(() => {
          this.transformImage(retryCount + 1);
        }, retryDelay);
        return;
      }

      recordPricingOutcome('gen_fail_v2');
      this.trackStatsEvent('ai_generation_failed', {
        errorCode: error?.name || 'TRANSFORM_ERROR',
        errorMessage: error?.message || String(error),
        retryCount
      });

      if (typeof window.trackProductAbMetric === 'function') {
        const http = this._lastTransformHttpStatus;
        if (!(typeof http === 'number' && http >= 400)) {
          window.trackProductAbMetric('gen_drop');
        }
      }
      
      let errorMessage = 'Błąd połączenia z serwerem';
      
      if (error.name === 'AbortError') {
        errorMessage = 'Przekroczono limit czasu (5 minut). Spróbuj ponownie.';
      } else if (error?.message && (error.message.includes('Failed to fetch') || error.message.includes('Error completing request') || error.message.includes('Load failed'))) {
        errorMessage = 'Błąd sieci. Sprawdź połączenie internetowe i spróbuj ponownie.';
      } else if (error?.message && error.message.includes('NetworkError')) {
        errorMessage = 'Błąd sieci. Spróbuj ponownie za chwilę.';
      } else if (error?.message && error.message.includes('TypeError')) {
        errorMessage = 'Błąd przetwarzania. Spróbuj ponownie.';
      } else if (error?.message) {
        errorMessage = 'Błąd: ' + error.message;
      } else if (typeof error === 'string') {
        errorMessage = 'Błąd: ' + error;
      }
      
      this.showError(errorMessage, 'transform');
    } finally {
      if (this._transformVisHandler && typeof document !== 'undefined') {
        document.removeEventListener('visibilitychange', this._transformVisHandler);
        this._transformVisHandler = null;
      }
      this.hideLoading();
      if (!this._generationWaitRetrying) {
        this._finishGenerationWait('failed');
      }
      this._generationWaitRetrying = false;
    }
  }

  // FUNKCJA DODAWANIA WATERMARKU
  async addWatermark(imageUrl) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log('🔤 [WATERMARK DEBUG] START - imageUrl:', imageUrl?.substring(0, 100));
        console.log('🔤 [WATERMARK DEBUG] document.fonts.status:', document.fonts.status);
        console.log('🔤 [WATERMARK DEBUG] Czekam na document.fonts.ready...');
        
        // 🔧 POZIOM 1: Poczekaj na załadowanie fontów PRZED renderowaniem
        await document.fonts.ready;
        console.log('✅ [WATERMARK DEBUG] document.fonts.ready - fonty załadowane!');
        
        const img = new Image();
        // ✅ crossOrigin tylko dla zdalnych URL-i (HTTP/HTTPS), NIE dla base64 data URI!
        // Base64 data URI nie wymaga crossOrigin - działa bezpośrednio
        if (imageUrl && !imageUrl.startsWith('data:')) {
          img.crossOrigin = 'anonymous'; // Tylko dla zdalnych URL-i
        }
        
        img.onload = () => {
          try {
            console.log('🖼️ [WATERMARK DEBUG] Image loaded:', img.width, 'x', img.height);
            
            // ✅ ZMNIEJSZENIE WATERMARKU: 50% rozmiaru oryginału (dla miniaturki w Shopify i emaili)
            // Oryginał BEZ watermarku pozostaje w pełnym rozmiarze na Vercel (do druku)
            const scale = 0.5; // 50% rozmiaru (zmniejszamy dla Shopify + Vercel watermark)
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            canvas.width = Math.round(img.width * scale);
            canvas.height = Math.round(img.height * scale);
            console.log(`📐 [WATERMARK DEBUG] Watermark canvas size: ${canvas.width}x${canvas.height} (${Math.round(scale * 100)}% of original)`);
            
            // Rysuj oryginalny obraz na zmniejszonym Canvas (automatycznie skaluje)
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            console.log('✅ [WATERMARK DEBUG] Original image drawn on resized canvas (50% scale)');
            
            // ===== WZÓR DIAGONALNY - "LUMLY.PL" i "PODGLAD" NA PRZEMIAN =====
            ctx.save();
            
            // ✅ DOSTOSOWANY FONT SIZE: większy dla lepszej widoczności
            const fontSize = Math.max(20, Math.min(canvas.width, canvas.height) * 0.11); // 11% canvas
            console.log('📏 [WATERMARK DEBUG] fontSize:', fontSize);
            
            // 🔧 POZIOM 2: Użyj systemowych fontów z fallbackami + UPPERCASE bez polskich znaków
            const fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
            ctx.font = `bold ${fontSize}px ${fontFamily}`;
            console.log('🔤 [WATERMARK DEBUG] Font ustawiony:', ctx.font);
            
            // 🔒 Watermark podglądu: ZBALANSOWANY (opacity 0.45 + cieńszy obrys)
            ctx.fillStyle = 'rgba(255, 255, 255, 0.45)';
            ctx.strokeStyle = 'rgba(0, 0, 0, 0.35)';
            ctx.lineWidth = 1.5;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            
            // 🔧 POZIOM 3: Test renderowania - sprawdź czy font działa
            const testText = 'TEST';
            const testMetrics = ctx.measureText(testText);
            console.log('🔍 [WATERMARK DEBUG] Test measureText("TEST"):', {
              width: testMetrics.width,
              actualBoundingBoxLeft: testMetrics.actualBoundingBoxLeft,
              actualBoundingBoxRight: testMetrics.actualBoundingBoxRight
            });
            
            if (testMetrics.width === 0) {
              console.error('❌ [WATERMARK DEBUG] Font test FAILED! width=0, próbuję fallback monospace');
              ctx.font = `bold ${fontSize}px monospace`;
              console.log('🔄 [WATERMARK DEBUG] Fallback font:', ctx.font);
              
              const fallbackMetrics = ctx.measureText(testText);
              console.log('🔍 [WATERMARK DEBUG] Fallback measureText("TEST"):', {
                width: fallbackMetrics.width
              });
            } else {
              console.log('✅ [WATERMARK DEBUG] Font test OK! width=' + testMetrics.width);
            }
            
            // Test canvas rendering - czy tekst się faktycznie renderuje?
            const testCanvas = document.createElement('canvas');
            testCanvas.width = 200;
            testCanvas.height = 100;
            const testCtx = testCanvas.getContext('2d');
            testCtx.font = ctx.font;
            testCtx.fillStyle = 'black';
            testCtx.fillText('Lumly.pl', 100, 50);
            const testDataUrl = testCanvas.toDataURL();
            console.log('🧪 [WATERMARK DEBUG] Test canvas rendering:', testDataUrl.substring(0, 100) + '...');
            
            // Obróć canvas w przeciwną stronę niż backend (ok. +30°)
            ctx.translate(canvas.width/2, canvas.height/2);
            ctx.rotate(30 * Math.PI / 180);
            ctx.translate(-canvas.width/2, -canvas.height/2);
            console.log('🔄 [WATERMARK DEBUG] Canvas rotated +30°');
            
            // 🔧 TEKST WATERMARKU - tylko "Lumly.pl"
            const texts = ['Lumly.pl'];
            console.log('📝 [WATERMARK DEBUG] Teksty watermarku:', texts);
            
            // Rysuj watermarki w siatce - na przemian
            const spacing = Math.max(200, Math.min(canvas.width, canvas.height) * 0.3);
            console.log('📏 [WATERMARK DEBUG] Spacing:', spacing);
            
            let textIndex = 0;
            let watermarkCount = 0;
            
            for(let y = -canvas.height; y < canvas.height * 2; y += spacing) {
              for(let x = -canvas.width; x < canvas.width * 2; x += spacing * 1.5) {
                const text = texts[0]; // Tylko "Lumly.pl"
                // ✅ RYSUJ STROKE PRZED FILL (dla lepszej widoczności)
                ctx.strokeText(text, x, y);
                ctx.fillText(text, x, y);
                textIndex++;
                watermarkCount++;
              }
              // Zmień wzór co wiersz dla lepszego efektu
              textIndex++;
            }
            
            console.log('✅ [WATERMARK DEBUG] Narysowano', watermarkCount, 'watermarków');
            
            ctx.restore();
            
            // Zwróć obraz z watermarkiem jako Data URL
            // ✅ ZMNIEJSZONA JAKOŚĆ: 70% quality (watermark nie musi być w wysokiej jakości - tylko do podglądu/emaili)
            const result = canvas.toDataURL('image/jpeg', 0.70);
            const resultSizeKB = Math.round(result.length / 1024);
            console.log('✅ [WATERMARK DEBUG] Canvas.toDataURL() - rozmiar:', result.length, 'znaków (', resultSizeKB, 'KB /', (result.length / 1024 / 1024).toFixed(2), 'MB)');
            console.log('✅ [WATERMARK DEBUG] Watermark: 50% rozmiaru + 70% quality = kompaktowy plik');
            console.log('✅ [WATERMARK DEBUG] Result preview:', result.substring(0, 100) + '...');
            
            resolve(result);
          } catch (error) {
            console.error('❌ [WATERMARK DEBUG] Canvas error:', error);
            console.error('❌ [WATERMARK DEBUG] Error stack:', error.stack);
            this._reportToSentry(error, 'watermark-canvas');
            reject(error);
          }
        };
        
        img.onerror = (error) => {
          console.error('❌ [WATERMARK DEBUG] Image load error:', error);
          console.error('❌ [WATERMARK DEBUG] Failed imageUrl:', imageUrl?.substring(0, 100));
          reject(new Error('Nie udało się załadować obrazu do watermarku: ' + error.message));
        };
        
        // ✅ Ustaw src - działa zarówno z URL jak i base64 data URI
        console.log('🖼️ [WATERMARK DEBUG] Setting img.src, type:', imageUrl?.startsWith('data:') ? 'base64' : 'URL');
        img.src = imageUrl;
      } catch (error) {
        console.error('❌ [WATERMARK DEBUG] Async error:', error);
        console.error('❌ [WATERMARK DEBUG] Error stack:', error.stack);
        this._reportToSentry(error, 'watermark-async');
        reject(error);
      }
    });
  }

  initPilotImageEditor() {
    if (!this.pilotEditPanel || !this.resultImage) return;
    if (this.pilotEditPanel.dataset.pilotEditorInit === '1') {
      this.layoutPilotUnderImageActions();
      return;
    }
    this.pilotEditPanel.dataset.pilotEditorInit = '1';

    if (!document.getElementById('pilotEditImageWrap')) {
      const wrap = document.createElement('div');
      wrap.id = 'pilotEditImageWrap';
      wrap.className = 'pilot-edit-image-wrap';
      this.resultImage.parentNode.insertBefore(wrap, this.resultImage);
      wrap.appendChild(this.resultImage);
    }
    const imageWrap = document.getElementById('pilotEditImageWrap');
    if (imageWrap && this.pilotEditLoading) imageWrap.appendChild(this.pilotEditLoading);
    if (imageWrap && this.pilotEditVersionSlider) imageWrap.after(this.pilotEditVersionSlider);
    this.layoutPilotUnderImageActions();

    this.pilotEditBtn.addEventListener('click', () => this.openPilotImageEditor({ scrollToPanel: true }));
    if (this.pilotEditBtn) this.pilotEditBtn.textContent = 'Edytuj obrazek';
    this.pilotEditSubmitBtn?.addEventListener('click', () => this.submitPilotImageEdit());
    this.pilotEditAcceptBtn?.addEventListener('click', () => this.acceptPilotImageEdit());
    this.pilotEditInstruction?.addEventListener('input', () => {
      this.updatePilotEditInstructionHighlight();
      this.updatePilotEditSubmitState();
    });
    this.ensurePilotEditSuccessClickDelegation();
    if (this.pilotEditBtn) this.pilotEditBtn.style.display = 'none';
    this.syncPilotEditEntryUi();
  }

  getPilotEditVersionPreviewUrl(idx) {
    if (idx >= this.pilotEditHistory.length) {
      return this.watermarkedImageUrl || this.transformedImage;
    }
    const ver = this.pilotEditHistory[idx];
    return ver?.watermarkedImageUrl || ver?.transformedImage || '';
  }

  updatePilotEditVersionUI() {
    const total = this.pilotEditHistory.length + 1;
    const hasEdits = this.pilotEditHistory.length > 0;
    if (this.pilotEditVersionSlider) {
      const show = hasEdits && this.pilotEditPanel?.classList.contains('is-open');
      this.pilotEditVersionSlider.style.display = show ? 'flex' : 'none';
    }
    if (this.pilotEditViewingIndex < 0 || this.pilotEditViewingIndex >= total) {
      this.pilotEditViewingIndex = total - 1;
    }
    if (this.pilotEditAcceptBtn) {
      if (hasEdits) {
        this.pilotEditAcceptBtn.textContent = '✓ Gotowe — zamknij';
        this.pilotEditAcceptBtn.classList.add('has-edits');
      } else {
        this.pilotEditAcceptBtn.textContent = 'Zamknij';
        this.pilotEditAcceptBtn.classList.remove('has-edits');
      }
    }
    this._pilotEditMaxReached = this.getPilotEditTotalUsed() >= this.getPilotEditUsageLimit();
    this.updatePilotEditSubmitState();
    this.updatePilotEditVersionDots();
  }

  updatePilotEditInstructionHighlight() {
    const block = document.getElementById('pilotEditInstructionBlock');
    if (!block || !this.pilotEditInstruction) return;
    const hasText = (this.pilotEditInstruction.value?.trim().length || 0) >= 3;
    block.classList.toggle('is-empty', !hasText);
  }

  updatePilotEditLimitHint() {
    const el = this.pilotEditLimitHint;
    if (!el) return;
    const used = this.getPilotEditTotalUsed();
    const max = this.getPilotEditUsageLimit();
    const remaining = Math.max(0, max - used);
    el.classList.remove('is-ok', 'is-low', 'is-last', 'is-empty');
    let tone = 'is-ok';
    let label = `Zostało <strong>${remaining} z ${max}</strong> poprawek.`;
    if (this._pilotEditMaxReached || remaining <= 0) {
      tone = 'is-empty';
      label = `<strong>Koniec poprawek (${max}/${max}).</strong> Wybierz wersję i kliknij „Gotowe — zamknij”.`;
    } else if (remaining === 1) {
      tone = 'is-last';
      label = `<strong>Ostatnia poprawka</strong> — zostało 1 z ${max}. Potem obrazu nie da się już zmienić.`;
    } else if (remaining <= 2) {
      tone = 'is-low';
      label = `<strong>Zostały ${remaining} z ${max} poprawek</strong> — zużywaj ostrożnie.`;
    }
    el.classList.add(tone);
    const pips = Array.from({ length: max }, (_, i) => {
      const isUsed = i < used;
      const isNext = !isUsed && i === used && remaining > 0 && remaining <= 2;
      return `<span class="pilot-edit-quota-pip${isUsed ? ' is-used' : ''}${isNext ? ' is-next' : ''}"></span>`;
    }).join('');
    el.innerHTML = `<span class="pilot-edit-quota-pips" aria-hidden="true">${pips}</span><span class="pilot-edit-quota-label">${label}</span>`;
  }

  updatePilotEditSubmitState() {
    if (!this.pilotEditSubmitBtn) return;
    this.updatePilotEditLimitHint();
    if (this._pilotEditMaxReached) {
      this.pilotEditSubmitBtn.disabled = true;
      this.pilotEditSubmitBtn.textContent = 'Brak poprawek';
      this.pilotEditSubmitBtn.classList.add('is-faded');
      return;
    }
    if (this.pilotEditInFlight) return;
    const hasText = (this.pilotEditInstruction?.value?.trim().length || 0) >= 3;
    this.pilotEditSubmitBtn.disabled = !hasText;
    this.pilotEditSubmitBtn.classList.toggle('is-faded', !hasText);
    const remaining = Math.max(0, this.getPilotEditUsageLimit() - this.getPilotEditTotalUsed());
    this.pilotEditSubmitBtn.textContent = remaining === 1 ? 'Popraw — ostatnia' : 'Popraw';
  }

  updatePilotEditVersionDots() {
    const container = document.getElementById('pilotEditVersionDots');
    if (!container) return;
    const total = this.pilotEditHistory.length + 1;
    container.replaceChildren();
    if (total <= 1) return;
    const currentIdx = this.pilotEditViewingIndex >= 0 ? this.pilotEditViewingIndex : total - 1;
    for (let i = 0; i < total; i++) {
      const src = this.getPilotEditVersionPreviewUrl(i);
      if (!src) continue;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pilot-edit-thumb' + (i === currentIdx ? ' active' : '');
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.draggable = false;
      btn.appendChild(img);
      btn.addEventListener('click', () => this.selectPilotEditVersion(i));
      container.appendChild(btn);
    }
  }

  selectPilotEditVersion(idx) {
    const total = this.pilotEditHistory.length + 1;
    if (idx < 0 || idx >= total) return;
    this.pilotEditViewingIndex = idx;
    const previewUrl = this.getPilotEditVersionPreviewUrl(idx);
    if (previewUrl && this.resultImage) {
      this.setPreviewImageWithFallback(this.resultImage, previewUrl, 'pilotEdit-version');
    }
    this.updatePilotEditVersionDots();
  }

  acceptPilotImageEdit() {
    const idx = this.pilotEditViewingIndex;
    if (idx >= 0 && idx < this.pilotEditHistory.length) {
      const chosen = this.pilotEditHistory[idx];
      this.transformedImage = chosen.transformedImage;
      this.watermarkedImageUrl = chosen.watermarkedImageUrl;
      this.watermarkedImageBase64 = null;
      this.setPilotEditSessionToken(chosen.editSessionToken, chosen.transformedImage);
      this.textOverlayBaseImage = chosen.textOverlayBaseImage;
      this.textOverlayOriginalWatermarked = chosen.textOverlayOriginalWatermarked;
      this.textOverlayState = { ...chosen.textOverlayState };
      this.pilotEditHistory = this.pilotEditHistory.slice(0, idx);
      const previewUrl = this.watermarkedImageUrl || this.transformedImage;
      this.setPreviewImageWithFallback(this.resultImage, previewUrl, 'pilotEdit-accept');
    }
    this.persistPilotEditSessionToStore();
    this.syncPilotEditVersionsToGallery().catch(() => {});
    this.closePilotImageEditor();
  }

  async openPilotImageEditor(options = {}) {
    if (!this.isPilotImageEditProduct()) return;
    this.ensurePilotEditDom();
    if (this.textOverlayState?.applied) {
      this.showPilotEditOpenError('Najpierw popraw obraz, a dopiero potem dodaj napis.');
      return;
    }
    if (!this.transformedImage || !this.transformedImage.startsWith('http')) {
      this.showPilotEditOpenError('Najpierw wygeneruj obraz, który chcesz poprawić.');
      return;
    }

    this.clearPilotEditOpenError();
    this.ensurePilotEditMatchesCurrentImage();

    await this.refreshPilotEditUsageFromServer();

    const granted = await this.fetchPilotEditGrantIfNeeded();
    if (!granted) {
      const max = this.getPilotEditUsageLimit();
      if (this.getPilotEditTotalUsed() >= max) {
        const myImagesUrl = this.getMyGenerationsPageUrl();
        this.showPilotEditOpenError(
          `Wykorzystano limit poprawek. Obrazki możesz zobaczyć <a href="${myImagesUrl}" style="color:inherit;text-decoration:underline;font-weight:700;">tutaj</a> (Moje obrazy).`,
          { html: true }
        );
      } else {
        this.showPilotEditOpenError('Nie udało się otworzyć edytora. Spróbuj ponownie.');
      }
      return;
    }

    this.ensurePilotEditDom();
    if (this.pilotEditBtn && this.pilotEditPanel) this.initPilotImageEditor();
    if (!this.pilotEditPanel) {
      this.showPilotEditOpenError('Nie udało się otworzyć edytora. Spróbuj ponownie.');
      return;
    }

    this.hidePilotEditFreshBanner();
    if (this.pilotEditEntryMode !== 'gallery') {
      this.setPilotEditEntryMode('gallery');
    }

    this.clearPilotEditOpenError();
    this.pilotEditPanel.classList.add('is-open');
    this.syncPilotEditEntryUi();
    if (typeof window.trackProductAbMetric === 'function') {
      window.trackProductAbMetric('edit_open');
    }
    this.updatePilotEditUndoButton();
    this.updatePilotEditInstructionHighlight();
    this.pilotEditInstruction?.focus();
    if (options.scrollToPanel !== false) {
      requestAnimationFrame(() => {
        (this.pilotEditPanel || this.pilotEditInstruction)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
    this.syncPilotEditPersonalizationVisibility();
  }

  closePilotImageEditor() {
    if (!this.pilotEditPanel) return;
    if (this.pilotEditInFlight && this.pilotEditAbortController) {
      this.pilotEditAbortController.abort();
    }
    this.pilotEditPanel.classList.remove('is-open');
    this.setPilotEditBusy(false);
    if (this.transformedImage && this.pilotEditEntryMode !== 'gallery') {
      this.setPilotEditEntryMode('gallery');
    } else {
      this.syncPilotEditEntryUi();
    }
    if (this.pilotEditVersionSlider) this.pilotEditVersionSlider.style.display = 'none';
    this.syncPilotEditPersonalizationVisibility();
  }

  setPilotEditStatus(message, isError = false) {
    this.ensurePilotEditDom();
    const el = this.pilotEditStatus;
    if (!el) return;
    try {
      el.textContent = message || '';
      el.classList.toggle('is-error', !!isError);
    } catch (_) {}
  }

  setPilotEditBusy(isBusy) {
    this.pilotEditInFlight = isBusy;
    const imageWrap = document.getElementById('pilotEditImageWrap');
    if (imageWrap) imageWrap.classList.toggle('is-busy', isBusy);
    if (this.pilotEditAcceptBtn) this.pilotEditAcceptBtn.disabled = isBusy;
    if (this.pilotEditInstruction) this.pilotEditInstruction.disabled = isBusy;
    if (isBusy) {
      this.startPilotEditProgress();
      if (this.pilotEditSubmitBtn) {
        this.pilotEditSubmitBtn.disabled = true;
        this.pilotEditSubmitBtn.textContent = 'Poprawiam…';
      }
    } else {
      this.stopPilotEditProgress(true);
      // Nie nadpisuj disabled — updatePilotEditSubmitState() pilnuje pustego pola
      this.updatePilotEditSubmitState();
    }
    this.syncPilotEditPersonalizationVisibility();
  }

  startPilotEditProgress() {
    this.stopPilotEditProgress(false);
    const progressBar = document.getElementById('pilotEditProgressBar');
    const loadingStage = document.getElementById('pilotEditLoadingStage');
    const stages = [
      { atMs: 0, percent: 8, text: 'Przesyłamy polecenie...' },
      { atMs: 8000, percent: 28, text: 'Poprawiamy obraz...' },
      { atMs: 18000, percent: 52, text: 'Dopracowujemy szczegóły...' },
      { atMs: 35000, percent: 72, text: 'Jeszcze chwila, nie zamykaj karty...' },
      { atMs: 60000, percent: 88, text: 'To może potrwać — zostań na stronie.' }
    ];
    if (progressBar) progressBar.style.width = stages[0].percent + '%';
    if (loadingStage) loadingStage.textContent = stages[0].text;
    const startedAt = Date.now();
    this._pilotEditProgressInterval = setInterval(() => {
      const elapsed = Date.now() - startedAt;
      let current = stages[0];
      for (let i = 0; i < stages.length; i += 1) {
        if (elapsed >= stages[i].atMs) current = stages[i];
      }
      const next = stages.find((stage) => stage.atMs > current.atMs);
      let percent = current.percent;
      if (next) {
        const span = next.atMs - current.atMs;
        const t = Math.min(1, (elapsed - current.atMs) / span);
        percent = current.percent + (next.percent - current.percent) * t;
      }
      if (progressBar) progressBar.style.width = Math.min(90, percent) + '%';
      if (loadingStage) loadingStage.textContent = current.text;
    }, 400);
  }

  stopPilotEditProgress(complete) {
    if (this._pilotEditProgressInterval) {
      clearInterval(this._pilotEditProgressInterval);
      this._pilotEditProgressInterval = null;
    }
    const progressBar = document.getElementById('pilotEditProgressBar');
    if (complete && progressBar) progressBar.style.width = '100%';
  }

  updatePilotEditUndoButton() {
    this.updatePilotEditVersionUI();
  }

  async submitPilotImageEdit() {
    if (this.pilotEditInFlight) return;
    await this.refreshPilotEditUsageFromServer();
    if (this.getPilotEditTotalUsed() >= this.getPilotEditUsageLimit()) {
      this.setPilotEditStatus(
        `Osiągnięto limit ${this.getPilotEditUsageLimit()} poprawek. Wybierz najlepszą wersję i kliknij „Gotowe — zamknij".`,
        true
      );
      return;
    }
    const instruction = this.pilotEditInstruction?.value?.trim() || '';
    if (instruction.length < 3) {
      this.setPilotEditStatus('Napisz, co dokładnie chcesz poprawić.', true);
      this.pilotEditInstruction?.focus();
      return;
    }
    if (!this.transformedImage?.startsWith('http')) {
      this.setPilotEditStatus('Brak czystej wersji obrazu do poprawy.', true);
      return;
    }

    this.ensurePilotEditMatchesCurrentImage();
    const granted = await this.fetchPilotEditGrantIfNeeded();
    if (!granted) {
      this.setPilotEditStatus('Sesja poprawek wygasła. Zamknij edytor i otwórz go ponownie.', true);
      return;
    }

    const previousState = {
      transformedImage: this.transformedImage,
      watermarkedImageUrl: this.watermarkedImageUrl,
      editSessionToken: this.pilotEditSessionToken,
      textOverlayBaseImage: this.textOverlayBaseImage,
      textOverlayOriginalWatermarked: this.textOverlayOriginalWatermarked,
      textOverlayState: { ...this.textOverlayState }
    };

    this.setPilotEditBusy(true);
    this.setPilotEditStatus('');
    if (typeof window.trackProductAbMetric === 'function') {
      window.trackProductAbMetric('edit_apply');
    }
    this.pilotEditAbortController = new AbortController();

    try {
      const response = await fetch('https://customify-s56o.vercel.app/api/edit-image-pilot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        signal: this.pilotEditAbortController.signal,
        body: JSON.stringify({
          productHandle: this.getProductHandle(),
          imageUrl: this.transformedImage,
          instruction,
          editSessionToken: this.pilotEditSessionToken,
          ...this.getPilotEditUsageRequestBody()
        })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.success) {
        throw new Error(result.message || 'Nie udało się poprawić obrazu.');
      }

      this.applyPilotEditUsageFromApi(result);

      this.pilotEditHistory.push(previousState);
      this.transformedImage = result.transformedImage;
      this.watermarkedImageUrl = result.watermarkedImageUrl;
      this.watermarkedImageBase64 = null;
      this.setPilotEditSessionToken(result.editSessionToken, result.transformedImage);
      this.textOverlayBaseImage = this.transformedImage;
      this.textOverlayOriginalWatermarked = this.watermarkedImageUrl;
      this.textOverlayWatermarkedUrl = null;
      this.textOverlayState = {
        ...this.textOverlayState,
        text: '',
        applied: false,
        previewUrl: null
      };
      if (this.textOverlayInput) this.textOverlayInput.value = '';

      this.setPreviewImageWithFallback(
        this.resultImage,
        this.watermarkedImageUrl,
        'pilotEdit-result'
      );
      this.pilotEditInstruction.value = '';
      this.updatePilotEditInstructionHighlight();
      this.updatePilotEditVersionUI();
      this.setPilotEditStatus('Gotowe — jeśli efekt Ci pasuje, kliknij „Gotowe — zamknij”.');
      if (!this.pilotEditAnchorKey) {
        this.pilotEditAnchorKey = this.normalizePilotEditImageKey(this.pilotEditAnchorImageUrl || this.pilotEditHistory[0]?.transformedImage || this.transformedImage);
        if (!this.pilotEditAnchorImageUrl) {
          this.pilotEditAnchorImageUrl = this.pilotEditHistory[0]?.transformedImage || this.transformedImage;
        }
      }
      this.persistPilotEditSessionToStore();

      await this.syncPilotEditVersionsToGallery();

      if (typeof window.trackProductAbMetric === 'function') {
        window.trackProductAbMetric('edit_ok');
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
      const limitHit = /limit/i.test(String(error?.message || '')) && /poprawek/i.test(String(error?.message || ''));
      if (typeof window.trackProductAbMetric === 'function') {
        window.trackProductAbMetric(limitHit ? 'edit_limit' : 'edit_fail');
      }
      if (!limitHit) {
        console.error('❌ [IMAGE-EDIT-PILOT]', error);
        this._reportToSentry(error, 'image-edit-pilot');
      }
      this.setPilotEditStatus(error.message || 'Nie udało się poprawić obrazu.', true);
    } finally {
      this.pilotEditAbortController = null;
      this.setPilotEditBusy(false);
    }
  }

  undoPilotImageEdit() {
    // Legacy — teraz sterowane suwakiem wersji
  }

  async showResult(imageUrl) {
    console.log('🎯 [CUSTOMIFY] showResult called, hiding actionsArea and stylesArea');
    
    // ✅ POKAŻ PRZETWORZONY OBRAZ AI (bez watermarku w podglądzie)
    // Watermark będzie dodany PO transformacji i zapisany przez /api/update-generation-watermark
    // 📱 Phone case: use background-image in PREVIEW area (same place as uploaded image)
    if (this.isPhonePhotoCaseProduct()) {
      console.log('📱 [PHONE PREVIEW] Phone case detected, using preview area');
      // Use watermarkedImageUrl if available, otherwise use imageUrl
      const finalImageUrl = this.watermarkedImageUrl || imageUrl;
      console.log('📱 [PHONE PREVIEW] Using image URL:', finalImageUrl ? finalImageUrl.substring(0, 50) + '...' : 'none');
      
      const photoBg = document.getElementById('phoneCasePhotoBg');
      const resultBg = document.getElementById('phoneCaseResultBg');
      const inner = document.querySelector('#customify-app-container .phone-case-inner');
      
      // Set image in PREVIEW area (direct Blob; proxy only on load error → Sentry)
      if (photoBg) {
        this.setPreviewBackgroundWithFallback(photoBg, finalImageUrl, 'phonePreview-photoBg');
        console.log('[PHONE PREVIEW] set background image in PREVIEW area (phoneCasePhotoBg)', finalImageUrl.substring(0, 50) + '...');
      } else {
        console.warn('⚠️ [PHONE PREVIEW] phoneCasePhotoBg not found!');
      }
      
      // Also set in result area (backup, but resultArea will be hidden)
      if (resultBg) {
        this.setPreviewBackgroundWithFallback(resultBg, finalImageUrl, 'phonePreview-resultBg');
        console.log('[PHONE PREVIEW] set background image in RESULT area (phoneCaseResultBg) as backup');
      }
      
      if (inner) {
        const innerRect = inner.getBoundingClientRect();
        console.log('[PHONE PREVIEW] inner rect', {
          width: innerRect.width,
          height: innerRect.height,
          aspectRatio: innerRect.width / innerRect.height
        });
      }
      // Keep resultImage hidden but set src for compatibility
      if (this.resultImage) {
        this.setPreviewImageWithFallback(this.resultImage, finalImageUrl, 'phonePreview-resultImage');
      }
      // 📱 Phone case: hide resultArea, keep previewArea visible (like Spotify)
      if (this.resultArea) {
        this.resultArea.style.display = 'none !important';
        this.resultArea.style.setProperty('display', 'none', 'important');
        console.log('📱 [PHONE PREVIEW] resultArea hidden with !important');
      }
      if (this.previewArea) {
        this.previewArea.style.display = 'block';
        console.log('📱 [PHONE PREVIEW] previewArea shown');
      }
      // 📱 Phone case: Also hide resultArea after a delay (in case something shows it later)
      setTimeout(() => {
        if (this.resultArea && this.isPhonePhotoCaseProduct()) {
          this.resultArea.style.display = 'none !important';
          this.resultArea.style.setProperty('display', 'none', 'important');
          console.log('📱 [PHONE PREVIEW] resultArea hidden again (delayed)');
        }
      }, 100);
    } else {
      // Direct Blob preview; proxy fallback + Sentry on error (canvas nadal przez getCanvasSafeImageUrl)
      this.setPreviewImageWithFallback(this.resultImage, imageUrl, 'showResult-base');
      this.resultArea.style.display = 'block';
    }
    console.log('✅ [CUSTOMIFY] Showing AI result (watermark will be added after)');
    
    // Rozmiary są zawsze widoczne na górze (poza resultArea)
    this.sizeArea.style.display = 'block';
    console.log('🎯 [CUSTOMIFY] Size area visible on top (outside resultArea)');
    
    // UKRYJ przyciski "Przekształć z AI" i "Resetuj" (główne actionsArea)
    this.actionsArea.style.display = 'none';
    console.log('🎯 [CUSTOMIFY] actionsArea hidden:', this.actionsArea.style.display);
    
    // UKRYJ style po przekształceniu
    this.stylesArea.style.display = 'none';
    console.log('🎯 [CUSTOMIFY] stylesArea hidden:', this.stylesArea.style.display);
    
    // Zmień kolory przycisków po wygenerowaniu AI
    this.swapButtonColors();
    
    // UKRYJ pole upload po przekształceniu
    this.uploadArea.style.display = 'none';
    console.log('🎯 [CUSTOMIFY] uploadArea hidden:', this.uploadArea.style.display);
    // 📸 UKRYJ multi-upload grid po przekształceniu
    const multiUploadArea = document.getElementById('multiUploadArea');
    if (multiUploadArea) multiUploadArea.style.display = 'none';

    // Ukryj previewArea po generacji TYLKO dla spotify
    if (this.isSpotifyProduct() && this.previewArea) {
      this.previewArea.style.display = 'none';
      console.log('🎯 [CUSTOMIFY] previewArea hidden after generation (spotify only)');
      // Ukryj ponownie po 200ms - na wypadek gdyby coś później ustawiło block
      setTimeout(() => {
        if (this.previewArea) {
          this.previewArea.style.display = 'none';
          console.log('🎯 [CUSTOMIFY] previewArea hidden again (delayed)');
        }
      }, 200);
    }
    
    if (this.isSpotifyProduct() && this.spotifyFieldsPanel) {
      this.spotifyFieldsPanel.style.display = 'block';
    }
    
    // ✅ POKAŻ CENĘ NAD PRZYCISKIEM po wygenerowaniu AI
    this.updateCartPrice();
    
    // 🎵 Spotify frame: przelicz skalę z opóźnieniem (czekaj na layout + załadowanie obrazka)
    setTimeout(() => this.updateSpotifyFrameScale(), 100);
    this.resultImage.onload = () => {
      setTimeout(() => this.updateSpotifyFrameScale(), 50);
    };

    // Mobile: wynik na górze ekranu, nawet jeśli w trakcie generacji user przewinął stronę
    if (window.matchMedia('(max-width: 768px)').matches) {
      this.scrollMobileComposer('result');
    } else {
      this.scrollToGeneratedImage();
    }
    if (this.isPilotImageEditProduct()) {
      this.ensurePilotEditDom();
      if (this.pilotEditBtn && this.pilotEditPanel) this.initPilotImageEditor();
      this.layoutPilotUnderImageActions();
      this.syncPilotEditEntryUi();
    }
  }

  _stickyHeaderPad() {
    let pad = 8;
    const header = document.querySelector('sticky-header, header-component');
    if (header) {
      const hs = getComputedStyle(header);
      if (hs.position === 'sticky' || hs.position === 'fixed') {
        pad = Math.round(header.getBoundingClientRect().bottom) + 8;
      }
    }
    return pad;
  }

  _elIsShown(el) {
    if (!el) return false;
    const s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && el.getClientRects().length > 0;
  }

  _visiblePhotoEl(mode) {
    if (this.isPhonePhotoCaseProduct()) {
      const root = mode === 'result' ? (this.resultArea || this.previewArea) : this.previewArea;
      const inner = root && root.querySelector('.phone-case-inner');
      if (inner) return inner;
    }
    if (mode === 'result') return this.resultImage || this.resultArea;
    return this.previewImage || this.previewArea;
  }

  // Mobile: po uploadzie zdjęcie u góry, pola + „Zobacz Podgląd” na dole.
  // Po generacji: wynik u góry (user mógł zjechać w dół w trakcie czekania).
  scrollMobileComposer(mode) {
    try {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      const photoEl = this._visiblePhotoEl(mode);
      if (!photoEl) return;

      const bottomEl = mode === 'result'
        ? document.getElementById('addToCartBtn')
        : document.getElementById('transformBtn');

      let cancelled = false;
      let placed = false;
      const onMove = () => { if (placed) cancelled = true; };
      window.addEventListener('touchmove', onMove, { passive: true });
      window.addEventListener('wheel', onMove, { passive: true });

      const run = () => {
        if (cancelled) return;
        if (!photoEl.getBoundingClientRect().height) return;
        this._placeMobileComposer(mode, photoEl, bottomEl);
        placed = true;
      };

      // Dwa frame'y: najpierw DOM chowa loader i przenosi rozmiary, potem scroll
      requestAnimationFrame(() => requestAnimationFrame(run));
      setTimeout(run, 120);
      setTimeout(run, 450);
      if (photoEl.tagName === 'IMG' && !photoEl.complete) {
        photoEl.addEventListener('load', () => requestAnimationFrame(run), { once: true });
      }
      setTimeout(() => {
        window.removeEventListener('touchmove', onMove);
        window.removeEventListener('wheel', onMove);
      }, 900);
    } catch (scrollErr) {
      // Przewijanie to udogodnienie — nie blokuj podglądu
    }
  }

  _placeMobileComposer(mode, photoEl, bottomEl) {
    const headerPad = this._stickyHeaderPad();
    const vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    const bottomGap = 12;
    const available = vh - headerPad - bottomGap;

    // Po uploadzie zmniejsz zdjęcie tylko tyle, żeby pod nim weszły pola i przycisk.
    // Wyniku generacji nie ściskamy — ma być czytelny.
    if (mode === 'preview' && this._elIsShown(bottomEl) && photoEl.getBoundingClientRect().height) {
      const imgRect = photoEl.getBoundingClientRect();
      const botRect = bottomEl.getBoundingClientRect();
      const belowImage = Math.max(0, botRect.bottom - imgRect.bottom);
      const roomForImage = Math.floor(available - belowImage);
      const minImage = 180;
      if (roomForImage >= minImage) {
        photoEl.style.maxHeight = roomForImage + 'px';
      }
    }

    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const top = photoEl.getBoundingClientRect().top;
    if (Math.abs(top - headerPad) < 10) return;
    const target = Math.max(0, Math.round(scrollY + top - headerPad));

    // html ma scroll-behavior: smooth — iOS po timerze taki scroll po cichu odrzuca.
    const root = document.documentElement;
    const prevBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    root.style.overflowAnchor = 'none';
    document.body.style.overflowAnchor = 'none';
    root.scrollTop = target;
    document.body.scrollTop = target;
    if (document.scrollingElement) document.scrollingElement.scrollTop = target;
    root.style.scrollBehavior = prevBehavior;
  }

  // Przewija do miejsca z wygenerowanym obrazem TYLKO gdy nie jest w pełni widoczny w viewport
  scrollToGeneratedImage() {
    try {
      // Etui: wynik jest w previewArea (phoneCasePhotoBg), resultArea jest ukryte
      const target = this.isPhonePhotoCaseProduct()
        ? (document.getElementById('phoneCasePhotoBg') || this.previewArea)
        : (this.resultImage || this.resultArea);
      if (!target) return;

      let done = false;
      const doScroll = () => {
        if (done) return;
        if (!target.getBoundingClientRect().height) return; // jeszcze niewyrenderowane - poczekaj na load obrazka
        done = true;
        // block: 'nearest' = nic nie robi gdy obraz jest w pełni widoczny, przewija minimalnie gdy nie jest
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };

      requestAnimationFrame(doScroll);
      // Obraz może mieć wysokość 0 przed załadowaniem - sprawdź ponownie po load (addEventListener nie nadpisuje resultImage.onload)
      if (target.tagName === 'IMG' && !target.complete) {
        target.addEventListener('load', () => requestAnimationFrame(doScroll), { once: true });
      }
    } catch (scrollErr) {
      // Przewijanie to tylko udogodnienie - nie blokuj pokazania wyniku
    }
  }

  // NAPRAWIONA FUNKCJA: STWÓRZ NOWY PRODUKT Z OBRAZKIEM AI (UKRYTY W KATALOGU)
  async addToCart(retryCount = 0) {
    if (this._isOffline()) {
      this.showError('Brak połączenia z internetem. Sprawdź sieć i spróbuj ponownie.', 'cart');
      return;
    }
    this._sentryCrumb('cart', 'Start addToCart', { style: this.selectedStyle, size: this.selectedSize, retry: retryCount });
    this.showLoading();
    
    console.log('🛒 [CUSTOMIFY] addToCart called with:', {
      transformedImage: !!this.transformedImage,
      selectedStyle: this.selectedStyle,
      selectedSize: this.selectedSize,
      selectedProductType: this.selectedProductType,
      retryCount: retryCount
    });
    
    // ✅ SPRAWDŹ ROZMIAR - dla etui brak selektora, używamy domyślnego
    if (this.isPhonePhotoCaseProduct()) {
      if (!this.selectedSize) this.selectedSize = 'etui';
      if (this.selectedProductType !== 'etui') this.selectedProductType = 'etui';
    }
    if (!this.selectedSize) {
      console.log('❌ [CUSTOMIFY] No selectedSize, showing error');
      this.showError('Nie wybrałeś rozmiaru', 'cart');
      this.hideLoading();
      return;
    }
    
    // 🚨 WALIDACJA: Dla szkła tylko A5 i A4 są dozwolone (maksymalnie 20×30 cm)
    if (this.selectedProductType === 'szklo') {
      const allowedSizes = ['a5', 'a4'];
      if (!allowedSizes.includes(this.selectedSize.toLowerCase())) {
        console.error('❌ [CUSTOMIFY] Invalid size for szklo:', this.selectedSize);
        this.showError('Dla wydruku na szkle dostępne są tylko rozmiary: 15×21 cm (A5) i 20×30 cm (A4). Maksymalny rozmiar to 20×30 cm.', 'cart');
        this.hideLoading();
        return;
      }
    }
    
    console.log('✅ [CUSTOMIFY] selectedSize OK, proceeding with price calculation');

    // ✅ OBLICZ CENĘ NAJPIERW - niezależnie od obrazu AI
    const basePrice = this.originalBasePrice || 49.00;
    const sizePrice = this.getSizePrice(this.selectedSize);
    const frameColor = (window.CustomifyFrame && window.CustomifyFrame.color) ? window.CustomifyFrame.color : 'none';
    const frameSurcharge = this.getFrameSurcharge(frameColor);
    const frameSelected = frameSurcharge > 0;
    const finalPrice = basePrice + sizePrice + frameSurcharge;
    
    console.log('💰 [CUSTOMIFY] Price calculation:', {
      originalBasePrice: this.originalBasePrice,
      basePrice: basePrice,
      sizePrice: sizePrice,
      frameSelected: frameSelected,
      frameSurcharge: frameSurcharge,
      frameColor: window.CustomifyFrame?.color || 'none',
      selectedProductType: this.selectedProductType,
      finalPrice: finalPrice,
      size: this.selectedSize
    });

    // ✅ SPRAWDŹ OBRAZ AI DOPIERO POTEM
    if (!this.transformedImage) {
      this.showError('Wgraj zdjęcie i kliknij podgląd', 'cart');
      this.hideLoading();
      return;
    }
    
    // ✅ SPRAWDŹ STYL
    if (!this.selectedStyle) {
      this.showError('Wybierz styl', 'cart');
      return;
    }

    // 📱 Etui: wymagana marka i model telefonu
    if (this.isPhonePhotoCaseProduct()) {
      if (!this.selectedPhoneBrand || !this.selectedPhoneModel) {
        this.showError('Wybierz markę i model telefonu', 'cart');
        this.hideLoading();
        return;
      }
    }

    // 🆕 Tekst na obrazie: jeśli użytkownik wpisał tekst, musi kliknąć „Zastosuj napis”
    let textOverlayPayload = null;
    if (this.textOverlayEnabled) {
      const draftText = (this.textOverlayInput?.value || '').trim();
      if (draftText && !this.textOverlayState.applied) {
        this.showError('Kliknij „Zapisz”, aby dodać napis do zamówienia', 'cart');
        return;
      }
      textOverlayPayload = this.getTextOverlayPayload();
    }

    console.log('🛒 [CUSTOMIFY] Starting addToCart process...');

    // WP Ads: count only an add confirmed by Shopify, once per successful operation.
    let wpCartTracked = false;
    const trackWpCartAdded = () => {
      if (wpCartTracked || typeof wph !== 'function') return;
      wpCartTracked = true;
      try {
        const wpProductId =
          document.querySelector('[data-product-id]')?.getAttribute('data-product-id') ||
          window.ShopifyAnalytics?.meta?.product?.id || '';
        wph('track', 'AddToCart', {
          currency: 'PLN',
          contents: [{
            id: String(wpProductId),
            name: document.title,
            category: this.selectedStyle || '',
            price: Number(finalPrice.toFixed(2)),
            quantity: 1
          }]
        });
        console.log('📊 [WP PIXEL] AddToCart event sent');
      } catch (wpErr) {
        console.warn('⚠️ [WP PIXEL] AddToCart tracking error:', wpErr);
      }
    };

    this.hideError();

    // Pokaż pasek postępu dla koszyka
    this.showCartLoading();

    // ⚠️ FLAGA: Produkt już został utworzony w Shopify → NIE TWÓRZ ponownie przy retry (duplikat!)
    let productCreated = false;

    try {
      // Pobierz ID produktu z różnych możliwych źródeł
      const productId = 
        document.querySelector('[data-product-id]')?.getAttribute('data-product-id') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value ||
        window.ShopifyAnalytics?.meta?.product?.id ||
        null;
      
      console.log('🆔 [CUSTOMIFY] Original product ID:', productId);
      
      // Sprawdź czy finalPrice jest poprawny
      if (!finalPrice || finalPrice <= 0) {
        console.error('❌ [CUSTOMIFY] Invalid finalPrice:', finalPrice);
        this.showError('Błąd obliczania ceny. Spróbuj ponownie.', 'cart');
        return;
      }

      // Sprawdź czy mamy uploadedFile (z upload) czy originalImage (z galerii)
      console.log('[DEBUG] Before originalImage check');
      console.log('[DEBUG] this.uploadedFile:', !!this.uploadedFile);
      console.log('[DEBUG] this.originalImageFromGallery:', !!this.originalImageFromGallery);
      console.log('[DEBUG] this.transformedImage:', !!this.transformedImage);
      
      let originalImage;
      if (this.uploadedFile) {
        // Z upload - konwertuj plik na base64
        console.log('[DEBUG] Before fileToBase64 call');
        originalImage = await this.fileToBase64(this.uploadedFile);
        console.log('[DEBUG] After fileToBase64 call, originalImage length:', originalImage?.length);
      } else if (this.originalImageFromGallery) {
        // Z galerii - użyj zapisany originalImage
        originalImage = this.originalImageFromGallery;
      } else {
        // Fallback - użyj transformedImage jako originalImage
        originalImage = this.transformedImage;
        console.warn('⚠️ [CUSTOMIFY] No original image available, using transformed image as fallback');
      }

      console.log('[DEBUG] After originalImage assignment, before SPOTIFY section');
      console.log('[DEBUG] this.isSpotifyProduct() result:', this.isSpotifyProduct());

      // 🎵 SPOTIFY: Komponuj finalny obraz z maską i tekstami
      console.log('[SPOTIFY CHECK] Reached SPOTIFY section in addToCart');
      console.log('[SPOTIFY CHECK] this.transformedImage:', this.transformedImage?.substring(0, 50));
      console.log('[SPOTIFY CHECK] this.watermarkedImageUrl:', this.watermarkedImageUrl?.substring(0, 50));
      
      let finalTransformedImage = this.transformedImage;
      let watermarkedImageUrl = this.watermarkedImageUrl || null;
      let needsBackendWatermark = false;
      
      // DEBUG: Sprawdź isSpotifyProduct
      console.log('[SPOTIFY CHECK] Before isSpotifyProduct() call');
      const isSpotify = this.isSpotifyProduct();
      console.log('[SPOTIFY CHECK] After isSpotifyProduct() call, result:', isSpotify);
      console.log('[SPOTIFY DEBUG] isSpotifyProduct():', isSpotify);
      console.log('[SPOTIFY DEBUG] window.location.pathname:', window.location.pathname);
      console.log('[SPOTIFY DEBUG] pathname.toLowerCase():', window.location.pathname.toLowerCase());
      console.log('[SPOTIFY DEBUG] includes ramka-spotify:', window.location.pathname.toLowerCase().includes('ramka-spotify'));
      console.log('[SPOTIFY DEBUG] this.isSpotifyProduct direct:', this.isSpotifyProduct());
      
      if (isSpotify) {
        console.log('🎵 [SPOTIFY] Composing final image with mask and texts...');
        try {
          finalTransformedImage = await this.composeSpotifyImage();
          console.log('✅ [SPOTIFY] Image composed successfully, length:', finalTransformedImage.length);
          // Dla spotify - backend musi dodać watermark do skomponowanego obrazu
          watermarkedImageUrl = null;
          needsBackendWatermark = true;
        } catch (err) {
          console.error('❌ [SPOTIFY] Failed to compose image:', err);
          this._reportToSentry(err, 'spotify-compose');
          this.showError('Nie udało się przygotować obrazu. Spróbuj ponownie.', 'cart');
          this.hideLoading();
          return;
        }
      }
      
      // ✅ TYLKO BACKEND WATERMARK - już jest na Vercel Blob, nie trzeba uploadować ponownie!
      if (!watermarkedImageUrl && !needsBackendWatermark) {
        console.error('❌ [CUSTOMIFY] Brak backend watermarkedImageUrl - nie można dodać do koszyka!');
        alert('Wystąpił błąd podczas generowania obrazu. Spróbuj wygenerować obraz ponownie klikając "Przekształć z AI".');
        this.hideLoading();
        return; // Blokada dodania do koszyka
      }
      
      if (watermarkedImageUrl) {
        console.log('✅ [CUSTOMIFY] Używam backend watermarkedImageUrl (już na Vercel Blob):', watermarkedImageUrl.substring(0, 100));
      } else {
        console.log('🎵 [SPOTIFY] Backend doda watermark do skomponowanego obrazu');
      }

      const productData = {
        originalImage: originalImage,
        transformedImage: finalTransformedImage, // 🎵 Dla spotify: skomponowany obraz, dla innych: this.transformedImage
        watermarkedImage: watermarkedImageUrl, // ✅ URL obrazka z watermarkiem (fallback dla starych wersji)
        watermarkedImageUrl: watermarkedImageUrl, // ✅ URL obrazka z watermarkiem (backend PNG - PRIORYTET), null dla spotify
        needsBackendWatermark: needsBackendWatermark, // 🎵 Dla spotify: backend musi dodać watermark
        watermarkedImageBase64: this.watermarkedImageBase64 || null, // ✅ NOWE: Base64 watermarku (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
        style: this.selectedStyle,
        size: this.selectedSize,
        productType: this.isPhonePhotoCaseProduct() ? 'etui' : (this.selectedProductType || 'canvas'), // 📱 Etui: wymuszony productType
        originalProductTitle: document.querySelector('h1, .product-title, .view-product-title')?.textContent?.trim() || 'Produkt',
        originalProductId: productId, // ✅ Dodano ID produktu do pobrania ceny z Shopify
        originalProductHandle: typeof this.getProductHandle === 'function' ? this.getProductHandle() : null,
        orientacja: (typeof this.getPersonalizationFieldValue === 'function' ? this.getPersonalizationFieldValue('orientacja') : '') || null,
        finalPrice: finalPrice, // ✅ Przekaż obliczoną cenę do API
        frameColor: window.CustomifyFrame?.color || 'none', // ✅ Informacja o ramce dla debugowania
        frameSurcharge: frameSurcharge, // ✅ Dopłata za ramkę dla weryfikacji
        giftPackaging: typeof this.isGiftPackagingSelected === 'function' ? this.isGiftPackagingSelected() : false, // 🎁 Order attribute w adminie
        textOverlay: textOverlayPayload,
        ...(typeof window.getLumlyProductAbActive === 'function' && window.getLumlyProductAbActive() ? {
          abExperiment: window.getLumlyProductAbActive().experiment,
          abVariant: window.getLumlyProductAbActive().variant,
          abVisitorId: window.getLumlyProductAbActive().visitorId
        } : {})
      };

      console.log('🛒 [CUSTOMIFY] Creating product with data:', productData);
      console.log('🛒 [CUSTOMIFY] transformedImage type:', typeof this.transformedImage);
      console.log('🛒 [CUSTOMIFY] transformedImage length:', this.transformedImage?.length);
      console.log('🛒 [CUSTOMIFY] transformedImage is base64?', this.transformedImage?.startsWith('data:'));
      console.log('🛒 [CUSTOMIFY] transformedImage is URL?', this.transformedImage?.startsWith('http'));
      console.log('🛒 [CUSTOMIFY] transformedImage preview:', this.transformedImage?.substring(0, 200));
      
      // Stwórz nowy produkt z obrazkiem AI jako głównym obrazem
      // ✅ DODANO: Timeout i retry logic dla network errors
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 sekund timeout
      
      const response = await fetch('https://customify-s56o.vercel.app/api/products', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(productData),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);

      console.log('🛒 [CUSTOMIFY] API response status:', response.status);
      const result = await response.json();
      console.log('🛒 [CUSTOMIFY] API response:', result);

      // URL bez watermarku — właściwość z prefiksem _ (Shopify ukrywa w koszyku i checkout)
      let cleanImageUrlForOrder = null;
      if (result && result.success) {
        try {
          const debugInfo = result.saveGenerationDebug;
          if (debugInfo && debugInfo.blobPath && debugInfo.generationId) {
            const blobBaseUrl = 'https://vzwqqb14qtsxe2wx.public.blob.vercel-storage.com';
            const normalizedPath = debugInfo.blobPath.startsWith('/')
              ? debugInfo.blobPath.slice(1)
              : debugInfo.blobPath;
            const blobUrl = `${blobBaseUrl}/${normalizedPath}`;
            const generationResponse = await fetch(blobUrl);
            if (generationResponse.ok) {
              const generationData = await generationResponse.json();
              const generationsArray = generationData?.generations || [];
              const matchedGeneration = generationsArray.find((gen) => gen.id === debugInfo.generationId);
              const candidateUrl = matchedGeneration?.imageUrl || matchedGeneration?.transformedImage || null;
              if (candidateUrl && typeof candidateUrl === 'string' && candidateUrl.startsWith('http')) {
                cleanImageUrlForOrder = candidateUrl;
              }
            }
          }
        } catch (cleanUrlErr) {
          console.warn('⚠️ [CUSTOMIFY] cleanImageUrlForOrder:', cleanUrlErr?.message || cleanUrlErr);
        }
      }

      if (result.success) {
        productCreated = true; // ✅ Produkt istnieje w Shopify - retry NIE może tworzyć kolejnego
        console.log('✅ [CUSTOMIFY] Product created:', result.product);
        
        // Obraz AI jest już głównym obrazem produktu
        
        if (result.variantId) {
          console.log('🛒 [CUSTOMIFY] Attempting to add to cart with Variant ID:', result.variantId);
          console.log('🛒 [CUSTOMIFY] Product ID:', result.productId);
          console.log('🛒 [CUSTOMIFY] Variant ID type:', typeof result.variantId);
          console.log('🛒 [CUSTOMIFY] Variant ID length:', result.variantId.toString().length);
          
          // Tytuł z wszystkimi parametrami (ramka, podstawka)
          const selectedFrame = ((this.selectedProductType === 'plakat' || this.selectedProductType === 'canvas') && window.CustomifyFrame && window.CustomifyFrame.color)
            ? window.CustomifyFrame.color : 'none';
          const selectedStand = (this.selectedProductType === 'szklo' && window.CustomifyStand && window.CustomifyStand.type)
            ? window.CustomifyStand.type : 'none';
          let productTypeName;
          if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
            productTypeName = PRODUCT_TYPE_LABELS.etui;
          } else if (this.selectedProductType === 'szklo') {
            productTypeName = 'Szkło akrylowe';
          } else if (this.selectedProductType === 'plakat') {
            productTypeName = 'Plakat';
          } else if (this.selectedProductType === 'canvas') {
            productTypeName = 'Canvas';
          } else {
            productTypeName = PRODUCT_TYPE_LABELS[this.selectedProductType] || PRODUCT_TYPE_LABELS.canvas;
          }
          const standLabelForRamka = { none: 'brak', wood: 'podstawka drewniana', led: 'podstawka drewniana z LED' }[(selectedStand || 'none').toLowerCase()] || 'brak';
          const frameLabelForRamka = (this.selectedProductType === 'canvas'
            ? { none: 'Blejtram', black: 'American box czarna', wood: 'American box drewno' }
            : { none: 'brak', black: 'czarna', white: 'biała', wood: 'drewno' })[(selectedFrame || 'none').toLowerCase()] || (this.selectedProductType === 'canvas' ? 'Blejtram' : 'brak');
          
          const shortOrderId = result.shortOrderId || (result.orderId ? result.orderId.split('-').pop() : Date.now().toString());
          
          const spotifyTitle = (this.spotifyTitleInput?.value || '').trim().slice(0, 60);
          const spotifyArtist = (this.spotifyArtistInput?.value || '').trim().slice(0, 60);

          const properties = {
            'Rozmiar': this.getSizeDimension(this.selectedSize),
            'Rodzaj wydruku': productTypeName,
            'Ramka': this.selectedProductType === 'szklo' ? standLabelForRamka : frameLabelForRamka
          };
          if (typeof productData !== 'undefined' && productData.giftPackaging) {
            properties['Pakowanie'] = 'Gift pack';
          }
          if (this.isSpotifyProduct()) {
            if (spotifyTitle) properties['Tytuł utworu'] = spotifyTitle;
            if (spotifyArtist) properties['Artysta'] = spotifyArtist;
          }
          if (textOverlayPayload?.text) {
            properties['Napis na obrazie'] = textOverlayPayload.text;
          }
          if (this.isPhonePhotoCaseProduct()) {
            const brandLabel = this.getPhoneBrandLabel();
            const modelLabel = this.getPhoneModelLabel();
            if (brandLabel) properties['Marka'] = brandLabel;
            if (modelLabel) properties['Model'] = modelLabel;
          }

          // 📊 PERSONALIZATION: Dodaj surowe wartości pól personalizacji do properties zamówienia
          const cfg = this.getCustomFieldConfig();
          if (cfg && cfg.fields) {
            cfg.fields.forEach(field => {
              const el = document.getElementById(`customField_${field.id}`);
              if (!el) return;
              let val = el.value ? el.value.trim() : '';
              if (!val && field.defaultValue) val = String(field.defaultValue).trim();
              if (!val) return;
              if (field.id === 'orientacja') properties['Orientacja'] = val;
              if (field.id === 'imiona') properties['Imię / dedykacja'] = val;
              if (field.id === 'rocznica') properties['Rocznica / lata'] = val;
              if (field.id === 'opis_charakteru') properties['Opis osoby'] = val;
              if (field.id === 'dedykacja_imie') properties['Dedykacja / imię'] = val;
            });
          }

          const noteAttributes = {};
          if (textOverlayPayload) {
            noteAttributes['AI Text Overlay'] = JSON.stringify(textOverlayPayload);
          }
          if (productData.giftPackaging) {
            noteAttributes['Gift Pack'] = '| GIFT-PACK |';
          }
          // A/B purchase attribution → note_attributes (nie line items — Baselinker)
          try {
            const _abActive = typeof window.getLumlyProductAbActive === 'function'
              ? window.getLumlyProductAbActive()
              : (typeof window.lumlyAbActive === 'function' ? window.lumlyAbActive() : null);
            if (_abActive && _abActive.experiment && _abActive.variant) {
              noteAttributes['_ab'] = _abActive.experiment + ':' + _abActive.variant;
            }
          } catch (_) {}

          console.log('🛒 [CUSTOMIFY CART PROPERTIES VISIBLE]:', properties);
          if (Object.keys(noteAttributes).length > 0) {
            console.log('📝 [CUSTOMIFY NOTE ATTRIBUTES]:', noteAttributes);
          }

          const truncateLineProperties = (raw) => {
            const out = {};
            Object.entries(raw).forEach(([key, value]) => {
              if (value == null) return;
              const strVal = String(value);
              out[key] = strVal.length > 255 ? strVal.substring(0, 252) + '...' : strVal;
              if (strVal.length > 255) {
                console.warn('⚠️ [CUSTOMIFY] Property', key, 'truncated to 255 chars');
              }
            });
            return out;
          };

          const visibleOnlyForCart = truncateLineProperties({ ...properties });

          let linePropertiesForCart;
          let adminLinePropsMerged = false;
          try {
            const hiddenLineProps = {};
            if (result.orderId) {
              hiddenLineProps['_Order ID Full'] = result.orderId;
            }
            let finalAdminUrlLine = null;
            if (cleanImageUrlForOrder && cleanImageUrlForOrder.startsWith('http')) {
              finalAdminUrlLine = cleanImageUrlForOrder;
            } else if (result.vercelBlobUrl && result.vercelBlobUrl.startsWith('http')) {
              finalAdminUrlLine = result.vercelBlobUrl;
            } else if (result.permanentImageUrl && result.permanentImageUrl.startsWith('http')) {
              finalAdminUrlLine = result.permanentImageUrl;
            } else if (this.transformedImage && String(this.transformedImage).startsWith('http')) {
              finalAdminUrlLine = this.transformedImage;
            }
            if (finalAdminUrlLine) {
              // Prefiks _ — Shopify ukrywa w checkout; partner mapuje „_Link do zdjęcia”
              hiddenLineProps['_Link do zdjęcia'] = finalAdminUrlLine;
            }
            if (cleanImageUrlForOrder && cleanImageUrlForOrder.startsWith('http')) {
              hiddenLineProps['_AI_Image_Clean_URL'] = cleanImageUrlForOrder;
            }
            if (productId) {
              hiddenLineProps['_Original Product ID'] = String(productId);
            }
            linePropertiesForCart = truncateLineProperties({ ...properties, ...hiddenLineProps });
            adminLinePropsMerged = true;
            console.log('🔒 [CUSTOMIFY] Line properties (visible + admin):', Object.keys(linePropertiesForCart));
          } catch (propErr) {
            console.warn('⚠️ [CUSTOMIFY] Błąd budowy pól admin — koszyk tylko z widocznymi (zamówienie możliwe):', propErr?.message || propErr);
            linePropertiesForCart = visibleOnlyForCart;
            adminLinePropsMerged = false;
          }

          console.log('🖼️ [CUSTOMIFY] Image URLs:', {
            shopifyImageUrl: result.imageUrl,
            permanentImageUrl: result.permanentImageUrl,
            aiImageUrl: this.transformedImage,
            orderId: result.orderId
          });

    // ✅ ZAPISZ NOTE ATTRIBUTES (linki dla admina) — timeout 8s, nie blokuje koszyka
    if (Object.keys(noteAttributes).length > 0) {
      try {
        await Promise.race([
          this.updateCartNoteAttributes(noteAttributes),
          new Promise((_, reject) => setTimeout(() => reject(new Error('noteAttributes timeout')), 8000))
        ]);
        console.log('✅ [CUSTOMIFY] Note attributes updated successfully');
      } catch (error) {
        console.error('⚠️ [CUSTOMIFY] Note attributes failed (nie blokuje koszyka):', error.message);
      }
    }

    // ✅ DODAJ DO KOSZYKA PRZEZ POST /cart/add.js (zamiast GET redirect)
    // POST: dostajemy JSON response → wiemy czy się udało
    // Retry tylko cart add (nie tworzy nowego produktu) → fix race condition "produkt nie gotowy"
    console.log('✅ [CUSTOMIFY] Adding to cart via POST /cart/add.js');
    const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let cartAddAttempt = 0;
    let cartAdded = false;
    let lastCartError = '';
    let lastHttpStatus = null;
    let lastRawBody = '';
    let lastAddResult = {};
    while (cartAddAttempt < 3 && !cartAdded) {
      if (cartAddAttempt > 0) {
        console.log(`🔄 [CUSTOMIFY] Cart add retry ${cartAddAttempt}/2 — produkt może nie być jeszcze gotowy`);
        await new Promise(r => setTimeout(r, 1200 * cartAddAttempt)); // 1.2s, 2.4s
      }
      try {
        const addResponse = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(result.variantId, 10), quantity: 1, properties: linePropertiesForCart }] })
        });
        const addResult = await addResponse.json();
        if (addResponse.ok && addResult.items && addResult.items.length > 0) {
          cartAdded = true;
          trackWpCartAdded();
          // A/B cart liczy /api/products przy tworzeniu wariantu — bez frontu
          console.log('✅ [CUSTOMIFY] Added to cart via POST successfully');
          this.hideCartLoading();
          window.location.href = cartRoot + 'cart';
        } else {
          const errMsg = addResult.description || addResult.message || addResult.error || 'Błąd dodawania';
          lastCartError = errMsg;
          lastHttpStatus = addResponse.status;
          lastRawBody = JSON.stringify(addResult);
          lastAddResult = addResult;
          console.warn(`⚠️ [CUSTOMIFY] Cart add attempt ${cartAddAttempt + 1} failed:`, errMsg);
          cartAddAttempt++;
        }
      } catch (addErr) {
        lastCartError = addErr.message;
        console.warn(`⚠️ [CUSTOMIFY] Cart add attempt ${cartAddAttempt + 1} error:`, addErr.message);
        cartAddAttempt++;
      }
    }
    if (!cartAdded && adminLinePropsMerged) {
      console.warn('⚠️ [CUSTOMIFY] Ostatnia próba: cart/add tylko z widocznymi właściwościami (bez linków admin)');
      try {
        const addResponse = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(result.variantId, 10), quantity: 1, properties: visibleOnlyForCart }] })
        });
        const addResult = await addResponse.json();
        if (addResponse.ok && addResult.items && addResult.items.length > 0) {
          cartAdded = true;
          trackWpCartAdded();
          console.log('✅ [CUSTOMIFY] Dodano do koszyka (fallback widoczne-only)');
          this.hideCartLoading();
          window.location.href = cartRoot + 'cart';
        }
      } catch (fallbackErr) {
        console.warn('⚠️ [CUSTOMIFY] Fallback cart add:', fallbackErr?.message || fallbackErr);
      }
    }
    if (!cartAdded) {
      this.hideCartLoading();
      const cartPayloadJson = JSON.stringify({ items: [{ id: parseInt(result.variantId, 10), quantity: 1, properties: linePropertiesForCart }] });
      this._reportCartAddFailure(lastCartError || 'Nie udało się dodać do koszyka', lastAddResult, {
        variantId: result.variantId,
        productId: result.productId,
        httpStatus: lastHttpStatus,
        rawBody: lastRawBody,
        attemptsMade: cartAddAttempt,
        maxAttempts: 3,
        lineProperties: linePropertiesForCart || visibleOnlyForCart || {},
        payloadJson: cartPayloadJson
      });
      this.showError('❌ Nie udało się dodać do koszyka. Spróbuj ponownie.', 'cart');
    }
        }
      } else {
        console.error('❌ [CUSTOMIFY] Product creation failed:', result);
        this.hideCartLoading();
        this.showError('❌ Błąd podczas tworzenia produktu: ' + (result.error || 'Nieznany błąd'), 'cart');
      }
    } catch (error) {
      console.error('❌ [CUSTOMIFY] Add to cart error:', error);
      this._reportToSentry(error, 'addToCart');
      
      // ✅ RETRY LOGIC: Ponów próbę dla network errors (max 3 próby)
      // ⚠️ TYLKO jeśli produkt NIE ZOSTAŁ JESZCZE UTWORZONY — inaczej powstają duplikaty w Shopify!
      const isNetworkErrorCart = error?.message && (
        error.message.includes('Failed to fetch') ||
        error.message.includes('NetworkError') ||
        error.message.includes('Load failed') ||
        error.message.includes('Error completing request') ||
        error.message.includes('network failure')
      );
      if (!productCreated && retryCount < 3 && (error.name === 'AbortError' || isNetworkErrorCart)) {
        const retryDelay = (retryCount + 1) * 2000; // 2s, 4s, 6s
        console.log(`🔄 [CUSTOMIFY] Retrying addToCart in ${retryDelay}ms... (attempt ${retryCount + 1}/3)`);
        this.showError(`🔄 Błąd sieci - ponawiam próbę ${retryCount + 1}/3...`, 'cart');
        
        setTimeout(() => {
          this.addToCart(retryCount + 1);
        }, retryDelay);
        return;
      }
      
      this.hideCartLoading();
      
      let errorMessage = '❌ Błąd połączenia z serwerem.';
      
      if (error.name === 'AbortError') {
        errorMessage = '❌ Przekroczono limit czasu (30 sekund).';
      } else if (error?.message && (error.message.includes('Failed to fetch') || error.message.includes('Error completing request') || error.message.includes('Load failed') || error.message.includes('NetworkError'))) {
        errorMessage = '❌ Błąd sieci. Sprawdź połączenie internetowe.';
      } else if (error?.message) {
        errorMessage = '❌ Błąd: ' + error.message;
      } else if (typeof error === 'string') {
        errorMessage = '❌ Błąd: ' + error;
      }
      
      const recoveryHtml = errorMessage + ' Twój obraz jest zapisany — <a href="/pages/my-generations" style="color:#0066cc;text-decoration:underline;">znajdziesz go w Moje obrazy</a> i możesz wrócić do zamówienia.';
      this.showErrorWithHTML(recoveryHtml, 'cart');
    }
  }

  async updateCartNoteAttributes(noteAttributes) {
    if (!noteAttributes || Object.keys(noteAttributes).length === 0) {
      return;
    }

    console.log('📝 [CUSTOMIFY] Updating cart note attributes:', noteAttributes);

    const payload = {
      attributes: noteAttributes
    };

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Cart note update failed: ${response.status} ${errorText}`);
    }

    const data = await response.json();
    console.log('✅ [CUSTOMIFY] Cart attributes saved:', data.attributes || data);
    return data;
  }

  // UKRYJ PRODUKT PO DODANIU DO KOSZYKA
  async hideProductAfterCartAdd(productId) {
    if (!productId) {
      console.log('⚠️ [CUSTOMIFY] No product ID to hide');
      return;
    }

    try {
      console.log('🔒 [CUSTOMIFY] Hiding product after cart add:', productId);
      
      const response = await fetch('https://customify-s56o.vercel.app/api/hide-product', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: productId })
      });

      if (response.ok) {
        const result = await response.json();
        console.log('✅ [CUSTOMIFY] Product hidden successfully:', result);
      } else {
        console.error('❌ [CUSTOMIFY] Failed to hide product:', response.status);
      }
    } catch (error) {
      console.error('❌ [CUSTOMIFY] Error hiding product:', error);
      this._reportToSentry(error, 'hide-product');
    }
  }

  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const originalFileSize = Number.isFinite(file?.size) ? file.size : null;
      const baseDiagnostics = {
        originalFileSize,
        originalFileType: file?.type || null,
        originalFileNameExtension: this.getUploadFileExtension(file?.name),
        compressionAttempted: true
      };
      this.lastUploadDiagnostics = {
        ...this.lastUploadDiagnostics,
        ...baseDiagnostics,
        compressionSucceeded: false
      };

      // ZAWSZE kompresuj na frontend (optymalizacja rozmiaru)
      this.compressImage(file).then(compressedFile => {
        const compressionMeta = compressedFile?.customifyCompressionMeta || {};
        const compressedFileSize = Number.isFinite(compressedFile?.size) ? compressedFile.size : null;
        const compressionReductionPct = originalFileSize && compressedFileSize
          ? Math.round((1 - compressedFileSize / originalFileSize) * 100)
          : null;
        this.lastUploadDiagnostics = {
          ...this.lastUploadDiagnostics,
          ...baseDiagnostics,
          ...compressionMeta,
          compressedFileSize,
          compressedFileType: compressedFile?.type || null,
          compressionSucceeded: true,
          compressionReductionPct
        };
        this.convertToBase64(compressedFile, (base64) => {
          this.lastUploadDiagnostics = {
            ...this.lastUploadDiagnostics,
            base64Length: base64.length,
            estimatedImageBytes: this._base64SizeBytes(base64)
          };
          resolve(base64);
        }, reject);
      }).catch(error => {
        console.warn('📱 [MOBILE] Compression failed, using original file:', error?.message || error);
        this.lastUploadDiagnostics = {
          ...this.lastUploadDiagnostics,
          ...baseDiagnostics,
          compressionSucceeded: false,
          compressionError: error?.message || String(error)
        };
        // Fallback: użyj oryginalnego pliku bez kompresji — nie blokuj transformacji
        this.convertToBase64(file, (base64) => {
          this.lastUploadDiagnostics = {
            ...this.lastUploadDiagnostics,
            base64Length: base64.length,
            estimatedImageBytes: this._base64SizeBytes(base64),
            usedOriginalFileAfterCompressionFailure: true
          };
          resolve(base64);
        }, reject);
      });
    });
  }

  convertToBase64(file, resolve, reject) {
    if (typeof FileReader === 'undefined') {
      reject(new Error('FileReader nie jest obsługiwany przez tę przeglądarkę. Zaktualizuj przeglądarkę.'));
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result;
      const base64 = result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = async (event) => {
      console.warn('📱 [MOBILE] FileReader failed, trying fallbacks (Google Photos / content URI):', event);
      try {
        const buffer = await this._readFileAsArrayBuffer(file);
        resolve(this._arrayBufferToBase64(buffer));
        return;
      } catch (bufferError) {
        console.warn('📱 [MOBILE] arrayBuffer read failed, trying normalize:', bufferError);
      }
      try {
        const normalized = await this.normalizeUploadFile(file);
        this.convertToBase64(normalized, resolve, reject);
        return;
      } catch (normalizeError) {
        console.error('📱 [MOBILE] all read paths failed:', normalizeError);
      }
      const fileErr = new Error('Nie udało się odczytać pliku zdjęcia. Spróbuj wybrać je jeszcze raz.');
      fileErr.name = 'FileReadError';
      reject(fileErr);
    };
  }

  compressImage(file) {
    return new Promise((resolve, reject) => {
      const finishWithBitmap = async () => {
        try {
          if (typeof createImageBitmap !== 'function') return false;
          const bitmap = await createImageBitmap(file);
          const maxSize = 1024;
          const originalImageWidth = bitmap.width;
          const originalImageHeight = bitmap.height;
          let width = originalImageWidth;
          let height = originalImageHeight;
          const longerSide = Math.max(width, height);
          if (longerSide > maxSize) {
            const scale = maxSize / longerSide;
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const bitmapCtx = canvas.getContext('2d');
          if (!bitmapCtx) throw new Error('Canvas 2d unavailable');
          bitmapCtx.drawImage(bitmap, 0, 0, width, height);
          if (typeof bitmap.close === 'function') bitmap.close();
          const blob = await new Promise((res, rej) => {
            canvas.toBlob((b) => (b ? res(b) : rej(new Error('toBlob null'))), 'image/jpeg', 0.85);
          });
          blob.customifyCompressionMeta = {
            originalImageWidth,
            originalImageHeight,
            compressedImageWidth: width,
            compressedImageHeight: height,
            compressionMaxSize: maxSize,
            compressionQuality: 0.85,
            compressionMethod: 'createImageBitmap'
          };
          resolve(blob);
          return true;
        } catch (err) {
          console.warn('📱 [MOBILE] compressImage createImageBitmap failed:', err?.message || err);
          return false;
        }
      };

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        // Oblicz nowe wymiary (max 1024px - dłuższy bok)
        const maxSize = 1024;
        let { width, height } = img;
        
        // Znajdź dłuższy bok i przeskaluj zachowując proporcje
        const longerSide = Math.max(width, height);
        
        if (longerSide > maxSize) {
          const scale = maxSize / longerSide;
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }
        
        canvas.width = width;
        canvas.height = height;
        
        // Narysuj skompresowany obraz
        ctx.drawImage(img, 0, 0, width, height);
        
        // Konwertuj do blob z kompresją
        canvas.toBlob(blob => {
          if (!blob) {
            reject(new Error('Kompresja obrazu zwróciła pusty plik'));
            return;
          }
          blob.customifyCompressionMeta = {
            originalImageWidth: img.width,
            originalImageHeight: img.height,
            compressedImageWidth: width,
            compressedImageHeight: height,
            compressionMaxSize: maxSize,
            compressionQuality: 0.85
          };
          resolve(blob);
        }, 'image/jpeg', 0.85); // 85% jakość
      };
      
      img.onerror = async () => {
        console.error('📱 [MOBILE] Image load failed, trying createImageBitmap');
        const handled = await finishWithBitmap();
        if (!handled) {
          reject(new Error('Nie udało się wczytać zdjęcia do kompresji.'));
        }
      };
      
      const objectUrl = URL.createObjectURL(file);
      img.onload = ((originalOnload) => function() {
        URL.revokeObjectURL(objectUrl);
        originalOnload.call(this);
      })(img.onload);
      img.onerror = ((originalOnerror) => function() {
        URL.revokeObjectURL(objectUrl);
        originalOnerror.call(this);
      })(img.onerror);
      img.src = objectUrl;
    });
  }

  reset() {
    this.revokePreviewObjectUrl();
    this.uploadedFile = null;
    this.selectedStyle = null;
    this.selectedSize = null;
    this.transformedImage = null;
    this.textOverlayBaseImage = null;
    this.textOverlayWatermarkedUrl = null;
    this.textOverlayOriginalWatermarked = null;
    this.textOverlayState = { ...this.textOverlayState, text: '', applied: false };
    this.spotifyCropConfirmed = false;
    this.closeSpotifyCropper();
    this.phoneCropConfirmed = false;
    this.closePhoneCropper();
    this.phonePhotoCropConfirmed = false;
    this.closePhonePhotoCropper();
    if (this.textOverlayInput) {
      this.textOverlayInput.value = '';
      this.updateTextOverlayCounter();
    }
    if (this.textOverlayPanel) {
      this.textOverlayPanel.style.display = this.textOverlayEnabled ? 'none' : 'none';
    }
    if (this.spotifyFieldsPanel) {
      this.spotifyFieldsPanel.style.display = 'none';
    }
    
    this.fileInput.value = '';
    this.uploadArea.style.display = 'block'; // Pokaż pole upload z powrotem
    this.previewArea.style.display = 'none';
    this.stylesArea.style.display = 'none';
    
    // 📱 Phone case: Hide cart buttons in previewArea
    if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
      const phoneCaseCartActions = document.getElementById('phoneCaseCartActions');
      const phoneCaseCartPriceDisplay = document.getElementById('phoneCaseCartPriceDisplay');
      if (phoneCaseCartActions) {
        phoneCaseCartActions.style.display = 'none';
      }
      if (phoneCaseCartPriceDisplay) {
        phoneCaseCartPriceDisplay.style.display = 'none';
      }
    }
    
    // Usuń klasę has-result żeby previewArea mogło być widoczne po wgraniu nowego zdjęcia
    const container = document.getElementById('customify-app-container');
    if (container) {
      container.classList.remove('has-result');
    }
    this.sizeArea.style.display = 'block'; // ✅ ZAWSZE WIDOCZNE - nie ukrywaj rozmiarów
    this.actionsArea.style.display = 'none';
    this.resultArea.style.display = 'none';
    this.hideError();
    this.hideSuccess();
    
    this.stylesArea.querySelectorAll('.customify-style-card').forEach(card => card.classList.remove('active'));
    this.sizeArea.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
    
    // Przywróć stan początkowy przycisków
    const addToCartBtnMain = document.getElementById('addToCartBtnMain');
    const resetBtn = document.getElementById('resetBtn');
    if (addToCartBtnMain) {
      addToCartBtnMain.style.display = 'inline-block';
    }
    if (resetBtn) {
      resetBtn.style.display = 'none';
    }
    
    // Przywróć kolory przycisków do stanu początkowego
    this.resetButtonColors();

    if (this.isPilotImageEditProduct()) {
      this.resetPilotEditForNewBaseImage({ closeEditor: true, newBaseUrl: null, clearInstruction: true });
      this.hidePilotEditFreshBanner();
      this.setPilotEditEntryMode(null);
    }
  }

  tryAgain() {
    console.log('🔄 [CUSTOMIFY] tryAgain called - returning to style selection');

    if (this.isPilotImageEditProduct()) {
      this.resetPilotEditForNewBaseImage({ closeEditor: true, newBaseUrl: null, clearInstruction: true });
      this.hidePilotEditFreshBanner();
      this.setPilotEditEntryMode(null);
    }
    
    // Ukryj wynik AI
    this.resultArea.style.display = 'none';
    
    if (this.isFourWatercolourProduct()) this.setupFourWatercolourStyles();
    // Pokaż style AI i przyciski (nie dla produktu bez AI)
    if (!this.isSpotifyNoAIProduct()) {
      if (this.isMultiUploadProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = this.getMultiUploadStyle();
      } else if (this.isDlaNiejProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'caricature-new';
      } else if (this.isSuperheroBoyProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'superhero_boy';
      } else if (this.isSupermanProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'superman';
      } else if (this.isLoveRoseProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'love-rose';
      } else if (this.isRoyalLoveProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'royal-love';
      } else if (this.isGTAProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'gta';
      } else if (this.isSteampunkProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'steampunk';
      } else if (this.isHipHopProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'hiphop';
      } else if (this.isRetuszStarychZdjecProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'retusz-starych-zdjec';
      } else if (this.isLinkedinHeadshotProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'linkedin-headshot';
      } else if (this.isSzkicOlowekProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'szkic-olowek';
      } else if (this.isWatercolorAkwarelaProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'watercolor_ok';
      } else if (this.isOilPaintsHerProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'oil-paints';
      } else if (this.isActiveThemedPortraitProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = this.getActiveThemedPortraitStyle();
      } else {
        this.stylesArea.style.display = 'block';
      }
      this.actionsArea.style.display = 'flex';
      // Przywróć transformBtn jeśli był ukryty inline stylem (np. przez handleBezZmianStyle)
      const transformBtnRestore = document.getElementById('transformBtn');
      if (transformBtnRestore) transformBtnRestore.style.display = '';
    }
    
    // Pokaż pole upload (jeśli było ukryte)
    this.uploadArea.style.display = 'block';
    // 🔧 Wyzeruj fileInput żeby kolejny wybór pliku zawsze odpalił change (przeglądarka nie odpala przy tym samym pliku)
    const fileInputEl = document.getElementById('fileInput');
    if (fileInputEl) fileInputEl.value = '';
    // 📸 Multi-upload: pokaż grid
    const multiUploadArea = document.getElementById('multiUploadArea');
    if (multiUploadArea && this.isMultiUploadProduct()) {
      multiUploadArea.style.display = 'block';
    }
    
    // 📱 Phone case: Hide cart buttons in previewArea
    if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
      const phoneCaseCartActions = document.getElementById('phoneCaseCartActions');
      const phoneCaseCartPriceDisplay = document.getElementById('phoneCaseCartPriceDisplay');
      if (phoneCaseCartActions) {
        phoneCaseCartActions.style.display = 'none';
      }
      if (phoneCaseCartPriceDisplay) {
        phoneCaseCartPriceDisplay.style.display = 'none';
      }
    }
    
    // Zresetuj wybrane style i rozmiary
    this.selectedStyle = this.isMultiUploadProduct() ? this.getMultiUploadStyle() : (this.isDlaNiejProduct() ? 'caricature-new' : (this.isSuperheroBoyProduct() ? 'superhero_boy' : (this.isSupermanProduct() ? 'superman' : (this.isLoveRoseProduct() ? 'love-rose' : (this.isRoyalLoveProduct() ? 'royal-love' : (this.isGTAProduct() ? 'gta' : (this.isSteampunkProduct() ? 'steampunk' : (this.isHipHopProduct() ? 'hiphop' : (this.isRetuszStarychZdjecProduct() ? 'retusz-starych-zdjec' : (this.isLinkedinHeadshotProduct() ? 'linkedin-headshot' : (this.isSzkicOlowekProduct() ? 'szkic-olowek' : (this.isWatercolorAkwarelaProduct() ? 'watercolor_ok' : (this.isOilPaintsHerProduct() ? 'oil-paints' : (this.getActiveThemedPortraitStyle() || null))))))))))))));
    this.selectedSize = null;
    this.transformedImage = null;
    this.textOverlayBaseImage = null;
    this.textOverlayWatermarkedUrl = null;
    this.textOverlayOriginalWatermarked = null;
    this.textOverlayState = { ...this.textOverlayState, text: '', applied: false };
    this.spotifyCropConfirmed = false;
    this.closeSpotifyCropper();
    this.phoneCropConfirmed = false;
    this.closePhoneCropper();
    this.phonePhotoCropConfirmed = false;
    this.closePhonePhotoCropper();
    if (this.textOverlayInput) {
      this.textOverlayInput.value = '';
      this.updateTextOverlayCounter();
    }
    if (this.textOverlayPanel) {
      this.textOverlayPanel.style.display = this.textOverlayEnabled ? 'none' : 'none';
    }
    if (this.spotifyFieldsPanel) {
      this.spotifyFieldsPanel.style.display = 'none';
    }
    
    // Usuń aktywne style
    this.stylesArea.querySelectorAll('.customify-style-card').forEach(card => card.classList.remove('active'));
    
    // Usuń aktywne rozmiary
    this.sizeArea.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
    
    // Ukryj wiadomości
    this.hideSuccess();
    this.hideError();
    
    if (this.isFourWatercolourProduct()) this.setupFourWatercolourStyles();
    console.log('🔄 [CUSTOMIFY] tryAgain completed - user can select new style');
    if (this.isPilotImageEditProduct()) {
      this.syncPilotUnderImageActions();
      this.setPilotEditPersonalizationFieldsVisible(true);
    }
  }

  _startGenerationWait() {
    if (this._generationWait && this._generationWait.open) return;
    this._generationWait = { open: true, startedAt: Date.now(), sentLeft: false };
    this._sendGenerationWaitEvent('start');
  }

  _finishGenerationWait(event) {
    if (!this._generationWait || !this._generationWait.open) return;
    const durationMs = Date.now() - this._generationWait.startedAt;
    this._generationWait.open = false;
    this._sendGenerationWaitEvent(event, { durationMs });
  }

  _trackGenerationWaitLeave() {
    if (!this._generationWait || !this._generationWait.open || this._generationWait.sentLeft) return;
    this._generationWait.sentLeft = true;
    this._generationWait.open = false;
    const durationMs = Date.now() - this._generationWait.startedAt;
    this._sendGenerationWaitEvent('left', { durationMs });
    if (typeof window.trackProductAbMetric === 'function') {
      window.trackProductAbMetric('gen_leave');
    }
  }

  _sendGenerationWaitEvent(event, extra = {}) {
    try {
      const payload = JSON.stringify({
        event,
        durationMs: extra.durationMs || 0,
        style: this.selectedStyle || null,
        productHandle: this.getProductHandle ? this.getProductHandle() : null
      });
      const url = 'https://customify-s56o.vercel.app/api/generation-wait-event';
      if (event === 'left' && typeof navigator !== 'undefined' && navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([payload], { type: 'text/plain' }));
        return;
      }
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: payload,
        keepalive: true
      }).catch(() => {});
    } catch (err) {
      console.warn('⚠️ [GEN-WAIT] Tracking skip:', err?.message || err);
    }
  }

  showLoading(options = {}) {
    this.loadingArea.style.display = 'block';
    this.actionsArea.style.display = 'none';

    const progressBar = document.getElementById('progressBar');
    const loadingStage = document.getElementById('loadingStage');
    const loadingTip = document.getElementById('loadingTip');
    const keepOpen = document.getElementById('loadingKeepOpen');

    const isGenerateWait = !!options.trackWait;
    const headline = document.getElementById('loadingHeadline');
    if (headline) {
      headline.textContent = isGenerateWait ? 'Tworzymy Twój obraz' : 'Dodajemy do koszyka';
    }

    if (keepOpen) {
      keepOpen.textContent = isGenerateWait
        ? 'Nie zamykaj tej karty — zwykle trwa ok. minuty.'
        : 'Chwila, nie zamykaj karty.';
    }

    const stages = isGenerateWait
      ? [
          { atMs: 0, percent: 8, text: 'Przesyłamy zdjęcie...' },
          { atMs: 12000, percent: 22, text: 'Przygotowujemy obraz...' },
          { atMs: 28000, percent: 45, text: 'Tworzymy Twój portret...' },
          { atMs: 48000, percent: 68, text: 'Dopracowujemy szczegóły...' },
          { atMs: 75000, percent: 82, text: 'Jeszcze chwila, nie zamykaj karty...' },
          { atMs: 105000, percent: 90, text: 'To może potrwać do 2 minut — zostań na stronie.' }
        ]
      : [
          { atMs: 0, percent: 15, text: 'Przygotowujemy zamówienie...' },
          { atMs: 4000, percent: 45, text: 'Zapisujemy obraz...' },
          { atMs: 10000, percent: 70, text: 'Dodajemy do koszyka...' },
          { atMs: 18000, percent: 88, text: 'Jeszcze chwila...' }
        ];

    const tips = isGenerateWait
      ? [
          'Na tym etapie nic nie płacisz. Najpierw zobaczysz podgląd.',
          'Po podglądzie wybierzesz rozmiar i ramkę. Drukujemy na płótnie, gotowe do powieszenia.',
          'To prezent ze zdjęcia — takiego nie kupisz w zwykłym sklepie.',
          'Przy zamówieniu możesz dodać pakowanie na prezent.',
          'Jeśli napis na obrazku będzie nie tak, grafik poprawi go ręcznie. Wpisz to w uwagach przy zamówieniu.',
          'Wysyłka kurierem po akceptacji podglądu — obraz przychodzi naciągnięty na ramę.'
        ]
      : [];

    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
    if (this._loadingTipInterval) {
      clearInterval(this._loadingTipInterval);
      this._loadingTipInterval = null;
    }

    const startedAt = Date.now();
    let tipIndex = 0;
    if (loadingTip) {
      loadingTip.textContent = tips[0] || '';
    }
    if (progressBar) progressBar.style.width = (stages[0].percent || 8) + '%';
    if (loadingStage) loadingStage.textContent = stages[0].text;

    this.progressInterval = setInterval(() => {
      const elapsed = Date.now() - startedAt;
      let current = stages[0];
      for (let i = 0; i < stages.length; i++) {
        if (elapsed >= stages[i].atMs) current = stages[i];
      }
      const next = stages.find((stage) => stage.atMs > current.atMs);
      let percent = current.percent;
      if (next) {
        const span = next.atMs - current.atMs;
        const t = Math.min(1, (elapsed - current.atMs) / span);
        percent = current.percent + (next.percent - current.percent) * t;
      }
      if (progressBar) progressBar.style.width = Math.min(90, percent) + '%';
      if (loadingStage) loadingStage.textContent = current.text;
    }, 400);

    if (tips.length > 1) {
      this._loadingTipInterval = setInterval(() => {
        tipIndex = (tipIndex + 1) % tips.length;
        if (loadingTip) loadingTip.textContent = tips[tipIndex];
      }, 9000);
    }

    if (options.trackWait) {
      this._startGenerationWait();
    }
  }

  hideLoading() {
    // Zatrzymaj animację paska postępu
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
    if (this._loadingTipInterval) {
      clearInterval(this._loadingTipInterval);
      this._loadingTipInterval = null;
    }
    
    // Ustaw pasek na 100% przed ukryciem
    const progressBar = document.getElementById('progressBar');
    if (progressBar) {
      progressBar.style.width = '100%';
    }
    
    this.loadingArea.style.display = 'none';
    // NIE pokazuj actionsArea jeśli mamy już wynik AI
    console.log('🎯 [CUSTOMIFY] hideLoading called, transformedImage:', !!this.transformedImage);
    if (!this.transformedImage) {
      this.actionsArea.style.display = 'flex';
      console.log('🎯 [CUSTOMIFY] actionsArea shown because no transformedImage');
    } else {
      console.log('🎯 [CUSTOMIFY] actionsArea NOT shown because transformedImage exists');
    }
  }

  showCartLoading() {
    const cartLoadingArea = document.getElementById('cartLoadingArea');
    if (cartLoadingArea) {
      cartLoadingArea.style.display = 'block';
      
      // Animacja paska postępu dla koszyka
      const progressBar = document.getElementById('cartProgressBar');
      const loadingStage = document.getElementById('cartLoadingStage');
      
      if (progressBar && loadingStage) {
        let progress = 0;
        const stages = [
          { percent: 25, text: 'Tworzenie produktu...' },
          { percent: 50, text: 'Przesyłanie obrazu...' },
          { percent: 75, text: 'Dodawanie do koszyka...' },
          { percent: 90, text: 'Finalizowanie...' }
        ];
        
        let currentStage = 0;
        progressBar.style.width = '0%';
        loadingStage.textContent = stages[0].text;
        
        this.cartProgressInterval = setInterval(() => {
          if (currentStage < stages.length) {
            const targetPercent = stages[currentStage].percent;
            if (progress < targetPercent) {
              progress += 1;
              progressBar.style.width = progress + '%';
            } else {
              loadingStage.textContent = stages[currentStage].text;
              currentStage++;
            }
          }
        }, 80); // Szybsza animacja dla koszyka
      }
    }
  }

  hideCartLoading() {
    const cartLoadingArea = document.getElementById('cartLoadingArea');
    if (cartLoadingArea) {
      // Zatrzymaj animację paska postępu
      if (this.cartProgressInterval) {
        clearInterval(this.cartProgressInterval);
        this.cartProgressInterval = null;
      }
      
      // Ustaw pasek na 100% przed ukryciem
      const progressBar = document.getElementById('cartProgressBar');
      if (progressBar) {
        progressBar.style.width = '100%';
      }
      
      cartLoadingArea.style.display = 'none';
    }
  }

  /** A/B wariant komunikatu o limicie (raz na przeglądarkę) */
  getLimitMessageVariant() {
    try {
      let v = localStorage.getItem('customify_limit_msg_variant');
      if (!v) {
        v = Math.random() < 0.5 ? 'A' : 'B';
        localStorage.setItem('customify_limit_msg_variant', v);
      }
      return v;
    } catch {
      return 'default';
    }
  }

  /** Lejek limitu → KV (panel /admin/limit-wall-users) */
  trackLimitFunnelShowLimit(customerInfo, opts = {}) {
    if (!customerInfo?.customerId) return;
    const body = {
      event: 'limit_message_shown',
      customerId: String(customerInfo.customerId),
      messageVariant: opts.messageVariant || this.getLimitMessageVariant(),
      wallTier: opts.wallTier || 'unknown',
      productHandle: typeof this.getProductHandle === 'function' ? this.getProductHandle() : null,
      source: opts.source || 'transform_403'
    };
    fetch('https://customify-s56o.vercel.app/api/limit-funnel-event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(() => {});
  }

  trackLimitFunnelGenerationSuccess(customerInfo) {
    if (!customerInfo?.customerId) return;
    fetch('https://customify-s56o.vercel.app/api/limit-funnel-event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event: 'generation_success',
        customerId: String(customerInfo.customerId)
      })
    }).catch(() => {});
  }

  showError(message, location = 'top') {
    this.trackUiErrorShown(message, location, false);

    // Ukryj wszystkie komunikaty błędów najpierw
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
    if (this.errorMessageTransform) {
      this.errorMessageTransform.style.display = 'none';
    }
    if (this.errorMessageBottom) {
      this.errorMessageBottom.style.display = 'none';
    }
    const phoneCaseCartError = document.getElementById('phoneCaseCartError');
    if (phoneCaseCartError) {
      phoneCaseCartError.style.display = 'none';
    }
    
    // Pokaż błąd w odpowiednim miejscu
    if (location === 'transform' && this.errorMessageTransform) {
      // Błędy transformacji - nad przyciskiem "Zobacz Podgląd"
      this.errorMessageTransform.textContent = message;
      this.errorMessageTransform.style.display = 'block';
    } else if (location === 'cart') {
      // Błędy koszyka - nad przyciskiem "Dodaj do koszyka"
      // 📱 Etui: pokaż w errorMessageBottom (zaraz pod #cartPriceDisplay)
      if (this.errorMessageBottom) {
        this.errorMessageBottom.textContent = message;
        this.errorMessageBottom.style.display = 'block';
      }
    } else if (location === 'top' && this.errorMessage) {
      // Błędy uploadu/walidacji pliku - na górze
      this.errorMessage.textContent = message;
      this.errorMessage.style.display = 'block';
    } else {
      // Fallback: pokaż w górze jeśli nie określono lokalizacji
      if (this.errorMessage) {
        this.errorMessage.textContent = message;
        this.errorMessage.style.display = 'block';
      }
    }
  }

  showErrorWithHTML(message, location = 'top') {
    this.trackUiErrorShown(message, location, true);

    // Ukryj wszystkie komunikaty błędów najpierw
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
    if (this.errorMessageTransform) {
      this.errorMessageTransform.style.display = 'none';
    }
    if (this.errorMessageBottom) {
      this.errorMessageBottom.style.display = 'none';
    }
    const phoneCaseCartError = document.getElementById('phoneCaseCartError');
    if (phoneCaseCartError) {
      phoneCaseCartError.style.display = 'none';
    }
    
    // Pokaż błąd z HTML w odpowiednim miejscu
    if (location === 'transform' && this.errorMessageTransform) {
      // Błędy transformacji - nad przyciskiem "Zobacz Podgląd"
      this.errorMessageTransform.innerHTML = message;
      this.errorMessageTransform.style.display = 'block';
    } else if (location === 'cart') {
      // Błędy koszyka - nad przyciskiem "Dodaj do koszyka"
      // 📱 Etui: pokaż w errorMessageBottom (zaraz pod #cartPriceDisplay)
      if (this.errorMessageBottom) {
        this.errorMessageBottom.innerHTML = message;
        this.errorMessageBottom.style.display = 'block';
      }
    } else if (location === 'top' && this.errorMessage) {
      // Błędy uploadu/walidacji pliku - na górze
      this.errorMessage.innerHTML = message;
      this.errorMessage.style.display = 'block';
    } else {
      // Fallback: pokaż w górze jeśli nie określono lokalizacji
      if (this.errorMessage) {
        this.errorMessage.innerHTML = message;
        this.errorMessage.style.display = 'block';
      }
    }
  }

  hideError() {
    // Ukryj wszystkie komunikaty błędów
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
    if (this.errorMessageTransform) {
      this.errorMessageTransform.style.display = 'none';
    }
    if (this.errorMessageBottom) {
      this.errorMessageBottom.style.display = 'none';
    }
    const phoneCaseCartError = document.getElementById('phoneCaseCartError');
    if (phoneCaseCartError) {
      phoneCaseCartError.style.display = 'none';
    }
  }

  showSuccess(message, options = {}) {
    if (
      this.isPilotImageEditProduct() &&
      this.pilotEditEntryMode !== 'fresh' &&
      typeof message === 'string' &&
      message.includes('pilot-edit-success-cta')
    ) {
      return;
    }
    if (options.html) {
      this.successMessage.innerHTML = message;
    } else {
      this.successMessage.textContent = message;
    }
    this.successMessage.style.display = 'block';
    if (options.html && this.isPilotImageEditProduct() && message.includes('pilotEditSuccessBtn')) {
      this.ensurePilotEditSuccessClickDelegation();
      const freshBtn = document.getElementById('pilotEditSuccessBtn');
      if (freshBtn) delete freshBtn.dataset.pilotBound;
      this.bindPilotEditSuccessButton();
    }
  }

  hideSuccess() {
    this.successMessage.style.display = 'none';
  }

  // Zmień kolory przycisków po wygenerowaniu AI
  swapButtonColors() {
    const transformBtn = document.getElementById('transformBtn');
    const addToCartBtnMain = document.getElementById('addToCartBtnMain');
    
    if (transformBtn && addToCartBtnMain) {
      // Po AI: "Zobacz Podgląd" -> czarny, "Dodaj do koszyka" -> czerwony
      transformBtn.classList.remove('customify-btn-red');
      transformBtn.classList.add('customify-btn-primary');
      addToCartBtnMain.classList.remove('customify-btn-primary');
      addToCartBtnMain.classList.add('customify-btn-red');
      console.log('🔄 [CUSTOMIFY] Button colors swapped after AI generation');
    }
  }

  // Przywróć kolory przycisków do stanu początkowego
  resetButtonColors() {
    const transformBtn = document.getElementById('transformBtn');
    const addToCartBtnMain = document.getElementById('addToCartBtnMain');
    
    if (transformBtn && addToCartBtnMain) {
      // Na początku: "Zobacz Podgląd" -> czerwony, "Dodaj do koszyka" -> czarny
      transformBtn.classList.remove('customify-btn-primary');
      transformBtn.classList.add('customify-btn-red');
      addToCartBtnMain.classList.remove('customify-btn-red');
      addToCartBtnMain.classList.add('customify-btn-primary');
      console.log('🔄 [CUSTOMIFY] Button colors reset to initial state');
    }
  }
}

/**
 * CART - ukryj Order ID, Cena (w properties), sekcja ilości
 */
function hideCartOrderIdQuantityCena() {
  const items = document.querySelectorAll('.cart-item, .cart-items__row, tr[role="row"]');
  items.forEach(r => {
    r.querySelectorAll('.cart-items__properties dt').forEach(dt => {
      const t = (dt.textContent || '').trim().toLowerCase();
      const dd = dt.nextElementSibling;
      if ((t.includes('order id') || t === 'cena') && dd) {
        dt.style.display = dd.style.display = 'none';
      }
    });
    // Ukryj TYLKO kontrolki ilości (+/-, input), nie cały komponent – inaczej ukrywa się symbol Usuń
    const quantitySelectors = 'quantity-selector-component .quantity-minus, quantity-selector-component .quantity-plus, quantity-selector-component input, quantity-input .quantity-minus, quantity-input .quantity-plus, quantity-input input';
    r.querySelectorAll(quantitySelectors).forEach(x => { x.style.display = 'none'; });
    // Przycisk usuwania – pokaż (ZACHOWAJ ikonę kosza SVG! el.textContent usuwało ją)
    const removeSelectors = 'a[href*="quantity=0"], a[href*="cart/change"], .cart-item__remove, .line-item__remove, [data-cart-remove], button[aria-label*="Remove"], button[aria-label*="Usuń"]';
    r.querySelectorAll(removeSelectors).forEach(el => {
      el.style.display = '';
      el.style.visibility = 'visible';
      if (el.querySelector('svg')) {
        // Ma ikonę – zachowaj SVG, usuń resztę (np. "Remove"), dodaj "Usuń"
        const svg = el.querySelector('svg');
        el.innerHTML = '';
        el.appendChild(svg.cloneNode(true));
        const txt = document.createElement('span');
        txt.className = 'customify-remove-text';
        txt.textContent = ' Usuń';
        el.appendChild(txt);
      } else {
        // Brak ikony – dodaj ikonę kosza + tekst
        const iconSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>';
        el.innerHTML = iconSvg + ' <span class="customify-remove-text">Usuń</span>';
      }
      el.setAttribute('aria-label', 'Usuń');
    });
    // Fallback: znajdź w komórce ilości cokolwiek z "Remove"
    r.querySelectorAll('td:nth-child(3) a, td:nth-child(3) button').forEach(el => {
      if ((el.textContent || '').trim().toLowerCase().includes('remove') || (el.getAttribute('aria-label') || '').toLowerCase().includes('remove')) {
        el.style.display = '';
        el.style.visibility = 'visible';
        if (el.querySelector('svg')) {
          const svg = el.querySelector('svg');
          el.innerHTML = '';
          el.appendChild(svg.cloneNode(true));
          const txt = document.createElement('span');
          txt.className = 'customify-remove-text';
          txt.textContent = ' Usuń';
          el.appendChild(txt);
        } else {
          const iconSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>';
          el.innerHTML = iconSvg + ' <span class="customify-remove-text">Usuń</span>';
        }
        el.setAttribute('aria-label', 'Usuń');
      }
    });
  });
  // Nagłówek kolumny – zmień na "Usuń" zamiast "Ilość"
  document.querySelectorAll('.cart-items th:nth-child(3)').forEach(h => {
    h.style.display = '';
    const t = (h.textContent || '').trim().toLowerCase();
    if (t.includes('ilość') || t.includes('quantity')) h.textContent = 'Usuń';
  });
}

/**
 * CART INTEGRATION - AI Image Display
 */
function initCartIntegration() {
  if (window.location.pathname.includes('/cart')) hideCartOrderIdQuantityCena();
  // Znajdź wszystkie elementy koszyka z AI obrazkami
  const cartItems = document.querySelectorAll('.cart-item, .cart-items__row');
  
  cartItems.forEach(item => {
    // Ukryte property z URL obrazu (stare i nowe nazwy)
    const aiImageProperty = item.querySelector('dd[data-property="_Link do zdjęcia"], dd[data-property="_AI_Image_URL"], dd[data-property="Link do zdjęcia"]');
    
    const imageUrl = aiImageProperty?.textContent?.trim() || '';
    const looksLikeHttpImageUrl = imageUrl.startsWith('http') && imageUrl.length > 24;
    if (aiImageProperty && looksLikeHttpImageUrl) {
      
      // Ukryj surowy URL
      const propertyDiv = aiImageProperty.closest('.cart-items__properties');
      if (propertyDiv) {
        propertyDiv.style.display = 'none';
      }
      
      // Dodaj miniaturkę
      const imageCell = item.querySelector('.cart-items__image, .cart-item__image-wrapper');
      if (imageCell && !imageCell.querySelector('.cart-item__ai-image')) {
        const aiImage = document.createElement('img');
        aiImage.src = imageUrl;
        aiImage.alt = 'AI Transformed Image';
        aiImage.className = 'cart-item__ai-image';
        aiImage.style.cssText = 'width: 80px; height: 80px; object-fit: cover; border-radius: 0; border: 2px solid #e0e0e0;';
        
        // Wstaw miniaturkę jako główny obrazek lub obok
        const existingImage = imageCell.querySelector('img');
        if (existingImage) {
          existingImage.replaceWith(aiImage);
        } else {
          imageCell.appendChild(aiImage);
        }
      }
    }
  });
}

/**
 * MOBILE THUMBNAILS - Dodaj miniaturki na mobile
 */
function addMobileThumbnails() {
  // Sprawdź czy jesteśmy na mobile
  if (window.innerWidth > 749) return;
  
  // Znajdź właściwy container - product information media (widoczny na mobile)
  const mediaContainer = document.querySelector('.product-information__media');
  if (!mediaContainer) {
    console.log('🎯 [CUSTOMIFY] Media container not found, skipping thumbnails');
    return;
  }
  
  // Sprawdź czy miniaturki już istnieją
  if (mediaContainer.querySelector('.customify-mobile-thumbnails')) return;
  
  // Znajdź wszystkie obrazy w kontenerze
  const productImages = mediaContainer.querySelectorAll('img');
  if (productImages.length < 2) return; // Potrzebujemy co najmniej 2 obrazy
  
  console.log('🎯 [CUSTOMIFY] Dodaję miniaturki na mobile, znaleziono', productImages.length, 'obrazów');
  
  // Stwórz container dla miniaturek
  const thumbnailsContainer = document.createElement('div');
  thumbnailsContainer.className = 'customify-mobile-thumbnails';
  thumbnailsContainer.style.cssText = `
    display: flex !important;
    gap: 8px !important;
    padding: 10px !important;
    justify-content: center !important;
    margin-top: 10px !important;
    flex-wrap: wrap !important;
    width: 100% !important;
  `;
  
  // Dodaj miniaturki (użyj pierwszych 3 obrazów - 0, 1, 2)
  for (let i = 0; i < Math.min(3, productImages.length); i++) {
    const img = productImages[i];
    const thumbnail = document.createElement('div');
    thumbnail.className = 'customify-mobile-thumbnail';
    thumbnail.style.cssText = `
      width: 60px !important;
      height: 60px !important;
      border-radius: 6px !important;
      border: 2px solid #e0e0e0 !important;
      cursor: pointer !important;
      transition: all 0.3s ease !important;
      overflow: hidden !important;
      flex-shrink: 0 !important;
    `;
    
    // Stwórz nowy obraz z tym samym src
    const thumbnailImg = document.createElement('img');
    thumbnailImg.src = img.src;
    thumbnailImg.alt = img.alt || 'Thumbnail';
    thumbnailImg.style.cssText = `
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      border-radius: 4px !important;
    `;
    
    thumbnail.appendChild(thumbnailImg);
    
    // Dodaj event listener do kliknięcia
    thumbnail.addEventListener('click', () => {
      // Znajdź odpowiedni przycisk nawigacji i kliknij go
      const navButtons = document.querySelectorAll('.slideshow-control');
      if (navButtons[i]) {
        navButtons[i].click();
        console.log('🎯 [CUSTOMIFY] Kliknięto miniaturkę', i);
      }
    });
    
    // Hover effect
    thumbnail.addEventListener('mouseenter', () => {
      thumbnail.style.borderColor = '#dc3545';
      thumbnail.style.transform = 'scale(1.05)';
    });
    
    thumbnail.addEventListener('mouseleave', () => {
      thumbnail.style.borderColor = '#e0e0e0';
      thumbnail.style.transform = 'scale(1)';
    });
    
    thumbnailsContainer.appendChild(thumbnail);
  }
  
  // Dodaj container do media container
  mediaContainer.appendChild(thumbnailsContainer);
  console.log('✅ [CUSTOMIFY] Miniaturki na mobile dodane pomyślnie');
}

/**
 * INITIALIZATION
 */
document.addEventListener('DOMContentLoaded', async () => {
  // B5: Stara przeglądarka bez obsługi ES Modules / nowoczesnego JS
  if (window.CUSTOMIFY_LEGACY_BROWSER) {
    const container = document.getElementById('customify-app-container');
    if (container) {
      container.innerHTML = '<div style="background:#fff3cd;border:1px solid #ffc107;border-radius:8px;padding:16px;margin:16px 0;font-family:sans-serif;font-size:14px;color:#856404"><strong>⚠️ Twoja przeglądarka jest za stara</strong><br>Personalizacja zdjęć wymaga nowszej przeglądarki. Zaktualizuj przeglądarkę do najnowszej wersji (Chrome, Safari, Firefox) lub spróbuj na innym urządzeniu.</div>';
    }
    return;
  }

  // Simple-product: nie uruchamiaj Customify w ogóle (strona ma tylko przycisk Kup → koszyk)
  const p = window.ShopifyProduct;
  if (p && p.tags) {
    const tags = Array.isArray(p.tags) ? p.tags : String(p.tags).split(',');
    if (tags.some(t => String(t).toLowerCase().trim() === 'simple-product')) {
      return;
    }
  }

  // Resolve a new visitor's price before constructing the configurator.
  if (window.LumlyPricingReady) await window.LumlyPricingReady;

  // Initialize Customify app
  if (typeof window.trackProductAbMetric === 'function') window.trackProductAbMetric('assigned');
  const customifyApp = new CustomifyEmbed();
  
  // ✅ AUTO-LOAD: Sprawdź czy user wybrał generację na stronie "Moje generacje"
  try {
    const selectedData = localStorage.getItem('customify_selected_generation');
    if (selectedData) {
      const { index, generation } = JSON.parse(selectedData);
      console.log('🎯 [CUSTOMIFY] Auto-loading generation from "Moje generacje":', index, generation);
      
      // Załaduj generację używając reuseGeneration() (ta sama funkcja co kliknięcie w galerii)
      setTimeout(() => {
        // Sprawdź czy DOM jest gotowy (resultImage musi istnieć)
        const resultImage = document.getElementById('resultImage');
        if (!resultImage) {
          console.warn('⚠️ [CUSTOMIFY] resultImage not found, retrying in 1s...');
          setTimeout(() => {
            customifyApp.reuseGeneration(generation);
            console.log('✅ [CUSTOMIFY] Generation loaded from "Moje generacje" (retry), ready for checkout');
          }, 1000);
          return;
        }
        
        customifyApp.reuseGeneration(generation);
        console.log('✅ [CUSTOMIFY] Generation loaded from "Moje generacje", ready for checkout');
        
        // Scroll do wyniku żeby user widział co się załadowało
        const resultArea = document.getElementById('resultArea');
        if (resultArea) {
          resultArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 2000); // 2s delay żeby DOM się załadował + galeria się zbudowała
      
      // Wyczyść po użyciu
      localStorage.removeItem('customify_selected_generation');
    }
  } catch (error) {
    console.error('❌ [CUSTOMIFY] Error loading selected generation:', error);
    if (typeof Sentry !== 'undefined' && Sentry.captureException) {
      Sentry.captureException(error, { tags: { customify_area: 'load-selected-generation' } });
    }
  }
  
  // Initialize cart integration
  initCartIntegration();
  
  // Add mobile thumbnails - WYŁĄCZONE (miniaturki są obsługiwane przez theme.liquid)
  // addMobileThumbnails();
  
  // Re-add thumbnails on resize - WYŁĄCZONE
  // window.addEventListener('resize', () => {
  //   addMobileThumbnails();
  // });
  
  // Clean up dividers and spacing
  window.addEventListener('load', () => {
    setTimeout(() => {
      // Add mobile thumbnails after load - WYŁĄCZONE
      // addMobileThumbnails();
      // USUŃ DIVIDERY FIZYCZNIE Z DOM
      const dividers = document.querySelectorAll('.divider, .divider__line, .divider-AM3M2YnhsTllLTUtCS__divider_VJhene');
      dividers.forEach(divider => {
        if (divider && divider.parentNode) {
          divider.parentNode.removeChild(divider);
          console.log('🎯 [CUSTOMIFY] Divider usunięty z DOM');
        }
      });

      // AGRESYWNE USUNIĘCIE ODSTĘPÓW MIĘDZY TYTUŁEM A BADGE'AMI
      const titleElement = document.querySelector('.view-product-title');
      const badgesElement = document.querySelector('.product-badges');
      
      if (titleElement) {
        titleElement.style.setProperty('margin-bottom', '0px', 'important');
        titleElement.style.setProperty('padding-bottom', '0px', 'important');
        titleElement.style.setProperty('margin', '0 0 0px 0', 'important');
        console.log('🎯 [CUSTOMIFY] Odstępy tytułu usunięte (inline)');
      }
      
      if (badgesElement) {
        badgesElement.style.setProperty('margin', '0 0 24px 0', 'important');
        badgesElement.style.setProperty('padding', '0', 'important');
        badgesElement.style.setProperty('gap', '8px', 'important');
        badgesElement.style.setProperty('display', 'block', 'important');
        console.log('🎯 [CUSTOMIFY] Odstęp badge\'ów ustawiony: 16px');
      }

      // DODATKOWE FORCE HIDE DIVIDERS - INLINE STYLES
      const allDividers = document.querySelectorAll('.divider, .divider__line, .divider-AM3M2YnhsTllLTUtCS__divider_VJhene');
      allDividers.forEach(divider => {
        divider.style.setProperty('display', 'none', 'important');
        divider.style.setProperty('visibility', 'hidden', 'important');
        divider.style.setProperty('opacity', '0', 'important');
        divider.style.setProperty('height', '0', 'important');
        divider.style.setProperty('margin', '0', 'important');
        divider.style.setProperty('padding', '0', 'important');
        divider.style.setProperty('border', 'none', 'important');
        console.log('🎯 [CUSTOMIFY] Divider ukryty (inline styles)');
      });
    }, 1000); // Zwiększ opóźnienie do 1 sekundy
  });
});

// FUNKCJA NAPRAWY POWIĘKSZONYCH ZDJĘĆ W DIALOGU - UNIWERSALNA
function fixDialogImages() {
  if (window.__fixDialogImagesBusy) return;
  const dialog = document.querySelector('dialog[open]');
  if (!dialog) return;
  window.__fixDialogImagesBusy = true;
  try {
  // Znajdź wszystkie zdjęcia w dialogu
  const allImages = dialog.querySelectorAll('img');
  let largestImg = null;
  let largestWidth = 0;
  
  allImages.forEach(img => {
    const width = img.clientWidth;
    if (width > largestWidth) {
      largestWidth = width;
      largestImg = img;
    }
  });
  
  if (!largestImg) {
    window.__fixDialogImagesBusy = false;
    return;
  }
  
  // Wymuś poprawne style - WYPEŁNIA CAŁY KONTENER
  largestImg.style.setProperty('object-fit', 'cover', 'important');
  largestImg.style.setProperty('max-height', 'none', 'important');
  largestImg.style.setProperty('height', '100%', 'important');
  largestImg.style.setProperty('width', '100%', 'important');
  largestImg.style.setProperty('object-position', 'center', 'important');
  
  // Styluj kontener
  if (largestImg.parentElement) {
    largestImg.parentElement.style.setProperty('height', '100%', 'important');
  }
  
  console.log('✅ Zdjęcie w dialogu naprawione - brak białych pól!');
  } finally {
    window.__fixDialogImagesBusy = false;
  }
}

// Event listener dla kliknięć w przyciski powiększenia
document.addEventListener('click', function(e) {
  const zoomButton = e.target.closest('.product-media-container__zoom-button, button[class*="zoom"]');
  if (zoomButton) {
    setTimeout(fixDialogImages, 100);  // Czekaj aż dialog się otworzy
    setTimeout(fixDialogImages, 300);  // Ponownie po załadowaniu
    setTimeout(fixDialogImages, 600);  // I jeszcze raz dla pewności
  }
});

// Tylko gdy dialog otwarty — unikaj pustego pollingu co 300ms na każdej stronie
setInterval(function() {
  if (document.querySelector('dialog[open]')) fixDialogImages();
}, 500);



// ====================================================
// DYNAMICZNE PRZENOSZENIE SEKCJI RODZAJU I ROZMIARU
// ====================================================
 document.addEventListener('DOMContentLoaded', function() {
 var resultArea = document.getElementById('resultArea');
 var inlineSlot = document.getElementById('type-size-inline-slot');
 var originalPlaceholder = document.getElementById('type-size-original-placeholder');
 var productTypeArea = document.getElementById('productTypeArea');
 var sizeArea = document.getElementById('sizeArea');
 // Elemente ramki
 var frameSelector = document.getElementById('frameSelector');
 var frameToggle = document.getElementById('frameToggle');
 var frameOptions = document.getElementById('frameOptions');
 var frameCurrentLabel = document.getElementById('frameCurrentLabel');

 if (!resultArea || !inlineSlot || !originalPlaceholder || !productTypeArea || !sizeArea) {
 return;
 }

 function isVisible(el) {
 if (!el) return false;
 var style = window.getComputedStyle(el);
 return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
 }

 function moveToResult() {
 if (inlineSlot.contains(productTypeArea)) {
 return;
 }
 inlineSlot.appendChild(productTypeArea);
 // Przenieś selektor pakietów cyfrowych (między typem a rozmiarem)
 var pkgSelector = document.getElementById('digitalPackageSelector');
 if (pkgSelector && !inlineSlot.contains(pkgSelector)) {
 inlineSlot.appendChild(pkgSelector);
 }
 if (!inlineSlot.contains(sizeArea)) {
 inlineSlot.appendChild(sizeArea);
 }
 }

 function moveBack() {
 if (!productTypeArea || productTypeArea.parentElement === originalPlaceholder.parentElement) {
 return;
 }
 originalPlaceholder.parentNode.insertBefore(productTypeArea, originalPlaceholder);
 // Cofnij selektor pakietów cyfrowych
 var pkgSelector = document.getElementById('digitalPackageSelector');
 if (pkgSelector && pkgSelector.parentElement !== originalPlaceholder.parentElement) {
 originalPlaceholder.parentNode.insertBefore(pkgSelector, originalPlaceholder);
 }
 if (sizeArea && sizeArea.parentElement !== originalPlaceholder.parentElement) {
 originalPlaceholder.parentNode.insertBefore(sizeArea, originalPlaceholder);
 }
 }

 function syncPosition() {
 // 🎵 SPOTIFY: Nie przenoś elementów gdy "bez-zmian" jest aktywny
 if (window.spotifyBezZmianActive) {
 return;
 }
 if (window.__customifySyncPositionBusy) return;
 window.__customifySyncPositionBusy = true;
 try {
 if (isVisible(resultArea)) {
 moveToResult();
 } else {
 moveBack();
 }
 } finally {
 window.__customifySyncPositionBusy = false;
 }
 }

 function scheduleSyncPosition() {
 if (window.__customifySyncPositionScheduled) return;
 window.__customifySyncPositionScheduled = true;
 requestAnimationFrame(function() {
 window.__customifySyncPositionScheduled = false;
 syncPosition();
 });
 }

 // Obserwuj zmiany widoczności
 var observer = new MutationObserver(scheduleSyncPosition);
 observer.observe(resultArea, { attributes: true, attributeFilter: ['style', 'class'], subtree: false });

 // Polling jako fallback (np. zmiany przez skrypty zewnętrzne) — rzadziej, żeby uniknąć stack overflow
 setInterval(scheduleSyncPosition, 1500);

 // Pierwsza synchronizacja
 syncPosition();

 // ============ LOGIKA RAMKI ============
 // Stan globalny (współdzielony między lokalizacjami)
 window.CustomifyFrame = window.CustomifyFrame || { color: 'none' };

 function setFrame(color) {
 window.CustomifyFrame.color = color;
if (window.__customify) {
var activeTypeBtn = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
if (activeTypeBtn) window.__customify.selectedProductType = activeTypeBtn.getAttribute('data-product-type');
}
 // Aktualizuj UI
 if (frameCurrentLabel) {
var isCanvas = isCanvasSelected();
 frameCurrentLabel.textContent =
color === 'black' ? (isCanvas ? 'Rama Premium - American Box Czarna' : 'Czarna') :
 color === 'white' ? 'Biała' :
color === 'wood' ? (isCanvas ? 'Rama Premium - American Box Drewno' : 'Drewno') :
(isCanvas ? 'Rama Klasyczna - Blejtram' : 'Brak ramki');
 }
 if (frameOptions) {
 var opts = frameOptions.querySelectorAll('.frame-option');
 opts.forEach(function(opt){
 opt.setAttribute('aria-selected', opt.getAttribute('data-frame') === color ? 'true' : 'false');
 });
 }
 }

 function toggleOptions() {
 if (!frameOptions) return;
 var isOpen = frameOptions.style.display !== 'none';
 frameOptions.style.display = isOpen ? 'none' : 'block';
 if (frameSelector) frameSelector.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
 }

 function closeOptions() {
 if (frameOptions) {
 frameOptions.style.display = 'none';
 if (frameSelector) frameSelector.setAttribute('aria-expanded', 'false');
 }
 }

 function isPlakatSelected() {
 var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
 return active && active.getAttribute('data-product-type') === 'plakat';
 }

function isCanvasSelected() {
var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
return active && active.getAttribute('data-product-type') === 'canvas';
}

 // 🚨 ROLLBACK: START - Funkcje dla produktu cyfrowego
 function isDigitalProductSelected() {
 var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
 return active && active.getAttribute('data-product-type') === 'digital';
 }

 function updateDigitalProductUI() {
 var isDigital = isDigitalProductSelected();
 var sizeArea = document.getElementById('sizeArea');
 
 // Ukryj/pokaż rozmiary
 if (sizeArea) {
 if (isDigital) {
 sizeArea.style.display = 'none';
 console.log('📦 [DIGITAL] Size area hidden for digital product');
 } else {
 sizeArea.style.display = 'block';
 console.log('📦 [DIGITAL] Size area shown for physical product');
 }
 }

 // Pokaż/ukryj selektor pakietów cyfrowych
 var pkgSelector = document.getElementById('digitalPackageSelector');
 if (pkgSelector) {
 pkgSelector.style.display = isDigital ? 'block' : 'none';
 console.log('📦 [DIGITAL] Package selector:', isDigital ? 'shown' : 'hidden');
 }
 }
 // 🚨 ROLLBACK: END - Funkcje dla produktu cyfrowego

 function updateFrameAvailability() {
var enabled = isPlakatSelected() || isCanvasSelected();
 // 🚨 ROLLBACK: START - Ukryj ramkę dla produktu cyfrowego
 var isDigital = isDigitalProductSelected();
 if (isDigital) {
 enabled = false; // Produkt cyfrowy nie ma ramki
 }
 // 🚨 ROLLBACK: END - Ukryj ramkę dla produktu cyfrowego
 
 if (frameSelector) {
 if (enabled) {
 frameSelector.style.display = 'block'; // ✅ Pokazuje ramkę
 frameSelector.classList.remove('disabled');
frameSelector.classList.toggle('canvas-frame-mode', isCanvasSelected());
frameSelector.classList.toggle('poster-frame-mode', isPlakatSelected());
if (isCanvasSelected() && window.CustomifyFrame && window.CustomifyFrame.color === 'white') {
setFrame('none');
} else {
setFrame((window.CustomifyFrame && window.CustomifyFrame.color) || 'none');
}
 } else {
 frameSelector.style.display = 'none'; // ✅ Całkowicie ukrywa ramkę
 frameSelector.classList.add('disabled');
frameSelector.classList.remove('canvas-frame-mode', 'poster-frame-mode');
 closeOptions();
 }
 }
 }

 // ============ 🆕 LOGIKA PODSTAWKI (SZKŁO) ============
 window.CustomifyStand = window.CustomifyStand || { type: 'none' };
 
 var standSelector = document.getElementById('standSelector');
 var standToggle = document.getElementById('standToggle');
 var standOptions = document.getElementById('standOptions');
 var standCurrentLabel = document.getElementById('standCurrentLabel');
 
 function isSzkloSelected() {
 var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
 return active && active.getAttribute('data-product-type') === 'szklo';
 }
 
 function setStand(type) {
 window.CustomifyStand.type = type;
 // Aktualizuj UI
 if (standCurrentLabel) {
 standCurrentLabel.textContent =
 type === 'wood' ? ('Podstawka drewniana (+' + (window.__customify?.standPricing.wood ?? 29) + ' zł)') :
 type === 'led' ? ('Podstawka drewniana z LED (+' + (window.__customify?.standPricing.led ?? 39.90).toFixed(2) + ' zł)') :
 'Brak podstawki';
 }
 if (standOptions) {
 var opts = standOptions.querySelectorAll('.stand-option');
 opts.forEach(function(opt){
 opt.setAttribute('aria-selected', opt.getAttribute('data-stand') === type ? 'true' : 'false');
 });
 }
 
 // Aktualizuj ceny po zmianie podstawki
 if (window.__customify) {
 window.__customify.updateProductPrice();
 window.__customify.updateCartPrice();
 }
 }
 
 function toggleStandOptions() {
 if (!standOptions) return;
 var isOpen = standOptions.style.display !== 'none';
 standOptions.style.display = isOpen ? 'none' : 'block';
 if (standSelector) standSelector.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
 }
 
 function closeStandOptions() {
 if (standOptions) {
 standOptions.style.display = 'none';
 if (standSelector) standSelector.setAttribute('aria-expanded', 'false');
 }
 }
 
 // === PAKIETY CYFROWE ===
window.CustomifyDigitalPackage = window.CustomifyDigitalPackage || { count: 1, price: 69 };

var DIGITAL_PACKAGE_PRICES = { 1: 69, 3: 89, 5: 149, 10: 199 };

 function isDigitalSelected() {
 var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
 return active && active.getAttribute('data-product-type') === 'digital';
 }

 function setDigitalPackage(count) {
 count = parseInt(count, 10) || 1;
 window.CustomifyDigitalPackage.count = count;
 window.CustomifyDigitalPackage.price = DIGITAL_PACKAGE_PRICES[count] || 69;

 // Aktualizuj active na przyciskach
 var pkgBtns = document.querySelectorAll('.digital-package-btn');
 pkgBtns.forEach(function(btn) {
 btn.classList.toggle('active', parseInt(btn.getAttribute('data-package'), 10) === count);
 });

 // Odśwież ceny w UI
 if (window.__customify) {
 if (isDigitalSelected()) {
 window.__customify.selectedProductType = 'digital';
 }
 window.__customify.updateProductPrice();
 window.__customify.updateCartPrice();
 }
 }

 function updateDigitalPackageSelector() {
 var el = document.getElementById('digitalPackageSelector');
 if (!el) return;
 el.style.display = isDigitalSelected() ? 'block' : 'none';
 }

 function initDigitalPackageSelector() {
 var el = document.getElementById('digitalPackageSelector');
 if (!el) return;

 // Obsługa kliknięcia w pakiet
 el.addEventListener('click', function(e) {
 var btn = e.target.closest('.digital-package-btn');
 if (!btn) return;
 setDigitalPackage(btn.getAttribute('data-package'));
 });

 // Ustaw domyślny (1 plik) i pokaż/ukryj
 setDigitalPackage(1);
 updateDigitalPackageSelector();
 }
 // === KONIEC PAKIETY CYFROWE ===

 function updateStandAvailability() {
 var enabled = isSzkloSelected();
 
 if (standSelector) {
 if (enabled) {
 standSelector.style.display = 'block';
 standSelector.classList.remove('disabled');
 } else {
 standSelector.style.display = 'none';
 standSelector.classList.add('disabled');
 closeStandOptions();
 }
 }
 }
 
 function updateSizeAvailability() {
 var isSzklo = isSzkloSelected();
 var sizeButtons = document.querySelectorAll('.customify-size-btn');
 
 sizeButtons.forEach(function(btn) {
 var size = btn.getAttribute('data-size');
 if (isSzklo) {
 // Dla szkła: tylko A5 i A4 widoczne
 if (size === 'a5' || size === 'a4') {
 btn.style.display = 'block';
 } else {
 btn.style.display = 'none';
 }
 } else {
 // Dla plakat/canvas: A4, A3, A2, A0, A1 widoczne (bez A5)
 if (size === 'a5') {
 btn.style.display = 'none';
 } else {
 btn.style.display = 'block';
 }
 }
 });
 
 // Jeśli aktualnie wybrany rozmiar jest ukryty, wybierz pierwszy widoczny
 if (window.__customify && window.__customify.selectedSize) {
 var currentBtn = document.querySelector('.customify-size-btn[data-size="' + window.__customify.selectedSize + '"]');
 if (currentBtn && currentBtn.style.display === 'none') {
 // Wybierz pierwszy widoczny rozmiar
 var firstVisible = Array.from(sizeButtons).find(function(b) { return b.style.display !== 'none'; });
 if (firstVisible) {
 firstVisible.click();
 }
 }
 }
 }

 // Inicjalizacja UI ramki i podstawki
 setFrame(window.CustomifyFrame.color || 'none');
 setStand(window.CustomifyStand.type || 'none');
 updateFrameAvailability();
 updateStandAvailability();
 updateSizeAvailability();
 initDigitalPackageSelector();
 // 🚨 ROLLBACK: START - Inicjalizacja UI produktu cyfrowego
 updateDigitalProductUI();
 // 🚨 ROLLBACK: END - Inicjalizacja UI produktu cyfrowego

 // Zdarzenia UI
 if (frameToggle) {
 frameToggle.addEventListener('click', function(e){
 if (frameSelector && frameSelector.classList.contains('disabled')) return;
 toggleOptions();
 });
 }
 if (frameOptions) {
 frameOptions.addEventListener('click', function(e){
 var target = e.target.closest('.frame-option');
 if (!target) return;
 if (frameSelector && frameSelector.classList.contains('disabled')) return;
 var color = target.getAttribute('data-frame');
 setFrame(color);
 closeOptions();
 if (window.__customify && typeof window.__customify.updateCartPrice === 'function') {
 window.__customify.updateCartPrice();
 if (typeof window.__customify.updateProductPrice === 'function') {
 window.__customify.updateProductPrice();
 }
 }
 });
 }
 document.addEventListener('click', function(e){
 if (!frameSelector) return;
 if (!frameSelector.contains(e.target)) closeOptions();
 });
 
 // 🆕 Event listenery dla podstawki (szkło)
 if (standToggle) {
 standToggle.addEventListener('click', function(e){
 if (standSelector && standSelector.classList.contains('disabled')) return;
 toggleStandOptions();
 });
 }
 if (standOptions) {
 standOptions.addEventListener('click', function(e){
 var target = e.target.closest('.stand-option');
 if (!target) return;
 if (standSelector && standSelector.classList.contains('disabled')) return;
 var type = target.getAttribute('data-stand');
 setStand(type);
 closeStandOptions();
 });
 }
 document.addEventListener('click', function(e){
 if (!standSelector) return;
 if (!standSelector.contains(e.target)) closeStandOptions();
 });

 // Nasłuchiwanie na zmianę typu produktu (Plakat/Canvas/Szkło/Digital)
 var typeBtns = productTypeArea ? productTypeArea.querySelectorAll('.customify-product-type-btn') : [];
 typeBtns.forEach(function(btn){
 btn.addEventListener('click', function(){
 // Daj czas istniejącym handlerom na ustawienie .active
 setTimeout(function(){
 updateFrameAvailability();
 updateStandAvailability(); // 🆕 Aktualizuj dostępność podstawki
 updateSizeAvailability(); // 🆕 Aktualizuj widoczność rozmiarów
 updateDigitalPackageSelector(); // 🆕 Pakiety cyfrowe
 // 🚨 ROLLBACK: START - Aktualizuj UI produktu cyfrowego
 updateDigitalProductUI();
 // 🚨 ROLLBACK: END - Aktualizuj UI produktu cyfrowego
 }, 0);
 });
 });
 
// 🆕 AUTO-INICJALIZACJA dla produktów ze szkłem
var currentUrl = window.location.pathname.toLowerCase();
var isSzkloProduct = currentUrl.includes('szkle') ||
currentUrl.includes('szklo') ||
currentUrl.includes('akryl') ||
currentUrl.includes('karykatura-dla-niej') ||
currentUrl.includes('salon-spa') ||
currentUrl.includes('nauczycielki-karykatura-na-prezent') ||
currentUrl.includes('zkaonczenie-podziekowanie-prezent') ||
currentUrl.includes('portret-nauczyciela-ze-zdjecia-na-zakonczenie-roku-podziekowanie');
 
 if (isSzkloProduct) {
 console.log('🔍 [SZKLO] Produkt ze szkłem wykryty - automatyczne filtrowanie rozmiarów');
 // Ustaw szkło jako wybrany typ
 if (window.__customify) {
 window.__customify.selectedProductType = 'szklo';
 }
 // Wywoła updateSizeAvailability() żeby pokazać tylko A5 i A4
 updateStandAvailability();
 updateSizeAvailability();
 
 // 🆕 AUTO-ZAZNACZ ROZMIAR A5 jako domyślny dla szkła
 setTimeout(function() {
 var a5Btn = document.querySelector('.customify-size-btn[data-size="a5"]');
 var activeBtn = document.querySelector('.customify-size-btn.active');
 var activeSize = activeBtn ? activeBtn.getAttribute('data-size') : null;
 if (a5Btn && activeSize !== 'a5') {
 a5Btn.click();
 console.log('✅ [SZKLO] Automatycznie zaznaczono rozmiar A5');
 }
 }, 100);
 
 console.log('✅ [SZKLO] Automatycznie pokazano tylko rozmiary dla szkła (A5, A4)');
 }
 });

// ====================================================
// CART WATERMARK INTEGRATION
// ====================================================
 (function() {
 // Tylko strona koszyka — observer na body na stronach produktu powodował stack overflow
 if (!window.location.pathname.includes('/cart')) return;
 
 // Funkcja dodawania watermarku do obrazka
 async function addWatermarkToImage(imageUrl) {
 return new Promise((resolve, reject) => {
 const img = new Image();
 img.crossOrigin = 'anonymous';
 
 img.onload = () => {
 try {
 const canvas = document.createElement('canvas');
 const ctx = canvas.getContext('2d');
 
 canvas.width = img.width;
 canvas.height = img.height;
 
 // Rysuj oryginalny obraz
 ctx.drawImage(img, 0, 0);
 
 // ===== WZÓR DIAGONALNY - "Lumly.pl" i "Podgląd" NA PRZEMIAN =====
 ctx.save();
 
 // ✅ ZWIĘKSZONY FONT I OPACITY DLA LEPSZEJ WIDOCZNOŚCI
 const fontSize = Math.max(40, Math.min(canvas.width, canvas.height) * 0.08); // Min 40px, max 8% obrazu
 
 // ✅ FIX: Użyj systemowego fontu z fallbackami (Arial może nie być dostępny w Canvas)
 // Użyj fontu który ZAWSZE jest dostępny w przeglądarce
 const fontFamily = 'sans-serif'; // Systemowy font - zawsze dostępny
 ctx.font = `bold ${fontSize}px ${fontFamily}`;
 
 // ✅ SPRAWDŹ CZY FONT JEST ZAŁADOWANY (test renderowania)
 ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'; // ✅ ZWIĘKSZONA OPACITY (było 0.5)
 ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)'; // ✅ ZWIĘKSZONA OPACITY (było 0.35)
 ctx.lineWidth = 2; // ✅ ZWIĘKSZONA GRUBOŚĆ (było 1.5)
 ctx.textAlign = 'center';
 ctx.textBaseline = 'middle';
 
 // ✅ TEST: Sprawdź czy tekst się renderuje (jeśli nie - użyj innego fontu)
 const testText = 'Test';
 const testMetrics = ctx.measureText(testText);
 if (testMetrics.width === 0) {
 console.warn('⚠️ [WATERMARK] Font test failed, using fallback');
 ctx.font = `bold ${fontSize}px monospace`; // Fallback na monospace
 }
 
 // Obróć canvas
 ctx.translate(canvas.width/2, canvas.height/2);
 ctx.rotate(-30 * Math.PI / 180);
 ctx.translate(-canvas.width/2, -canvas.height/2);
 
 // Rysuj watermarki w siatce - na przemian "Lumly.pl" i "Podgląd"
 const spacing = Math.max(200, Math.min(canvas.width, canvas.height) * 0.3); // ✅ DYNAMICZNY SPACING
 let textIndex = 0;
 const texts = ['Lumly.pl', 'Podgląd'];
 
 for(let y = -canvas.height; y < canvas.height * 2; y += spacing) {
 for(let x = -canvas.width; x < canvas.width * 2; x += spacing * 1.5) {
 const text = texts[textIndex % 2];
 // ✅ RYSUJ STROKE PRZED FILL (dla lepszej widoczności)
 ctx.strokeText(text, x, y);
 ctx.fillText(text, x, y);
 textIndex++;
 }
 // Zmień wzór co wiersz dla lepszego efektu
 textIndex++;
 }
 
 ctx.restore();
 
 // Zwróć obraz z watermarkiem jako Data URL
 resolve(canvas.toDataURL('image/jpeg', 0.92));
 console.log('✅ [CUSTOMIFY CART] Watermark dodany do miniaturki');
 } catch (error) {
 console.error('❌ [CUSTOMIFY CART] Watermark error:', error);
 if (typeof Sentry !== 'undefined' && Sentry.captureException) { Sentry.captureException(error, { tags: { customify_area: 'cart-watermark' } }); }
 reject(error);
 }
 };
 
 img.onerror = (error) => {
 console.error('❌ [CUSTOMIFY CART] Image load error:', error);
 reject(error);
 };
 
 img.src = imageUrl;
 });
 }
 
 function showImageLightbox(imageUrl) {
 console.log('🔍 [CUSTOMIFY CART] Pokazuję lightbox dla:', imageUrl);
 
 // Stwórz overlay
 const overlay = document.createElement('div');
 overlay.className = 'customify-lightbox';
 
 // Dodaj powiększony obraz
 const img = document.createElement('img');
 img.src = imageUrl;
 img.alt = 'Powiększony obraz AI';
 
 // Przycisk zamknięcia
 const closeBtn = document.createElement('button');
 closeBtn.className = 'customify-lightbox-close';
 closeBtn.innerHTML = '×';
 closeBtn.setAttribute('aria-label', 'Zamknij');
 
 overlay.appendChild(img);
 overlay.appendChild(closeBtn);
 
 // Zamknij po kliknięciu overlay lub przycisku
 overlay.addEventListener('click', (e) => {
 if (e.target === overlay || e.target === closeBtn) {
 overlay.remove();
 console.log('🔍 [CUSTOMIFY CART] Lightbox zamknięty');
 }
 });
 
 // Zamknij po ESC
 const handleEsc = (e) => {
 if (e.key === 'Escape') {
 overlay.remove();
 document.removeEventListener('keydown', handleEsc);
 console.log('🔍 [CUSTOMIFY CART] Lightbox zamknięty (ESC)');
 }
 };
 document.addEventListener('keydown', handleEsc);
 
 document.body.appendChild(overlay);
 }
 
 function disableAIProductLinks() {
 if (window.__customifyCartLinksBusy) return;
 window.__customifyCartLinksBusy = true;
 try {


 // Znajdź wszystkie elementy koszyka (różne selektory dla różnych motywów)
 const cartItems = document.querySelectorAll(
 '.cart-item, .cart-items__table-row, .cart-items__row, [data-line-item], .line-item, .cart__line-item'
 );
 

 
 cartItems.forEach((item, index) => {
 // Znajdź wszystkie linki w tym elemencie (miniaturka + tytuł)
 const links = item.querySelectorAll('a[href*="/products/"]');
 console.log(`🔗 [CUSTOMIFY CART] Element ${index} - znaleziono linków: ${links.length}`);
 
 links.forEach((link, linkIndex) => {
 // Sprawdź czy już przetworzono ten link (unikaj wielokrotnego dodawania event listenerów)
 if (link.dataset.customifyProcessed === 'true') {
 console.log(`⏭️ [CUSTOMIFY CART] Link ${linkIndex} już przetworzony - pomijam`);
 return;
 }
 
 // Oznacz jako przetworzony
 link.dataset.customifyProcessed = 'true';
 
 // Znajdź obrazek w linku
 const img = link.querySelector('img');
 
 if (img) {
 // To jest link z miniaturką - sprawdź czy mamy URL z watermarkiem w cart properties
 console.log(`🖼️ [CUSTOMIFY CART] Link ${linkIndex} ma obrazek`);
 console.log(` Obrazek src: ${img.src}`);
 
 // Znajdź cart properties dla tego produktu
 const cartItem = link.closest('.cart-item, .cart-items__table-row, tr[role="row"]');
 let watermarkedUrl = null;
 
if (cartItem) {
const properties = cartItem.querySelectorAll('dd, .product-option dd');
 properties.forEach(prop => {
 const dt = prop.previousElementSibling;
 if (!dt) return;

 const propertyName = dt.textContent.trim();
 const normalizedName = propertyName.replace(/\s+/g, '').toLowerCase();

 if (normalizedName.includes('ai_image_watermarked')) {
 watermarkedUrl = prop.textContent.trim();
 console.log('✅ [CUSTOMIFY CART] Znaleziono URL z watermarkiem:', watermarkedUrl);
 }

// ✅ UKRYJ "Styl AI", "Rozmiar", "Rodzaj wydruku" i wszystkie ukryte properties
if (propertyName.startsWith('_') || 
normalizedName.includes('ai_image_') || 
normalizedName.includes('styl ai') || 
normalizedName === 'stylai' ||
propertyName === 'Styl AI' ||
propertyName.toLowerCase() === 'styl ai' ||
propertyName.includes('Styl AI') ||
propertyName.includes('styl ai') ||
propertyName === 'Rozmiar' ||
propertyName === 'Rodzaj wydruku' ||
propertyName.includes('Link do zdjęcia')) {
dt.style.display = 'none';
prop.style.display = 'none';
console.log('🙈 [CUSTOMIFY CART] Ukryto property:', propertyName);
}
 });
 }
 
 // ✅ Główny obrazek produktu w Shopify jest już Z watermarkiem (uploadowany z watermarkedImage)
 // ✅ Miniaturka: mała (250px) - Shopify automatycznie
 // ✅ Lightbox: DUŻA (1200px) - zmieniamy parametr width w URL
 
 let originalSrc = img.src;
 console.log('🖼️ [CUSTOMIFY CART] Oryginalny src:', originalSrc);
 
 // Zmień URL Shopify na większy rozmiar dla lightbox (1200px zamiast 250px)
 if (originalSrc.includes('cdn.shopify.com') || originalSrc.includes('lumly.pl/cdn/')) {
 let largeImageSrc = originalSrc;
 
 if (largeImageSrc.includes('width=')) {
 // Zmień istniejący parametr width
 largeImageSrc = largeImageSrc.replace(/width=\d+/, 'width=1200');
 } else {
 // Dodaj parametr width
 largeImageSrc = largeImageSrc + (largeImageSrc.includes('?') ? '&' : '?') + 'width=1200';
 }
 
 img.dataset.watermarkedSrc = largeImageSrc;
 console.log('✅ [CUSTOMIFY CART] Przygotowano większy obrazek (1200px):', largeImageSrc);
 } else {
 // Nie ma cdn.shopify.com - zostaw oryginalny
 img.dataset.watermarkedSrc = originalSrc;
 console.log('⚠️ [CUSTOMIFY CART] To nie jest Shopify CDN URL - używam oryginalnego');
 }
 
 link.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 console.log('🖼️ [CUSTOMIFY CART] Kliknięto miniaturkę - pokazuję lightbox');
 
 // Użyj większego obrazka (1200px) przygotowanego wcześniej
 const imageToShow = img.dataset.watermarkedSrc || img.src;
 console.log('📏 [CUSTOMIFY CART] Pokazuję obrazek:', imageToShow);
 
 showImageLightbox(imageToShow);
 });
 
 // Zmień cursor na zoom-in
 link.style.cursor = 'zoom-in';
 link.title = 'Kliknij aby powiększyć';
 } else {
 // To jest link z tytułem - wyłącz całkowicie
 console.log(`📝 [CUSTOMIFY CART] Link ${linkIndex} to tytuł - wyłączam`);
 console.log(` Link href: ${link.href}`);
 console.log(` Link text: ${link.textContent.trim()}`);
 
 link.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 console.log('📝 [CUSTOMIFY CART] Kliknięto tytuł - blokuję');
 });
 
 link.style.cursor = 'default';
 link.style.pointerEvents = 'none';
 link.style.textDecoration = 'none';
 }
 });
 });
 
 console.log(`✅ [CUSTOMIFY CART] Wyłączono linki dla ${cartItems.length} produktów`);
 } finally {
 window.__customifyCartLinksBusy = false;
 }
 }

 function scheduleDisableAIProductLinks() {
 if (window.__customifyCartLinksScheduled) return;
 window.__customifyCartLinksScheduled = true;
 setTimeout(function() {
 window.__customifyCartLinksScheduled = false;
 disableAIProductLinks();
 }, 200);
 }

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', scheduleDisableAIProductLinks);
} else {
scheduleDisableAIProductLinks();
}

document.addEventListener('cart:updated', () => {
setTimeout(scheduleDisableAIProductLinks, 500);
});

 // Obserwuj zmiany tylko w kontenerze koszyka — bez fallbacku na body
 const cartContainer = document.querySelector('.cart-items, .cart, [data-cart-items], cart-items-component');
 if (!cartContainer) {
 console.log('✅ [CUSTOMIFY CART] Brak kontenera koszyka — pomijam MutationObserver');
 return;
 }

 const observer = new MutationObserver((mutations) => {
 const isLightboxChange = mutations.some(mutation => {
 return Array.from(mutation.addedNodes).some(node => {
 return node.classList && node.classList.contains('customify-lightbox');
 }) || Array.from(mutation.removedNodes).some(node => {
 return node.classList && node.classList.contains('customify-lightbox');
 });
 });

 if (isLightboxChange) return;

 // Ignoruj zmiany atrybutów wywołane przez nas (data-customify-processed, style linków)
 const isOwnAttributeChange = mutations.every(mutation =>
 mutation.type === 'attributes' &&
 mutation.target &&
 mutation.target.dataset &&
 mutation.target.dataset.customifyProcessed === 'true'
 );
 if (isOwnAttributeChange) return;

 scheduleDisableAIProductLinks();
 });

 observer.observe(cartContainer, {
 childList: true,
 subtree: true,
 attributes: true,
 attributeFilter: ['data-customify-processed', 'style', 'class']
 });
 
 console.log('✅ [CUSTOMIFY CART] Inicjalizacja zakończona - obserwuję zmiany');
 })();

// ====================================================
// CHECKOUT LINK MODIFICATION
// ====================================================
 (function() {
 // Sprawdź czy jesteśmy na checkout lub thank you page
 const isCheckout = window.location.pathname.includes('/checkout') || 
 window.location.pathname.includes('/thank_you') ||
 window.Shopify?.Checkout;
 
 if (!isCheckout) {
 console.log('🛒 [CUSTOMIFY CHECKOUT] Nie jesteśmy na checkout - pomijam');
 return;
 }
 
 console.log('🛒 [CUSTOMIFY CHECKOUT] Inicjalizacja wyłączania linków produktów AI');
 
 function showImageLightbox(imageUrl) {
 console.log('🔍 [CUSTOMIFY CHECKOUT] Pokazuję lightbox dla:', imageUrl);
 
 // Stwórz overlay
 const overlay = document.createElement('div');
 overlay.style.cssText = `
 position: fixed;
 top: 0;
 left: 0;
 width: 100vw;
 height: 100vh;
 background: rgba(0, 0, 0, 0.9);
 z-index: 99999;
 display: flex;
 align-items: center;
 justify-content: center;
 cursor: zoom-out;
 animation: fadeIn 0.2s ease;
 `;
 
 // Dodaj powiększony obraz
 const img = document.createElement('img');
 img.src = imageUrl;
 img.alt = 'Powiększony obraz AI';
 img.style.cssText = `
 max-width: 90vw;
 max-height: 90vh;
 object-fit: contain;
 border-radius: 8px;
 box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
 `;
 
 // Przycisk zamknięcia
 const closeBtn = document.createElement('button');
 closeBtn.innerHTML = '×';
 closeBtn.setAttribute('aria-label', 'Zamknij');
 closeBtn.style.cssText = `
 position: absolute;
 top: 20px;
 right: 20px;
 width: 40px;
 height: 40px;
 background: white;
 border: none;
 border-radius: 50%;
 cursor: pointer;
 font-size: 24px;
 font-weight: bold;
 color: #333;
 display: flex;
 align-items: center;
 justify-content: center;
 box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
 transition: all 0.2s ease;
 `;
 
 overlay.appendChild(img);
 overlay.appendChild(closeBtn);
 
 // Zamknij po kliknięciu overlay lub przycisku
 overlay.addEventListener('click', (e) => {
 if (e.target === overlay || e.target === closeBtn) {
 overlay.remove();
 console.log('🔍 [CUSTOMIFY CHECKOUT] Lightbox zamknięty');
 }
 });
 
 // Zamknij po ESC
 const handleEsc = (e) => {
 if (e.key === 'Escape') {
 overlay.remove();
 document.removeEventListener('keydown', handleEsc);
 console.log('🔍 [CUSTOMIFY CHECKOUT] Lightbox zamknięty (ESC)');
 }
 };
 document.addEventListener('keydown', handleEsc);
 
 document.body.appendChild(overlay);
 }
 
 function disableAIProductLinks() {
 console.log('🛒 [CUSTOMIFY CHECKOUT] Wyłączam linki dla wszystkich produktów w checkout...');
 
 // Znajdź wszystkie elementy checkout (różne selektory dla Shopify checkout)
 const checkoutItems = document.querySelectorAll(
 '.product, .product-thumbnail, [data-product-table], .order-summary__section--product-list .product, .review-block__content .product'
 );
 
 console.log('🛒 [CUSTOMIFY CHECKOUT] Znaleziono elementów checkout:', checkoutItems.length);
 
 checkoutItems.forEach((item, index) => {
 // Znajdź wszystkie linki w tym elemencie
 const links = item.querySelectorAll('a[href*="/products/"]');
 console.log(`🔗 [CUSTOMIFY CHECKOUT] Element ${index} - znaleziono linków: ${links.length}`);
 
 links.forEach((link, linkIndex) => {
 // Znajdź obrazek w linku
 const img = link.querySelector('img');
 
 if (img) {
 // To jest link z miniaturką - wyłącz i dodaj lightbox
 console.log(`🖼️ [CUSTOMIFY CHECKOUT] Link ${linkIndex} ma obrazek - dodaję lightbox`);
 
 link.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 showImageLightbox(img.src);
 });
 
 // Zmień cursor na zoom-in
 link.style.cursor = 'zoom-in';
 link.title = 'Kliknij aby powiększyć';
 } else {
 // To jest link z tytułem - wyłącz całkowicie
 console.log(`📝 [CUSTOMIFY CHECKOUT] Link ${linkIndex} to tytuł - wyłączam`);
 
 link.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 });
 
 link.style.cursor = 'default';
 link.style.pointerEvents = 'none';
 link.style.textDecoration = 'none';
 }
 });
 });
 
 console.log(`✅ [CUSTOMIFY CHECKOUT] Wyłączono linki dla ${checkoutItems.length} produktów`);
 }
 
 // Uruchom po załadowaniu DOM
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', disableAIProductLinks);
 } else {
 disableAIProductLinks();
 }
 
 // Uruchom ponownie po zmianach (Shopify checkout może się dynamicznie aktualizować)
 setTimeout(disableAIProductLinks, 1000);
 setTimeout(disableAIProductLinks, 2000);
 
 console.log('✅ [CUSTOMIFY CHECKOUT] Inicjalizacja zakończona');
 })();


// ====================================================
// CONTACT PAGE FUNCTIONALITY
// ====================================================
 document.addEventListener('DOMContentLoaded', function() {
 // Sprawdź czy jesteśmy na stronie kontakt
 if (window.location.pathname.includes('/pages/kontakt') || window.location.pathname.includes('/policies/contact-information')) {
 // Czekaj chwilę, żeby DOM się załadował
 setTimeout(function() {
 // Znajdź główną treść strony - szukaj po różnych selektorach
 let targetElement = null;
 
 // Próbuj znaleźć główną sekcję z treścią
 const selectors = [
 '#MainContent',
 'main',
 '.main-content',
 '.page-content',
 '.rte',
 '.page__content',
 '.page-content-wrapper',
 '[class*="policy"]',
 '[class*="content"]',
 'article',
 '.content-for-layout',
 '[class*="page"]'
 ];
 
 for (const selector of selectors) {
 const element = document.querySelector(selector);
 if (element && element.offsetHeight > 0) {
 targetElement = element;
 break;
 }
 }
 
 // Jeśli nie znaleziono, szukaj po nagłówku h1
 if (!targetElement) {
 const h1 = document.querySelector('h1');
 if (h1) {
 // Znajdź najbliższy kontener z treścią
 targetElement = h1.closest('div, section, article, main') || h1.parentElement;
 }
 }
 
 // Ostatecznie użyj body, ale znajdź miejsce przed footerem
 if (!targetElement) {
 const footer = document.querySelector('footer, [class*="footer"]');
 if (footer) {
 targetElement = footer;
 } else {
 targetElement = document.body;
 }
 }
 
 if (targetElement) {
 // Utwórz formularz kontaktowy
 const contactFormHTML = `
 <div id="contact-form-container" style="
 max-width: 600px;
 margin: 40px auto;
 padding: 30px;
 background: #fff;
 border-radius: 8px;
 box-shadow: 0 2px 8px rgba(0,0,0,0.1);
 ">
 <h2 style="
 font-size: 24px;
 font-weight: 600;
 margin-bottom: 20px;
 color: #333;
 ">Wyślij wiadomość</h2>
 
 <form id="contactForm" style="display: flex; flex-direction: column; gap: 16px;">
 <div>
 <label for="contactName" style="display: block; margin-bottom: 6px; font-weight: 500; color: #555;">
 Imię i nazwisko *
 </label>
 <input 
 type="text" 
 id="contactName" 
 name="name" 
 required
 style="
 width: 100%;
 padding: 12px;
 border: 1px solid #ddd;
 border-radius: 4px;
 font-size: 16px;
 box-sizing: border-box;
 "
 >
 </div>
 
 <div>
 <label for="contactEmail" style="display: block; margin-bottom: 6px; font-weight: 500; color: #555;">
 Email *
 </label>
 <input 
 type="email" 
 id="contactEmail" 
 name="email" 
 required
 style="
 width: 100%;
 padding: 12px;
 border: 1px solid #ddd;
 border-radius: 4px;
 font-size: 16px;
 box-sizing: border-box;
 "
 >
 </div>
 
 <div>
 <label for="contactSubject" style="display: block; margin-bottom: 6px; font-weight: 500; color: #555;">
 Temat
 </label>
 <input 
 type="text" 
 id="contactSubject" 
 name="subject"
 style="
 width: 100%;
 padding: 12px;
 border: 1px solid #ddd;
 border-radius: 4px;
 font-size: 16px;
 box-sizing: border-box;
 "
 >
 </div>
 
 <div>
 <label for="contactMessage" style="display: block; margin-bottom: 6px; font-weight: 500; color: #555;">
 Wiadomość *
 </label>
 <textarea 
 id="contactMessage" 
 name="message" 
 required
 rows="6"
 style="
 width: 100%;
 padding: 12px;
 border: 1px solid #ddd;
 border-radius: 4px;
 font-size: 16px;
 font-family: inherit;
 box-sizing: border-box;
 resize: vertical;
 "
 ></textarea>
 </div>
 
 <button 
 type="submit"
 style="
 background: #000;
 color: #fff;
 padding: 14px 28px;
 border: none;
 border-radius: 4px;
 font-size: 16px;
 font-weight: 600;
 cursor: pointer;
 transition: background 0.2s;
 "
 onmouseover="this.style.background='#333'"
 onmouseout="this.style.background='#000'"
 >
 Wyślij wiadomość
 </button>
 
 <div id="contactFormMessage" style="
 margin-top: 12px;
 padding: 12px;
 border-radius: 4px;
 display: none;
 "></div>
 </form>
 </div>
 `;
 
 // Jeśli targetElement to footer, dodaj przed nim
 if (targetElement.tagName === 'FOOTER' || targetElement.className.includes('footer')) {
 targetElement.insertAdjacentHTML('beforebegin', contactFormHTML);
 } else {
 // W przeciwnym razie dodaj na końcu elementu
 targetElement.insertAdjacentHTML('beforeend', contactFormHTML);
 }
 
 // Obsługa formularza
 const form = document.getElementById('contactForm');
 const messageDiv = document.getElementById('contactFormMessage');
 
 if (form) {
 form.addEventListener('submit', async function(e) {
 e.preventDefault();
 
 const formData = {
 name: document.getElementById('contactName').value,
 email: document.getElementById('contactEmail').value,
 subject: document.getElementById('contactSubject').value || 'Kontakt ze strony',
 message: document.getElementById('contactMessage').value
 };
 
 // Wyłącz przycisk podczas wysyłania
 const submitBtn = form.querySelector('button[type="submit"]');
 submitBtn.disabled = true;
 submitBtn.textContent = 'Wysyłanie...';
 
 try {
 const response = await fetch('https://customify-s56o.vercel.app/api/contact-form', {
 method: 'POST',
 headers: {
 'Content-Type': 'application/json'
 },
 body: JSON.stringify(formData)
 });
 
 const result = await response.json();
 
 if (response.ok && result.success) {
 messageDiv.style.display = 'block';
 messageDiv.style.background = '#E8F5E9';
 messageDiv.style.color = '#2E7D32';
 messageDiv.textContent = '✅ ' + result.message;
 form.reset();
 } else {
 throw new Error(result.error || 'Błąd wysyłania wiadomości');
 }
 } catch (error) {
 messageDiv.style.display = 'block';
 messageDiv.style.background = '#FFEBEE';
 messageDiv.style.color = '#C62828';
 messageDiv.textContent = '❌ Błąd: ' + error.message;
 } finally {
 submitBtn.disabled = false;
 submitBtn.textContent = 'Wyślij wiadomość';
 }
}); // Zamknij addEventListener
} // Zamknij if (form)
} // Zamknij if (targetElement)
}, 500); // Czekaj 500ms na załadowanie DOM
}
});

// ============================================================
// SYSTEM KREDYTÓW – pobieranie pliku cyfrowego za kredyt
// ============================================================
(function() {
  'use strict';

  var CREDITS_API_BASE = 'https://customify-s56o.vercel.app';

  var el = {};
  var currentCredits = 0;
  var creditsChecked = false;

  function getCustomerId() {
    return window.ShopifyCustomer && window.ShopifyCustomer.id ? window.ShopifyCustomer.id : null;
  }
  function getCustomerEmail() {
    return window.ShopifyCustomer && window.ShopifyCustomer.email ? window.ShopifyCustomer.email : '';
  }

  function initCreditsUI() {
    el.section    = document.getElementById('creditsSection');
    el.loading    = document.getElementById('creditsLoading');
    el.available  = document.getElementById('creditsAvailable');
    el.empty      = document.getElementById('creditsEmpty');
    el.notLogged  = document.getElementById('creditsNotLoggedIn');
    el.success    = document.getElementById('creditsSuccess');
    el.error      = document.getElementById('creditsError');
    el.useBtn     = document.getElementById('useCreditsBtn');
    el.balanceInfo= document.getElementById('creditsBalanceInfo');
    el.successMsg = document.getElementById('creditsSuccessMsg');
    el.errorMsg   = document.getElementById('creditsErrorMsg');

    if (!el.section) return;

    var productTypeArea = document.getElementById('productTypeArea');
    if (productTypeArea) {
      productTypeArea.addEventListener('click', function(e) {
        var btn = e.target.closest('.customify-product-type-btn');
        if (!btn) return;
        setTimeout(function() {
          onProductTypeChanged(btn.getAttribute('data-product-type'));
        }, 50);
      });
    }

    if (el.useBtn) el.useBtn.addEventListener('click', handleUseCredit);

    var activBtn = document.querySelector('.customify-product-type-btn.active');
    if (activBtn) onProductTypeChanged(activBtn.getAttribute('data-product-type'));

    watchResultArea();
  }

  function onProductTypeChanged(type) {
    if (!el.section) return;
    if (type !== 'digital') { el.section.style.display = 'none'; return; }

    var resultArea = document.getElementById('resultArea');
    if (resultArea && resultArea.style.display === 'none') {
      el.section.style.display = 'none';
      return;
    }

    el.section.style.display = 'block';
    hideAll();

    var customerId = getCustomerId();
    if (!customerId) { showState('notLogged'); return; }
    if (creditsChecked) { showByBalance(); return; }
    fetchCredits();
  }

  function fetchCredits() {
    showState('loading');
    creditsChecked = false;
    var customerId = getCustomerId();

    fetch(CREDITS_API_BASE + '/api/credits/check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ customerId: customerId })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      currentCredits = data.credits || 0;
      creditsChecked = true;
      showByBalance();
    })
    .catch(function(err) {
      console.error('[CREDITS] Błąd sprawdzania kredytów:', err);
      if (el.section) el.section.style.display = 'none';
    });
  }

  function showByBalance() {
    if (currentCredits > 0) {
      showState('available');
      if (el.balanceInfo) el.balanceInfo.textContent = 'Masz ' + currentCredits + ' ' + label(currentCredits);
    } else {
      showState('empty');
    }
  }

  function handleUseCredit() {
    var inst = window.__customify;
    if (!inst) { showError('Błąd aplikacji. Odśwież stronę.'); return; }

    var imageUrl = null;
    if (inst.cleanImageUrl && inst.cleanImageUrl.startsWith('http')) imageUrl = inst.cleanImageUrl;
    else if (inst.transformedImage && inst.transformedImage.startsWith('http')) imageUrl = inst.transformedImage;

    if (!imageUrl) { showError('Brak obrazu. Wygeneruj najpierw portret.'); return; }

    var customerId = getCustomerId();
    if (!customerId) { showError('Musisz być zalogowany.'); return; }

    if (el.useBtn) { el.useBtn.disabled = true; el.useBtn.textContent = 'Wysyłam...'; }

    fetch(CREDITS_API_BASE + '/api/credits/use', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ customerId: customerId, imageUrl: imageUrl, style: inst.selectedStyle || '' })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.success) {
        currentCredits = data.creditsRemaining || 0;
        creditsChecked = true;
        showState('success');
        if (el.successMsg) {
          el.successMsg.textContent = 'Email wysłany na ' + getCustomerEmail() + '. Pozostało: ' + currentCredits + ' ' + label(currentCredits) + '.';
        }
      } else {
        showError(data.error || 'Błąd podczas użycia kredytu.');
        if (el.useBtn) { el.useBtn.disabled = false; el.useBtn.textContent = '💳 Pobierz za 1 kredyt'; }
      }
    })
    .catch(function(err) {
      console.error('[CREDITS] Błąd użycia kredytu:', err);
      showError('Błąd połączenia. Spróbuj ponownie.');
      if (el.useBtn) { el.useBtn.disabled = false; el.useBtn.textContent = '💳 Pobierz za 1 kredyt'; }
    });
  }

  function watchResultArea() {
    var resultArea = document.getElementById('resultArea');
    if (!resultArea) { setTimeout(watchResultArea, 500); return; }

    new MutationObserver(function() {
      var isVisible = resultArea.style.display !== 'none';
      var activeBtn = document.querySelector('.customify-product-type-btn.active');
      var isDigital = activeBtn && activeBtn.getAttribute('data-product-type') === 'digital';
      if (isVisible && isDigital && el.section) {
        el.section.style.display = 'block';
        var customerId = getCustomerId();
        if (!creditsChecked && customerId) fetchCredits();
        else if (creditsChecked) showByBalance();
        else if (!customerId) showState('notLogged');
      }
    }).observe(resultArea, { attributes: true, attributeFilter: ['style'] });
  }

  function showState(state) {
    hideAll();
    var map = { loading: el.loading, available: el.available, empty: el.empty, notLogged: el.notLogged, success: el.success };
    if (map[state]) map[state].style.display = 'block';
  }
  function hideAll() {
    [el.loading, el.available, el.empty, el.notLogged, el.success, el.error].forEach(function(e) { if (e) e.style.display = 'none'; });
  }
  function showError(msg) {
    hideAll();
    if (el.error && el.errorMsg) { el.errorMsg.textContent = msg; el.error.style.display = 'block'; }
  }
  function label(n) {
    if (n === 1) return 'kredyt';
    if (n >= 2 && n <= 4) return 'kredyty';
    return 'kredytów';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCreditsUI);
  } else {
    initCreditsUI();
  }
})();

